export const en = {
    'pgnav.catalog.memberships': 'Memberships',
    'sitemap.new.memberships': 'New membership',
    'offerTemplate.card.memberships': 'Page for each membership',
    'offerTemplate.pageName.memberships': 'Membership page',
    'offerTemplate.sample.memberships': 'Sample membership',
    'catalogPanel.kind.memberships': 'Membership',
    'catalogPanel.art.cta.memberships': 'Join now',
    'catalogPanel.membershipBody': 'Recurring memberships and prepaid packs. Choose what members receive in the dashboard.',
    'designs.list.memberships': 'Memberships page',
    'designs.item.memberships': 'Page for each membership',
    'sample.navMemberships': 'Memberships',
    'navm.auto.desc.memberships': 'Memberships and prepaid packs',
    // ── Common ────────────────────────────────────────────────────────────────
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.discard': 'Discard',
    'common.confirm': 'Confirm',
    'common.processing': 'Working…',
    'common.saving': 'Saving…',
    'common.saved': 'Changes saved',
    'common.none': '—',
    'common.back': 'Back',
    'common.search': 'Search',
    'common.close': 'Close',
    /* Said by Pages, the project frame and Policies. It was called
       `pages.linkCopied` back when only one screen said it. */
    'common.changeImage': 'Change image',
    /* Todavía no hay ninguna: se elige, no se cambia. */
    'common.selectImage': 'Select image',
    'common.linkCopied': 'Link copied',
    'common.copyFailed': 'The link could not be copied',
    'common.untitled': 'Untitled',
    'common.unnamed': 'Unnamed',
    'common.open': 'Open',
    'common.items': 'items',
    'common.starred': 'starred',
    'common.star': 'Star',
    'common.unstar': 'Unstar',
    'common.refreshingData': 'Updating…',
    'common.refreshFailed': 'Could not update. The displayed data may be out of date.',
    'common.refresh': 'Refresh',
    'common.refreshList': 'Refresh the list',
    'common.selection.one': '{count} selected',
    'common.selection.many': '{count} selected',
    'common.selection.actions': 'Actions for selected items',
    'common.pagination.showing': 'Showing {start}–{end} of {total} {unit}',
    'common.pagination.total': '{total} {unit}',
    'common.pagination.previous': 'Previous page',
    'common.pagination.next': 'Next page',
    'common.pagination.page': 'Page {page}',
    'common.starFilter.viewAllAria': 'Show everything, not only {label}',
    'common.starFilter.onlyAria': 'Show only {label}',
    'common.starFilter.viewAll': 'Show all',
    'common.starFilter.only': '{label} only',
    'common.planUsage.limitLabel': '{label}: limit {limit}',
    'common.planUsage.usedLabel': '{label}: {used} of {limit}',
    'common.planUsage.unlimited': 'unlimited',
    'common.planUsage.ofLimit': '{used} of {limit}',
    'common.planUsage.fullTitle': 'You reached a plan limit',
    'common.planUsage.warningTitle': 'You are close to a limit',
    'common.planUsage.title': 'Plan usage',
    'common.planUsage.moreInfo': 'More information about plan limits',
    'common.planUsage.tooltip': 'Usage and limits',
    'common.planUsage.dialogAria': 'Plan usage and limits',
    'common.planUsage.resets': 'Resets {date}.',
    'common.planUsage.fullBody': 'You reached the maximum on your {plan} plan. Upgrade to keep adding more.',
    'common.planUsage.warningBody': 'You are getting close to your {plan} plan limit. Add capacity before it fills up.',
    'common.planUsage.okBody': 'You are within the limits of your {plan} plan.',
    'common.planUsage.upgrade': 'Upgrade to {plan}',
    'common.planUsage.emailSubject': 'I need more capacity (Business)',
    'common.planUsage.contact': 'Contact véltica',
    // ── Settings › Site settings ──────────────────────────────────────────────
    'settings.general.title': 'Site settings',
    'settings.general.intro': 'Set the project identity, time zone, access, and how the véltica badge appears on your published site.',
    'settings.general.identity.title': 'Project identity',
    'settings.general.identity.intro': 'The name you will recognize this site by inside your dashboard.',
    'settings.general.identity.nameLabel': 'Project name',
    'settings.general.timezone.title': 'Time zone',
    'settings.general.timezone.intro': 'Decides how dates are grouped and when each day starts in Analytics.',
    'settings.general.timezone.label': 'Site time zone',
    'settings.general.timezone.detect': 'Detect',
    'settings.general.timezone.detected': 'Time zone detected: {zone}',
    'settings.general.icons.title': 'Site icons',
    'settings.general.icons.intro': 'Icons for browsers and devices. Images are resized for you and go live when you publish.',
    'settings.general.icons.faviconLight': 'Light favicon',
    'settings.general.icons.faviconDark': 'Dark favicon',
    'settings.general.icons.webclip': 'Web clip',
    'settings.general.icons.change': 'Change {icon}',
    'settings.general.icons.upload': 'Upload {icon}',
    'settings.general.icons.failed': 'That image could not be processed',
    'settings.general.password.title': 'Site password',
    'settings.general.password.intro': 'Keep the published site behind a password.',
    'settings.general.password.toggle': 'Password protection',
    'settings.general.password.toggleHint': 'Visitors have to enter it before they can see anything.',
    'settings.general.password.new': 'New password (optional)',
    'settings.general.password.current': 'Password',
    'settings.general.password.keepHint': 'Leave blank to keep the current one',
    'settings.general.password.minHint': 'At least 6 characters',
    'settings.general.password.tooShort': 'The password needs at least 6 characters',
    'settings.general.pending.title': "What still needs completing",
    'settings.general.pending.intro': "The services, bookings, products and posts the AI started that you haven't finished yet.",
    'settings.general.pending.toggle': "Show as “Coming soon”",
    'settings.general.cart.title': "Cart",
    'settings.general.cart.intro': "Let customers gather several things and pay once, with a single shipment.",
    'settings.general.cart.toggle': "Use a cart",
    'settings.general.cart.hintOn': "Offers that can be bought together get “Add to cart”, and the site bar gets the cart icon. Bookings and subscriptions keep their own button. Shows after you publish again.",
    'settings.general.cart.hintOff': "Each offer is bought on its own, with its button. Shows after you publish again.",
    'settings.general.accounts.title': "Customer accounts",
    'settings.general.accounts.intro': "Let customers sign in to your site with their email to see their details and what they have with you. No passwords: they sign in with a code sent to their email.",
    'settings.general.accounts.toggle': "Customer accounts",
    'settings.general.accounts.mode.auto': "Automatic",
    'settings.general.accounts.mode.on': "Always",
    'settings.general.accounts.mode.off': "Never",
    'settings.general.accounts.hint.auto': "They turn on by themselves as soon as your site publishes something to buy or book. Customers sign in at /account and the account icon shows in the bar.",
    'settings.general.accounts.hint.on': "Always on: customers can create an account and sign in at /account. Works right away, no need to publish again.",
    'settings.general.accounts.hint.off': "Your site has no customer accounts: customers buy and book as guests. Memberships can be bought without an account.",
    'settings.general.pending.hintSoon': "They show on your site with their photo and name, without a price. Clicking them shows a notice that they are coming soon, so the page never looks half-built.",
    'settings.general.pending.hintHide': "They won't appear on your site until you complete and publish them. Sections with only those are hidden.",
    'settings.general.badge.title': 'véltica badge',
    'settings.general.badge.introCanRemove': 'Choose whether the badge appears on this site’s published pages.',
    'settings.general.badge.introFree': 'The badge appears on published pages of sites on the free plan.',
    'settings.general.badge.previewLabel': 'Preview',
    'settings.general.badge.previewAria': 'Preview of the Made with véltica badge',
    'settings.general.badge.madeWith': 'Made with',
    'settings.general.badge.toggle': 'Show the “Made with véltica” badge',
    'settings.general.badge.toggleAria': 'Show the Made with véltica badge',
    'settings.general.badge.hintCanRemove': 'It sits quietly in the corner of every published page.',
    'settings.general.badge.hintFree': 'Upgrade this site’s plan to hide it.',
    'settings.general.badge.upsell': 'To remove véltica’s branding from your published site,',
    'settings.general.badge.upsellLink': 'add a paid site plan',
    'settings.general.overview.title': 'Project details',
    'settings.general.overview.intro': 'Identifiers, dates, and overall numbers for this site.',
    'settings.general.overview.id': 'Site ID',
    'settings.general.overview.created': 'Created',
    'settings.general.overview.updated': 'Last updated',
    'settings.general.overview.published': 'Last published',
    'settings.general.overview.unpublished': 'Not published',
    'settings.general.overview.pages': 'Pages',
    'settings.general.overview.collectionItems': 'Collection items',
    'settings.general.danger.title': 'Project administration',
    'settings.general.danger.intro': 'The site goes offline right away, and your data is kept for 30 days in case you change your mind.',
    'settings.general.danger.delete': 'Delete project',
    'settings.general.danger.deleteHint': 'The site, its content, and its history cannot be brought back.',
    'settings.general.danger.thisProject': 'this project',
    'settings.general.delete.title': 'Delete “{project}”?',
    'settings.general.delete.intro': "The site goes offline right away.",
    'settings.general.delete.gracePill': "30 days to restore it",
    'settings.general.delete.lostTitle': 'What gets deleted',
    'settings.general.delete.lostSite': 'Site and pages',
    'settings.general.delete.lostSiteHint': 'The published site, its files, and everything on its pages.',
    'settings.general.delete.lostCms': 'CMS and forms',
    'settings.general.delete.lostCmsHint': 'Collections, their items, and every message you have received.',
    'settings.general.delete.lostCommerce': 'Contacts and sales activity',
    'settings.general.delete.lostCommerceHint': 'Contacts, offers, sales, and booked appointments.',
    'settings.general.delete.lostAnalytics': 'Analytics and backups',
    'settings.general.delete.lostAnalyticsHint': 'Your analytics history and every saved backup.',
    'settings.general.delete.keptTitle': 'What you keep',
    'settings.general.delete.keptStripe': 'Your Stripe account',
    'settings.general.delete.keptStripeHint': 'It only gets disconnected from this project. The account, its balance, and its transaction history stay in Stripe, and so do your sales records.',
    'settings.general.delete.keptDomains': 'The domains you bought',
    'settings.general.delete.keptDomainsHint': 'They stay registered in your name until renewal, and you can point them at another project.',
    'settings.general.delete.keptImages': 'Your images',
    'settings.general.delete.keptImagesHint': 'The library belongs to your account, not to this site: your uploads stay available to your other projects.',
    'settings.general.delete.keptPlan': 'Your membership',
    'settings.general.delete.keptPlanHint': 'Your plan belongs to your account, not to the site. Deleting a project does not cancel it or change its price.',
    'settings.general.delete.graceBody': 'The site goes offline right now, but the data is kept for a month and you can restore it from your dashboard. After that it is deleted for good. If you connected your own domain, remember to remove or repoint its DNS records wherever you registered it: they will still point here.',
    'settings.general.delete.confirmLabel': 'Type {project} to confirm',
    'settings.general.delete.confirmFallback': 'the project name',
    'settings.general.delete.confirmPlaceholder': 'Project name',
    'settings.general.delete.confirmHint': "Capital letters and accents don't matter.",
    'settings.general.delete.confirmTooltip': 'Type the project name to confirm',
    'settings.general.error.emptyName': 'The name cannot be empty',
    'settings.general.error.saveFailed': 'Your changes could not be saved',
    // ── Server errors ─────────────────────────────────────────────────────────
    'error.project.notFound': 'We could not find this project.',
    'error.project.forbidden': 'You do not have access to this project.',
    'error.project.roleForbidden': 'Your role in this project does not allow this.',
    'error.network': 'Could not connect. Check your connection and try again.',
    'error.unexpected': 'Something went wrong. Please try again.',
    // ── Language ──────────────────────────────────────────────────────────────
    'language.label': 'Language',
    'language.es': 'Spanish',
    'language.en': 'English',
    // ── Sign in and sign up ───────────────────────────────────────────────────
    'auth.welcomeBack': 'Welcome back',
    'auth.createAccount': 'Create your account',
    'auth.signInIntro': 'Sign in to keep building your sites.',
    'auth.signUpIntro': 'Start building and running your sites with véltica.',
    'auth.signIn': 'Sign in',
    'auth.signUp': 'Create account',
    'auth.continue': 'Continue',
    'auth.continuing': 'Continuing…',
    'auth.sending': 'Sending…',
    'auth.sendingCode': 'Sending code…',
    'auth.verifying': 'Verifying…',
    'auth.saving': 'Saving…',
    'auth.email': 'Email',
    'auth.emailPlaceholder': 'you@example.com',
    'auth.emailHint': 'We will send you a code to continue.',
    'auth.rememberEmail': 'Remember my email on this device',
    'auth.recentlyUsed': 'Recently used',
    'auth.continueWith': 'Continue with {provider}',
    'auth.continueWithEmail': 'Continue with email',
    'auth.or': 'or',
    'auth.checkYourEmail': 'Check your email',
    'auth.codeLabel': 'Verification code',
    'auth.codeHint': 'Enter the code we emailed you.',
    'auth.resendCode': 'Resend code',
    'auth.nameQuestion': 'What is your name?',
    'auth.nameWhy': 'That is how we make your véltica workspace yours.',
    'auth.name': 'Name',
    'auth.namePlaceholder': 'Your name',
    'auth.newPasswordTitle': 'Create a new password',
    'auth.newPasswordHint': 'Pick a strong password you have not used before.',
    'auth.newPassword': 'New password',
    'auth.confirmPassword': 'Confirm password',
    'auth.passwordPlaceholder': 'At least 8 characters',
    'auth.repeatPlaceholder': 'Repeat your password',
    'auth.savePassword': 'Save new password',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.noAccount': "Don't have an account?",
    'auth.haveAccount': 'Already have an account?',
    'auth.requestNewLink': 'Request another link',
    'auth.terms': 'Terms and conditions',
    'auth.privacy': 'Privacy policy',
    'auth.photoBy': 'Photo by',
    'auth.lightMode': 'Light mode',
    'auth.darkMode': 'Dark mode',
    'auth.switchToLight': 'Switch to light mode',
    'auth.switchToDark': 'Switch to dark mode',
    'auth.accessAria': 'Sign in to véltica',
    'auth.previewAria': 'véltica preview',
    'auth.hero.loginTitle': "Your whole business, in one place.",
    'auth.hero.loginBody': "Your site, your sales and your bookings, all run from véltica.",
    'auth.hero.signupTitle': "Your site, ready in minutes.",
    'auth.hero.signupBody': "Build your page, take payments and accept bookings without writing a line of code.",
    'auth.hero.site': "Website",
    'auth.hero.payments': "Payments",
    'auth.hero.bookings': "Bookings",
    'auth.workspaceAria': 'véltica workspace',
    'auth.error.badEmail': 'Enter a valid email address.',
    'auth.error.noMx': 'That domain does not accept email. Check the spelling.',
    'auth.error.needName': 'Enter your name to continue.',
    'auth.error.badCode': 'That code is invalid or expired. Check your email or ask for a new one.',
    'auth.error.shortPassword': 'The password needs at least 8 characters.',
    'auth.error.mismatch': 'The passwords do not match.',
    'auth.error.generic': 'We could not continue. Please try again in a moment.',
    'auth.error.google': 'We could not sign you in with Google. Try again or use your email.',
    'auth.error.expiredLink': 'This link expired or is not valid. Request a new one to continue.',
    'auth.useAnotherEmail': 'Use another email',
    'auth.codeSentTo': 'We sent a 6-digit code to {email}. Enter it to continue.',
    'auth.notArrived': 'Did not get it?',
    'auth.back': 'Back',
    'auth.enterYourEmail': 'Enter your email',
    'auth.didYouMean': 'Did you mean {suggestion}?',
    'auth.legalPrefix': 'By continuing, you confirm that you understand and accept our',
    'auth.legalMiddle': 'and our',
    // ── Home and the create wizard ────────────────────────────────────────────
    'home.beta.label': 'Beta.',
    'home.beta.body': 'véltica is under active development: expect changes and the odd rough edge while we polish it.',
    'home.footer.legalAria': 'Legal information',
    'home.footer.terms': 'Terms and conditions',
    'home.footer.privacy': 'Privacy policy',
    'home.deleted.title': 'This project is deleted',
    'home.deleted.unnamed': 'Untitled',
    'home.deleted.gone': 'was deleted and its site is no longer online.',
    'home.deleted.purgeSoon': 'It will be permanently deleted soon.',
    'home.deleted.purgeToday': 'It will be permanently deleted today.',
    'home.deleted.purgeInOne': 'It will be permanently deleted in 1 day.',
    'home.deleted.purgeInDays': 'It will be permanently deleted in {count} days.',
    'home.deleted.recoverable': 'You can restore it until then with all its content; you will have to publish it again to put it back online.',
    'home.deleted.recover': 'Restore',
    'home.deleted.tooltip': 'This project is deleted',
    'create.dialogAria': 'Create project',
    'create.nameAria': 'Project name',
    'create.namePlaceholder': 'Project name',
    'create.close': 'Close',
    'create.categoriesAria': 'Template categories',
    'create.categories': 'Categories',
    'create.stepsAria': 'Customisation steps',
    'create.customise': 'Customise',
    'create.templatesAria': 'Templates',
    'create.fontsAria': 'Font pairings',
    'create.fromTemplate': 'From the template',
    'create.custom': 'Custom',
    'create.headingFont': 'Heading font',
    'create.bodyFont': 'Body font',
    'create.reset': 'Reset',
    'create.done': 'Done',
    'create.fontLibrary': 'Font library',
    'create.fontFiltersAria': 'Filter fonts by style',
    'create.edit': 'Edit',
    'create.palettesAria': 'Color palettes',
    'create.paletteLibrary': 'Color library',
    'create.paletteFiltersAria': 'Filter palettes by style',
    'create.cancel': 'Cancel',
    'create.back': 'Back',
    'create.preparing': 'Preparing your site…',
    'create.previewAria': 'Template preview',
    'create.previewUnavailable': 'Preview unavailable',
    'create.templatesForNewAria': 'Templates for the new site',
    'create.fontPairsAria': 'Font pairings',
    'create.restore': 'Restore',
    'create.createSite': 'Create site',
    'create.next': 'Next',
    'create.loadingPreview': 'Loading preview…',
    'create.loadingTemplates': 'Loading templates…',
    'create.refreshTemplates': 'Refresh',
    'account.language.title': 'Panel language',
    'account.language.intro': 'The language you see the panel and the editor in. It travels with your account, so it applies on any computer you sign in from.',
    'account.language.notProject': 'It does not change your sites: each project’s emails and booking page use the language you pick in its {region} settings.',
    // ── My account ────────────────────────────────────────────────────────────
    'account.title': 'My account',
    'account.intro': 'Manage your profile, your email, and access to your account.',
    'account.profile.title': 'Profile',
    'account.profile.intro': 'Your name and photo show up in the dashboard.',
    'account.profile.photoAlt': 'Profile photo',
    'account.profile.uploading': 'Uploading…',
    'account.profile.remove': 'Remove',
    'account.profile.photoHint': 'JPG, PNG or WebP. Max 10 MB.',
    'account.profile.name': 'Name',
    'account.profile.namePlaceholder': 'Your name',
    'account.profile.saved': 'Profile saved.',
    'account.email.title': 'Email',
    'account.email.current': 'Current email:',
    'account.email.external': 'You signed in with an outside provider, so your email is managed there.',
    'account.email.step1': 'Step 1 of 2 · Verify it is you',
    'account.email.step2': 'Step 2 of 2 · Confirm your new email',
    'account.email.codeSentCurrent': 'We sent a code to your current email, {email}. Enter it to continue.',
    'account.email.codeSentNew': 'We sent a code to your new email, {email}. Enter it to confirm the change.',
    'account.email.codeCurrent': 'Code from your current email',
    'account.email.codeNew': 'Code from your new email',
    'account.email.verifying': 'Verifying…',
    'account.email.confirming': 'Confirming…',
    'account.email.inProgress': 'Verification in progress. Use the code we sent to {email}.',
    'account.email.pendingChange': 'Change pending to {email}.',
    'account.email.didYouMean': 'Did you mean {suggestion}?',
    'account.providers.title': 'Connected accounts',
    'account.providers.intro': 'Providers you can sign in with.',
    'account.providers.connected': 'Connected',
    'account.providers.disconnect': 'Disconnect',
    'account.providers.connect': 'Connect',
    'account.sessions.title': 'Active sessions',
    'account.sessions.intro': 'Devices where your account is signed in.',
    'account.sessions.loading': 'Loading sessions…',
    'account.sessions.failed': 'We could not load the list of sessions.',
    'account.sessions.current': 'Current session',
    'account.sessions.startedAt': 'Started {date}',
    'account.sessions.signOutCurrent': 'Sign out of this session',
    'account.sessions.signOut': 'Sign out',
    'account.sessions.signingOut': 'Signing out…',
    'account.delete.graceIntro': "Your sites go offline and your membership is cancelled right away. You have {days} days to restore your account; after that your projects, images and data are deleted for good.",
    'account.delete.domainsTitle': "Your domains",
    'account.delete.domainsHint': "They stay yours until they expire. Choose what to do with each one.",
    'account.delete.domainExpires': "Expires on {date}",
    'account.delete.domainTransfer': "Transfer it",
    'account.delete.domainTransferHint': "We'll email you the code to move it to another registrar.",
    'account.delete.domainLocked': "Locked by a refund or dispute.",
    'account.delete.domainExpire': "Let it expire",
    'account.delete.domainExpireHint': "It won't renew and will be released when it expires.",
    'account.delete.noticeTeam': "{names}: their members will lose access.",
    'account.delete.noticeBookings.one': "You have 1 upcoming booking. Your customer won't be notified. Let them know or cancel it first.",
    'account.delete.noticeBookings.many': "You have {count} upcoming bookings. Your customers won't be notified. Let them know or cancel them first.",
    'account.delete.noticeSubscriptions.one': "1 customer subscription will stop renewing at the end of its period.",
    'account.delete.noticeSubscriptions.many': "{count} customer subscriptions will stop renewing at the end of their period.",
    'account.delete.noticeDisputes.one': "You have 1 open dispute. It stays in your Stripe account. Respond in time even if you delete véltica.",
    'account.delete.noticeDisputes.many': "You have {count} open disputes. They stay in your Stripe account. Respond in time even if you delete véltica.",
    'account.delete.dialogGrace': "Your sites will go offline and your membership will be cancelled now. You'll have {days} days to restore your account by signing in; after that everything is deleted for good.",
    'auth.deletionScheduled': "Your account is scheduled to be deleted on {date}. If you change your mind, sign in before then to restore it.",
    'account.restore.title': "Your account will be deleted on {date}",
    'account.restore.lead': "Your projects, images and data are kept until then. If you restore it, everything comes back, with three things to do:",
    'account.restore.sites': "Your sites were unpublished. Publish them again from the editor.",
    'account.restore.domains': "Your domains were disconnected and auto-renew is off. Reconnect them and turn it back on if you like.",
    'account.restore.plan': "Your membership was cancelled. You'll be on the free plan until you pick another.",
    'account.restore.cta': "Restore my account",
    'account.restore.restoring': "Restoring…",
    'account.restore.failed': "We couldn't restore your account. Please try again.",
    'account.restore.keepDeleting': "Rather keep it deleted?",
    'account.restore.signOut': "Sign out",
    'account.delete.title': 'Delete account',
    'account.delete.typeToConfirm': 'Type {word} to confirm',
    'account.delete.word': 'DELETE',
    'account.delete.codeSent': 'We sent a code to {email}. Enter it to confirm the deletion.',
    'account.delete.code': 'Verification code',
    'account.delete.button': 'Delete my account',
    'account.delete.sending': 'Sending…',
    'account.delete.deleting': 'Deleting…',
    'account.delete.dialogAria': 'Confirm account deletion',
    'account.delete.dialogTitle': 'Delete your account?',
    'account.delete.noProjects': 'You have no projects, but your account and its data will be deleted.',
    'account.profile.changePhoto': 'Change photo',
    'account.email.newEmail': 'New email',
    'account.email.newPlaceholder': 'new@example.com',
    'account.email.back': 'Back',
    'account.email.discard': 'Discard',
    'account.email.enterCode': 'Enter code',
    'account.sessions.signOutAll': 'Sign out on all devices',
    'account.delete.sendCode': 'Send code',
    'account.delete.confirmAll': 'Yes, delete my account',
    'account.cancel': 'Cancel',
    // ── Project sidebar ───────────────────────────────────────────────────────
    /* Menu labels and breadcrumb labels are TWO sets, not one. The menu says
       “Home” — where you are going; the breadcrumb says “Dashboard” — where you
       are. Merging them would save a dozen keys and make the trail at the top
       contradict the menu on the left. */
    'nav.aria': 'Company sections',
    'nav.home': 'Home',
    'nav.favorites': 'Favorites',
    'nav.pin': 'Add {name} to favorites',
    'nav.unpin': 'Remove {name} from favorites',
    'nav.contacts': 'Contacts',
    'nav.team': 'Team',
    'nav.config': 'Settings',
    'nav.help': 'Help',
    /* The badge on a row that does not exist yet. Kept apart from
       `nav.group.apps`, which today reads the same: one labels a folder and the
       other marks a row, so the day the folder is named after its contents there
       is no guessing which use had to change. */
    'nav.soon': 'Coming soon',
    'nav.configWarning.title': 'Settings need attention',
    'nav.configWarning.policies': 'Policies left to write: {count}',
    'nav.configWarning.holes': 'Missing details in your policies: {count}',
    'nav.configWarning.business': 'Missing business details: {count}',
    'nav.configWarning.openPolicies': 'Review policies',
    'nav.configWarning.openBusiness': 'Complete business information',
    'nav.configPending.one': 'You have 1 detail left to fill in',
    'nav.configPending.many': 'You have {count} details left to fill in',
    'nav.group.website': 'Website',
    'nav.group.catalog': 'Catalogue',
    'nav.group.sales': 'Sales',
    'nav.group.bookings': 'Bookings',
    'nav.group.analytics': 'Analytics',
    'nav.group.apps': 'Coming soon',
    'nav.group.admin': 'Admin',
    'nav.pages': 'Pages',
    'nav.cms': 'Content',
    'nav.forms': 'Forms',
    'nav.payments': 'All offers',
    'nav.digitalProducts': 'Digital products',
    'nav.physicalProducts': 'Physical products',
    'nav.services': 'Services',
    /* “Payments” and not “Orders”: nothing here gets packed or shipped — they are
       charges Stripe already confirmed. */
    'nav.orders': 'Payments',
    'nav.payouts': 'Payouts',
    'nav.collections': 'Collections',
    'section.collections': 'Collections',
    'collections.title': 'Collections',
    'collections.subtitle': 'Group your offers: “Summer”, “Sale”, a brand. Each gets its own page and works as a catalog filter.',
    'collections.new': 'New collection',
    'collections.emptyTitle': 'No collections yet',
    'collections.emptyBody': 'A collection groups offers with a name, description and image. Pick them by hand or let them join automatically with rules (by tag, price, brand…).',
    'collections.count': '{count} offers',
    'collections.saved': 'Collection saved',
    'collections.remove': 'Delete {title}',
    'collections.removeTitle': 'Delete “{title}”?',
    'collections.removeBody': 'Offers aren’t deleted: they just stop being grouped here.',
    'collections.removeConfirm': 'Delete collection',
    'collections.openLink': 'Open on the site',
    'collections.copyLink': 'Copy link',
    'collections.designPage': 'Design its page',
    'collections.createdTitle': '“{title}” is ready',
    'collections.createdBody': 'Its page on the site uses the collections template. Open it in the editor to change its design: it applies to all of them.',
    'collections.linkCopied': 'Link copied.',
    'collections.linkCopyFailed': 'Could not copy the link.',
    'collections.kind.manual': 'Manual',
    'collections.kind.manualHint': 'You choose which offers go in and in what order.',
    'collections.kind.auto': 'Automatic',
    'collections.kind.autoHint': 'Offers that meet your conditions join on their own, new ones too.',
    'collections.form.newTitle': 'New collection',
    'collections.form.editTitle': 'Edit collection',
    'collections.form.lead': 'Its name, image and which offers go in.',
    'collections.form.close': 'Close',
    'collections.form.image': 'Image',
    'collections.form.name': 'Name',
    'collections.form.namePlaceholder': 'E.g. Summer collection',
    'collections.form.description': 'Description',
    'collections.form.descriptionPlaceholder': 'What shows above its products.',
    'collections.form.type': 'How it’s built',
    'collections.form.conditions': 'Conditions',
    'collections.form.matchLead': 'Offers must match',
    'collections.match.all': 'all conditions',
    'collections.match.any': 'any condition',
    'collections.form.valuePlaceholder': 'Value',
    'collections.form.removeRule': 'Remove condition',
    'collections.form.addRule': 'Add condition',
    'collections.form.picked': '{count} selected',
    'collections.form.draft': 'draft',
    'collections.form.offers': 'Offers',
    'collections.form.search': 'Search offers…',
    'collections.form.noOffers': 'No offers match.',
    'collections.form.sort': 'Order',
    'collections.form.previewCount': '{count} offers match today',
    'collections.form.previewLoading': 'Calculating…',
    'collections.form.previewEmpty': 'No offers meet these conditions yet.',
    'collections.form.inCollection': 'In the collection',
    'collections.form.footNeedName': 'Name it to continue',
    'collections.form.required': 'Required',
    'collections.form.optional': 'Optional',
    'collections.form.needTitle': 'Give the collection a name.',
    'collections.form.cancel': 'Cancel',
    'collections.form.saving': 'Saving…',
    'collections.form.save': 'Save',
    'collections.form.create': 'Create collection',
    'collections.field.tag': 'Tag',
    'collections.field.kind': 'Type',
    'collections.field.price': 'Price',
    'collections.field.title': 'Title',
    'collections.field.stock': 'Availability',
    'collections.field.brand': 'Brand',
    'collections.op.is': 'is',
    'collections.op.isNot': 'is not',
    'collections.op.contains': 'contains',
    'collections.op.notContains': 'doesn’t contain',
    'collections.op.lt': 'less than',
    'collections.op.gt': 'greater than',
    'collections.opPrice.lt': 'is less than',
    'collections.opPrice.gt': 'is greater than',
    'collections.opPrice.is': 'is equal to',
    'collections.opPrice.isNot': 'is not equal to',
    'collections.opPrice.free': 'is free',
    'collections.opPrice.paid': 'is paid',
    'collections.opStock.is': 'is in stock',
    'collections.opStock.isNot': 'is out of stock',
    'collections.kindValue.products': 'Physical product',
    'collections.kindValue.digital': 'Digital',
    'collections.kindValue.services': 'Service',
    'collections.kindValue.bookings': 'Booking',
    'collections.sort.manual': 'List order',
    'collections.sort.newest': 'Newest first',
    'collections.sort.bestselling': 'Best selling',
    'collections.sort.priceAsc': 'Price: low to high',
    'collections.sort.priceDesc': 'Price: high to low',
    'collections.sort.title': 'Alphabetical',
    'offers.tags.title': 'Tags',
    'offers.tags.titleWithBrand': 'Brand and tags',
    'offers.brand.label': 'Brand',
    'offers.brand.placeholder': 'Search or create a brand',
    'offers.brand.create': 'Create “{name}”',
    'offers.brand.empty': 'No brands yet. Type one to create it.',
    'offers.brand.allChosen': 'You already picked the brand.',
    'offers.brand.limit': 'One brand per offer.',
    'offers.brand.remove': 'Remove {name} from this offer',
    'offers.brand.deleteAria': 'Delete {name} from every offer',
    'offers.brand.deleteTitle': 'Delete the brand “{name}”?',
    'offers.brand.deleteBody': 'It will be removed from {count} offers, published ones too. The offers are not deleted.',
    'offers.brand.deleteBodyOne': 'It will be removed from 1 offer, even if published. The offer is not deleted.',
    'offers.brand.deleteConfirm': 'Delete brand',
    'offers.brand.deleted': 'Brand removed from {count} offers.',
    'offers.brand.deletedOne': 'Brand removed from 1 offer.',
    'offers.brand.count': '{count} offers',
    'offers.brand.countOne': '1 offer',
    'offers.tags.body': 'Not shown on the site: used to group offers into automatic collections.',
    'offers.tags.pickPlaceholder': 'Search or create a tag',
    'offers.tags.empty': 'No tags yet. Type one to create it.',
    'offers.tags.allChosen': 'You already picked every tag.',
    'offers.tags.limit': 'Up to {max} tags per offer.',
    'offers.tags.removeOne': 'Remove {name} from this offer',
    'offers.tags.deleteAria': 'Delete {name} from every offer',
    'offers.tags.deleteTitle': 'Delete the tag “{name}”?',
    'offers.tags.deleteBody': 'It will be removed from {count} offers, published ones too. The offers are not deleted.',
    'offers.tags.deleteBodyOne': 'It will be removed from 1 offer, even if published. The offer is not deleted.',
    'offers.tags.deleteConfirm': 'Delete tag',
    'offers.tags.deleted': 'Tag removed from {count} offers.',
    'offers.tags.deletedOne': 'Tag removed from 1 offer.',
    'nav.coupons': "Coupons",
    'nav.shipping': 'Shipping',
    'find.coupons': "Coupons",
    'find.shipping': 'Shipping',
    'orders.detail.coupon': "Coupon",
    'orders.detail.couponSaved': "Saved {amount}",
    'coupons.title': "Coupons",
    'coupons.subtitle': "Discount codes for your offers and services. They apply at your site’s checkout.",
    'coupons.loading': "Loading coupons…",
    'coupons.loadFailed': "Could not load coupons.",
    'coupons.retry': "Try again",
    'coupons.new': "New coupon",
    'coupons.search': "Search by code or description",
    'nav.blog': "Blog",
    'section.blog': "Blog",
    'find.blog': "Blog",
    'blog.title': "Blog",
    'blog.nav': "Blog",
    'blog.readMore': "Read more",
    'blog.indexPage': "Blog page",
    'designs.gallery': "Gallery",
    'designs.single.services': "Service",
    'designs.single.bookings': "Booking",
    'designs.single.digital': "Product",
    'designs.single.products': "Product",
    'designs.single.memberships': "Membership",
    'designs.single.collections': "Collection",
    'designs.single.blog': "Post",
    'designs.single.cms': "Entry",
    'designs.apply': "Apply",
    'designs.collectionPage': 'Page of each collection',
    'designs.inUse': "In use",
    'designs.title': "Page designs",
    'designs.category': 'Content type',
    'designs.chooseType': 'Choose a content type to see its designs',
    'designs.cardHint': "Catalog, bookings and blog",
    'designs.change': "Change design",
    'designs.applied': "Design applied.",
    'designs.rowTitle': "Page designs",
    'contentPanel.addToPage': "Add to page",
    'designs.footTitleBlog': "Blog page designs",
    'designs.footTitle': "Shop page designs",
    'designs.footList.blog': "Blog page",
    'designs.footItem.blog': "Page for each post",
    'designs.footList': "List page",
    'designs.footItem': "Page for each offer",
    'designs.footTitleCms': "“{name}” page designs",
    'designs.footList.cms': "List page",
    'designs.footItem.cms': "Page for each entry",
    'designs.rowHint': "Change the list and the page for each offer.",
    'designs.rowHintBlog': "Change the blog page and the page for each post.",
    'designs.list.services': "Services page",
    'designs.list.digital': "Digital products page",
    'designs.list.products': "Shop page",
    'designs.list.bookings': "Bookings page",
    'designs.item.services': "Page for each service",
    'designs.item.digital': "Page for each digital product",
    'designs.item.products': "Page for each product",
    'designs.item.bookings': "Page for each booking",
    'designs.d.list-grid.name': "Grid",
    'designs.d.list-grid.desc': "The title and the offers in three columns.",
    'designs.d.list-cover.name': 'Cover + grid',
    'designs.d.blog-cover.desc': 'A cover with the latest post photo, soft blur, title and description, followed by a three-column grid of posts.',
    'designs.d.blog-article.name': "Article",
    'designs.d.blog-article.desc': "The starting design: breadcrumb, title, intro, author with date and reading time, cover, the text, and at the end share and the author profile.",
    'designs.d.blog-sidebar.name': 'List + sidebar',
    'designs.d.blog-sidebar.desc': 'Filters on top; posts in two columns with a sidebar beside them: about, topics, recent posts and authors.',
    'blog.design.filters': 'Filter bar',
    'blog.design.cover': "Cover",
    'blog.design.coverInfo': "A cover at the top with the latest post photo, softly blurred, and the blog title over it.",
    'blog.design.sidebar': "Sidebar",
    'blog.design.sidebarInfo': "Topics, most read, authors and newsletter beside the posts.",
    'blog.design.side.left': "Left",
    'blog.design.side.right': "Right",
    'blog.design.side.off': "Off",
    'blog.design.design': "Design",
    'blog.design.designHintIndex': "How the page with all the posts looks",
    'blog.design.designHintPost': "How each post looks",
    'blog.design.designsIndex': "Blog page designs",
    'blog.design.designsPost': "Post designs",
    'blog.design.manage': "Manage posts in the dashboard",
    'catalogPage.designHintIndex': "How the page with all of them looks",
    'catalogPage.designHintItem': "How the page of each one looks",
    'catalogPage.manage': "Manage offers in the dashboard",
    'catalogPage.noPage': "This page does not exist yet. Pick a design to create it.",
    'catalogPage.filtersInfo': "Search, type and price filters above the list.",
    'catalogPage.coverInfo': "A cover at the top with the photo of the newest one, softly blurred, and the page title over it.",
    'catalogPage.sidebarInfo': "A short text and, if the site has a contact page, a button to it, beside the list.",
    'catalogPage.sidebarText': "Not sure which one to choose? Write to us and we will help you.",
    'cmsPage.designHintIndex': "How the page with all the entries looks",
    'cmsPage.designHintItem': "How the page of each entry looks",
    'cmsPage.manage': "Manage content in the CMS",
    'cmsPage.designsIndex': "Collection page designs",
    'cmsPage.designsItem': "Entry page designs",
    'cmsPage.coverInfo': "A cover at the top with the photo of the newest entry, softly blurred, and the collection name over it.",
    'itemPiece.breadcrumb': "Breadcrumb",
    'itemPiece.breadcrumb.info': "Home › Section › this page, above the title.",
    'itemPiece.toc': "Table of contents",
    'itemPiece.toc.info': "The article headings as links, above the text.",
    'itemPiece.authorProfile': "Author",
    'itemPiece.authorProfile.info': "The author with photo and bio, after the text.",
    'itemPiece.share': "Share",
    'itemPiece.share.info': "Buttons to share the page, after the text.",
    'itemPiece.adjacent': "Previous / next",
    'itemPiece.adjacent.info': "Links to the previous and the next one, after the text.",
    'itemPiece.related': "Related",
    'itemPiece.related.info': "Others like this one, in their own section at the end of the page.",
    /* El texto de la portada del blog al encenderla (lo lee quien visita). */
    'blogPage.coverSubtitle': "Ideas, stories and news to explore.",
    'blog.design.filtersBody': 'Search, topic, author and sort above the posts.',
    'designs.d.list-cover.desc': 'A cover with the latest offer photo from this category, soft blur, title and description, followed by a three-column grid.',
    'designs.d.list-wide.name': "Two columns",
    'designs.d.list-wide.desc': "A centered title and larger cards, two by two.",
    'designs.d.list-rows.name': "Rows",
    'designs.d.list-rows.desc': "One offer per row: the photo on one side and the text on the other.",
    'designs.d.list-split.name': "Title on the side",
    'designs.d.list-split.desc': "The title fixed on the left and the offers on the right.",
    'designs.d.item-split.name': "Classic",
    'designs.d.item-split.desc': "Photos on one side; text and purchase on the other.",
    'designs.d.item-calendar.name': "Calendar first",
    'designs.d.item-calendar.desc': "Name and description on top, and the calendar full width.",
    'designs.d.item-hero.name': "Cover",
    'designs.d.item-hero.desc': "A photo backdrop, a gallery below the description, and a purchase card on the side.",
    'designs.d.item-sidebar.name': "Purchase on the side",
    'designs.d.item-scroll-gallery.name': "Vertical gallery and sticky purchase",
    'designs.d.item-scroll-gallery.desc': "Scroll through photos on the left, with a sticky purchase panel and expandable details on the right.",
    'designs.d.item-sidebar.desc': "A spacious gallery with a floating purchase card alongside it.",
    'designs.d.item-booking-below.name': "Calendar below",
    'designs.d.item-booking-below.desc': "Photos and text on top with “See times”; the calendar in its own section.",
    'designs.d.item-booking-steps.name': "Step by step",
    'designs.d.item-booking-steps.desc': "A photo cover, “How it works” in three steps, and the calendar at the end.",
    'designs.d.item-variants.name': "Variants in view",
    'designs.d.item-variants.desc': "Photos and text on top; below, the options (sizes, colors) and the purchase.",
    'designs.d.item-showcase.name': "Showcase",
    'designs.d.item-showcase.desc': "Full-width photos first; below, the text and the purchase.",
    'designs.d.item-gallery-section.name': "Separate gallery",
    'designs.d.item-gallery-section.desc': "Cover below the title and purchase on top; the remaining photos in a separate gallery.",
    'designs.d.item-booking-details.name': 'Details first',
    'designs.d.item-booking-details.desc': 'Service summary beside photos, with full details below and booking checkout afterwards.',
    'designs.d.item-minimal.name': "Minimal",
    'designs.d.item-minimal.desc': "One column without photos: the text and the button.",
    'blog.design.postGroup': "Post",
    'blog.design.indexGroup': "Blog page",
    'blog.design.appliedIndex': "Design applied to the blog page. You can undo it.",
    'blog.design.change': "Blog design",
    'blog.design.applied': "Design applied to the post template. You can undo it.",
    'blog.design.empty': "There are no blog designs in the library yet.",
    'blog.design.loadFailed': "Couldn't load the designs.",
    'blog.template': "Post template",
    'blog.posts': "Posts",
    'blog.edit': "Edit",
    'blog.editWith': "Edit the template, previewed with this post",
    'blog.noPostsYet': "No posts yet.",
    'blog.viewOnSite': "View the blog on the site",
    'blog.subtitle': "Write posts for your site. They go live when you save them, without republishing the site.",
    'blog.new': "New post",
    'blog.loading': "Loading the blog",
    'blog.loadFailed': "The blog couldn't be loaded.",
    'blog.retry': "Try again",
    'blog.search': "Search by title, address or category",
    'blog.empty.title': "No posts yet",
    'blog.empty.body': "Write your first one: some news, a guide or the story of your business.",
    'blog.noResults': "No posts match.",
    'blog.clearSearch': "Show all",
    'blog.filter.aria': "Post filters",
    'blog.filter.all': "All",
    'blog.authors.button': "Authors",
    'blog.authors.title': "Blog authors",
    'blog.authors.lead': "Photo, bio and links for whoever writes. They show on the site next to their posts.",
    'blog.authors.editNamed': "Edit {name}",
    'blog.authors.editLead': "What shows on their bio card and their blog page.",
    'blog.authors.back': "Back to authors",
    'blog.authors.photo': "Photo",
    'blog.authors.addPhoto': "Add photo",
    'blog.authors.changePhoto': "Change photo",
    'blog.authors.removePhoto': "Remove photo",
    'blog.authors.bio': "Bio",
    'blog.authors.bioPlaceholder': "Two or three lines about who they are and what they write about.",
    'blog.authors.links': "Links",
    'blog.authors.linkLabel': "Name (Instagram…)",
    'blog.authors.linkUrl': "https://",
    'blog.authors.newPlaceholder': "Author name",
    'blog.authors.emptyTitle': "No authors yet",
    'blog.authors.none': "Add who writes to give them a photo, a bio and their own page.",
    'blog.authors.add': "New author",
    'blog.authors.newTitle': "New author",
    'blog.authors.name': "Name",
    'blog.authors.delete': "Delete author",
    'blog.authors.profileDeleteTitle': "Delete {name}?",
    'blog.authors.profileDeleteBody': "Their profile is deleted and their name is removed from {count} posts. The posts stay.",
    'blog.authors.deleteBodyNone': "Their profile is deleted. They sign no posts.",
    'blog.authors.profileDeleted': "Author deleted",
    'blog.authors.addLink': "Add link",
    'blog.authors.removeLink': "Remove link",
    'blog.authors.saved': "Author saved",
    'blog.authors.loading': "Loading…",
    'blog.authors.posts': "{count} posts",
    'blog.authors.postsOne': "1 post",
    'blog.filter.button': "Filters",
    'blog.filter.title': "Filter posts",
    'blog.filter.close': "Close filters",
    'blog.filter.status': "Status",
    'blog.filter.category': "Category",
    'blog.filter.reset': "Reset filters",
    'blog.newShort': "New",
    'usage.stat.blogPosts': "Published posts",
    'blog.state.draft': "Draft",
    'blog.state.scheduled': "Scheduled",
    'blog.state.published': "Published",
    'blog.col.title': "Post",
    'blog.col.status': "Status",
    'blog.col.date': "Date",
    'blog.col.actions': "Actions",
    'blog.date.published': "Published {date}",
    'blog.date.scheduled': "Goes live {date}",
    'blog.date.edited': "Edited {date}",
    'blog.untitled': "Untitled",
    'blog.moreOptions': "More post options",
    'blog.options': "Options",
    'blog.open': "Open",
    'blog.menu.edit': "Edit",
    'blog.menu.publish': "Publish",
    'blog.menu.toDraft': "Move to draft",
    'blog.menu.delete': "Delete",
    'blog.delete.title': "Delete “{title}”?",
    'blog.delete.body': "The post disappears from the site and cannot be recovered.",
    'blog.delete.confirm': "Delete",
    'blog.toast.deleted': "Post deleted.",
    'blog.toast.published': "Post published.",
    'blog.toast.scheduled': "Post scheduled for {date}.",
    'blog.toast.saved': "Changes saved.",
    'blog.toast.draft': "The post is now a draft.",
    'blog.back': "Blog",
    'blog.editor.loadFailed': "The post couldn't be opened.",
    'blog.editor.titlePlaceholder': "Post title",
    'blog.editor.addCover': "Add cover",
    'blog.editor.changeCover': "Change",
    'blog.editor.removeCover': "Remove",
    'blog.editor.publish': "Publish",
    'blog.editor.schedule': "Schedule",
    'blog.editor.unpublish': "Move to draft",
    'blog.editor.delete': "Delete post",
    'blog.field.slug': "Address",
    'blog.field.slugHint': "It is already published: if you change the address, links that were shared stop working.",
    'blog.link.copy': "Copy link",
    'blog.link.copied': "Link copied",
    'blog.link.open': "View on site",
    'blog.link.copyFailed': "Couldn't copy the link.",
    'blog.link.needSite': "Publish the site so the post gets a link.",
    'blog.link.liveAfterPublish': "This is a draft: the link will work as soon as you publish the post.",
    'blog.link.liveScheduled': "Scheduled: the link will work from the publish date.",
    'blog.address.body': "Where the post lives on your site. If you change it after sharing, the old link stops working.",
    'blog.field.excerpt': "Excerpt",
    'blog.field.excerptHint': "Shown in blog lists and when the post is shared.",
    'blog.field.categories': "Categories",
    'blog.field.removeCategory': "Remove {name}",
    'blog.categories.placeholder': "Search or create a category",
    'blog.categories.create': "Create “{name}”",
    'blog.categories.count': "{count} posts",
    'blog.categories.countOne': "1 post",
    'blog.categories.empty': "No categories yet. Type one to create it.",
    'blog.categories.allChosen': "This post already has every category.",
    'blog.categories.limit': "Up to {max} categories per post.",
    'blog.categories.deleteAria': "Delete the {name} category from the whole blog",
    'blog.categories.deleteTitle': "Delete the “{name}” category?",
    'blog.categories.deleteBody': "It will be removed from the {count} posts that use it, published ones included. The posts aren't deleted.",
    'blog.categories.deleteBodyOne': "It will be removed from the post that uses it, even if it's published. The post isn't deleted.",
    'blog.categories.deleteConfirm': "Delete category",
    'blog.categories.deleted': "Category removed from {count} posts.",
    'blog.categories.deletedOne': "Category removed from 1 post.",
    'blog.authors.placeholder': "Search or create an author",
    'blog.authors.create': "Create “{name}”",
    'blog.authors.limit': "Up to {max} authors per post.",
    'blog.authors.allChosen': "All authors are already selected.",
    'blog.authors.empty': "No authors yet. Type a name to create one.",
    'blog.authors.remove': "Remove {name} from this post",
    'blog.authors.deleteAria': "Delete {name} from the whole blog",
    'blog.authors.deleteTitle': "Delete the author “{name}”?",
    'blog.authors.deleteBody': "Their name will be removed from {count} posts, including published posts. Coauthors are kept. The posts aren't deleted.",
    'blog.authors.deleteBodyOne': "Their name will be removed from this post, even if it's published. Coauthors are kept. The post isn't deleted.",
    'blog.authors.deleteConfirm': "Delete author",
    'blog.authors.deleted': "Author removed from {count} posts.",
    'blog.authors.deletedOne': "Author removed from 1 post.",
    'blog.field.author': "Authors",
    'blog.field.date': "Publish date",
    'blog.field.coverAlt': "Cover description",
    'blog.seo.title': "Search and social",
    'blog.seo.metaTitle': "Title",
    'blog.seo.metaDescription': "Description",
    'blog.seo.image': "Share image",
    'blog.seo.imageDefault': "If you don't pick one, the cover is used.",
    'blog.seo.pick': "Choose image",
    'blog.editor.kind': "Blog post",
    'blog.seo.preview': "How it looks on Google",
    'blog.seo.previewEmpty': "Write an excerpt or a description.",
    'blog.editor.excerptPlaceholder': "Add a subtitle or a short summary",
    'blog.editor.noAuthor': "No author",
    'blog.field.dateNow': "When published",
    'blog.field.time': "Publish time",
    'blog.field.dateClear': "Clear",
    'blog.field.dateFuture': "Goes live on its own that day, at that time.",
    'blog.tab.aria': "Post sections",
    'blog.tab.write': "Write",
    'blog.seo.searchTitle': "Search engines",
    'blog.seo.searchBody': "What Google shows for this post. Left empty, it uses the title and excerpt.",
    'blog.seo.shareTitle': "When shared",
    'blog.seo.shareBody': "What people see when the link is pasted into WhatsApp, Instagram or an email.",
    'blog.seo.customImage': "Custom share image.",
    'blog.seo.useCover': "Use the cover",
    'coupons.empty.title': "No coupons yet",
    'coupons.empty.body': "Create a discount code and share it. Customers type it at checkout, or get it already applied through a link.",
    'coupons.noResults': "No coupons match your search",
    'coupons.clearSearch': "Clear search",
    'coupons.col.code': "Code",
    'coupons.col.discount': "Discount",
    'coupons.col.appliesTo': "Applies to",
    'coupons.col.uses': "Uses",
    'coupons.col.status': "Status",
    'coupons.col.expires': "Expires",
    'coupons.col.actions': "Actions",
    'coupons.appliesAll': "All offers",
    'coupons.appliesOne': "1 offer",
    'coupons.appliesMany': "{count} offers",
    'coupons.off': "{amount} off",
    'coupons.duration.forever': "Every charge",
    'coupons.duration.months': "For {count} months",
    'coupons.minimumShort': "Minimum purchase {amount}",
    'coupons.usesTitle': "Sales with this coupon: {revenue} · Discounted: {discount}",
    /* La ficha del teléfono no lleva rótulo de columna —el propio encabezado
       desaparece a ese ancho—, así que un «0» suelto no dice de qué es. El
       número solo, en la tabla ancha, se lee al lado de «Uses» en la cabecera;
       aquí necesita la palabra puesta encima. */
    'coupons.usesOne': "1 use",
    'coupons.usesMany': "{count} uses",
    'coupons.usesLimitOne': "{uses} / {max} use",
    'coupons.usesLimitMany': "{uses} / {max} uses",
    'coupons.noExpiry': "No end date",
    'coupons.status.active': "Active",
    'coupons.status.inactive': "Paused",
    'coupons.status.expired': "Expired",
    'coupons.status.exhausted': "Used up",
    'coupons.toggleAria': "Turn {code} on or off",
    'coupons.moreOptions': "More coupon options",
    'coupons.copyCodeAria': 'Copy code {code}',
    'coupons.options': "Options",
    'coupons.menu.edit': "Edit",
    'coupons.menu.copyCode': "Copy code",
    'coupons.menu.copyLink': "Copy link with coupon",
    'coupons.menu.pause': "Pause",
    'coupons.menu.resume': "Activate",
    'coupons.menu.delete': "Delete",
    'coupons.toast.created': "Coupon {code} created",
    'coupons.toast.saved': "Coupon saved",
    'coupons.toast.deleted': "Coupon deleted",
    'coupons.toast.paused': "Coupon paused",
    'coupons.toast.resumed': "Coupon activated",
    'coupons.toast.codeCopied': "Code copied",
    'coupons.toast.linkCopied': "Link copied",
    'coupons.delete.title': "Delete coupon {code}?",
    'coupons.delete.body': "It stops working at checkout right away. Sales already made with it keep the code and the discount.",
    'coupons.delete.confirm': "Delete coupon",
    'coupons.form.newTitle': "New coupon",
    'coupons.form.editTitle': "Edit coupon",
    'coupons.form.lead': "Stripe validates the code and applies the discount at checkout.",
    'coupons.form.close': "Close",
    'coupons.form.code': "Code",
    'coupons.form.codePlaceholder': 'SUMMER20',
    'coupons.form.generate': "Generate",
    'coupons.form.codeHint': "What the customer types. Letters, numbers and dashes; 3 to 40 characters, no spaces.",
    'coupons.form.description': "Internal note (optional)",
    'coupons.form.descriptionPlaceholder': "Summer campaign, influencer, returning customers…",
    'coupons.form.discount': "Discount",
    'coupons.form.percent': "Percentage",
    'coupons.form.amount': "Fixed amount",
    'coupons.form.appliesTo': "Applies to",
    'coupons.form.allOffers': "All offers",
    'coupons.form.someOffers': "Specific offers",
    'coupons.form.allOffersHint': "Works on any offer or service paid online, including ones you create later.",
    'coupons.form.searchOffers': "Search offers",
    'coupons.form.selectedCount': "{count} selected",
    'coupons.form.noOffers': "You do not have any offers yet.",
    'coupons.form.noOfferMatches': "No offers match.",
    'coupons.form.untitled': "Untitled",
    'coupons.form.kindService': "Service",
    'coupons.form.kindDigital': "Digital product",
    'coupons.form.kindOffer': "Offer",
    'coupons.form.draft': "Draft",
    'coupons.form.archived': "Archived",
    'coupons.form.duration': "On subscriptions",
    'coupons.form.durationHint': "How many charges get the discount when the purchase is billed monthly or yearly.",
    'coupons.form.duration.once': "First charge only",
    'coupons.form.duration.repeating': "Several months",
    'coupons.form.duration.forever': "Every charge",
    'coupons.form.months': "months",
    'coupons.form.limits': "Limits",
    'coupons.form.limitUses': "Limit the number of uses",
    'coupons.form.uses': "uses in total",
    'coupons.form.limitDate': "Set an expiration date",
    'coupons.form.limitMinimum': "Require a minimum purchase",
    'coupons.form.active': "Active",
    'coupons.form.activeHint': "A paused coupon is not accepted at checkout but keeps its settings.",
    'coupons.form.combinesWithMember': "Combine with member discount",
    'coupons.form.combinesOn': "Stacks with the member discount: members get both.",
    'coupons.form.combinesOff': "Doesn't stack: members get whichever saves more, the coupon or their discount.",
    'coupons.form.shareLink': "Link with the coupon applied",
    'coupons.form.copy': "Copy",
    'coupons.form.editWarning': "Already used {count} times. Changing the discount does not affect those purchases or subscriptions that already have it.",
    'coupons.form.errorCode': "The code needs 3 to 40 letters, numbers or dashes (no spaces or other symbols).",
    'coupons.form.errorPercent': "The percentage must be a whole number between 1 and 100.",
    'coupons.form.errorAmount': "Enter the discount amount.",
    'coupons.form.errorOffers': "Choose at least one offer, or apply it to all.",
    'coupons.form.errorMonths': "Months must be between 1 and 36.",
    'coupons.form.errorUses': "The use limit must be at least 1.",
    'coupons.form.errorDate': "The expiration date must be in the future.",
    'coupons.form.errorMinimum': "Enter the minimum purchase amount.",
    'coupons.form.cancel': "Cancel",
    'coupons.form.save': "Save changes",
    'coupons.form.create': "Create coupon",
    'coupons.form.saving': "Saving…",
    'nav.bookings': 'Bookings',
    'nav.bookingsCalendar': 'Appointments',
    'nav.activeAppointments': 'Active appointments: {count}',
    'nav.newItems': 'New items',
    'nav.analytics': 'Visits',
    'nav.salesAnalytics': 'Sales',
    'nav.bookingsAnalytics': 'Bookings',
    'nav.emails': 'Inbox',
    'nav.emailMarketing': 'Marketing',
    'nav.courses': 'Courses',
    'nav.users': 'Users',
    'nav.authCodes': 'Codes',
    'nav.siteTemplates': 'Templates',
    'nav.templates': 'Blocks',
    'nav.images': 'Images',
    // ── Breadcrumb: what each screen is called ────────────────────────────────
    /* The long name of a section, the one read in the top bar. It does not always
       match the menu, and it should not: inside the Bookings folder the row is
       called “Services” because the folder already says what they are, but the
       trail at the top has to stand on its own. */
    'section.overview': 'Dashboard',
    'section.contacts': 'Contacts',
    'section.pages': 'Pages',
    'section.cms': 'CMS',
    'section.analytics': 'Analytics',
    'section.forms': 'Forms',
    'section.emails': 'Inbox',
    'section.bookings': 'Scheduled services',
    'section.bookingsCalendar': 'Appointments',
    'section.bookingsList': 'Appointments',
    'section.business': 'Business information',
    'section.region': 'Region and currency',
    'section.policies': 'Policies',
    'section.emailMarketing': 'Marketing',
    'section.courses': 'Courses',
    'section.payments': 'All offers',
    'section.digitalProducts': 'Digital products',
    'section.physicalProducts': 'Physical products',
    'section.services': 'Services',
    'section.orders': 'Payments',
    'section.coupons': 'Coupons',
    'section.shipping': 'Shipping',
    'shipping.title': 'Shipping',
    'shipping.subtitle': 'Your orders to ship and how they get there: shipping options, countries and stock.',
    'shipping.tab.orders': 'Orders',
    'shipping.tab.settings': 'Settings',
    'shipping.orders.emptyTitle': 'No orders to ship yet',
    'shipping.orders.emptyBody': 'When someone buys a physical product, the order shows up here so you can pack it and ship it.',
    'shipping.loadFailed': 'Couldn’t load shipping',
    'shipping.loading': 'Loading shipping…',
    'shipping.rates.title': 'Shipping options',
    'shipping.rates.note': 'What buyers choose from at checkout. They apply to all your physical products.',
    'shipping.countries.title': 'Countries you ship to',
    'shipping.countries.note': 'Checkout only accepts addresses in these countries.',
    'shipping.countries.removeAria': 'Remove {name}',
    'shipping.countries.add': 'Add country',
    'shipping.stock.title': 'Stock',
    'shipping.stock.note': 'Each sale takes one unit off the product, if you set a stock for it.',
    'shipping.stock.restock': 'Restock on refund',
    'shipping.stock.restockHint': 'When you fully refund an order, the unit becomes available again.',
    'shipping.rate.pickupNoAddress': 'Pick up at the business',
    'shipping.rate.free': 'Free',
    'shipping.rate.freeOver': '{price} · free over {over}',
    'shipping.rate.defaultName': 'Standard shipping',
    'shipping.rate.pickupName': 'Local pickup',
    'shipping.rate.nameRequired': 'Give it a name: it’s what buyers see at checkout.',
    'shipping.rate.kind': 'Shipping type',
    'shipping.rate.flat': 'Ship',
    'shipping.rate.pickup': 'Pickup',
    'shipping.rate.name': 'Name',
    'shipping.rate.nameHint': 'How it shows at checkout, e.g. “Standard (3–5 days)”.',
    'shipping.rate.amount': 'Cost',
    'shipping.rate.amountHint': 'Leave it at zero for free shipping.',
    'shipping.rate.freeOverLabel': 'Free over',
    'shipping.rate.freeOverHint': 'Leave blank for no threshold. Orders that reach this amount ship free.',
    'shipping.rate.pickupAddress': 'Pickup location',
    'shipping.rate.pickupPlaceholder': 'Street address and opening hours',
    'shipping.rate.pickupHint': 'Included in the email that says the order is ready.',
    'shipping.rate.add': 'Add',
    'shipping.rate.save': 'Save',
    'shipping.rate.activeAria': 'Offer {name} at checkout',
    'shipping.rate.turnOff': 'Stop offering it',
    'shipping.rate.turnOn': 'Offer it at checkout',
    'shipping.rate.editAria': 'Edit {name}',
    'shipping.rate.edit': 'Edit',
    'shipping.rate.removeAria': 'Delete {name}',
    'shipping.rate.remove': 'Delete',
    'shipping.rate.addTitle': 'Add shipping option',
    'shipping.rate.full': 'You have {max} shipping options, the most checkout allows.',
    'section.payouts': 'Payouts',
    'section.salesAnalytics': 'Sales analytics',
    'section.bookingsAnalytics': 'Booking analytics',
    'section.team': 'Team',
    'section.config': 'Settings',
    'section.brand': 'Style',
    'section.general': 'Site settings',
    'section.publish': 'Domain',
    'section.usage': 'Usage and limits',
    'section.backups': 'Backups',
    'section.transfer': 'Transfer site',
    'section.stripe': 'Stripe',
    'section.googleAnalytics': 'Google Analytics',
    'section.omnisend': 'Omnisend',
    'section.calendars': 'Calendars',
    'config.desc.calendars': 'Google Calendar, Outlook and Apple: your bookings in your calendar and your busy times off the schedule.',
    'calset.description': 'Connect the calendar you already use. It’s set per team member, the same as from Bookings.',
    'calset.checking': 'Checking…',
    'calset.checkingBody': 'One moment.',
    'calset.failed': 'Could not load',
    'calset.failedBody': 'Try again in a moment.',
    'calset.retry': 'Try again',
    'calset.noServices': 'First, a bookable service',
    'calset.noServicesBody': 'Syncing is for Bookings appointments. Create a service with a schedule and come back here.',
    'calset.createService': 'Go to Bookings',
    'calset.connected': 'Calendars connected',
    'calset.connectedBody': 'Your bookings and busy times sync on their own.',
    'calset.notConnected': 'No calendars connected',
    'calset.emptyBody': 'Connect Google Calendar, Outlook or Apple to see your bookings there and stop selling times you’re already busy.',
    'calset.statusOk': 'Active',
    'calset.google': 'Google Calendar · {email}',
    'calset.feed': 'External calendar · {name}',
    'calset.export': 'Your bookings, published for your calendar',
    'calset.providers': 'Calendars you can connect',
    'calset.apple': 'Apple (iCloud)',
    'calset.google.name': 'Google Calendar',
    'calset.outlook': 'Outlook',
    'calset.manage': 'Manage',
    'calset.connect': 'Connect a calendar',
    'calset.whatTitle': 'What it does',
    'calset.what1': 'Every new booking shows up in your calendar, with the time and the customer.',
    'calset.what2': 'Times you’re already busy in your calendar stop being offered on the booking page.',
    'calset.what3': 'It’s per person: each team member connects their own.',
    'section.openTable': 'OpenTable',
    'config.desc.openTable': 'Connect your restaurant and every booking widget on the site will use it.',
    'otset.description': 'Connect your restaurant once and every OpenTable widget and button on the site will use that ID.',
    'otset.checking': 'Checking…',
    'otset.checkingBody': 'Reading the site settings.',
    'otset.connected': 'OpenTable connected',
    'otset.connectedBody': 'Your restaurant ({id}) is in every OpenTable widget on the site. In the editor the ID is locked.',
    'otset.notConnected': 'Not connected',
    'otset.emptyBody': 'Enter your restaurant ID. If your pages already have OpenTable widgets, they’ll switch to this one.',
    'otset.statusOk': 'Connected',
    'otset.idLabel': 'Your restaurant ID',
    'otset.changeId': 'Change the ID',
    'otset.placeholder': 'E.g. 1434817, or paste the widget code',
    'otset.detected': 'ID found: {id}.',
    'otset.notDetected': 'We couldn’t find an ID in what you pasted.',
    'otset.where': 'It’s in your OpenTable account, under the reservation widget.',
    'otset.openGuestCenter': 'Open Guest Center',
    'otset.connect': 'Connect',
    'otset.saveNew': 'Save the new ID',
    'otset.disconnect': 'Disconnect',
    'otset.confirmDisconnect': 'Yes, disconnect',
    'otset.cancel': 'Cancel',
    'otset.disconnectNote': 'Your existing widgets aren’t deleted: they go back to the ID each had, or ask for one.',
    'otset.saveFailed': 'Couldn’t save. Try again.',
    'otset.adminOnly': 'Only project admins can change this.',
    'otset.whatTitle': 'What connecting does',
    'otset.what1': 'OpenTable widgets you add in the editor come with your restaurant already set.',
    'otset.what2': 'The ones you already have switch to this ID, without touching each one.',
    'otset.what3': 'The “OpenTable” shortcut on buttons (like the navbar’s main button) comes pre-filled.',
    /* The screens that do not hang off a project: they sit above all of them and
       open from the user menu or from Admin. */
    'global.settings': 'Account',
    'global.billing': 'Billing',
    'global.domains': 'Domains',
    'global.authCodes': 'Codes',
    'global.plans': 'Plans',
    'global.usage': 'Account usage',
    'global.siteTemplates': 'Templates',
    'global.templates': 'Blocks',
    'global.images': 'Images',
    'global.users': 'Users',
    // ── Project frame: notices that belong to no section ──────────────────────
    'workspace.saveFailed': 'We could not save your latest changes. Reload before you keep editing.',
    'workspace.pagesSaveFailed': 'We could not save your latest page changes. Reload before you carry on.',
    'workspace.pageLimit': 'You have reached your plan’s page limit.',
    'workspace.pageDuplicated': 'Page duplicated',
    'workspace.renamePrompt': 'New page name',
    'workspace.nameUpdated': 'Name updated',
    'workspace.homeUpdated': 'Home page updated',
    'workspace.confirmDeletePage': 'Delete “{name}”? This cannot be undone.',
    'workspace.pageDeleted': 'Page deleted',
    'workspace.comingSoonBody': 'The navigation for this app is ready. Its content arrives in a later stage.',
    // ── Top bar ───────────────────────────────────────────────────────────────
    'topbar.openMenu': 'Open menu',
    'topbar.closeMenu': 'Close menu',
    'topbar.home': 'Go to home',
    /* The same in both languages, and still a key: the lint guard cannot tell a
       proper noun from a word nobody translated, and the exception list should
       only ever carry the brand. */
    'topbar.beta': 'Beta',
    'topbar.breadcrumbAria': 'Location',
    'topbar.projectFallback': 'Company',
    'topbar.saveChanges': 'Save changes',
    'topbar.unsavedChanges': 'Unsaved changes',
    // ── Dashboard search ──────────────────────────────────────────────────────
    'search.aria': 'Search the dashboard',
    'search.close': 'Close search',
    'search.placeholder': 'Search the dashboard…',
    'search.resultsAria': 'Results',
    'search.empty': 'Nothing found for “{query}”.',
    'search.contact': 'Contact',
    'search.contacts': 'Contacts',
    'search.offerActive': 'Active offer',
    'search.offer': 'Offer',
    // ── Project card, at the foot of the menu ─────────────────────────────────
    'sidebar.project.label': 'Project',
    'sidebar.project.aria': 'Project: {name}. Switch project',
    'sidebar.project.create': 'Create new',
    'sidebar.project.deleteSoon': 'Deleted soon',
    'sidebar.project.deleteToday': 'Deleted today',
    'sidebar.project.deleteOne': 'Deleted in 1 day',
    'sidebar.project.deleteMany': 'Deleted in {count} days',
    'sidebar.project.deletedFirstSoon': 'The first one, soon',
    'sidebar.project.deletedFirstToday': 'The first one, today',
    'sidebar.project.deletedFirstOne': 'The first one, in 1 day',
    'sidebar.project.deletedFirstMany': 'The first one, in {count} days',
    // ── Upgrade card ──────────────────────────────────────────────────────────
    'sidebar.upgrade.freeAria': 'Upgrade your plan',
    'sidebar.upgrade.freeTitle': 'Get more from your site',
    'planInvitation.domain': 'Use your own domain',
    'planInvitation.pages': 'Room for more pages',
    'planInvitation.branding': 'Remove the véltica badge',
    'planInvitation.notNow': 'Not now',
    'sidebar.upgrade.freeBody': 'Your own domain, more pages, and no véltica badge.',
    'sidebar.upgrade.freeCta': 'See plans',
    'sidebar.upgrade.dismissFree': 'Hide the upgrade invitation',
    'sidebar.upgrade.usageAria': 'Plan usage notice',
    'sidebar.upgrade.usageTitle': 'Your plan is running tight',
    'sidebar.upgrade.usageCta': 'Upgrade my plan',
    'sidebar.upgrade.dismissUsage': 'Hide the usage notice',
    /* One whole sentence per metric rather than “{percent}% of {metric}”.
       English would survive the placeholder; Spanish would not — it needs “del
       almacenamiento” but “de los envíos”, and one shared slot cannot say both.
       The pair stays in step this way. */
    'sidebar.upgrade.usage.storage': 'You have used {percent}% of the storage your plan includes.',
    'sidebar.upgrade.usage.bandwidth': 'You have used {percent}% of the bandwidth your plan includes.',
    'sidebar.upgrade.usage.forms': 'You have used {percent}% of the form submissions your plan includes.',
    'sidebar.upgrade.usage.ai': 'You have used {percent}% of the AI usage your plan includes.',
    // ── Dispute banner ────────────────────────────────────────────────────────
    'dispute.overdue': 'the deadline has passed',
    'dispute.dueToday': 'the deadline is today',
    'dispute.dueOne': '1 day left to respond',
    'dispute.dueMany': '{count} days left to respond',
    'dispute.many': '{count} disputed sales',
    'dispute.one': 'A {amount} charge was disputed',
    'dispute.manyDue': 'Most urgent: {due}.',
    'dispute.manyNoDue': 'Review them before their deadlines pass.',
    'dispute.oneDue': '{due} and defend “{offer}”.',
    'dispute.oneNoDue': 'Respond to defend “{offer}”.',
    'dispute.viewAll': 'View the disputes',
    'dispute.respond': 'Respond',
    // ── Notification bell ─────────────────────────────────────────────────────
    'notif.title': 'Notifications',
    'notif.bellAria': 'Notifications',
    'notif.bellAriaCount': 'Notifications ({count})',
    'notif.moreActions': 'More notification actions',
    'notif.clear': 'Clear notifications',
    'notif.loading': 'Checking for updates…',
    'notif.newOne': '1 new',
    'notif.newMany': '{count} new',
    'notif.allClear': 'All caught up',
    'notif.markRead': "Mark as read",
    'notif.markReadAria': "Mark “{title}” as read",
    'notif.markAllRead': "Mark all as read",
    'notif.emptyBody': 'You have no new notifications.',
    'notif.actionAria': '{action}: {title}',
    'notif.dismiss': 'Dismiss notification',
    'notif.dismissShort': 'Remove',
    'notif.dismissAria': 'Dismiss notification from {title}',
    'notif.billingTitle': 'We could not charge your subscription',
    'notif.billingBody': 'Your plan stays active while we retry, but it will be cancelled if the payment does not go through. Check the card to keep it.',
    'notif.billingAction': 'Update payment method',
    'notif.someoneWrote': 'Someone wrote',
    'notif.viewMessage': 'View message',
    'notif.saleTitle': '{amount} sale',
    'notif.deletedOffer': 'Deleted offer',
    'notif.viewSale': 'View sale',
    'notif.stockLow': 'Only {count} left of {name}',
    'notif.stockOut': '{name} is sold out',
    'notif.stockLowBody': 'Restock soon so you don’t miss sales.',
    'notif.stockOutBody': 'It shows as “Sold out” on your site until you restock.',
    'notif.refundFailed': 'Couldn’t refund {amount}',
    'notif.refundFailedBody': 'Refund it manually in Stripe',
    'notif.restock': 'Restock',
    'notif.inviteFrom': '{name} invited you to {project}',
    'notif.invite': 'You were invited to {project}',
    'notif.inviteBody': 'As {role}. It takes up a seat until you respond.',
    'notif.inviteAction': 'View invitation',
    'notif.transferFrom': '{name} wants to transfer {project} to you',
    'notif.transfer': 'Someone wants to transfer {project} to you',
    'notif.transferBody': 'The site would move to your account with its content and its domain.',
    'notif.transferAction': 'See what I get',
    'notif.authCodeTitle': 'Your transfer code is ready',
    'notif.authCodeAction': 'View the code',
    'notif.bookingCancelled': '{who} cancelled their appointment',
    'notif.bookingMoved': '{who} moved their appointment',
    'notif.bookingNew': '{who} booked an appointment',
    'notif.someClient': 'A customer',
    'notif.booking': 'Booking',
    'notif.viewBooking': 'View the appointment',
    'notif.viewNewTime': 'View the new time',
    // ── Search: what people call it when they look for it ─────────────────────
    /* Its own namespace rather than `section.*`, on purpose. The menu says what
       each place is called; this says what someone types when hunting for it, and
       the two part ways: the menu reads “Content” and this reads “Content (CMS)”,
       because whoever typed “cms” has to recognise it in the list. The synonyms it
       matches on do not live here — nobody reads those. See `dashboardSearch`. */
    'find.kind.destination': 'Go to',
    'find.kind.page': 'Pages',
    'find.kind.cms': 'Content',
    'find.kind.contact': 'Contacts',
    'find.kind.offer': 'Offers',
    'find.group.website': 'Website',
    'find.group.sales': 'Sales',
    'find.group.analytics': 'Analytics',
    'find.group.people': 'People',
    'find.group.account': 'Account',
    'find.group.apps': "Coming soon",
    'find.group.settings': 'Settings',
    'find.pages': 'Pages',
    'find.cms': 'Content (CMS)',
    'find.forms': 'Forms',
    'find.publish': 'Domain',
    'find.payments': 'All offers',
    'find.digitalProducts': 'Digital products',
    'find.physicalProducts': 'Physical products',
    'find.services': 'Services',
    'find.orders': 'Payments',
    'find.payouts': 'Payouts',
    'find.bookings': 'Scheduled services',
    'find.stripe': 'Stripe',
    'find.analytics': 'Visit analytics',
    'find.salesAnalytics': 'Sales analytics',
    'find.bookingsAnalytics': 'Booking analytics',
    'find.contacts': 'Contacts',
    'find.team': 'Team',
    'find.billing': 'Billing',
    'find.plans': 'Plans',
    'find.usage': 'Usage and limits',
    'find.settings': 'Account settings',
    'find.help': 'Help',
    'find.general': 'Site settings',
    'find.business': 'Business details',
    'find.policies': 'Policies',
    'find.region': 'Region and currency',
    'find.backups': 'Backups',
    'find.googleAnalytics': 'Google Analytics',
    // ── Settings: the index ───────────────────────────────────────────────────
    /* Card labels are not repeated here: they come from `section.*`, the same
       ones the breadcrumb writes. It is the one place in the dashboard where the
       index and the trail above name the same thing, and splitting them would let
       the two drift apart with nothing to catch it. */
    'config.title': 'Settings',
    'config.intro': 'Manage publishing, business details, legal compliance and the integrations of your site.',
    /* Shared by the settings frame, the index, and the screens that hang off it.
       It was called `settings.general.back` back when only one screen used it. */
    'config.back': 'Back to Settings',
    'config.open': 'Open',
    'config.group.site': 'Site and publishing',
    'config.group.business': 'Business and compliance',
    'config.group.integrations': 'Integrations',
    'config.desc.publish': 'Manage your site’s public address and the domains connected to it.',
    'config.desc.backups': 'Browse and restore saved versions of your content and settings.',
    'config.desc.usage': 'Keep an eye on the resources your plan includes.',
    'config.desc.brand': 'Pick the colors and typefaces used by your pages, your booking page and your emails.',
    'config.desc.general': 'Set the name, the icons, the time zone, access and the badge.',
    'config.desc.transfer': 'Hand the site over to another account, with everything it contains.',
    'config.stripeRows': 'In your Stripe account',
    'config.desc.business': 'Keep the tax details, address and contacts your legal documents need in one place.',
    'config.desc.region': 'Set the country, the currency you charge in, and the language of your legal documents.',
    'config.desc.policies': 'Manage your privacy, terms, refund and cancellation documents.',
    'config.desc.stripe': 'Connect and manage the account that processes your site’s payments.',
    'config.desc.omnisend': 'Send the contacts arriving through your site’s forms to your lists.',
    'config.desc.googleAnalytics': 'Connect your measurement ID and track the site in your Google Analytics property.',
    'config.stripe.none': 'Not connected',
    'config.stripe.pending': 'Setup pending',
    'config.stripe.restricted': 'Under review',
    'config.stripe.ready': 'Connected',
    'config.omnisend.invalid': 'The key stopped working',
    'config.omnisend.ok': 'Connected',
    'config.policies.noneWritten': 'None are written',
    'config.policies.unwritten': '{count} left to write',
    'config.policies.holesOne': '1 detail to fill in',
    'config.policies.holesMany': '{count} details to fill in',
    'config.policies.complete': 'Complete',
    'config.business.complete': 'Complete',
    'config.business.missing': '{count} details missing',
    // ── Settings › Business information ───────────────────────────────────────
    'business.title': 'Business information',
    /* Split in three because a link sits in the middle. A `{}` slot will not do:
       what goes inside is a button, not text. */
    'business.introBefore': 'Keep the tax, contact and location details your legal documents need in one place. Once saved,',
    'business.policiesTemplates': 'the Policies templates',
    'business.introAfter': 'can fill these in on their own.',
    'business.loading': 'Loading your business information',
    'business.loadFailedTitle': 'Could not load',
    'business.loadFailed': 'We could not load your information.',
    'business.retry': 'Try again',
    'business.saved': 'Information saved',
    'business.missingOne': '1 detail missing to sell',
    'business.missingMany': '{count} details missing to sell',
    'business.missingBody': 'Name, email and address are the minimum your customers need to know who you are and where to raise a claim. Anything marked optional can stay empty.',
    'business.fieldMissing': 'Still empty',
    'business.optional': 'Optional',
    'business.saveFailed': 'Could not save',
    'business.changeIn': 'Change it in',
    'business.regionPath': 'Settings → Region and currency',
    'business.identity.title': 'Legal and trading identity',
    'business.identity.note': 'How your business presents itself to customers and to the authorities.',
    'business.tradeName.label': 'Trading name',
    'business.tradeName.hint': 'The public name your customers know the business by.',
    'business.tradeName.placeholder': 'Business name',
    'business.legalName.label': 'Legal name',
    'business.legalName.hint': 'The name registered with the tax authority; it may be an individual’s name. If you leave it empty, the trading name is used.',
    'business.legalName.placeholder': 'Full name or registered company name',
    /* “RFC” is the Mexican name, and this dashboard started there. English gets
       the generic term: the field is the business tax identifier, whatever the
       country happens to call it. */
    'business.taxId.label': 'Tax ID',
    'business.taxId.label.mx': 'RFC (Mexican tax ID)',
    'business.taxId.label.es': 'NIF / CIF',
    'business.taxId.label.us': 'EIN / Tax ID',
    'business.taxId.hint': 'If you add it, it appears in your terms and conditions.',
    'business.taxId.placeholder': 'Tax identification number',
    'business.address.title': 'Address and jurisdiction',
    'business.address.note': 'The address goes into your privacy notice; the country and state decide which law applies.',
    'business.address.label': 'Full address',
    'business.address.hint': 'Street and number, district and postcode.',
    'business.address.placeholder': 'Street, number, district and postcode',
    'business.city.label': 'City',
    'business.city.placeholder': 'City',
    'business.state.label': 'State',
    'business.state.placeholder': 'State or province',
    'business.country.label': 'Country',
    'business.country.placeholder': 'Pick a country',
    'business.currency.label': 'Currency you charge in',
    'business.currency.placeholder': 'Pick a currency',
    'business.contact.title': 'Contact and privacy officer',
    'business.contact.note': 'Where customers reach you, and who handles requests about personal data.',
    'business.email.label': 'Contact email',
    'business.email.hint': 'The address that will receive requests about personal data.',
    'business.email.placeholder': 'Email address',
    'business.phone.label': 'Phone',
    'business.phone.placeholder': 'Phone number',
    'business.phone.hint': 'If you add it, it appears as another way to reach you in your policies.',
    'business.legalContact.label': 'Legal officer',
    'business.legalContact.hint': 'Who handles requests about personal data. If you leave it empty, the business owner answers them.',
    'business.legalContact.placeholder': 'Name of the person responsible',
    // ── Settings › Region and currency ────────────────────────────────────────
    'region.title': 'Region and currency',
    'region.intro': 'Set the country you operate in, the currency you charge in, and the language of your legal documents. These decide how amounts are written, which prices sync to Stripe, and the legal framework your templates cite.',
    'region.loading': 'Loading the setting',
    'region.loadFailedTitle': 'Could not load',
    'region.retry': 'Try again',
    'region.jurisdiction.title': 'Jurisdiction and regional format',
    'region.jurisdiction.note': 'Sets the legal framework of your documents and the format used for dates and amounts.',
    'region.country': 'Country',
    'region.profileNote': 'Your policy templates cite {note}.',
    'region.policiesChangeBefore': 'Changing the country changes the',
    'region.policiesLink': 'Policies templates',
    /* What each country’s templates cite. This lived in `lib/region.tsx`, written
       by hand in Spanish; the statute names do not translate — the LFPDPPP is
       called the LFPDPPP in English too — but the sentence around them does. */
    'region.profile.mx': 'the LFPDPPP, ARCO rights, INAI and PROFECO',
    'region.profile.es': 'the GDPR, the LOPDGDD and the Spanish Data Protection Agency',
    'region.profile.us': 'the US model: CCPA/CPRA rights, the FTC and your state attorney general',
    'region.profile.generic': 'no specific statute: they refer to “applicable law”, because we do not have templates written for your country yet',
    'region.currency.title': 'Charging currency',
    'region.currency.note': 'Sets the currency of every price on the site and of the prices synced to Stripe.',
    'region.currency.label': 'Currency',
    'region.currency.preview': 'Format preview:',
    'region.currency.warnOne': 'The currency will change on 1 offer.',
    'region.currency.warnMany': 'The currency will change on {count} offers.',
    'region.currency.keepsAmountLead': 'The number itself stays:',
    'region.currency.keepsAmount': 'a price of 1,200 will now read 1,200 {currency}. No exchange rate is applied. Check your prices after saving.',
    'region.currency.withStripe': 'Stripe will create new prices and retire the old ones. Recorded sales are untouched and active subscriptions keep their original currency.',
    'region.currency.withoutStripe': 'Stripe is not connected. The change applies in véltica first, and the prices will be created in {currency} once you connect the account.',
    'region.currency.mixed': 'There are currently prices in {codes}. On save, all of them will use the selected currency.',
    'region.language.title': 'Site language',
    'region.language.note': 'The language this business serves its customers in: the emails they get, the booking page, the checkout and the legal documents.',
    'region.language.label': 'Language',
    'region.language.hint': 'It does not change your dashboard language. You pick that in your user menu and it applies to all your projects. The available legal templates switch to this language; documents you have already edited are left alone.',
    'region.checkOffersBefore': 'After saving, check the amounts in',
    'region.saved': 'Setting saved',
    'region.repriced': 'Currency changed. {prices} prices across {offers} offers were relabelled.',
    'region.repricedPartial': '{prices} prices changed, but {failed} could not be pushed to Stripe. Check them in Offers.',
    'region.confirm.title': 'Change to {currency}',
    'region.confirm.button': 'Change the currency',
    'region.confirm.working': 'Changing…',
    'region.confirm.bodyOne': 'The prices of 1 offer are about to be relabelled{stripe}.',
    'region.confirm.bodyMany': 'The prices of {count} offers are about to be relabelled{stripe}.',
    'region.confirm.stripeTail': ', creating new prices in Stripe and retiring the old ones',
    'region.confirm.noConvertLead': 'The figure is not converted.',
    'region.confirm.noConvert': 'A price of 1,200 stays 1,200, now in {currency}. Check them afterwards in Offers.',
    // ── Settings › Policies ───────────────────────────────────────────────────
    /* Each document’s title and description are NOT here: the server sends them,
       written in the PROJECT’s language — `region.language` — which is the
       language that document is shown to the end customer in. Translating them to
       the dashboard language would put an English heading on top of a Spanish
       legal text. See `language.ts`. */
    'policies.title': 'Policies',
    'policies.intro': 'Manage the legal documents that govern the relationship between your business and your customers. Once published, they are linked automatically from the booking and payment pages.',
    'policies.loading': 'Loading your policies',
    'policies.loadFailedTitle': 'Could not load',
    'policies.loadFailed': 'We could not load your policies.',
    'policies.retry': 'Try again',
    'policies.noneTitle': 'No policies published',
    'policies.noneBody': 'Write and publish the documents you need so they are available on your site.',
    'policies.pendingOne': '1 policy pending',
    'policies.pendingMany': '{count} policies pending',
    'policies.pendingBody': 'Pending policies are not shown on the site. The easiest option is the automatic version: it writes itself from your business details.',
    'policies.live': 'Published',
    'policies.draft': 'Pending',
    'policies.unpublished': 'Not published',
    'policies.autoFoot': 'Automatic · updates itself with your business details',
    'policies.missingFields': 'To publish it, add: {fields}',
    'policies.completeBusiness': 'Complete in Business information',
    'policies.auto.title': 'Automatic version',
    'policies.auto.body': 'It writes itself from your business details and the country chosen in Region, and updates when you change them. If you edit the text, it becomes yours and stops updating.',
    'policies.empty.title': 'How do you want to create this policy?',
    'policies.empty.body': 'We recommend the automatic version: it is drafted from your business details, points to each service’s own conditions and keeps itself up to date. If you prefer, you can write your own from a template.',
    'policies.useAuto': 'Use the automatic version',
    'policies.autoOn': 'Automatic version turned on',
    'policies.restoreAuto': 'Go back to the automatic version',
    'policies.restoreAuto.title': 'Go back to the automatic version?',
    'policies.restoreAuto.body': 'Your text will be replaced by the automatic version, written from your business details. Any changes you made by hand will be lost.',
    'policies.restoreAuto.confirm': 'Use automatic',
    'policies.holesOne': '1 detail left in brackets: not published until filled in',
    'policies.holesMany': '{count} details left in brackets: not published until filled in',
    'policies.savedOn': 'Saved on {date}',
    'policies.willPublishAt': 'Will publish at {path}',
    'policies.copyLink': 'Copy link',
    'policies.openLink': 'Open link',
    'policies.edit': 'Edit',
    'policies.write': 'Write',
    'policies.disclaimerBefore': 'The templates are a starting reference and are not legal advice. They are adapted for',
    'policies.disclaimerCite': 'and refer to {note}',
    'policies.disclaimerChangeIn': '— change it in',
    'policies.disclaimerAfter': 'Review the content and consider getting professional advice before publishing. Your business is responsible for what they say.',
    'policies.back': 'Back to Policies',
    'policies.saved': 'Policy saved',
    'policies.withdrawn': 'Policy withdrawn',
    'policies.autoSwitch': 'Automatic',
    'policies.autoSwitchAria': 'Automatic version of {title}',
    'policies.autoOff': 'It’s yours now: the text no longer updates itself',
    'policies.languageNoteBefore': 'Your policies are written in {language}, your site’s language. To change the language of these pages, click',
    'policies.languageLink': 'Region › Language',
    'policies.saveFailed': 'Could not save',
    'policies.body.title': 'Policy content',
    'policies.body.noteBefore': 'Once saved, it will be available at',
    'policies.unsaved': 'Unsaved',
    'policies.startTemplate': 'Write my own from a template',
    'policies.useHours': 'Use {hours} h, like your service',
    'policies.viewLive': 'View published',
    'policies.fillOne': 'Won’t be published while 1 detail in brackets remains: {list}',
    'policies.fillMany': 'Won’t be published while {count} details in brackets remain: {list}',
    'policies.editorDisclaimer': 'This template is a starting reference and is not legal advice. Review the content before publishing; your business is responsible for what it says.',
    'policies.toolbar': 'Document formatting',
    'policies.editorAria': 'Policy content',
    'policies.format.paragraph': 'Paragraph',
    'policies.format.h1': 'Main heading',
    'policies.format.h1Short': 'Heading',
    'policies.format.h2': 'Subheading',
    'policies.format.bold': 'Bold',
    'policies.format.list': 'List',
    // ── Settings › Style ──────────────────────────────────────────────────────
    'brand.title': 'Brand',
    'brand.intro': 'Your site’s colors and typefaces. They are used on your pages, on your booking page, and in the emails we send your customers.',
    'brand.saveFailed': 'Could not save',
    'brand.loading': 'Loading your style…',
    'brand.saving': 'Saving…',
    'brand.savedState': 'Saved',
    'brand.logo.title': 'Logo',
    'brand.logo.note': 'Your mark, at the top of your booking page and in the emails your customers receive.',
    'brand.logo.light': 'On a light background',
    'brand.logo.dark': 'On a dark background',
    'brand.logo.empty': 'No logo',
    'brand.logo.change': 'Change',
    'brand.logo.add': 'Add',
    'brand.logo.remove': 'Remove',
    'brand.logo.fallback': 'The light one is used.',
    'brand.name.label': 'Brand name',
    'brand.name.placeholder': 'The name that sits beside the mark',
    'brand.name.show': 'Show the name next to the logo',
    'brand.colors.title': 'Colors',
    'brand.colors.note': 'The site’s nine. Changing them repaints headings, buttons, cards and borders across all your pages.',
    'brand.palettes.legend': 'Or start from a ready-made combination',
    'brand.fonts.title': 'Typefaces',
    'brand.fonts.note': 'One for headings and one for body text. This pair is used by every page.',
    'brand.fonts.headings': 'Headings',
    'brand.fonts.body': 'Body',
    /* A sample line, to see the typeface with real words. It is translated: in
       English you have to be able to judge how the letters fall in English. */
    'brand.fonts.sample': 'Text preview',
    'brand.editorNote': 'This is the same thing you edit in the editor: if you have it open in another tab, close it before changing the style here, or its next autosave will put its own values back.',
    // ── Notices the guard could not see ───────────────────────────────────────
    /* All of these sat hardcoded inside screens already listed as translated.
       They are not between tags — they live inside `showToast(…)` or a
       `confirm(…)` — so the lint rule never looked at them until it was widened
       to cover the calls that write on screen. */
    'common.discarded': 'Changes discarded',
    'common.listDate.today': 'Today at {time}',
    'common.listDate.yesterday': 'Yesterday at {time}',
    'common.pickImage': 'Pick an image file',
    'account.signedOut': 'Signed out.',
    'account.photoTooBig': 'The image has to be under 10 MB.',
    'account.codeResent': 'Code sent again.',
    'account.email.invalidFormat': 'Write a valid email address.',
    'account.email.alreadyYours': 'That is already your address.',
    'account.email.noMx': 'That domain does not receive email. Check the spelling.',
    'account.email.sentToCurrent': 'We sent a code to your current address.',
    'account.email.sentToNew': 'We sent a code to your new address.',
    'account.email.writeCode': 'Write the code we sent you.',
    'account.email.updated': 'Email updated. We closed your other sessions.',
    'account.providers.lastOne': 'At least one sign-in method has to remain.',
    'account.providers.disconnected': 'Provider disconnected.',
    'account.delete.codeSentToast': 'We sent a code to confirm.',
    'account.delete.badCode': 'That code is not valid, or it has expired.',
    'forms.statusFailed': 'The status could not be changed',
    'forms.deleted': 'Message deleted',
    'forms.deleteFailed': 'The message could not be deleted',
    'forms.bulkPartial': '{done} of {total} deleted',
    'forms.emailCopied': 'Email copied',
    'forms.emailCopyFailed': 'The email could not be copied',
    'settings.general.icons.tooBig': 'The icon has to be under 2 MB',
    'settings.general.icons.unreadable': 'That image could not be read',
    'pages.createFailed': 'The page could not be created',
    'home.deleted.done': 'Project deleted. You can recover it for {days} days.',
    'home.deleted.failed': 'The project could not be deleted',
    'home.restored': 'Project recovered',
    'home.restoreFailed': 'We could not recover the project',
    'home.template.confirmDelete': 'Delete “{name}”?',
    'home.template.confirmReset': 'Discard the unpublished changes to “{name}”? It will go back to the published version.',
    // ── Project dashboard: overview ───────────────────────────────────────────
    'overview.unlimited': 'Unlimited',
    'overview.ofLimit': 'of {limit}',
    'overview.resetsAt': 'Resets {when}',
    'overview.notes.placeholder': 'Write a note, to-do or jotting for the team…',
    'overview.notes.saveFailed': 'Could not save note.',
    'overview.notes.charsLeft': '{count} characters left',
    'overview.notes.title': 'Team notes',
    'overview.notes.meta': 'Collaborative log',
    'overview.notes.add': 'Post note',
    'overview.notes.edited': 'edited',
    'overview.notes.edit': 'Edit',
    'overview.notes.delete': 'Delete',
    'overview.notes.deleteConfirm': 'Delete note?',
    'overview.notes.save': 'Save',
    'overview.notes.cancel': 'Cancel',
    'overview.notes.you': 'You',
    'overview.notes.initialNote': 'Initial project note',
    'overview.notes.keyboardHint': '{key} + Enter to post',
    'overview.notes.editHint': '{key} + Enter to save · Esc to cancel',
    'overview.notes.full': 'This project\'s notes are at their limit. Delete one to keep writing.',
    'overview.notes.unnamed': 'Team member',
    'overview.setup.aria': 'Project first steps',
    'overview.setup.eyebrow': 'First steps',
    'overview.setup.title': 'Get your site ready to publish',
    'overview.setup.prev': "Previous steps",
    'overview.setup.next': "Next steps",
    'overview.setup.leftOne': '1 left',
    'overview.setup.leftMany': '{count} left',
    'overview.setup.progress': '{done} of {total}',
    'overview.setup.done': 'Done',
    'overview.openLink': 'Open link',
    'overview.empty': 'Nothing here yet.',
    'overview.createNew': 'Create new',
    'overview.new': 'New',
    'overview.summary.title': 'Visits',
    'overview.last30': 'Last 30 days',
    'overview.stat.views': 'Views',
    'overview.stat.uniques': 'Unique visitors',
    'overview.stat.countries': 'Countries',
    'overview.stat.topPage': 'Most popular page',
    'overview.sales.title': 'Sales',
    'overview.stat.revenue': 'Net revenue',
    'overview.stat.orders': 'Sales',
    'overview.stat.aov': 'Average order',
    'overview.stat.customers': 'Customers',
    'overview.chart.revenue': 'Revenue',
    'overview.site.aria': 'Published site',
    'overview.site.unpublished': 'Not published. Your changes are not online yet.',
    'overview.site.openHomeAria': 'Open the published home page',
    'overview.site.view': 'View site',
    'overview.site.openEditor': 'Open in Editor',
    'overview.card.pages': 'Pages',
    'overview.card.cms': 'Content (CMS)',
    'overview.card.bookings': 'Upcoming appointments',
    'overview.card.offers': "Catalogue",
    'overview.card.contacts': 'Contacts',
    'overview.card.forms': 'Forms',
    'overview.card.transactions': 'Transactions',
    'overview.card.toShip': 'To ship',
    'overview.payouts.title': 'Payouts',
    'overview.payouts.meta': 'What reaches your bank',
    'overview.payouts.available': 'Available',
    'overview.payouts.onTheWay': 'On the way',
    'overview.usage.title': 'Plan usage',
    'overview.usage.pages': 'Pages',
    'overview.usage.collections': 'Collections',
    'overview.usage.cmsItems': 'CMS items',
    'overview.usage.offers': "Published offers",
    'overview.usage.contacts': 'Contacts',
    'overview.usage.ai': 'AI-generated sites',
    'overview.usage.forms': 'Forms',
    'overview.domain.title': 'Domain and SSL',
    'overview.domain.none': 'No custom domain.',
    'overview.domain.yourSubdomain': 'your Veltica subdomain',
    'overview.domain.primary': 'primary',
    'overview.domain.getDomain': 'Get a domain',
    'overview.noVisits': 'No visits yet',
    'overview.noSales': 'No sales yet',
    'overview.noSalesHint': 'When someone buys on your site, this is where you will see how much you made and how it compares with last month.',
    'overview.viewAnalytics': 'View full analytics',
    'overview.viewSalesAnalytics': 'View sales analytics',
    'overview.viewDetail': 'View details',
    'overview.manage': 'Manage',
    'overview.ssl.ready': 'SSL ready',
    'overview.ssl.pending': 'SSL pending',
    // ── Forms inbox ───────────────────────────────────────────────────────────
    'forms.loadingMessage': 'Loading the message',
    'forms.loadingList': 'Loading your submissions',
    'forms.backToForms': 'Back to forms',
    'forms.detail.email': 'Email',
    'forms.detail.copyEmailAria': 'Copy the sender’s email',
    'forms.detail.notProvided': 'Not provided',
    'forms.detail.received': 'Received',
    'forms.detail.sourcePage': 'Source page',
    'forms.detail.copyUrlAria': 'Copy the source page URL',
    'forms.detail.noSource': 'Not available for this submission',
    'forms.detail.status': 'Status',
    'forms.detail.openProfile': 'Open profile',
    'forms.detail.markRead': 'Mark as read',
    'forms.detail.markUnread': 'Mark as unread',
    'forms.detail.reply': 'Reply',
    'forms.detail.delete': 'Delete message',
    'forms.detail.noAnswers': 'This submission came in with no answers.',
    'forms.delete.body': 'This message and every answer in it will be permanently deleted. This cannot be undone.',
    'forms.title': 'Forms',
    'forms.searchAria': 'Search submissions',
    'forms.searchPlaceholder': 'Search submissions…',
    'forms.clearSearch': 'Clear search',
    'forms.starred': 'starred',
    'forms.filtersAria': 'Filters and sorting',
    'forms.filtersDialogAria': 'Form filters and sorting',
    'forms.filterTitle': 'Filter submissions',
    'forms.filterForm': 'Form',
    'forms.filterByFormAria': 'Filter by form',
    'forms.allForms': 'All forms',
    'forms.filterStarred': 'Starred',
    'forms.filterStatus': 'Status',
    'forms.status.all': 'All',
    'forms.status.unread': 'New',
    'forms.status.read': 'Read',
    'forms.resetFilters': 'Reset filters',
    'forms.exportCsv': 'Export CSV',
    'forms.exportCsvAria': 'Export submissions to CSV',
    /* Las columnas del CSV de envíos. Se traducen porque el archivo lo abre
       quien lo descarga, en su idioma, no el programa. */
    'forms.csv.filename': 'form-submissions',
    'forms.csv.date': 'Date',
    'forms.csv.form': 'Form',
    'forms.csv.name': 'Name',
    'forms.csv.email': 'Email',
    'forms.csv.status': 'Status',
    'forms.csv.answers': 'Answers',
    'forms.csv.page': 'Page',
    'forms.csv.statusUnread': 'New',
    'forms.csv.statusRead': 'Read',
    'forms.csv.statusSpam': 'Spam',
    'forms.loadFailed': 'We could not load the forms.',
    'forms.emptyTitle': 'No submissions yet',
    'forms.emptyBody': 'Messages will show up here when someone fills in a form on your site.',
    'forms.noResultsTitle': 'No submissions found',
    'forms.noResultsBody': 'Try another search, or clear the filters.',
    'forms.clearFilters': 'Clear filters',
    'forms.col.contact': 'Contact',
    'forms.col.form': 'Form',
    'forms.col.date': 'Date',
    'forms.col.actions': 'Actions',
    'forms.viewForm': 'View submission',
    'forms.moreOptions': 'More options',
    'forms.openForm': 'Open submission',
    'forms.unspam': 'Not spam',
    'forms.markSpam': 'Mark as spam',
    'forms.copyEmail': 'Copy email',
    'forms.card.submission': 'Submission',
    'forms.card.actions': 'Actions',
    'forms.card.answers': 'Answers',
    'forms.closeFilters': 'Close filters',
    'forms.onlyStarred': 'Starred only',
    // ── Project pages ─────────────────────────────────────────────────────────
    'pages.creating': 'Creating page…',
    'pages.bulkDelete.aria': 'Delete pages',
    'pages.bulkDelete.titleOne': 'Delete 1 page?',
    'pages.bulkDelete.titleMany': 'Delete {count} pages?',
    'pages.bulkDelete.body': 'The selected pages and their content will be deleted. The home page is left alone.',
    'pages.undone': 'This cannot be undone.',
    'pages.cancel': 'Cancel',
    'pages.confirmDelete': 'Yes, delete',
    'pages.delete.aria': 'Delete page',
    'pages.delete.title': 'Delete this page?',
    'pages.delete.body': 'You are about to delete {name}.',
    'pages.delete.thisPage': 'this page',
    'pages.delete.confirmBody': 'You are about to delete “{name}”. This cannot be undone.',
    'pages.title': 'Pages',
    'pages.searchAria': 'Search pages',
    'pages.searchPlaceholder': 'Search pages…',
    'pages.clearSearch': 'Clear search',
    'pages.starred': 'starred',
    'pages.filtersAria': 'Filters and sorting',
    'pages.filtersDialogAria': 'Page filters and sorting',
    'pages.filterTitle': 'Filter pages',
    'pages.closeFilters': 'Close filters',
    'pages.filterType': 'Type',
    'pages.type.all': 'All',
    'pages.type.home': 'Home page',
    'pages.filterStarred': 'Starred',
    'pages.onlyStarred': 'Starred only',
    'pages.resetFilters': 'Reset filters',
    'pages.newAria': 'New page',
    'pages.new': 'New page',
    'pages.newShort': 'New',
    'pages.emptyTitle': 'No pages yet',
    'pages.emptyBody': 'Create your first page to start building the site.',
    'pages.createPage': 'Create page',
    'pages.noResultsTitle': 'No pages found',
    'pages.noResultsBody': 'Try another search, or change the filters.',
    'pages.clearFilters': 'Clear filters',
    'pages.col.name': 'Name',
    'pages.col.created': 'Created',
    'pages.col.updated': 'Last edited',
    'pages.col.actions': 'Actions',
    'pages.homeAria': 'Home page',
    'pages.nameAria': 'Page name',
    'pages.openEditor': 'Open in Editor',
    'pages.open': 'Open',
    'pages.menu.openEditor': 'Open in editor',
    'pages.menu.settings': 'Settings',
    'pages.menu.stats': 'Stats',
    'pages.menu.preview': 'Preview',
    'pages.menu.openPublished': 'Open published',
    'pages.menu.copyLink': 'Copy link',
    'pages.menu.duplicate': 'Duplicate',
    'pages.menu.rename': 'Rename',
    'pages.menu.setHome': 'Set as home',
    'pages.menu.delete': 'Delete',
    // ── Domain and publishing ─────────────────────────────────────────────────
    'publish.terms': 'Terms and conditions',
    'publish.privacy': 'Privacy policy',
    'publish.copy': 'Copy',
    'publish.title': 'Domain',
    'publish.dns.pointing': 'The domain already points to véltica. The SSL certificate will be issued in a few minutes and the status will update on its own.',
    'publish.dns.wrongTarget': 'It currently points to {found}, but it needs to point to {expected}. Update the Value field at your provider.',
    'publish.dns.managedBy': 'This domain’s DNS is managed by {provider}. Add the record from there.',
    'publish.dns.notFound': 'The required record was not found. Check that it is saved at the provider managing this domain’s DNS.',
    'publish.active.aria': 'Active addresses',
    'publish.active.title': 'Active addresses',
    'publish.testMode': 'Test mode: custom domains connect instantly and do not actually resolve.',
    'publish.badge.active': 'Active',
    'publish.badge.ssl': 'SSL active',
    'publish.badge.primary': 'Primary',
    'publish.makePrimary': 'Make primary',
    'publish.loadingDomains': 'Loading domains…',
    'publish.reconnecting': 'Reconnecting…',
    'publish.reconnect': 'Reconnect',
    'publish.dnsAndTransfer': 'DNS and transfer',
    'publish.disconnect': 'Disconnect',
    'publish.renewal': 'The registration expires on {date}.',
    'publish.billing': 'Billing',
    'publish.registering': 'The domain is being registered in your name. When that finishes, it will connect to the site automatically.',
    'publish.awaitingCert': 'The domain is already connected to the site. You do not need to change any DNS; only the certificate is left. The status will change to SSL active on its own.',
    'publish.completeConnection': 'Finish connecting',
    'publish.addRecords': 'Add these records at your DNS provider. The SSL certificate is issued once the domain points to véltica.',
    'publish.dns.type': 'Type',
    'publish.dns.name': 'Name',
    'publish.dns.value': 'Value',
    'publish.rootDomainNote': 'Yours is a root domain: if your provider does not allow CNAME at the root, use an ALIAS/ANAME record with the same value, or connect www.{hostname} instead.',
    'publish.propagation': 'Propagation can take a few minutes. The status will change to SSL active on its own, and you can also ask for another check.',
    'publish.checking': 'Checking…',
    'publish.retry': 'Retry',
    'publish.autoChecked': 'The status is checked automatically every few seconds.',
    'publish.viewAllDomains': 'View all your domains',
    'publish.owned.aria': 'Domains you already own',
    'publish.owned.title': 'Domains you already own',
    'publish.owned.note': 'You bought these here and they are not connected to any site. You can use one for this one.',
    'publish.connecting': 'Connecting…',
    'publish.connect': 'Connect',
    'publish.expiresOn': 'The registration expires on {date}.',
    'publish.search.aria': 'Connect your own domain',
    'publish.search.placeholder': 'yourbusiness',
    'publish.search.inputAria': 'Domain name, dot com',
    'publish.search.searching': 'Searching…',
    'publish.search.button': 'Search',
    'publish.search.checking': 'Checking availability…',
    'publish.search.testPrices': 'Test mode: the prices shown are real, but no purchase will be made.',
    'publish.credit.applied': '{amount} of credit from your yearly plan is applied. After that, {price} a year.',
    'publish.credit.yearlyIncludes': 'The yearly plan includes {amount} of credit towards your first year of domain. After that, {price} a year.',
    'publish.perYear': '/yr',
    'publish.openingPayment': 'Opening payment…',
    'publish.buyDomain': 'Buy domain',
    'publish.connectWithPro': 'Connect it with Pro',
    'publish.isItYours': 'Already yours? Connect it',
    'publish.unavailableCheck': 'We could not check availability ({reason}). The prices shown are still valid.',
    'publish.extensionsFor': 'Extensions available for {term}.',
    'publish.freeWithPlan': 'Free with your plan',
    'publish.freeWithYearly': 'Free with the yearly plan',
    'publish.wizard.enterDomain': 'Enter your domain',
    'publish.wizard.domainPlaceholder': 'www.yourcompany.com',
    'publish.wizard.rootOrSub': 'You can connect the root domain ({root}) or a subdomain ({sub}).',
    'publish.wizard.pickProvider': 'Choose your domain provider',
    'publish.wizard.pickProviderHint': 'Tell us the provider so we can open its DNS settings for you.',
    'publish.wizard.addRecordAt': 'Add this record at {registrar}',
    'publish.wizard.addRecordHint': 'Open the DNS settings and add the record below. Under Name/Host, use only the value shown.',
    'publish.wizard.goTo': 'Go to {registrar}',
    'publish.wizard.verify': 'Check the connection',
    'publish.wizard.verifyHint': 'Once you have saved the record, start the check. We will validate the DNS and issue the SSL certificate automatically.',
    'publish.wizard.back': 'Back',
    'publish.wizard.verifyAndConnect': 'Check and connect',
    'publish.noDomainYet': 'Do not have one yet?',
    'publish.findNew': 'Find a new one',
    'publish.startOver': 'Start over',
    'publish.alreadyRegistered': 'Already registered one?',
    'publish.connectMine': 'Connect mine',
    'publish.cancelConnection': 'Cancel the connection?',
    'publish.disconnectDomain': 'Disconnect domain?',
    'publish.buyTerms': 'By buying you accept our',
    'publish.and': 'and our',
    'publish.oneYearNotice': 'The registration lasts one year. We will let you know before it expires.',
    'publish.wizard.continue': 'Continue',
    'publish.wizard.change': 'Change',
    'publish.wizard.next': 'Next',
    'publish.description': 'The site will be reachable at every active address. Secondary ones redirect to the primary.',
    'publish.genericError': 'Something went wrong. Try again.',
    'publish.invalidDomain': 'Enter a valid domain, for example www.yourcompany.com.',
    'publish.purchaseIncomplete': 'Your domain was registered, but we could not finish connecting it. It is listed below with the details. Do not buy it again.',
    'publish.siteFor': 'Site for {domain}',
    'publish.checkout.description': 'Registration and automatic connection of the domain to your site.',
    'publish.checkout.feature.owned': 'The domain is registered in your name and can be transferred later',
    'publish.checkout.feature.auto': 'The connection to the site is set up automatically',
    'publish.checkout.feature.ssl': 'Security certificate (HTTPS) included',
    'publish.checkout.feature.notice': 'The expiration date is always visible',
    'publish.checkout.unit': 'USD/yr',
    'publish.checkout.billed': 'One year of registration · ${price} USD today',
    'publish.checkout.back': 'Back to search',
    'publish.status.purchasing': 'Registering the domain…',
    'publish.status.pendingDns': 'Waiting for DNS…',
    'publish.status.verifying': 'Verifying…',
    'publish.status.active': 'SSL active',
    'publish.status.error': 'Check the settings',
    'publish.status.disconnected': 'Not connected',
    'publish.status.processing': 'Processing…',
    'publish.diagnosis.ok': 'DNS verified: issuing the certificate',
    'publish.diagnosis.wrongTarget': 'The domain points to a different target',
    'publish.diagnosis.notFound': 'DNS record not detected',
    'publish.subdomain.unpublished': 'Not published',
    'publish.subdomain.includedRedirect': 'Included with véltica · redirects to your primary domain',
    'publish.subdomain.included': 'Included with véltica',
    'publish.hero.searchTitle': 'Find a domain for your site',
    'publish.hero.connectTitle': 'Connect your domain',
    'publish.search.checkingDomain': 'Checking {domain}',
    'publish.search.checkingSelected': 'Checking the selected domain',
    'publish.availability.available': 'Available',
    'publish.availability.unknown': 'We could not check availability',
    'publish.availability.premium': 'Premium domain: it cannot be bought through véltica',
    'publish.availability.taken': 'Already registered',
    'publish.bump.freeFirstYear': 'Free the first year',
    'publish.bump.withCredit': 'With your credit',
    'publish.bump.coveredByYearly': 'covered by your yearly plan',
    'publish.bump.freeWithYearly': 'Free with the yearly plan',
    'publish.bump.cheaperWithYearly': 'Cheaper with the yearly plan',
    'publish.bump.firstYear': 'the first year',
    'publish.bump.priceFirstYear': '{price} the first year',
    'publish.creditSpent': 'You already used your plan’s domain credit',
    'publish.needsPaidPlan': 'Connecting your own domain requires the Pro or Business plan',
    'publish.getWithYearly': 'Get it with the yearly plan',
    'publish.buyWithPro': 'Buy with Pro',
    'publish.alt.unavailable': 'Unavailable',
    'publish.alt.checkOnSelect': 'Price shown when you pick it',
    'publish.alt.perYear': '{price} /yr',
    'publish.cancelMessage': 'The information entered in this wizard will be discarded. You can start the process again whenever you need to.',
    'publish.cancelConfirm': 'Cancel connection',
    'publish.cancelDismiss': 'Continue setup',
    'publish.disconnect.ownedMessage': '{hostname} will stop directing traffic to the site, but it stays yours until its renewal: it remains in the list and you can reconnect it whenever you want. The site will still be reachable at its véltica address.',
    'publish.disconnect.externalMessage': '{hostname} will stop directing traffic to the site and will leave the list. You can connect it again whenever you want. The site will still be reachable at its véltica address.',
    'publish.disconnect.confirm': 'Disconnect',
    'publish.disconnect.cancel': 'Cancel',
    // ── Project team ──────────────────────────────────────────────────────────
    'team.role.includes': 'Includes',
    'team.role.excludes': 'Does not include',
    'team.ownerOnly': 'Deleting or transferring the project, and managing who belongs to it, are the owner’s alone.',
    'team.pickRoleAria': 'Choose role',
    'team.inviteSentTo': 'Invitation sent to {email}',
    'team.title': 'Team',
    'team.introShort': 'Manage who is on the project and what they can do.',
    'team.intro': 'Manage the people working on this project and what each of them can do. Permissions apply to this site only.',
    'team.loading': 'Loading members and permissions…',
    'team.membersTitle': 'Members with access',
    'team.membersHint': 'The owner keeps overall control. To change that, the project has to be transferred.',
    'team.leaveAria': 'Leave this project',
    'team.invitesTitle': 'Pending invitations ({count})',
    'team.invitesHint': 'Each invitation holds a seat until it is accepted, cancelled, or expires.',
    'team.expiresInOne': 'Expires in 1 day',
    'team.expiresInDays': 'Expires in {days} days',
    'team.inviteTitle': 'Invite someone',
    'team.inviteHint': 'We will email them so they can join this project with the role you pick.',
    'team.emailLabel': 'Their email',
    'team.emailPlaceholder': 'name@company.com',
    'team.roleLabel': 'Role',
    'team.rolePlaceholder': 'Pick a role',
    'team.inviteSent': 'Invitation sent',
    'team.inviteSentHint': 'If it does not reach them, share this link directly. For security, it is shown only once.',
    'team.rolesTitle': 'Role reference',
    'team.rolesHint': 'Check what each role covers before assigning it.',
    'team.leave.body': 'You will lose access to {project} right away. To work on it again, someone else will have to invite you.',
    'team.remove.body': '{name} will lose access to this project right away. Restoring it means sending and accepting a new invitation.',
    'team.cancelInvite.body': 'The link sent to {name} will stop working and the seat frees up. You can invite someone again later.',
    'team.workStays': 'Your content and the changes you made stay in the project.',
    // ── Analytics ─────────────────────────────────────────────────────────────
    'analytics.title': 'Analytics',
    'analytics.subtitle': 'The numbers that matter for your site.',
    'analytics.last30': 'Last 30 days',
    'analytics.emptyTitle': 'No visits yet',
    'analytics.emptyBody': 'Visits to your published site will show up here. They are counted on the server, with nothing to install.',
    'analytics.pageViews': 'Page views',
    'analytics.uniqueVisitors': 'Unique visitors',
    'analytics.countries': 'Countries',
    'analytics.topPage': 'Most popular page',
    'analytics.viewsByCountry': 'Views by country',
    'analytics.topPages': 'Top pages',
    'analytics.trafficSources': 'Traffic sources',
    'analytics.devices': 'Devices',
    'analytics.campaigns': 'Campaigns',
    'analytics.unknownCountry': 'Unknown',
    // ── Contenido (CMS) ───────────────────────────────────────────────────────
    'cms.title': 'Content (CMS)',
    'cms.subtitle': 'Manage the collections and dynamic content of your site.',
    'cms.usage.collections': 'Collections',
    'cms.usage.items': 'Items',
    'cms.searchAria': 'Search collections',
    'cms.searchPlaceholder': 'Search collections…',
    'cms.clearSearch': 'Clear search',
    'cms.starred': 'starred',
    'cms.filtersAria': 'Filters and sorting',
    'cms.filtersDialogAria': 'Collection filters and sorting',
    'cms.filterTitle': 'Filter collections',
    'cms.closeFilters': 'Close filters',
    'cms.filterContent': 'Content',
    'cms.filter.all': 'All',
    'cms.filter.withItems': 'With items',
    'cms.filter.empty': 'Empty',
    'cms.filterStarred': 'Starred',
    'cms.allStars': 'All',
    'cms.onlyStarred': 'Starred only',
    'cms.resetFilters': 'Reset filters',
    'cms.newAria': 'New collection',
    'cms.new': 'New collection',
    'cms.newShort': 'New',
    'cms.emptyTitle': 'No collections yet',
    'cms.emptyBody': 'A collection holds content that repeats with the same shape: your blog, your services, your team.',
    'cms.emptyCta': 'Create one in the editor',
    'cms.noResultsTitle': 'No collections found',
    'cms.noResultsBody': 'Try another name, description or filter.',
    'cms.clearFilters': 'Clear filters',
    'cms.unit': 'collections',
    'cms.col.name': 'Name',
    'cms.col.url': 'URL',
    'cms.col.status': 'Status',
    'cms.col.created': 'Created',
    'cms.col.updated': 'Last edited',
    'cms.col.items': 'Items',
    'cms.col.actions': 'Actions',
    'cms.selectAll': 'Select everything on this page',
    'cms.deselectAll': 'Clear the selection',
    'cms.starOne': 'Star {name}',
    'cms.itemCount': '{count} items',
    'cms.showContent': 'Show content',
    'cms.showContentShort': 'Show',
    'cms.openInEditor': 'Open in Editor',
    'cms.viewPublished': 'View published',
    'cms.copyLink': 'Copy link',
    'cms.copyUrl': 'Copy URL',
    'cms.open': 'Open',
    'cms.linkCopied': 'Link copied',
    'cms.moreOptions': 'More options',
    'cms.options': 'Options',
    'cms.delete': 'Delete',
    'cms.deleting': 'Deleting…',
    'cms.cancel': 'Cancel',
    'cms.untitled': 'Untitled',
    'cms.backToCollections': "Back to content",
    'cms.deleteCollection': 'Delete collection',
    'cms.delete.title': 'Delete “{name}”?',
    'cms.delete.confirm': 'Delete everything',
    'cms.delete.body': 'The collection will be deleted along with its site page. This cannot be undone.',
    'cms.delete.willDeleteOne': '1 item will be deleted:',
    'cms.delete.willDeleteMany': '{count} items will be deleted:',
    'cms.delete.andMore': 'and {count} more…',
    'cms.delete.noItems': 'This collection has no items.',
    'cms.collectionDeleted': 'Collection “{name}” deleted',
    /* El nombre del cupo, tal y como lo lee el aviso de plan lleno: «Llegaste al
       máximo de colecciones de tu plan Pro». */
    'cms.limit.collections': 'collections',
    'cms.limit.items': 'items',
    /* La vigencia de una ficha con fechas. Sale de `SCHEDULE_STATE_LABELS`, que
       lo tenía fijo en español dentro de `@webbuilder/shared-types`. */
    'cms.schedule.upcoming': 'Upcoming',
    'cms.schedule.current': 'Running',
    'cms.schedule.past': 'Ended',
    // ── Contenido (CMS): los elementos de una colección ───────────────────────
    'cms.item.subtitle': 'Manage the items in this collection.',
    'cms.item.searchAria': 'Search items',
    'cms.item.searchPlaceholder': 'Search items…',
    'cms.item.starred': 'starred',
    'cms.item.filtersDialogAria': 'Item filters and sorting',
    'cms.item.filterTitle': 'Filter items',
    'cms.item.filterStatus': 'Status',
    'cms.item.status.all': 'All',
    'cms.item.status.published': 'Published',
    'cms.item.status.draft': 'Drafts',
    'cms.item.filterStarred': 'Starred',
    'cms.item.allStars': 'All',
    'cms.item.onlyStarred': 'Starred only',
    'cms.item.newAria': 'New item',
    'cms.item.new': 'New item',
    'cms.item.newShort': 'New',
    'cms.item.bulkDelete.titleOne': 'Delete 1 item',
    'cms.item.bulkDelete.titleMany': 'Delete {count} items',
    'cms.item.bulkDelete.body': 'The selected items will be deleted from this collection. This cannot be undone.',
    'cms.item.bulkDeleted.one': '1 item deleted',
    'cms.item.bulkDeleted.many': '{count} items deleted',
    'cms.item.emptyTitle': 'This collection is empty',
    'cms.item.emptyBody': 'Each item is one entry in the collection: a post, a product, a team member.',
    'cms.item.emptyCta': 'Create item',
    'cmsEmpty.blogBody': "The template is showing sample text. Write your first post to see it with your own content.",
    'cmsEmpty.blogCta': "Write a post",
    'cmsEmpty.itemsBody': "The template is showing sample text. Create the first item to see it with your content.",
    'cmsEmpty.services.title': "No services yet",
    'cmsEmpty.services.body': "This template is showing sample text. Create your first service to see it with your own content.",
    'cmsEmpty.services.cta': "Create a service",
    'cmsEmpty.bookings.title': "No booking services yet",
    'cmsEmpty.bookings.body': "This template is showing sample text. Create your first booking service to see it with your own content.",
    'cmsEmpty.bookings.cta': "Create a booking service",
    'cmsEmpty.digital.title': "No digital products yet",
    'cmsEmpty.digital.body': "This template is showing sample text. Create your first digital product to see it with your own content.",
    'cmsEmpty.digital.cta': "Create a digital product",
    'cmsEmpty.products.title': "No physical products yet",
    'cmsEmpty.products.body': "This template is showing sample text. Create your first physical product to see it with your own content.",
    'cmsEmpty.products.cta': "Create a physical product",
    'cms.item.noResultsTitle': 'No items found',
    'cms.item.noResultsBody': 'Try another name, slug or filter.',
    'cms.item.unit': 'items',
    'cms.item.selectOne': 'Select {name}',
    'cms.item.starOne': 'Star {name}',
    /* Para las fichas sin título, que las hay mientras se escriben. */
    'cms.item.thisItem': 'this item',
    'cms.item.noUrl': 'No URL',
    'cms.item.noUrlYet': 'No address yet',
    'cms.item.copyUrlAria': 'Copy the URL of {name}',
    'cms.item.openAria': 'Open {name} in a new tab',
    'cms.item.published': 'Published',
    'cms.item.draft': 'Draft',
    'cms.item.edit': 'Edit content',
    'cms.item.editShort': 'Open',
    'cms.item.seo': 'SEO',
    'cms.item.duplicate': 'Duplicate',
    'cms.item.deleted': 'Item deleted',
    /* Va en el título de la copia y en su slug: «Pricing (copy)» y
       «pricing-copy». Por eso una sola palabra y sin paréntesis. */
    'insert.groupInFolders': 'Group into folders',
    'insert.showAll': 'Show everything open',
    'common.copySuffix': '(copy)',
    'cms.item.copySuffix': 'copy',
    // ── Contenido (CMS): el SEO de un elemento ────────────────────────────────
    'cms.seo.back': 'Back to the items',
    'cms.seo.heading': 'SEO · {title}',
    'cms.seo.save': 'Save',
    'cms.seo.section': 'Item SEO',
    'cms.seo.titleLabel': 'Search engine title',
    'cms.seo.titlePlaceholder': '60 characters recommended, at most',
    'cms.seo.titleCount': '{count} / 60 characters',
    'cms.seo.descLabel': 'Meta description',
    'cms.seo.descPlaceholder': 'Describe this item…',
    'cms.seo.descCount': '{count} / 160 characters',
    'cms.seo.imageLabel': 'Social image (1200×630px)',
    'cms.seo.imageAlt': 'Social image for this item',
    'cms.seo.removeImage': 'Remove the image',
    'cms.seo.upload': 'Drag a file here, or click to upload',
    'cms.seo.uploading': 'Uploading…',
    // ── Contacts ─────────────────────────────────────────────────────────────
    'contacts.title': 'Contacts',
    'contacts.subtitle': 'Manage the people who interact with your site.',
    'contacts.loadingDetail': 'Loading contact',
    'contacts.detailLoadFailed': 'Could not open this contact',
    'contacts.detailLoadFailedBody': 'The contact is still in your list, but its details could not be loaded. Try again in a moment.',
    'contacts.loadingList': 'Loading your contacts',
    'contacts.unnamed': 'Unnamed contact',
    'contacts.thisContact': 'this contact',
    'contacts.back': 'Back to contacts',
    'contacts.detail.subtitle': 'Contact details and activity.',
    'contacts.detail.contact': 'Contact',
    'contacts.detail.tabsAria': 'Contact details',
    'contacts.edit': 'Edit',
    'contacts.name': 'Name',
    'contacts.namePlaceholder': 'Contact name',
    'contacts.email': 'Email',
    'contacts.emailPlaceholder': 'email@example.com',
    'contacts.phone': 'Phone',
    'contacts.phonePlaceholder': '+1 (555) 000-0000',
    'contacts.tags': 'Tags',
    'contacts.noEmail': 'No email',
    'contacts.noPhone': 'No phone number',
    'contacts.copyEmail': 'Copy email',
    'contacts.copyEmailFor': 'Copy {name}’s email',
    'contacts.emailCopied': 'Email copied',
    'contacts.emailCopyFailed': 'The email could not be copied',
    'contacts.tags.placeholder': "Search or create a tag",
    'contacts.tags.create': "Create “{name}”",
    'contacts.tags.empty': "No tags yet. Type one to create it.",
    'contacts.tags.allChosen': "This contact already has every tag.",
    'contacts.tags.limit': "Up to {max} tags per contact.",
    'contacts.tags.removeOne': "Remove {name}",
    'contacts.tags.deleteAria': "Delete the {name} tag from every contact",
    'contacts.tags.deleteTitle': "Delete the “{name}” tag?",
    'contacts.tags.deleteBody': "It will be removed from the {count} contacts that have it. The contacts aren't deleted.",
    'contacts.tags.deleteBodyOne': "It will be removed from the contact that has it. The contact isn't deleted.",
    'contacts.tags.deleteConfirm': "Delete tag",
    'contacts.tags.deleted': "Tag removed from {count} contacts.",
    'contacts.tags.deletedOne': "Tag removed from 1 contact.",
    'contacts.tags.count': "{count} contacts",
    'contacts.tags.countOne': "1 contact",
    'contacts.tags.remove': 'Remove {tag}',
    'contacts.tags.addShort': 'Add…',
    'contacts.tags.add': 'Add tag',
    'contacts.status.title': 'Status',
    'contacts.status.active': 'Active',
    'contacts.status.activePlural': 'Active',
    'contacts.status.spam': 'Spam',
    'contacts.status.blocked': 'Blocked',
    'contacts.status.blockedPlural': 'Blocked',
    'contacts.summary.title': 'Summary',
    'contacts.summary.purchases': 'Purchases',
    'contacts.summary.totalValue': 'Total value',
    'contacts.summary.bookings': 'Bookings',
    'contacts.summary.forms': 'Forms submitted',
    'contacts.lastSeen': 'Last interaction',
    'contacts.firstSeen': 'First interaction',
    'contacts.initialSource': 'First contact',
    'contacts.origin.title': 'Source',
    'contacts.source.form': 'Form',
    'contacts.source.booking': 'Booking',
    'contacts.source.account': "Account",
    'contacts.account.badge': "Account",
    'contacts.account.badgeHint': "Has an account on your site",
    'contacts.account.filterTitle': "Site account",
    'contacts.account.filterAll': "All",
    'contacts.account.filterYes': "With account",
    'contacts.account.filterNo': "Without account",
    'contacts.account.label': "Site account",
    'contacts.account.activeSince': "Active since {date}",
    'contacts.account.none': "No account",
    'contacts.account.lastLogin': "Last sign-in",
    'contacts.account.cardTitle': "Account and memberships",
    'contacts.account.blocked': "Blocked",
    'contacts.account.sessions': "Open sessions",
    'contacts.account.marketing': "Accepts news",
    'contacts.account.closeSessions': "Sign them out",
    'contacts.account.sessionsClosed': "We signed them out. They’ll need to sign in again with their code.",
    'contacts.account.block': "Block account",
    'contacts.account.unblock': "Unblock account",
    'contacts.account.blockedDone': "Account blocked: they can no longer sign in to your site.",
    'contacts.account.unblockedDone': "Account unblocked.",
    'contacts.account.actionFailed': "That didn’t work. Please try again.",
    'contacts.access.title': "Access",
    'contacts.access.give': "Give access",
    'contacts.access.empty': "You haven't given any access yet.",
    'contacts.access.state.active': "Active",
    'contacts.access.state.expired': "Expired",
    'contacts.access.state.revoked': "Removed",
    'contacts.access.kind.membership': "Membership",
    'contacts.access.kind.pack': "Pack",
    'contacts.access.kind.digital': "Digital product",
    'contacts.access.until': "Until {date}",
    'contacts.access.forever': "No end date",
    'contacts.access.givenBy': "Given by {name} on {date}",
    'contacts.access.givenOn': "Given on {date}",
    'contacts.access.revoke': "Remove access",
    'contacts.access.revokeTitle': "Remove this access?",
    'contacts.access.revokeBody': "They will lose “{name}” right away. They won't be emailed.",
    'contacts.access.revoked': "Access removed",
    'contacts.access.revokeFailed': "Couldn't remove the access.",
    'contacts.access.dialogTitle': "Give access",
    'contacts.access.dialogLead': "A membership, pack or digital product, at no cost. They use it just as if they had bought it.",
    'contacts.access.what': "What to give",
    'contacts.access.chooseOffer': 'Select an offer',
    'contacts.access.noMatches': 'No offers match your search.',
    'contacts.access.chooseDate': 'Select a date',
    'contacts.access.nothing': "You don't have memberships, packs or digital products to give.",
    'contacts.access.howLong': "For how long",
    'contacts.access.noEnd': "No end date",
    'contacts.access.untilDate': "Until a date",
    'contacts.access.packHint': "The pack includes its bookings and lasts its normal validity.",
    'contacts.access.note': "Internal note",
    'contacts.access.notePlaceholder': "E.g. comp for a review",
    'contacts.access.notify': "Send notification email",
    'contacts.access.notifyHint': "We tell them what you gave them and how to sign in to their account.",
    'contacts.access.giveCta': "Give access",
    'contacts.access.given': "Access given",
    'contacts.access.givenNotified': "Access given and email sent",
    'contacts.access.giveFailed': "Couldn't give access.",
    'orders.granted': "Comp",
    'contacts.membership.fallbackTitle': "Membership",
    'contacts.membership.state.active': "Active",
    'contacts.membership.state.ending': "Cancelling",
    'contacts.membership.state.past_due': "Payment due",
    'contacts.membership.state.paused': "Paused",
    'contacts.membership.state.ended': "Ended",
    'contacts.membership.per.day': "{price} a day",
    'contacts.membership.per.week': "{price} a week",
    'contacts.membership.per.month': "{price} a month",
    'contacts.membership.per.year': "{price} a year",
    'contacts.membership.everyN': "{price} every {count} {unit}",
    'contacts.membership.units.day': "days",
    'contacts.membership.units.week': "weeks",
    'contacts.membership.units.month': "months",
    'contacts.membership.units.year': "years",
    'contacts.membership.renews': "Renews on {date}",
    'contacts.membership.endsOn': "Ends on {date}",
    'contacts.membership.endedOn': "Ended on {date}",
    'contacts.membership.cancelAtEnd': "Cancel at period end",
    'contacts.membership.cancelNow': "Cancel now",
    'contacts.membership.manage': "Manage",
    'contacts.membership.cancelAtEndTitle': "Cancel at the end of the period?",
    'contacts.membership.cancelAtEndBody': "“{name}” stays active until {date} and won’t be charged again. Your customer sees it as “Cancelling” in their account.",
    'contacts.membership.cancelNowTitle': "Cancel the membership now?",
    'contacts.membership.cancelNowBody': "“{name}” ends right now and won’t be charged again. The current period isn’t refunded: to refund it, do it from Orders.",
    'contacts.membership.cancelled': "Membership cancelled.",
    'contacts.source.purchase': 'Purchase',
    'contacts.source.manual': 'Manual',
    'contacts.actions': 'Actions',
    'contacts.unspam': 'Not spam',
    'contacts.markSpam': 'Mark as spam',
    'contacts.unblock': 'Unblock',
    'contacts.block': 'Block',
    'contacts.delete': 'Delete',
    'contacts.deleteContact': 'Delete contact',
    'contacts.moreActions': "More actions",
    'contacts.tab.activity': 'Activity',
    'contacts.tab.forms': 'Forms',
    'contacts.tab.purchases': 'Purchases',
    'contacts.tab.bookings': 'Bookings',
    'contacts.tab.notes': 'Notes',
    'contacts.tab.memberships': "Memberships",
    'contacts.membershipsTab.empty': "No memberships or packs.",
    'contacts.membershipsTab.pack': "Pack",
    'contacts.membershipsTab.packDone': "Used up",
    'contacts.membershipsTab.left': "{remaining} of {limit} left",
    'contacts.membershipsTab.expires': "expires {date}",
    'contacts.membershipsTab.free': "Free",
    'contacts.membershipsTab.discount': "{percent}% off",
    'contacts.membershipsTab.since': "since {date}",
    'contacts.membershipsTab.leftFree': "Left",
    'contacts.activity.sentForm': 'Submitted {form}',
    'contacts.activity.bought': 'Bought {offer}',
    'contacts.activity.refunded': 'Refunded {offer}',
    'contacts.activity.booked': 'Booked {service}',
    'contacts.activity.rescheduled': 'Rescheduled {service}',
    'contacts.activity.rescheduledCustomer': 'Customer rescheduled {service}',
    'contacts.activity.rescheduledBy': '{name} rescheduled {service}',
    'contacts.activity.rescheduledTeam': 'Team rescheduled {service}',
    'contacts.activity.scheduleUpdated': 'Date and time updated',
    'contacts.activity.previousDate': 'Previous date',
    'contacts.activity.newDate': 'New date',
    'contacts.activity.openNote': 'Open this note in Notes',
    'contacts.activity.note': 'Note by {author}',
    'contacts.activity.joined': 'Added to contacts',
    'contacts.activity.internalNote': 'Internal team note',
    'contacts.activity.viewOrder': 'View order and receipt',
    'contacts.activity.orderFailed': "Couldn't open the order.",
    'contacts.activity.bookingFailed': "Couldn't open the booking.",
    'contacts.card.answerOne': '{count} answer',
    'contacts.card.answersMany': '{count} answers',
    'contacts.booking.whenLabel': 'Appointment',
    'contacts.booking.resourceLabel': 'With',
    'contacts.booking.bookedAtLabel': 'Booked on',
    'contacts.booking.noResource': 'No resource assigned',
    'contacts.booking.durationMinuteOne': '{count} min',
    'contacts.booking.durationMinutesMany': '{count} min',
    'contacts.booking.durationHourOne': '{count} hr',
    'contacts.booking.durationHoursMany': '{count} hrs',
    'contacts.purchase.reference': 'Order #{reference}',
    'contacts.purchase.status.paid': 'Paid',
    'contacts.purchase.status.refunded': 'Refunded',
    'contacts.purchase.status.pending': 'Pending',
    'contacts.purchase.status.failed': 'Failed',
    'contacts.purchase.status.cancelled': 'Cancelled',
    'contacts.purchase.status.unknown': 'No status',
    'contacts.activity.showMore': 'Show more',
    'contacts.activity.empty': 'There is no activity for this contact yet.',
    'contacts.answer': 'Answer',
    'contacts.message.status.unread': 'New',
    'contacts.message.status.read': 'Read',
    'contacts.message.status.spam': 'Spam',
    'contacts.forms.empty': 'They have not submitted any forms yet.',
    'contacts.booking.deletedService': 'Deleted service',
    'contacts.booking.overdue': 'This has passed and still needs an outcome',
    'contacts.booking.withResource': 'With {resource}',
    'contacts.booking.empty': 'There are no bookings under this email yet.',
    'contacts.booking.status.held': 'Held',
    'contacts.booking.status.confirmed': 'Confirmed',
    'contacts.booking.status.cancelled': 'Cancelled',
    'contacts.booking.status.completed': 'Attended',
    'contacts.booking.status.no_show': 'No-show',
    'contacts.purchase.deletedOffer': 'Deleted offer',
    'contacts.purchase.empty': 'There are no purchases under this email yet.',
    'contacts.notes.placeholder': 'Write an internal note about this person…',
    'contacts.notes.emptyTitle': 'No internal notes',
    'contacts.notes.emptyBody': 'Add context so the team has a complete history for this person.',
    'contacts.notes.full': 'This person\'s notes are at their limit. Delete one to keep writing.',
    'contacts.searchAria': 'Search contacts',
    'contacts.searchPlaceholder': 'Search contacts…',
    'contacts.clearSearch': 'Clear search',
    'contacts.starred': 'starred',
    'contacts.filtersAria': 'Filters and sorting',
    'contacts.filtersDialogAria': 'Contact filters and sorting',
    'contacts.filterTitle': 'Filter contacts',
    'contacts.closeFilters': 'Close filters',
    'contacts.all': 'All',
    'contacts.resetFilters': 'Reset filters',
    'contacts.exportCsv': 'Export CSV',
    'contacts.exportCsvAria': 'Export contacts to CSV',
    'contacts.add.title': 'Add contact',
    'contacts.add.short': 'Add',
    'contacts.add.subtitle': 'Create a contact manually in this project.',
    'contacts.add.initialNote': 'Initial note',
    'contacts.add.initialNotePlaceholder': 'Relevant information about this contact…',
    'contacts.add.limitError': 'You have reached the free plan limit of 100 contacts.',
    'contacts.add.saveError': 'We could not save the contact. Check the details and try again.',
    'contacts.star': 'Star',
    'contacts.loadFailed': 'We could not load the contacts.',
    'contacts.emptyTitle': 'No contacts yet',
    'contacts.emptyBody': 'Contacts appear here automatically when someone submits a form, makes a purchase, or books an appointment. You can also add someone manually.',
    'contacts.noResultsTitle': 'No contacts found',
    'contacts.noResultsBody': 'Try another search, or clear the filters.',
    'contacts.clearFilters': 'Clear filters',
    'contacts.unit': 'contacts',
    'contacts.unselectAll': 'Unselect all',
    'contacts.selectAll': 'Select everyone on this page',
    'contacts.selectContact': 'Select {name}',
    'contacts.starContact': 'Star {name}',
    'contacts.col.name': 'Name',
    'contacts.col.email': 'Email',
    'contacts.col.source': 'First contact',
    'contacts.col.lastSeen': 'Last interaction',
    'contacts.col.created': 'Created',
    'contacts.view': 'View contact',
    'contacts.moreOptions': 'More options',
    'contacts.options': 'Options',
    'contacts.write': 'Write email',
    'contacts.editDialog.title': 'Edit contact',
    'contacts.editDialog.subtitle': 'Correct the name or add a phone number.',
    'contacts.editDialog.save': 'Save changes',
    'contacts.bulkDelete.titleOne': 'Delete 1 contact',
    'contacts.bulkDelete.titleMany': 'Delete {count} contacts',
    'contacts.bulkDelete.body': 'The selected contacts and their associated messages will be deleted. This cannot be undone.',
    'contacts.deleteDialog.title': 'Delete contact',
    'contacts.deleteDialog.prefix': 'This will delete',
    'contacts.deleteDialog.withMessages': 'along with {count} {messages}',
    'contacts.deleteDialog.undone': '. This cannot be undone.',
    'contacts.messageOne': 'received message',
    'contacts.messageMany': 'received messages',
    'contacts.deleting': 'Deleting…',
    'contacts.deletedOne': '1 contact deleted',
    'contacts.deletedMany': '{count} contacts deleted',
    'contacts.deletedPartial': 'Deleted {done} of {total}',
    'contacts.csv.name': 'Name',
    'contacts.csv.email': 'Email',
    'contacts.csv.phone': 'Phone',
    'contacts.csv.tags': 'Tags',
    'contacts.csv.status': 'Status',
    'contacts.csv.source': 'Source',
    'contacts.csv.forms': 'Forms',
    'contacts.csv.firstSeen': 'First interaction',
    'contacts.csv.lastSeen': 'Last interaction',
    'contacts.csv.note': 'Note',
    'contacts.csv.filename': 'contacts',
    // ── Selector de periodo y comparación ─────────────────────────────────────────
    'range.today': 'Today',
    'range.yesterday': 'Yesterday',
    'range.last7': 'Last 7 days',
    'range.last30': 'Last 30 days',
    'range.last90': 'Last 90 days',
    'range.last12m': 'Last 12 months',
    'range.lastWeek': 'Last week',
    'range.lastMonth': 'Last month',
    'range.lastYear': 'Last year',
    'range.group.rolling': 'Up to yesterday',
    'range.group.calendar': 'Whole periods',
    'range.period': 'Period',
    'range.custom': 'Custom',
    'range.pickAria': 'Choose a period',
    'range.pickStart': 'Pick the start date',
    'range.prevMonth': 'Previous month',
    'range.nextMonth': 'Next month',
    'range.group.shortcuts': 'Shortcuts',
    'range.next7': 'Next 7 days',
    'range.next30': 'Next 30 days',
    'range.thisMonth': 'This month',
    'range.comingMonth': 'Next month',
    'range.compare.trigger': 'Compare',
    'range.compare.aria': 'Compare with',
    'range.compare.previous': 'Previous period',
    'range.compare.previousHint': 'The stretch of the same length right before',
    'range.compare.year': 'Previous year',
    'range.compare.yearHint': 'The same dates a year ago',
    'range.compare.none': 'No comparison',
    'range.compare.noneHint': 'Only the chosen period',
    // ── Gráficas ──────────────────────────────────────────────────────────────────
    'chart.empty': "Nothing to plot yet. As soon as the first data point comes in, the day-by-day trend shows up here.",
    'chart.chosenPeriod': 'Chosen period',
    'traffic.title': 'Overall traffic',
    'traffic.perHour': 'Page views per hour',
    'traffic.perDay': 'Page views per day',
    'traffic.views': 'Views',
    'traffic.uniques': 'Unique',
    'analyticsCommon.comparedWith': 'Compared with',
    // ── Estadísticas de una página ────────────────────────────────────────────────
    'pageStats.fallbackName': 'Page',
    'pageStats.subtitle': 'Page stats',
    'pageStats.back': 'Back to pages',
    'pageStats.openEditor': 'Open in Editor',
    'pageStats.menuAria': 'Page settings',
    'pageStats.menu.editor': 'Open in editor',
    'pageStats.menu.settings': 'Settings',
    'pageStats.menu.stats': 'Statistics',
    'pageStats.menu.preview': 'Preview',
    'pageStats.menu.published': 'Open published',
    'pageStats.menu.copyLink': 'Copy link',
    'pageStats.menu.duplicate': 'Duplicate',
    'pageStats.menu.rename': 'Rename',
    'pageStats.menu.setHome': 'Set as home page',
    'pageStats.menu.delete': 'Delete',
    'pageStats.published': 'Published',
    'pageStats.draft': 'Draft',
    'pageStats.created': 'Created',
    'pageStats.updated': 'Last edited',
    'pageStats.heading': 'Statistics',
    'pageStats.loadFailed': 'We could not load the statistics for this page.',
    'pageStats.views': 'Page views',
    'pageStats.share': 'Of the site traffic',
    'pageStats.share.hint': 'How much of all the traffic came through here',
    'pageStats.forms': 'Form submissions',
    'pageStats.forms.meta': 'Messages received from this page',
    // ── Analíticas de ventas ──────────────────────────────────────────────────────
    'salesAn.title': 'Sales analytics',
    'salesAn.subtitle': 'How much you sell, what sells and who buys.',
    'salesAn.loadFailed': 'The sales analytics could not be loaded.',
    'salesAn.emptyTitle': 'No sales yet',
    'salesAn.emptyBody': 'Once somebody buys on your site, this is where you will see how much you billed, what sold and who bought it.',
    'salesAn.emptyCta': 'Create your first offer',
    'salesAn.otherCurrencies.lead': 'The figures below are {currency} only. You also took',
    'salesAn.otherCurrencies.in': 'in {currency}',
    'salesAn.otherCurrencies.tail': ', which is not added in here because these are different units.',
    'salesAn.revenue': 'Net revenue',
    'salesAn.revenue.note': 'What you took minus what you refunded. It does not subtract the Stripe fee, which is not stored at charge time.',
    'salesAn.orders': 'Sales',
    'salesAn.orders.note': 'Charges taken during the period, refunds included: the sale happened even if it was refunded later.',
    'salesAn.aov': 'Average order',
    'salesAn.aov.note': 'Net revenue divided by the number of sales.',
    'salesAn.customers': 'Customers',
    'salesAn.customers.hint': '{new} · {returning} returning',
    'salesAn.customers.note': 'Distinct buyers, by email. Somebody who bought twice counts once.',
    'salesAn.chart.title': 'Revenue',
    'salesAn.chart.perHour': 'Net revenue per hour',
    'salesAn.chart.perDay': 'Net revenue per day',
    'salesAn.chart.revenue': 'Revenue',
    'salesAn.chart.orders': 'Sales',
    'salesAn.gross': 'Charged',
    'salesAn.gross.note': 'Everything that came in, before refunds are subtracted.',
    'salesAn.refunded': 'Refunded',
    'salesAn.refunded.note': 'Refunds issued against sales in this period, full and partial.',
    'salesAn.newCustomers': 'New customers',
    'salesAn.newCustomers.hint': '{percent}% of those in the period',
    'salesAn.newCustomers.none': 'No purchases in this period',
    'salesAn.newCustomers.note': 'Buyers with no purchase before these dates, however old the site is.',
    'salesAn.disputes': 'Disputes',
    'salesAn.disputes.hint': '{amount} at stake',
    'salesAn.disputes.none': 'None in this period',
    'salesAn.disputes.note': 'Sales the buyer disputed with their bank. You respond from the charge record.',
    'salesAn.topOffers': 'Best sellers',
    'salesAn.offerDeleted': 'The offer was deleted',
    'salesAn.topCustomers': 'Top customers',
    'salesAn.recentSales': 'Recent sales',
    'salesAn.unnamed': 'Unnamed',
    'salesAn.chargeType': 'Charge type',
    'salesAn.oneTime': 'One-off',
    'salesAn.subscription': 'Subscription',
    'salesAn.newVsReturning': 'New and returning customers',
    'salesAn.new': 'New',
    'salesAn.returning': 'Returning',
    'salesAn.statusTitle': 'Sale status',
    'salesAn.status.paid': 'Paid',
    'salesAn.status.partiallyRefunded': 'Partly refunded',
    'salesAn.status.refunded': 'Refunded',
    'salesAn.noSales': 'No sales in this period.',
    'salesAn.noBuyers': 'No buyers in this period.',
    'salesAn.noCharges': 'No charges in this period.',
    'salesAn.unit.saleOne': '{count} sale',
    'salesAn.unit.saleMany': '{count} sales',
    'salesAn.unit.chargeOne': '{count} charge',
    'salesAn.unit.chargeMany': '{count} charges',
    'salesAn.unit.newOne': '{count} new',
    'salesAn.unit.newMany': '{count} new',
    'salesAn.unit.refundedOne': '{count} sale with a refund',
    'salesAn.unit.refundedMany': '{count} sales with a refund',
    'salesAn.unit.sales': 'sales',
    'salesAn.unit.customers': 'customers',
    'salesAn.unit.ofRevenue': 'of revenue',
    // ── Analíticas de reservas ────────────────────────────────────────────────────
    'bookingsAn.title': 'Booking analytics',
    'bookingsAn.subtitle': 'How many appointments you have, how many happen and when.',
    'bookingsAn.loadFailed': 'The booking analytics could not be loaded.',
    'bookingsAn.emptyTitle': 'No appointments yet',
    'bookingsAn.emptyBody': 'Once somebody books with you, this is where you will see how many appointments you had, how many happened and which services fill your calendar.',
    'bookingsAn.emptyCta': "Create a booking",
    'bookingsAn.otherCurrencies.lead': 'The revenue below is {currency} only. You also took',
    'bookingsAn.otherCurrencies.in': 'in {currency}',
    'bookingsAn.otherCurrencies.tail': ', which is not added in here because these are different units.',
    'bookingsAn.bookings': 'Appointments',
    'bookingsAn.bookings.upcoming': '{count} still upcoming',
    'bookingsAn.bookings.note': 'Appointments whose TIME falls in the period, whenever they were booked. Each attendee of a class counts as one.',
    'bookingsAn.excluded': 'Left out',
    'bookingsAn.excluded.detail': '{holds} that expired unpaid',
    'bookingsAn.attendance': 'Attendance',
    'bookingsAn.attendance.hint': '{came} came · {missed} did not',
    'bookingsAn.attendance.none': 'No outcomes recorded',
    'bookingsAn.attendance.note': 'Out of the appointments that already have an outcome recorded. Upcoming or unmarked ones are left out: if they counted, a full calendar would say nobody shows up.',
    'bookingsAn.cancellations': 'Cancellations',
    'bookingsAn.cancellations.hint': '{percent} of the appointments in the period',
    'bookingsAn.cancellations.note': 'Cancelled by the customer or by you. It does not include holds that expired unpaid: those never became an appointment.',
    'bookingsAn.revenue': 'Appointment revenue',
    'bookingsAn.revenue.hint': 'from {bookings}',
    'bookingsAn.revenue.note': 'Taken online minus refunded, only for appointments paid up front or with a deposit. What you charge on site does not go through here.',
    'bookingsAn.chart.title': 'Appointments',
    'bookingsAn.chart.perHour': 'Appointments per hour',
    'bookingsAn.chart.perDay': 'Appointments per day',
    'bookingsAn.chart.bookings': 'Appointments',
    'bookingsAn.chart.attended': 'Attended',
    'bookingsAn.hours': 'Booked hours',
    'bookingsAn.hours.note': 'The time that was genuinely taken. A class of six takes one hour, not six. Cancelled ones do not count: the slot went free again.',
    'bookingsAn.customers': 'Customers',
    'bookingsAn.customers.hint': '{new} · {returning} returning',
    'bookingsAn.customers.note': 'Distinct people, by email. Somebody who came twice counts once; somebody who left no email counts once each time.',
    'bookingsAn.leadTime': 'Average lead time',
    'bookingsAn.leadTime.before': 'before: {value}',
    'bookingsAn.leadTime.note': 'How long passes, on average, between somebody booking and the time of their appointment. It tells you how far ahead the calendar fills up.',
    'bookingsAn.pending': 'Unrecorded',
    'bookingsAn.pending.hint': 'They are past and still need an outcome',
    'bookingsAn.pending.none': 'All up to date',
    'bookingsAn.pending.note': 'Appointments whose time has passed and are still «held» or «confirmed». Until they are marked, the attendance above is worked out without them. You mark them from Appointments.',
    'bookingsAn.topServices': 'Most booked services',
    'bookingsAn.service.sub': '{came} · {missed} did not',
    'bookingsAn.serviceDeleted': 'The service was deleted',
    'bookingsAn.topCustomers': 'Who books most',
    'bookingsAn.unnamed': 'Unnamed',
    'bookingsAn.customer.noShow': '{count} no-shows',
    'bookingsAn.outcome': 'How they ended',
    'bookingsAn.outcome.attended': 'Attended',
    'bookingsAn.outcome.noShow': 'No-show',
    'bookingsAn.outcome.cancelled': 'Cancelled',
    'bookingsAn.outcome.empty': 'No appointment in this period has ended yet.',
    'bookingsAn.weekdays': 'Days of the week',
    'bookingsAn.resources': 'Who runs them',
    'bookingsAn.newVsReturning': 'New and returning customers',
    'bookingsAn.new': 'New',
    'bookingsAn.returning': 'Returning',
    'bookingsAn.noBookings': 'No appointments in this period.',
    'bookingsAn.noCustomers': 'No customers in this period.',
    'bookingsAn.unit.bookingOne': '{count} appointment',
    'bookingsAn.unit.bookingMany': '{count} appointments',
    'bookingsAn.unit.holdOne': '{count} hold',
    'bookingsAn.unit.holdMany': '{count} holds',
    'bookingsAn.unit.prepaidOne': '{count} prepaid appointment',
    'bookingsAn.unit.prepaidMany': '{count} prepaid appointments',
    'bookingsAn.unit.attendedOne': '{count} attended',
    'bookingsAn.unit.attendedMany': '{count} attended',
    'bookingsAn.unit.newOne': '{count} new',
    'bookingsAn.unit.newMany': '{count} new',
    'bookingsAn.unit.bookings': 'appointments',
    'bookingsAn.unit.customers': 'customers',
    'bookingsAn.dur.minutes': '{count} min',
    'bookingsAn.dur.hours': '{count} h',
    'bookingsAn.dur.hoursMinutes': '{hours} h {minutes} min',
    'bookingsAn.dur.days': '{count} days',
    // ── Google Analytics ──────────────────────────────────────────────────────
    'ga.checking': 'Checking…',
    'ga.checkingBody': 'One moment.',
    'ga.connected': 'Connected',
    'ga.connectedBody': 'Visits are sent to {id}. They can take a few minutes to show up in Google Analytics (under “Realtime”).',
    'ga.notConnected': 'Not connected',
    'ga.emptyBody': 'Paste the measurement ID of your web data stream. It starts with “G-”.',
    'ga.statusOk': 'Active',
    'ga.idLabel': 'Measurement ID',
    'ga.changeId': 'Change the measurement ID',
    'ga.placeholder': 'G-XXXXXXXXXX',
    'ga.detected': 'Valid ID: {id}.',
    'ga.notDetected': 'That doesn’t look like a GA4 ID: it starts with “G-” (“UA-” IDs no longer work).',
    'ga.where': 'It’s in Google Analytics › Admin › Data streams › your website.',
    'ga.openGa': 'Open Google Analytics',
    'ga.connect': 'Connect',
    'ga.saveNew': 'Save the new ID',
    'ga.disconnect': 'Disconnect',
    'ga.confirmDisconnect': 'Yes, disconnect',
    'ga.cancel': 'Cancel',
    'ga.disconnectNote': 'Pages will stop sending visits to Google Analytics right away. What was already measured stays in your Google account.',
    'ga.saveFailed': 'Could not save. Try again.',
    'ga.adminOnly': 'Only site admins can connect Google Analytics.',
    'ga.privacyTitle': 'Privacy and cookies, handled',
    'ga.privacy1': 'Visitors from the European Union, the UK and Switzerland see a notice with “Accept” and “Reject”, and Google Analytics doesn’t load until they accept.',
    'ga.privacy2': 'Everywhere else (United States, Mexico…) it loads without a notice, as is standard there.',
    'ga.privacy3': 'If the browser asks not to be tracked (Global Privacy Control), it doesn’t load. Your own visits with the admin bar don’t count either.',
    'ga.title': 'Google Analytics',
    'ga.description': 'Paste your measurement ID and the Google tag is added to every published page automatically, no republish needed.',
    'ga.builtIn': 'véltica Analytics',
    'ga.builtInBody': 'Still works separately, without cookies: visits, pages and traffic sources from the dashboard.',
    'ga.open': 'Open Analytics',
    // ── Offers ────────────────────────────────────────────────────────────────
    'offers.status.draft': 'Draft',
    'offers.status.active': 'Public',
    'offers.status.archived': 'Withdrawn',
    'offers.interval.one_time': 'One-time',
    'offers.interval.month': 'Monthly',
    'offers.interval.year': 'Yearly',
    'offers.type.digital': 'Digital product',
    'offers.type.service': 'Service',
    'offers.type.course': 'Course',
    'offers.type.physical': 'Physical product',
    'offers.statusAria': 'Status of {name}',
    'offers.noPrice': 'No price',
    'offers.noRevenue': 'Nothing earned yet',
    'offers.searchAria': 'Search offers',
    'offers.searchPlaceholder': 'Search offers...',
    'offers.clearSearch': 'Clear search',
    'offers.starLabel': 'starred',
    'offers.filtersAria': 'Filters and sorting',
    'offers.filtersDialogAria': 'Offer filters and sorting',
    'offers.filterTitle': 'Filter offers',
    'offers.closeFilters': 'Close filters',
    'offers.filterKind': 'What it is',
    'offers.kind.digital': 'Digital',
    'offers.kind.service': 'Service',
    'offers.kind.course': 'Course',
    'offers.kind.physical': 'Physical product',
    /* «Reserva» y no «Servicio con agenda»: es como se busca, y es la etiqueta que
       hace que la lista se lea igual que se piensa en ella. */
    'offers.kind.booking': 'Booking',
    'offers.newKind.title': 'What are you selling?',
    'offers.newKind.lead': 'Each one is set up differently. Pick one and we take you to the right place. You can change it later.',
    'offers.newKind.digitalBody': 'A file people download: a guide, a template, a pack.',
    'offers.newKind.bookingBody': 'An appointment on your calendar. Opens in Bookings, with its schedule.',
    'offers.newKind.serviceBody': 'Your time or your work, with no calendar behind it.',
    'offers.newKind.physicalBody': 'Something you ship or hand over: asks for the address at checkout.',
    'offers.newKind.courseBody': 'Lessons followed over time, with students and progress.',
    'offers.newKind.soon': 'Soon',
    'offers.filterStatus': 'Status',
    'offers.filter.all': 'All',
    'offers.filterStarred': 'Starred',
    'offers.allStars': 'All',
    'offers.onlyStarred': 'Starred only',
    'offers.resetFilters': 'Reset filters',
    'offers.clearFilters': 'Clear filters',
    'offers.new': 'New offer',
    'offers.newShort': 'New',
    'offers.unit': 'offers',
    'offers.loadFailed': 'We could not load your offers.',
    'offers.retry': 'Try again',
    'offers.empty.title': 'No offers yet',
    'offers.empty.body': 'An offer is what you sell: its name, its price and what the buyer gets.',
    'offers.noResults.title': 'No offers found',
    'offers.noResults.body': 'None of them match your search. Try another name or clear the filters.',
    'offers.col.offer': 'Offer',
    'offers.col.price': 'Price',
    'offers.col.status': 'Status',
    'offers.col.sales': 'Sales',
    'offers.col.revenue': 'Earned',
    'offers.col.created': 'Created',
    'offers.col.actions': 'Actions',
    'offers.starAria': 'Star {title}',
    'offers.sales.one': '1 sale',
    'offers.sales.many': '{count} sales',
    'offers.open': 'Open',
    'offers.moreOptions': 'More options',
    'offers.options': 'Options',
    'offers.menu.open': 'Open offer',
    'offers.menu.duplicate': 'Duplicate',
    'offers.menu.withdraw': 'Withdraw',
    'offers.copySuffix': '(copy)',
    'offers.duplicated': 'Offer duplicated',
    'offers.withdrawn': 'Offer withdrawn',
    'offers.withdraw.title': 'Withdraw this offer',
    'offers.withdraw.body': 'It will stop selling and leave this list. It is not deleted: the payments it already has will still be able to say what was sold.',
    'offers.withdraw.confirm': 'Withdraw',
    'offers.block.planTitle': 'Charging for bookings comes with the paid plans',
    'offers.block.digitalPlanTitle': 'Selling digital products comes with the paid plans',
    'offers.block.servicePlanTitle': 'Charging for services comes with the paid plans',
    'offers.block.stripeTitle': 'Connect Stripe to publish it',
    'offers.block.digitalStripeTitle': 'Connect Stripe to put it on sale',
    'offers.block.planBody': 'You can create and edit your services on the free plan. To charge for them online you need a membership: that is where the account receiving the money gets connected.',
    'offers.block.digitalPlanBody': 'You can create and prepare your digital products on the free plan. To sell them online you need a membership: that is where the account receiving the money gets connected.',
    'offers.block.stripeBody': 'This service charges online, so for someone to book it there has to be an account for that money to land in.',
    'offers.block.digitalStripeBody': 'This product charges online, so for someone to buy it there has to be an account for that money to land in.',
    'offers.block.serviceStripeBody': 'This service charges online, so for someone to buy it there has to be an account for that money to land in.',
    'offers.block.aside': 'Meanwhile it stays a draft: you keep editing it and nobody sees it.',
    'offers.block.notNow': 'Not now',
    'offers.block.connecting': 'Connecting…',
    'offers.loadingOne': 'Loading the offer',
    'offers.loadingAll': 'Loading your offers',
    'offers.sectionTitle': 'All offers',
    'offers.sectionSubtitle': 'What you sell from your site: product, price, images and description.',
    'offers.digital.sectionTitle': 'Digital products',
    'offers.digital.sectionSubtitle': 'Files the buyer downloads on payment: what it is, what it costs and what they get.',
    'offers.physical.sectionTitle': 'Physical products',
    'offers.physical.sectionSubtitle': 'What you ship or hand over: what it is, what it costs, how many are left and how it gets there.',
    'offers.service.sectionTitle': 'Services',
    'offers.service.sectionSubtitle': 'Your time or your work, with no calendar behind it. Anything booked by the hour lives in Bookings.',
    // ── Offers · detail ───────────────────────────────────────────────────────
    'offers.detail.back': 'Back to offers',
    'offers.detail.changeThumbAria': 'Change the thumbnail',
    'offers.detail.addThumbAria': 'Upload a thumbnail',
    'offers.detail.idCopied': 'ID copied',
    'offers.detail.withdraw': 'Withdraw',
    'offers.detail.withdrawBody': 'It will stop selling and leave the list. It is not deleted: the payments it already has will still be able to say what was sold.',
    'offers.detail.removeImageAria': 'Remove this image',
    'offers.detail.removeImage': 'Remove',
    'offers.detail.mediaFoot': 'The thumbnail shown in the list and in the header.',
    /* ── Dónde está la oferta, una vez publicada ───────────────────────────────
       Dos respuestas y no una: la gratuita tiene página propia —su formulario— y
       la de pago no, se vende con su botón dentro de tus páginas. */
    'offers.detail.link.copy': 'Copy URL',
    'offers.detail.link.copied': 'Copied',
    'offers.detail.link.open': 'Open',
    'offers.detail.link.needSite': 'It gets its own link once your site is published.',
    'offers.detail.link.publishToGetLink': 'Publish the page to get a link',
    /* Se llega aquí por un enlace guardado, no pulsando en el catálogo: esas
       filas van derechas a Reservas. El aviso dice dónde se edita. */
    'offers.detail.bookable.title': 'This one is booked, not just bought',
    'offers.detail.bookable.body': 'It is a bookable service, so everything about it (price, schedule, capacity, description and cancellation policy) is edited in Bookings, in a single wizard. This page only reads it: what you can do here is publish it, withdraw it, or change its cover.',
    'offers.detail.bookable.open': 'Open in Bookings',
    'offers.detail.files.add': 'Add another file',
    'offers.detail.files.hint': 'Up to 15 MB each. It counts towards your project’s storage.',
    'offers.detail.files.full': 'This offer already holds all the files it can. Remove one to add another.',
    'offers.detail.files.remove': 'Remove',
    'offers.detail.files.removeAria': 'Remove {name}',
    /* La pregunta que viene justo después de subir, contestada donde se hace. */
    /* What can't be configured yet, in a single card: it was two — one per tab —
       and back to back they read as two separate lists of promises. */
    /* Two tabs: what it has sold, and what it is. They don't split up fields —
       that went to the wizard — they split two things you never read at once. */
    'offers.detail.tabsAria': 'Offer sections',
    'offers.detail.hero.fileOne': '1 file',
    'offers.detail.hero.files': '{count} files',
    'offers.detail.tab.sales': 'Sales',
    'offers.detail.tab.settings': 'Settings',
    /* ── The offer's page ─────────────────────────────────────────────────────
       See the Spanish catalog for why this lives in the dashboard and not in the
       editor. Field labels are borrowed from the editor's page settings on
       purpose — same decision, different page. */
    'offers.detail.tab.page': 'Page',
    'offers.detail.tab.look': 'Appearance',
    'offers.look.panel': 'Offer column',
    'offers.look.title': 'Offer name',
    'offers.look.heading': 'Checkout heading',
    'offers.look.body': 'Description and intro',
    'offers.look.price': 'Price',
    'offers.look.badge': '“Free” label',
    'offers.look.badgeBook': '“Book” label',
    'offers.look.brandShow': 'On this page',
    'offers.look.logoMode.text': 'Text only',
    'offers.look.logoMode.both': 'Logo and text',
    'offers.look.logoMode.logo': 'Logo only',
    'offers.look.logoMode.hide': 'No logo',
    'offers.look.noLogoImage': 'Your brand has no logo image',
    'offers.look.noBrandName': 'Your brand has no name',
    'offers.look.logoHidden': 'The page will show no logo.',
    'offers.look.logoNothing': 'With this option, nothing from your brand shows.',
    'offers.look.brandEmpty': 'Your brand has no logo or name yet.',
    'offers.look.brandEdit': 'Change brand colors and logo',
    'offers.look.brandEditHint': 'Opens the editor on the brand step of the tutorial. Changes apply to the whole site.',
    'offers.look.customized': '{count} customized',
    'offers.look.asToday': 'As it is now',
    /* El nombre de la opción, que no es el del rótulo de la carpeta: dentro de una
       lista de estilos, «como está ahora» se lee como un estilo más. */
    'offers.look.defaultOption': 'Default',
    'offers.look.group.button': 'Button',
    'offers.look.saved': 'Appearance saved',
    'offers.look.note': 'Uses your site’s colors, text styles and buttons. It shows on the live page as soon as you save. No need to republish.',
    'offers.page.saved': 'Page settings saved',
    'offers.page.address': 'Address',
    'offers.page.slugHint': 'Letters, numbers and hyphens only. Accents and spaces are converted for you, and if the address is taken a number is added.',
    'offers.page.seo': 'Search engines',
    'offers.page.seoBody': "What Google shows for this offer. Leave it empty to use the name and description it already has.",
    'offers.page.canonicalHint': 'The preferred address when the same thing is sold in more than one place. Empty uses its own, which is the normal case.',
    'offers.page.shareBody': 'What people see when the link is pasted into WhatsApp, Instagram or an email.',
    'offers.page.coverImage': "The offer's cover image is used.",
    'offers.page.customImage': 'Custom image for sharing.',
    'offers.page.useCover': 'Back to the cover',
    'offers.page.visibilityBody': 'Who can reach this page from a search engine.',
    'offers.page.indexBody': 'Let Google and the others show it in their results.',
    'offers.page.sitemapBody': 'Includes it in the sitemap search engines read to discover new pages.',
    'offers.page.draftNote': "While the offer is a draft its page doesn't exist for anyone. Publish it for these settings to count.",
    'offers.detail.noDescription': 'No description',
    'offers.detail.card.offer': 'The offer',
    'offers.detail.editAll': 'Edit everything',
    'offers.detail.visibility': 'Visibility',
    /* ── One offer's analytics ────────────────────────────────────────────────
       Worked out from its own payments, so they talk about it and not about the
       catalog. The four figures borrow their labels from Sales analytics: they
       are the same ones and cannot be named differently depending on where you
       look at them. */
    'offers.detail.tab.notices': 'Notifications',
    'offers.detail.tab.analytics': 'Analytics',
    'offers.detail.analytics.claims': 'Claims',
    'offers.detail.analytics.chart': 'Sales of this offer',
    'offers.detail.analytics.chartFoot': 'Charged minus refunded, day by day, for the selected period.',
    'offers.detail.analytics.emptySales': "You haven't sold this offer yet. As soon as the first purchase comes in, its day-by-day trend shows up here.",
    'offers.detail.analytics.emptyClaims': "Nobody has claimed it yet. As soon as someone does, its day-by-day trend shows up here.",
    'offers.detail.analytics.otherCurrencies': 'There are sales in {count} more currency(ies). They are not added up here: each one is counted on its own, in Payments.',
    'offers.detail.draftNotice.title': 'This offer is not active yet',
    'offers.detail.draftNotice.serviceTitle': 'This service is not active yet',
    'offers.detail.draftNotice.body': 'It is saved as a draft. When you are ready, publish it so clients can buy it from your page.',
    'offers.detail.draftNotice.serviceBody': 'It is saved as a draft. When you are ready, publish it so clients can hire it from your page.',
    'offers.detail.draftNotice.publish': 'Publish',
    'offers.detail.fact.title': 'Name',
    'offers.detail.card.description': 'Description',
    'offers.detail.card.noDescription': 'No description added yet.',
    'offers.detail.card.meta': 'Technical details',
    'offers.detail.fact.files': 'Files',
    'offers.detail.fact.stock': 'Stock',
    'offers.detail.soldOut': 'Sold out',
    'offers.detail.hero.stockUnlimited': 'Unlimited stock',
    'offers.detail.edit': 'Edit',
    'offers.detail.fact.price': 'Price',
    'offers.detail.fact.billing': 'Billing',
    'offers.detail.fact.after': 'After paying',
    /* En una palabra, para que quepan en el recuadro del resumen: las del
       selector están escritas para elegir, no para leerse de un vistazo. */
    'offers.detail.thankYou.shortDefault': 'Built-in page',
    'offers.detail.thankYou.shortPage': 'A page of yours',
    'offers.detail.thankYou.shortUrl': 'External address',
    'offers.detail.id': 'ID',
    'offers.detail.copyIdAria': 'Copy the offer ID',
    'offers.detail.copy': 'Copy',
    'offers.detail.slug': 'Address',
    'offers.detail.slugHostExample': 'yoursite.com',
    'offers.detail.slugSaved': 'Address updated',
    'offers.detail.slugAdjusted': 'That address was taken. The offer is now at /{slug}.',
    'offers.detail.created': 'Created',
    'offers.detail.updated': 'Last edited',
    'offers.detail.thankYou.label': 'Where the buyer goes',
    'offers.detail.thankYou.default': 'Built-in thank-you page',
    'offers.detail.thankYou.page': 'A page on my site',
    'offers.detail.thankYou.url': 'An external address',
    'offers.detail.thankYou.defaultFoot': 'It confirms the purchase and shows what was paid and how much. Nothing to set up.',
    'offers.detail.thankYou.pageLabel': 'Page',
    'offers.detail.thankYou.loading': 'Loading…',
    'offers.detail.thankYou.pick': 'Pick a page',
    'offers.detail.thankYou.pageFoot': 'If you delete it later, the purchase goes back to the built-in page instead of breaking.',
    'offers.detail.thankYou.urlLabel': 'Address',
    'offers.detail.thankYou.urlFoot': 'A group, a webinar, another platform. It has to start with https://',
    'offers.price.removeAria': 'Remove the {price} price',
    'offers.price.remove': 'Remove price',
    'offers.price.amount': 'Price',
    'offers.price.currencyTitle': 'Changed in Settings → Region and currency',
    // ── Offers · new ──────────────────────────────────────────────────────────
    'offers.new.dialogAria': 'New offer',
    'offers.new.close': 'Close',
    'offers.new.step.review': 'Review',
    'offers.new.titleLabel': 'Title',
    'offers.new.titleFoot': 'The name the buyer will see it under.',
    'offers.new.brandLabel': 'Brand',
    'offers.new.brandPlaceholder': 'E.g. Nike, Apple…',
    'offers.new.brandFoot': 'Optional. Lets you build collections by brand.',
    'offers.new.tagsFoot': 'Optional. Not shown on the site: they help you build collections.',
    /* ── Lo mismo, dicho para un producto digital ──────────────────────────────
       La puerta ya prometió «Producto digital»; si aquí vuelve a poner «tu
       oferta» y un curso de ejemplo, parece que se abrió el formulario que no
       era. Sólo cambian las frases que dicen QUÉ se está montando. */
    /* La base del par: el asistente la usa a través de `say`, así que tiene que
       existir aunque la ficha tenga la suya con otra clave. */
    'offers.new.descriptionPlaceholder': 'What it includes, who it is for, what the buyer gets…',
    'offers.new.info.kickerDigital': 'Your file',
    'offers.new.info.titleDigital': 'Describe your product',
    'offers.new.info.leadDigital': 'The name, what it includes and its cover. It is what the buyer reads before downloading, and none of it is final: everything can be changed later.',
    'offers.new.titlePlaceholderDigital': 'Plant care guide (PDF)',
    'offers.new.descriptionPlaceholderDigital': 'How many pages, what is inside, who it is for…',
    'offers.new.info.kickerPhysical': 'Your product',
    'offers.new.info.titlePhysical': 'Describe your product',
    'offers.new.info.leadPhysical': 'The name, what it is and a good photo. It’s what buyers see before paying, and you can change all of it later.',
    'offers.new.titlePlaceholderPhysical': 'Handmade ceramic mug',
    'offers.new.descriptionPlaceholderPhysical': 'Size, materials, colors, care…',
    'offers.new.shipping.kicker': 'How it gets there',
    'offers.new.shipping.title': 'Stock and shipping',
    'offers.new.shipping.lead': 'How many units you have and how they reach the buyer. Stripe asks for the address at checkout.',
    'offers.new.shipping.stockLabel': 'Stock',
    'offers.new.shipping.stockHint': 'If you track it, each sale takes off the units bought and it shows “Sold out” at zero.',
    'offers.new.shipping.unlimited': 'Unlimited',
    'offers.new.shipping.limited': 'Track units',
    'offers.new.shipping.units': 'Units available',
    'offers.new.shipping.unitsHint': 'Update it whenever you restock.',
    'offers.new.step.variants': 'Variants',
    'offers.new.variants.kicker': 'Variants',
    'offers.new.variants.title': 'Sizes, colours and other options',
    'offers.new.variants.lead': "Optional. Add sizes, colours or other options; click a variant to give it its own photo, price and stock. Skip this step if the product comes in only one version.",
    'offers.new.variants.none': 'No variants',
    'offers.new.variants.stockByVariant': 'Stock by variant',
    'offers.new.shipping.stockByVariant': 'This product has variants: stock is tracked for each size or colour in the “Variants” step.',
    'offers.variants.empty.title': 'Does it come in more than one version?',
    'offers.variants.empty.body': "Add sizes, colours or materials. Each combination can have its own photo, price and stock.",
    'offers.variants.preset.size': 'Size',
    'offers.variants.preset.color': 'Colour',
    'offers.variants.preset.material': 'Material',
    'offers.variants.preset.custom': 'Custom',
    'offers.variants.preset.customHint': 'Style, scent, capacity…',
    'offers.variants.suggest.size': 'XS, S, M, L, XL, XXL',
    'offers.variants.suggest.color': 'Black, White, Gray, Navy, Red, Green, Beige',
    'offers.variants.suggest.material': 'Cotton, Linen, Polyester, Wool, Leather',
    'offers.variants.namePlaceholder': 'Option name, e.g. Style',
    'offers.variants.valueCount': '{count} values',
    'offers.variants.valueCountOne': '1 value',
    'offers.variants.firstValue': 'Type a value and press Enter',
    'offers.variants.addShort': 'Add',
    'offers.variants.suggestions': 'Suggestions',
    'offers.variants.addAll': 'Add all',
    'offers.variants.addOption': 'Add option:',
    'offers.variants.inventory': 'Inventory',
    'offers.variants.summary': '{count} variants',
    'offers.variants.summaryOne': '1 variant',
    'offers.variants.summaryUnits': '{count} units',
    'offers.variants.summaryUnlimited': 'unlimited stock',
    'offers.variants.summaryOff': '{count} not for sale',
    'offers.variants.bulkStock': 'Stock for all',
    'offers.variants.applyAll': 'Apply to all',
    'offers.variants.allUnlimited': 'All unlimited',
    'offers.variants.generateSku': 'Generate SKUs',
    'offers.variants.notSold': 'Not for sale',
    'offers.variants.stopSelling': 'Stop selling this one',
    'offers.variants.startSelling': 'Sell this one',
    'offers.variants.inventoryHint': 'Leave stock empty for unlimited. Turn off the combinations you do not make: buyers see them as unavailable.',
    'offers.variants.optionName': 'Option',
    'offers.variants.valuesHint': 'Type a value and press Enter. Separate several with commas.',
    'offers.variants.addValue': 'Add value',
    'offers.variants.addValueAria': 'Add a value to {name}',
    'offers.variants.removeValue': 'Remove {value}',
    'offers.variants.removeOption': 'Remove the option {name}',
    'offers.variants.removeOptionShort': 'Remove option',
    'offers.variants.tableAria': 'Stock by variant',
    'offers.variants.colVariant': 'Variant',
    'offers.variants.colStock': 'Stock',
    'offers.variants.colSku': 'SKU',
    'offers.variants.colSelling': 'On sale',
    'offers.variants.unlimited': 'Unlimited',
    'offers.variants.openVariant': "Open {variant}",
    'offers.variants.editAll': "Edit all",
    'offers.variants.allVariants': "All variants",
    'offers.variants.dialog.lead': "Its photo, price and what is left. Saved when you finish the wizard.",
    'offers.variants.dialog.allLead': "What you type here goes to every variant. An empty price changes none.",
    'offers.variants.dialog.photo': "Photo",
    'offers.variants.dialog.upload': "Upload",
    'offers.variants.dialog.photoForAll': "Use it for every “{value}”",
    'offers.variants.dialog.photoHint': "When this variant is chosen in the store, the main photo switches to this one.",
    'offers.variants.dialog.pricing': "Price",
    'offers.variants.dialog.compareAt': "Compare-at price",
    'offers.variants.dialog.cost': "Cost per item",
    'offers.variants.dialog.compareLow': "The compare-at price must be higher than the price to show crossed out.",
    'offers.variants.dialog.margin': "You make {profit} per item · {margin}% margin",
    'offers.variants.dialog.pricingHint': "The compare-at price shows crossed out in the store. Only you see the cost: it works out your margin.",
    'offers.variants.dialog.barcode': "Barcode",
    'offers.variants.dialog.barcodeHint': 'UPC, EAN, ISBN…',
    'offers.variants.dialog.stockHint': "Empty = unlimited.",
    'offers.variants.dialog.sellingOn': "It can be bought.",
    'offers.variants.dialog.sellingOff': "Shows as unavailable in the store.",
    'offers.variants.dialog.applyAll': "Apply to all",
    'offers.variants.dialog.done': "Done",
    'offers.variants.colPrice': 'Price',
    'offers.variants.samePrice': 'Empty = the product price',
    'offers.variants.priceAria': 'Price of {variant}',
    'offers.variants.priceInvalid': 'Check the variant prices: each must be an amount above zero, or left empty to use the product price.',
    'offers.variants.pickTone': 'Choose the shade of {value}',
    'offers.variants.pickPhoto': 'Photo for {value}',
    'offers.variants.photoHint': 'Choosing “{value}” in the store shows this photo.',
    'offers.variants.noPhoto': 'None',
    'offers.variants.stockCard': 'Stock by variant',
    'offers.variants.stockCardHint': 'Type how many are left and save. Empty = unlimited. Options, prices and SKUs are changed in the wizard.',
    'offers.variants.fewLeft': '{count} left',
    'offers.variants.stockSaveFailed': "Couldn't save the stock. Try again.",
    'offers.variants.stockAria': 'Stock of {variant}',
    'offers.variants.skuAria': 'SKU of {variant}',
    'offers.variants.sellingAria': 'Sell {variant}',
    'offers.variants.nameRequired': 'Give each option a name, like Size or Colour.',
    'offers.variants.valuesRequired': 'Add at least one value to each option.',
    'offers.variants.tooMany': 'Up to {max} combinations per product. Remove some values.',
    'offers.new.shipping.ratesLabel': 'Shipping options',
    'offers.new.shipping.ratesHint': 'They’re site-wide: options you add here apply to your other products too and save right away.',
    'offers.new.shipping.stockInvalid': 'Enter how many units you have (a whole number).',
    'offers.new.shipping.ratesRequired': 'Add at least one shipping or pickup option.',
    'offers.new.review.stockCount': '{count} in stock',
    'offers.new.review.noRates': 'No shipping options',
    'offers.new.uploadBodyDigital': 'The cover people see before downloading. Not the file itself, that comes next.',
    'offers.new.titlePlaceholder': 'Photography course',
    'offers.new.shortDescriptionLabel': 'Short description',
    'offers.new.shortDescriptionPlaceholder': 'What it is and its main benefit, in one or two sentences.',
    'offers.new.shortDescriptionFoot': 'Shown on cards and below the title, above the purchase options. Maximum 200 characters.',
    'offers.new.longDescriptionLabel': 'Full description',
    'offers.new.longDescriptionFoot': 'Explain what it includes and all the details. Shown below the purchase section.',
    'offers.new.descriptionLabel': 'Description',
    'offers.new.descriptionFoot': 'You can leave it for later and write it calmly in the offer page.',
    /* «Portada» y no «Imagen»: en un producto digital hay dos archivos en juego
       —lo que se enseña y lo que se entrega— y el rótulo es lo que los separa. */
    'offers.new.imageLabel': 'Cover',
    'offers.new.uploadTitle': 'Upload a cover',
    'offers.new.uploadBody': 'It is the offer’s cover: the one shown in the list and on your page.',
    'offers.new.payType': 'Payment type',
    'offers.new.file.label': 'The file you are selling',
    'offers.new.file.hint': 'Up to 15 MB each. It counts towards your project’s storage, and you can upload up to 5.',
    'offers.new.file.pick': 'Choose a file',
    'offers.new.file.tooLarge': 'That file is over 15 MB. Try a lighter one.',
    'offers.new.file.required': 'Upload the file you are delivering: without it the offer cannot sell anything.',
    'offers.new.file.rename': 'Rename',
    'offers.new.file.renameAria': 'File name',
    'offers.new.freeTitle': 'Free',
    'offers.new.freeBody': 'Nothing to pay. They leave their name and email, and it is theirs. You get the lead, no Stripe needed.',
    'offers.new.checkout.freeNote': 'No card. Their details go to your Payments as a $0 order.',
    'offers.new.checkout.get': 'Get it',
    'offers.new.checkout.ownSite': 'your site',
    'offers.new.oneTimeTitle': 'One-time',
    'offers.new.oneTimeBody': 'Paid once and that is it.',
    'offers.new.subscriptionTitle': 'Subscription',
    'offers.new.subscriptionBody': 'Charged automatically every period.',
    'offers.new.amountAria': 'Amount',
    /* ── Las cinco cadencias ───────────────────────────────────────────────────
       «Cada mes» y no «Mensual»: se lee al lado del importe —«$199 · cada mes»— y
       ahí el adjetivo obliga a traducir mentalmente a cuándo se cobra. */
    'offers.cadence.week': 'Every week',
    'offers.cadence.biweek': "Every 2 weeks",
    'offers.cadence.month': 'Every month',
    'offers.cadence.quarter': 'Every 3 months',
    'offers.cadence.half': 'Every 6 months',
    'offers.cadence.year': 'Every year',
    'offers.new.cadence.label': 'How often you charge it',
    'offers.new.suffix.week': '/wk',
    'offers.new.suffix.biweek': '/2 weeks',
    'offers.new.suffix.quarter': '/3 mo',
    'offers.new.suffix.half': '/6 mo',
    'offers.interval.week': 'Weekly',
    'offers.new.amountInvalid': 'Write just the number, for example 199.00',
    /* Ya no es opcional: sin precio la oferta existe y no se puede vender, y el
       botón de compra revienta al pulsarlo. */
    /* Ya no es opcional: sin precio la oferta existe y no se puede vender, y el
       botón de compra revienta al pulsarlo. */
    'offers.new.amountRequired': 'Put a price on it. Without one it cannot be sold.',
    'offers.new.amountZero': 'It has to be more than zero. If it is free, pick Free above.',
    'offers.new.amountFoot': 'What the buyer pays, in your project’s currency. You can change it later; the old price stays on the sales already made.',
    'offers.new.compareAt': 'Compare-at price (struck)',
    'offers.new.compareAtFoot': 'Optional. Shown struck through next to the price, with the discount: this is how a sale is announced.',
    'offers.new.compareAtLow': 'It must be higher than the price; as is, it won’t be saved.',
    'offers.new.compareAtOff': 'It will show {percent}% off.',
    'offers.new.review.title': 'Title',
    'offers.new.review.noTitle': 'No title',
    'offers.new.review.description': 'Description',
    'offers.new.review.noDescription': 'No description',
    'offers.new.review.billing': 'Billing',
    'offers.new.review.once': 'once',
    'offers.new.review.image': 'Image',
    'offers.new.review.noImage': 'No image',
    'offers.new.next.title': 'What happens when you create it',
    'offers.new.next.opens': 'Its page opens, where the rest of the images and the prices live.',
    'offers.new.next.sell': 'When it is ready, you put it on sale and add its buy button to your page.',
    /* ── The wizard, in edit mode ──────────────────────────────────────────────
       The detail page kept what the wizard doesn't ask about; everything else is
       changed here, at whichever step its summary shortcut opens. */
    'offers.edit.dialogAria': 'Edit {name}',
    'offers.edit.save': 'Save changes',
    'offers.edit.saving': 'Saving…',
    'offers.edit.onSave': 'When saving',
    'offers.edit.file.pending': 'not uploaded yet',
    'offers.edit.otherPrices': 'Other active prices',
    'offers.edit.otherPricesHint': 'This offer carries more than one price. The one above is what its buy button uses; these can be dropped, and they go when you save.',
    'offers.edit.keepPrice': 'Keep',
    'offers.edit.keepPriceAria': 'Keep the {price} price',
    'offers.edit.review.imageOne': '1 image',
    'offers.edit.review.images': '{count} images',
    'offers.edit.review.fileOne': '1 file',
    'offers.edit.review.files': '{count} files',
    'offers.edit.review.noFiles': 'None yet',
    'offers.new.previewAria': 'Offer preview',
    'offers.new.preview': 'Preview',
    'offers.new.suffix.month': '/mo',
    'offers.new.suffix.year': '/yr',
    'offers.new.back': 'Back',
    'offers.new.cancel': 'Cancel',
    'offers.new.nextStep': 'Next',
    'offers.new.creating': 'Creating…',
    'offers.new.create': 'Create offer',
    /* ── El asistente, reescrito sobre el armazón del de servicios ─────────────
       Cuatro pasos con raíl de iconos y la página de pago de Stripe maquetada al
       lado. Las claves viejas de los tres pasos anteriores siguen aquí porque
       siguen usándose: cambió el recorrido, no lo que se pregunta. */
    'offers.new.progressAria': 'Wizard steps',
    'offers.new.step.info': 'Information',
    'offers.new.step.files': 'File',
    'offers.new.files.kicker': 'What they download',
    'offers.new.files.title': 'Upload what you are selling',
    'offers.new.files.lead': 'The buyer gets it right after paying, on a page and by email. Up to 15 MB, and it counts towards your project’s storage.',
    'offers.new.step.price': 'Price',
    'offers.new.step.delivery': 'Delivery',
    'offers.new.step.extra': "More info",
    'offerFields.kicker': "Optional",
    'offerFields.title': "Additional information",
    'offerFields.lead': "What makes this one different: ingredients, how to use it, what’s included… Every item of this type has the same fields, and each one fills in its own. The page shows them where you placed them in the editor.",
    'offerFields.loading': "Loading fields…",
    'offerFields.loadFailed': "Couldn’t load the fields. Try again in a moment.",
    'offerFields.empty': "No fields yet. Add one (for example “Ingredients” or “How to use”) and fill it in for each item.",
    'offerFields.remove': "Remove field",
    'offerFields.removeOf': "Remove field {name}",
    'offerFields.removeConfirm': "Remove “{name}”? It disappears from every item of this type, along with what you wrote in it.",
    'offerFields.imagePick': "Choose image",
    'offerFields.imageChange': "Change",
    'offerFields.imageRemove': "Remove image",
    'offerFields.imageSet': "Image added",
    'offerFields.newName': "Field name",
    'offerFields.newPlaceholder': "e.g. Ingredients",
    'offerFields.newType': "Type",
    'offerFields.type.richText': "Text with formatting",
    'offerFields.type.text': "Short text",
    'offerFields.type.image': "Image",
    'offerFields.newHint': "It’s added to every item of this type, empty, so they all have the same fields.",
    'offerFields.create': "Add field",
    'offerFields.add': "Add field",
    'offerFields.unset': "Not filled in",
    'offers.photos.label': "Other photos",
    'offers.photos.makeCover': "Make cover",
    'offers.photos.remove': "Remove photo",
    'offers.photos.add': "Add photos",
    'offerFields.newOption': "+ New field…",
    'offerFields.newHintEditor': "Added to every item of this type. You fill it in for each one in the dashboard.",
    'offerFields.createFailed': "Couldn’t create the field. Try again.",
    'offers.new.step.shipping': 'Shipping',
    'gallery.label': 'Photos',
    'gallery.cover': 'Cover',
    'gallery.makeCover': 'Use as cover',
    'gallery.add': 'Add photo',
    'gallery.moveLeft': 'Move earlier',
    'gallery.moveRight': 'Move later',
    'gallery.hint': '{count} of {max}. Drag to reorder; the first is the cover: it shows in lists, cards and at checkout.',
    'gallery.emptyHint': 'Up to {max} photos. The first one becomes the cover.',
    'offers.new.optional': 'Optional',
    'offers.new.info.kicker': 'What you sell',
    'offers.new.info.title': 'Describe your offer',
    'offers.new.info.lead': 'The name, what it includes and its cover. It is what the buyer reads before deciding, and none of it is final: everything can be changed later.',
    'offers.new.titleRequired': 'Give it a name. It is the only thing an offer cannot go without.',
    'offers.new.price.kicker': 'How much it costs',
    'offers.new.price.title': 'Set the price',
    'offers.new.price.lead': 'Charged once, or every period. You can leave the amount for later. Without one the offer exists but cannot be sold.',
    'offers.new.after.kicker': 'What happens next',
    /* El paso volvió a ser sólo el destino: el tipo se elige en la puerta, así que
       el titular deja de prometer dos cosas y promete una. */
    'offers.new.after.landing': 'Where the buyer lands',
    'offers.new.after.landingLead': 'When they finish paying, Stripe sends them back. This decides where to. The built-in page works from day one, so it is only worth changing if you already have somewhere better.',
    'offers.new.after.landingLeadDigital': 'When they finish paying, Stripe sends them back to the page with their download. The built-in one works from day one and lists the files, so it is only worth changing if you already have somewhere better.',
    'offers.new.after.landingLeadPhysical': 'After paying, Stripe sends them back to your site. The built-in page confirms the purchase, and when you mark the order shipped they get an email with the tracking number.',
    'offers.new.after.pageHint': 'One of your site’s pages: a welcome, the instructions, the download.',
    'offers.new.after.pageMissing': 'Pick which page, or go back to the built-in one.',
    'offers.new.after.urlInvalid': 'It has to be a full address starting with https://',
    'offers.new.after.previewTitle': 'Where they land',
    'offers.new.after.previewHint': 'After paying',
    'offers.new.after.previewNote': 'The buyer gets here from Stripe, with the payment already done. Nothing here has to be built by you unless you want to.',
    'offers.new.thanks.title': 'Thank you for your purchase',
    'offers.new.thanks.body': 'The built-in page confirms the payment and says what was bought and how much. It exists from day one and needs no setup.',
    'offers.new.thanks.back': 'Back to the site',
    'offers.new.thanks.pagePending': 'The page you pick',
    'offers.new.thanks.pageBody': 'Your page, just as you built it. If you delete it later, the purchase falls back to the built-in one instead of breaking.',
    'offers.new.thanks.urlPending': 'The address you write',
    'offers.new.thanks.urlBody': 'They leave your site. Whatever is on the other side is on you: we cannot confirm the purchase there.',
    'offers.new.review.kicker': 'Review',
    'offers.new.review.title2': 'Check it before creating it',
    'offers.new.review.lead': 'Everything you decided, in one place. Anything can still be edited afterwards from the offer’s page.',
    'offers.new.review.after': 'After paying',
    'offers.new.review.edit': 'Edit',
    'offers.new.review.onCreate': 'When you create it',
    'offers.new.review.draftHint': 'Nobody can buy it yet. You put it on sale from its page whenever you want.',
    'offers.new.review.needsPrice': 'Without a price there is nothing to charge, so it can only be created as a draft. You add the price on its page.',
    'offers.new.review.needsStripe': 'Without Stripe connected there is nowhere for the money to go, so it can only be created as a draft. You connect it on the Price step, or later from Settings.',
    'offers.new.next.live': 'It goes on sale right away.',
    'offers.new.next.stays': 'It stays a draft: nobody can buy it yet.',
    'offers.new.createPublish': 'Create and put on sale',
    'offers.new.stripe.publishTitle': 'To sell, connect Stripe',
    'offers.new.stripe.reviewBody': 'The offer gets created either way and keeps everything you wrote. Charging is the only part that waits: the money goes into your own Stripe account, so it has to exist first.',
    'offers.new.stripe.connect': 'Connect Stripe',
    'offers.new.stripe.connecting': 'Opening…',
    'offers.new.previewHint': 'Stripe’s payment page',
    'offers.new.preview.noteZoom': 'It zooms into whatever you are editing. On the last step you see the whole page.',
    'offers.new.preview.noteFull': 'An idea of how it looks, not an exact copy: Stripe draws this page and it changes with the buyer’s country and payment methods.',
    'offers.new.checkout.eyebrow': 'Pay',
    'offers.new.checkout.email': 'Email',
    'offers.new.checkout.card': 'Card',
    'offers.new.checkout.address': 'Shipping address',
    'offers.new.checkout.name': 'Name on the card',
    'offers.new.checkout.pay': 'Pay',
    'offers.new.checkout.subscribe': 'Subscribe',
    'offers.new.checkout.foot': 'Secured by Stripe',
    // ── Payments ──────────────────────────────────────────────────────────────
    'orders.status.paid': 'Paid',
    'orders.status.free': 'Free',
    'orders.status.partial': 'Partly refunded',
    'orders.status.refunded': 'Refunded',
    'orders.loading': 'Loading your payments…',
    'orders.title': 'Payments',
    'orders.searchAria': 'Search payments',
    'orders.searchPlaceholder': 'Search by buyer, email or offer...',
    'orders.clearSearch': 'Clear search',
    'orders.filtersAria': 'Filters and sorting',
    'orders.filtersDialogAria': 'Payment filters and sorting',
    'orders.filterTitle': 'Filter payments',
    'orders.closeFilters': 'Close filters',
    'orders.filterPeriod': 'Period',
    'orders.period.all': 'All time',
    'orders.period.7': 'Last 7 days',
    'orders.period.30': 'Last 30 days',
    'orders.period.90': 'Last 90 days',
    'orders.filterOffer': 'Offer',
    'orders.allOffers': 'All',
    'orders.resetFilters': 'Reset filters',
    'orders.unit': 'payments',
    'orders.loadFailed': 'We could not load your payments.',
    'orders.retry': 'Try again',
    'orders.empty.title': 'No sales yet',
    'orders.empty.body': 'When someone buys on your site, the payment shows up here as soon as Stripe confirms it.',
    'orders.empty.offerTitle': 'This offer has not sold yet',
    'orders.empty.offerBody': 'When someone buys it, the payment shows up here as soon as Stripe confirms it.',
    'orders.noResults.title': 'No payments found',
    'orders.noResults.body': 'None of them match your search. Try another name or clear the filters.',
    'orders.clearFilters': 'Clear filters',
    'orders.deletedOffer': 'Deleted offer',
    'orders.col.offer': 'Offer',
    'orders.col.buyer': 'Buyer',
    'orders.col.amount': 'Amount',
    'orders.col.status': 'Status',
    'orders.col.date': 'Date',
    'orders.col.actions': 'Actions',
    'orders.noName': 'No name',
    'orders.noEmail': 'No email',
    'orders.viewBuyerAria': 'Open the record for {email}',
    'orders.disputed': 'Disputed',
    'orders.disputedTitle': 'Disputed: {amount}',
    'orders.disputeCount.one': '1 dispute',
    'orders.disputeCount.many': '{count} disputes',
    'orders.toShipCount': '{count} to ship',
    'orders.fulfillment.unfulfilled': 'To ship',
    'orders.fulfillment.shipped': 'Shipped',
    'orders.fulfillment.delivered': 'Delivered',
    'orders.fulfillment.ready_for_pickup': 'Ready for pickup',
    'orders.fulfillment.picked_up': 'Picked up',
    'orders.shipping.title': 'Shipping',
    'orders.shipping.shipTo': 'Ship to',
    'orders.shipping.copy': 'Copy address',
    'orders.shipping.copied': 'Address copied',
    'orders.shipping.phone': 'Phone',
    'orders.shipping.method': 'Shipping method',
    'orders.shipping.tracking': 'Tracking',
    'orders.shipping.shippedAt': 'Shipped on',
    'orders.shipping.deliveredAt': 'Delivered on',
    'orders.shipping.pickedUpAt': 'Picked up on',
    'orders.shipping.carrier': 'Carrier',
    'orders.shipping.otherCarrier': 'Other',
    'orders.shipping.carrierName': 'Carrier name',
    'orders.shipping.number': 'Tracking number',
    'orders.shipping.url': 'Tracking link',
    'orders.shipping.notify': 'Email the buyer',
    'orders.shipping.markShipped': 'Mark as shipped',
    'orders.shipping.saveTracking': 'Save tracking',
    'orders.shipping.markReady': 'Ready for pickup',
    'orders.shipping.markDelivered': 'Mark as delivered',
    'orders.shipping.editTracking': 'Edit tracking',
    'orders.shipping.markPickedUp': 'Mark as picked up',
    'orders.shipping.undo': 'Back to “To ship”',
    'orders.shipping.printSlip': 'Packing slip',
    'orders.detail.tabShipping': 'Shipping',
    'orders.detail.tabPurchase': 'Purchase',
    'orders.detail.loadFailed': "Couldn't load this order's shipping.",
    'orders.shipping.step.paid': 'Paid',
    'orders.shipping.step.preparing': 'Preparing',
    'orders.shipping.step.shipped': 'Shipped',
    'orders.shipping.step.delivered': 'Delivered',
    'orders.shipping.step.ready': 'Ready for pickup',
    'orders.shipping.step.pickedUp': 'Picked up',
    'orders.shipping.hint.unfulfilled': 'Get it ready and, once you hand it to the carrier, mark it as shipped: the buyer gets an email with the tracking number. If they pick it up at your business, mark it as ready for pickup.',
    'orders.shipping.hint.unfulfilledShip': 'Get it ready and, once you hand it to the carrier, mark it as shipped: the buyer gets an email with the tracking number.',
    'orders.shipping.hint.unfulfilledPickup': 'They’ll pick it up at your business. Once it’s ready, let them know: they get an email to come by.',
    'orders.shipping.hint.shipped': 'It’s on its way. Once it arrives, mark it as delivered.',
    'orders.shipping.hint.ready_for_pickup': 'We told the buyer they can come by. Once they pick it up, mark it as picked up.',
    'orders.shipping.track': 'Track package',
    'orders.shipping.pickupTitle': 'Local pickup',
    'orders.products': "{count} products",
    'orders.units': "{count} units",
    'orders.shipping.more': 'More actions',
    'orders.shipping.correctTitle': 'Correct status',
    'orders.shipping.backTo': 'Back to “{status}”',
    'orders.shipping.correctConfirmTitle': 'Correct the order status?',
    'orders.shipping.correctConfirmBody': 'The order goes back to “{status}”. The buyer doesn’t get any email, and it’s noted in the history.',
    'orders.history.title': 'History',
    'orders.history.paid': 'Order paid · {amount}',
    'orders.history.emailConfirmation': 'Confirmation email sent to the buyer',
    'orders.history.emailRefund': "Refund email sent to the buyer",
    'orders.history.emailShipped': '“On its way” email sent to the buyer',
    'orders.history.emailReady': '“Ready for pickup” email sent to the buyer',
    'orders.history.shipped': 'Shipped',
    'orders.history.delivered': 'Delivered',
    'orders.history.ready': 'Ready for pickup',
    'orders.history.pickedUp': 'Picked up',
    'orders.history.corrected': 'Status corrected: back to “{status}”',
    'orders.history.refundedFull': 'Fully refunded · {amount}',
    'orders.history.refundedPartial': 'Partial refund · {amount}',
    'orders.history.restocked': 'The unit went back into stock',
    'orders.history.oversold': "Sold without stock",
    'orders.history.auto': 'Automatic',
    'orders.history.byTeam': 'by {name}',
    'orders.history.byCustomer': '{name}',
    'orders.shipping.saved': 'Order updated',
    'orders.shipping.savedNotified': 'Order updated and buyer notified',
    'orders.shipping.restocked': 'The unit went back into stock when it was refunded.',
    'orders.underReview': 'Under review',
    'orders.underReviewTitle': 'Dispute under review: {amount}. The buyer’s bank decides.',
    'orders.exportCsv': 'Export CSV',
    /* Importe y devuelto van en unidades y sin símbolo, y la moneda en su propia
       columna: una hoja suma números, no «$1,234.50». */
    'orders.csv.filename': 'payments',
    'orders.csv.date': 'Date',
    'orders.csv.offer': 'Offer',
    'orders.csv.variant': 'Variant',
    'orders.csv.quantity': 'Quantity',
    'orders.csv.buyer': 'Buyer',
    'orders.csv.email': 'Email',
    'orders.csv.amount': 'Amount',
    'orders.csv.currency': 'Currency',
    'orders.csv.refunded': 'Refunded',
    'orders.csv.status': 'Status',
    'orders.csv.dispute': 'Dispute',
    'orders.csv.fulfillment': 'Fulfillment',
    'orders.csv.shipName': 'Ship to',
    'orders.csv.shipPhone': 'Phone',
    'orders.csv.shipLine1': 'Address',
    'orders.csv.shipLine2': 'Address 2',
    'orders.csv.shipCity': 'City',
    'orders.csv.shipState': 'State',
    'orders.csv.shipPostalCode': 'Postal code',
    'orders.csv.shipCountry': 'Country',
    'orders.csv.shipMethod': 'Shipping method',
    'orders.csv.carrier': 'Carrier',
    'orders.csv.tracking': 'Tracking number',
    'orders.csv.id': 'Reference',
    'orders.open': 'Open',
    'orders.moreOptions': 'More options',
    'orders.options': 'Options',
    'orders.menu.view': 'View payment',
    'orders.menu.buyer': 'View the buyer',
    'orders.menu.email': 'Email them',
    // ── Payments · detail ─────────────────────────────────────────────────────
    'orders.detail.dialogAria': 'Payment details',
    'orders.detail.close': 'Close',
    'orders.detail.disputeTitle': 'This payment was disputed',
    'orders.detail.disputeBody1': 'The buyer claimed {amount} back from their bank.',
    'orders.detail.disputeBody2': 'If nobody responds, it is lost without anyone reviewing it.',
    'orders.detail.disputeCta': 'Respond to the dispute',
    'orders.detail.reviewTitle': 'Dispute under review',
    'orders.detail.reviewBody': 'The {amount} claim has already been answered.',
    'orders.detail.reviewCta': 'View the dispute',
    'orders.detail.buyer': 'Buyer',
    'orders.detail.email': 'Email',
    'orders.detail.amount': 'Amount',
    'orders.detail.status': 'Status',
    'orders.detail.date': 'Date',
    'orders.detail.subscription': 'Subscription',
    'orders.detail.thisCharge': 'This charge',
    'orders.detail.customerSince': 'Customer since',
    'orders.detail.chargedTotal': 'Charged in total',
    /* Un pedido de una oferta gratuita: no hubo pasarela, así que en lugar del
       apartado del cobro va la explicación de por qué no hay ninguno. */
    'orders.detail.receipt': 'View receipt',
    'orders.detail.openInStripe': 'View more details',
    'orders.detail.offerDeleted': 'Deleted offer',
    'orders.detail.offerLabel': 'Offer',
    'orders.detail.item': 'Item',
    'orders.detail.items': 'Items ({count})',
    'orders.detail.total': 'Total',
    'orders.detail.customer': 'Customer',
    'orders.detail.cardName': "Card in the name of {name}",
    'orders.detail.free': 'Free',
    'orders.detail.viewOffer': 'View the offer',
    'orders.detail.respond': 'Respond',
    'orders.detail.view': 'View',
    'orders.detail.reviewBody2': 'The buyer’s bank decides now, which takes a few weeks. In the meantime the money stays held and there is nothing else to do.',
    'orders.detail.refundedNote': 'Refunded: {amount}',
    'orders.detail.paymentAndRefunds': 'Payment and refunds',
    'orders.detail.paymentMethod': 'Payment method',
    'orders.detail.refunds': 'Refunded',
    'orders.detail.noRefunds': 'No refunds',
    'orders.detail.unrefunded': 'Unrefunded amount',
    'orders.detail.manageRefunds': 'View and manage refunds in Stripe',
    'orders.detail.updatingPayment': 'Updating payment information…',
    'orders.detail.savedPayment': 'Showing saved data. The latest information from Stripe could not be retrieved.',
    'orders.detail.retryPayment': 'Retry',
    'orders.detail.chargeOf': 'Charge {number} of {total}',
    'orders.detail.fromSubscription': 'From a subscription',
    'orders.detail.manageInStripe': 'View more details in Stripe',
    'orders.detail.openStripe': 'Open Stripe',
    'orders.detail.due.past': 'The deadline to respond has passed.',
    'orders.detail.due.today': 'The deadline is today.',
    'orders.detail.due.one': '1 day left to respond.',
    'orders.detail.due.many': '{days} days left to respond.',
    // ── Stripe and payouts ────────────────────────────────────────────────────
    'stripe.banner.none.title': 'You cannot take payments yet',
    'stripe.banner.none.detail': 'You can create your offers and get them ready right now: they save either way. Connect Stripe to publish them and let someone pay.',
    'stripe.banner.pending.title': 'Finish setting up Stripe',
    'stripe.banner.pending.detail': 'Your Stripe account still needs a few details. Pick the setup back up to finish it.',
    'stripe.banner.restricted.title': 'Stripe has not enabled your payments yet',
    'stripe.banner.restricted.detail': 'You finished signing up, but Stripe has not enabled payments yet. It usually resolves on its own; if they need something, it will show up in the Stripe settings.',
    'stripe.banner.ready.title': 'Your account can take payments',
    'stripe.banner.ready.detail': 'The money from each sale goes straight into it.',
    'stripe.banner.failedTitle': 'We could not check your Stripe account',
    'stripe.banner.failedBody': 'You can keep creating and editing offers as usual. What we do not know right now is whether your account can take payments.',
    'stripe.retry': 'Try again',
    'stripe.connect': 'Connect with Stripe',
    /* Falta desde que el selector de estado ofrece los planes a quien no puede
       ni conectar: se pintaba «stripe.seePlans» tal cual en el botón. */
    'stripe.seePlans': 'See plans',
    'stripe.continueSetup': 'Continue setup',
    'stripeAttention.close': 'Close',
    'stripeAttention.neverShow': "Don't show again",
    'stripeAttention.kicker': 'Stripe',
    'stripeAttention.stripe.title': 'Stripe needs something from you',
    'stripeAttention.stripe.bodyOne': 'There is 1 pending item in your Stripe account, like confirming your email or a business detail.',
    'stripeAttention.stripe.bodyMany': 'There are {count} pending items in your Stripe account, like confirming your email or a business detail.',
    'stripeAttention.stripe.cta': 'Resolve',
    'stripeAttention.stripe.dialogBody': 'What Stripe needs to keep your account active. You can complete it right here.',
    'stripeAttention.tax.title': 'Do you need to collect taxes?',
    'stripeAttention.tax.body': 'Stripe can calculate and collect them on every sale. You decide whether you need it: tax obligations belong to your business.',
    'stripeAttention.tax.cta': 'Set up',
    'stripe.title': 'Stripe',
    /* El aviso al negocio, oferta por oferta. Estuvo en Configuración › Stripe,
       con un solo destinatario para todo el catálogo: ver `OfferSalesNotice`. */
    'offers.notify.title': 'Sale notices',
    'offers.notify.toggle': 'Notify me about this offer',
    'offers.notify.body': 'We email you when someone buys this offer, with the key details of the transaction.',
    'offers.notify.bookableBody': 'We email you when someone books this service, and when they move or cancel their appointment.',
    'offers.notify.emailLabel': 'Send to',
    'offers.notify.emailPlaceholder': 'name@example.com',
    'offers.notify.sendTo': 'Send to',
    'offers.notify.to.list': 'These emails',
    'offers.notify.to.list.hint': 'Every booking goes to the same inbox.',
    'offers.notify.to.person': 'The person on the booking',
    'offers.notify.to.person.hint': 'Each person only gets their own.',
    'offers.notify.personList': 'Each person’s email',
    'offers.notify.personEmail': 'name@example.com',
    'offers.notify.personEmailAria': '{name}’s email',
    'offers.notify.fallbackLabel': 'If someone has no email, their notices go to',
    'bookings.team.email': 'Email',
    'bookings.team.addEmail': 'Email for their notices (optional)',
    'bookings.team.emailInvalid': 'That email doesn’t look valid.',
    'offers.notify.add': 'Add',
    'offers.notify.remove': 'Remove {email}',
    'offers.notify.max': 'At most 5 emails can receive notices.',
    'offers.notify.invalid': 'Enter a valid email address.',
    'offers.notify.duplicate': 'This email has already been added.',
    'offers.notify.needEmail': 'Add at least one email to receive notices.',
    'offers.notify.saved': 'Notices for this offer updated',
    'offers.notify.off': 'Notifications are disabled.',
    'offers.notify.bookableOff': 'Notifications are disabled.',
    /* Los rótulos que ordenan la pantalla. Cortos a propósito: son separadores,
       no títulos, y el que explica cada cosa es el de su tarjeta. */
    'stripe.group.account': 'Your account',
    'stripe.group.sale': 'How each sale is charged',
    'stripe.group.start': 'First steps',
    'stripe.hero.none.title': "You can't get paid yet",
    'stripe.hero.none.body': 'Connect a Stripe account to charge for your offers. It takes a few minutes, the account is in your name and the money from each sale goes straight to it.',
    'stripe.hero.pending.title': 'Stripe still needs some details',
    'stripe.hero.pending.body': 'Stripe needs you to finish filling in your information before it turns on payments. Pick up where you left off.',
    'stripe.hero.restricted.title': 'Stripe is reviewing your account',
    'stripe.hero.restricted.body': "You've sent your details, but Stripe hasn't turned on payments yet. If it needs anything else, it shows up right below.",
    'stripe.hero.ready.title': 'You can get paid',
    'stripe.hero.ready.body': 'Your published offers charge straight into your Stripe account, and Stripe pays the money out to your bank.',
    'stripe.hero.meanwhile': 'Meanwhile, create your offers',
    'stripe.hero.goOffers': 'See my offers',
    'stripe.progress.connect': 'Connect your account',
    'stripe.progress.details': 'Complete your details',
    'stripe.progress.charges': 'Stripe turns on payments',
    'stripe.progress.done': 'done',
    'stripe.progress.current': 'current step',
    'stripe.progress.next': 'pending',
    'stripe.account.title': 'Stripe account',
    'stripe.account.subtitle': 'Check the status of the integration and manage the account that processes your payments.',
    'stripe.status.none': 'Not connected',
    'stripe.status.pending': 'Setup pending',
    'stripe.status.restricted': 'Awaiting review',
    'stripe.status.ready': 'Connected',
    'stripe.detail.none': 'You can create and edit your offers before connecting an account. Connecting Stripe is what lets them be published and paid for.',
    'stripe.detail.pending': 'Your Stripe account still needs a few details. Pick the setup back up to finish it.',
    'stripe.detail.restricted': 'Setup is finished, but Stripe has not enabled payments yet. Check the requirements listed below.',
    'stripe.detail.ready': 'The account can take payments and manage the matching transfers.',
    'stripe.detail.planLocked': 'Connecting Stripe comes with Pro or Business. Creating and editing your offers is free: they save either way, and they publish as soon as there is an account that can charge for them.',
    'stripe.checking': 'Checking your account status…',
    'stripe.checkFailed': 'We could not check the account status.',
    'stripe.fact.country': 'Account country',
    'stripe.fact.currency': 'Currency',
    'stripe.fact.payouts': 'Transfers to your bank',
    'stripe.payouts.on': 'Active',
    'stripe.payouts.off': 'Pending',
    'stripe.disconnect': 'Disconnect',
    'stripe.openDashboard': 'Open Stripe dashboard',
    'stripe.resetSetup': 'Restart setup',
    'stripe.disconnected': 'Account disconnected',
    'stripe.disconnect.short': 'The site stops taking payments. You can reconnect it later.',
    'stripe.danger.resetShort': 'Start over with another account.',
    'stripe.disconnect.title': 'Disconnect the account',
    'stripe.disconnect.body': 'The site will stop taking payments. The account and its history stay available in Stripe, and you can connect it again later.',
    'stripe.steps.title': 'Selling process',
    'stripe.steps.subtitle': 'Complete these steps to start accepting payments.',
    'stripe.steps.manageOffers': 'Manage offers',
    'stripe.steps.one': 'Create an offer with product, price, images and description',
    'stripe.steps.two': 'Add the buy action to a page and publish the site',
    'stripe.steps.three': 'Connect a Stripe account to enable payments',
    'stripe.account.business': 'Business details',
    'stripe.account.businessBody': 'Legal name, address and tax details',
    'stripe.account.bank': 'Bank account',
    'stripe.account.bankBody': 'Where your payouts go',
    'stripe.account.dataTitle': 'Your account details',
    'stripe.account.dataSubtitle': 'Stripe stores them, not us, and you change them in your Stripe dashboard.',
    'stripe.onboarding.done': 'Done',
    'stripe.settings.description': "Connect and manage the Stripe account that processes your site’s payments and payouts.",
    'stripe.onboarding.doneAria': "Stripe setup finished",
    'stripe.onboarding.progressAria': "Stripe setup in progress",
    'stripe.onboarding.readyTitle': "Your account can now take payments",
    'stripe.onboarding.reviewTitle': "Setup sent to Stripe",
    'stripe.onboarding.readyBody': "The money from every sale goes straight to your Stripe account.",
    'stripe.onboarding.reviewBody': "You finished the setup and Stripe is reviewing your details. It usually resolves on its own; if anything else is needed, it will show up here.",
    'stripe.onboarding.title': 'Finishing your Stripe signup…',
    'stripe.onboarding.body': 'It opened in another tab. When you finish, this updates on its own.',
    'stripe.onboarding.close': 'Close',
    'stripe.onboarding.later': 'Continue later',
    'stripe.embed.close': 'Close',
    'stripe.embed.disputeAria': 'Dispute in Stripe',
    'stripe.embed.paymentAria': 'Payment in Stripe',
    'stripe.embed.openingDispute': 'Opening the dispute…',
    'stripe.embed.openingPayment': 'Opening Stripe…',
    'stripe.embed.openingAccount': 'Opening your details…',
    'stripe.tax.rowOn': 'On: collected on every sale',
    'stripe.tax.rowOff': 'Off',
    'stripe.tax.rowIncomplete': 'Setup in Stripe is incomplete',
    'stripe.tax.configure': 'Set up',
    'stripe.tax.title': 'Taxes',
    'stripe.tax.subtitle': 'Stripe calculates and collects the tax on each sale based on where the buyer is.',
    'stripe.tax.toggle': 'Collect taxes at checkout',
    'stripe.tax.onReady': 'Taxes are collected on every sale.',
    'stripe.tax.offReady': 'Setup is complete; taxes are turned off.',
    'stripe.tax.registrationsOne': '1 active tax registration',
    'stripe.tax.registrationsMany': '{count} active tax registrations',
    'stripe.tax.registrationsNone': 'No tax registrations',
    'stripe.tax.behaviorInclusive': 'prices include tax',
    'stripe.tax.behaviorExclusive': 'tax is added to the price',
    'stripe.tax.behaviorByCurrency': 'included or added depending on currency',
    'stripe.tax.pending': 'Your tax settings in Stripe are incomplete (head office and how prices are treated). Taxes cannot be turned on until then.',
    'stripe.tax.noRegistrationsHint': 'Without a tax registration Stripe collects nowhere: add the countries or states where you are registered.',
    'stripe.tax.openSetup': 'Set up taxes',
    'stripe.tax.hideSetup': 'Hide',
    'stripe.tax.opening': 'Opening tax settings…',
    'orders.detail.tax': 'Taxes',
    'orders.detail.taxNote': 'Included in the amount',
    'stripe.embed.rejected': 'Stripe refused the embedded view. Check that the Connect embedded components are enabled in your platform account.',
    'stripe.embed.failed': 'We could not load {subject} from Stripe.',
    'stripe.embed.subject.dispute': 'the dispute',
    'stripe.embed.subject.payment': 'the payment',
    'stripe.embed.subject.payouts': 'your payouts',
    'stripe.embed.subject.notices': 'your account notices',
    'stripe.embed.subject.account': 'your account details',
    'payouts.title': 'Payouts',
    'payouts.subtitle': 'Your Stripe balance and when it reaches your bank.',
    'payouts.openStripe': 'View in Stripe',
    'payouts.next': 'Next payout',
    'payouts.balance': 'Your balance',
    'payouts.notEnabled': 'Stripe has not enabled your payouts yet',
    'payouts.arrives': 'Arrives {when}',
    'payouts.arrivesApprox': 'Arrives around {when}',
    'payouts.inTransitSuffix': ' · on its way',
    'payouts.noneScheduled': 'No payout scheduled',
    'payouts.arrival.today': 'today',
    'payouts.arrival.tomorrow': 'tomorrow',
    'payouts.available': 'Available',
    'payouts.availableNegative': 'Deducted from your next payout',
    'payouts.availableReady': 'Ready to be paid out',
    'payouts.inTransit': 'On its way',
    'payouts.inTransitNote': 'Charged, within Stripe’s window',
    'payouts.viaStripeOnly': 'Payouts are checked from your Stripe dashboard.',
    'payouts.empty.title': 'No payouts yet',
    'payouts.empty.body': 'When someone buys on your site, you will see your balance here and the date Stripe sends it to your bank.',
    'payouts.emptyNoAccount.body': 'Once you connect Stripe and someone buys on your site, you will see your balance here and the date it reaches your bank.',
    'payouts.loadingBalance': 'Checking your balance…',
    'payouts.loadingAccount': 'Checking your Stripe account…',
    // ── Billing ───────────────────────────────────────────────────────────────
    'billing.loading': 'Loading your billing…',
    'billing.title': 'Billing',
    'billing.subtitleShort': 'Your membership, your domains and all your charges.',
    'billing.subtitle': 'Your membership, the domains you bought and your account charges.',
    'billing.loadFailed': 'We could not load your billing.',
    'billing.actionFailed': 'We could not complete the action.',
    'billing.historyFailed': 'We could not load the history.',
    'billing.retry': 'Try again',
    'billing.refresh': 'Refresh',
    'billing.stripePortal': 'Stripe portal',
    'billing.changePlan': 'Change plan',
    'billing.seePlans': 'See plans',
    'billing.status.past_due': 'There is a charge outstanding. Check your card so you do not lose the plan.',
    'billing.status.unpaid': 'We could not charge the renewal. Update your card to reactivate the plan.',
    'billing.status.incomplete': 'The payment was left halfway. Try again from Plans.',
    'billing.status.paused': 'Your membership is paused.',
    'billing.invoice.paid': 'Paid',
    'billing.invoice.open': 'Outstanding',
    'billing.invoice.uncollectible': 'Uncollectible',
    'billing.invoice.void': 'Voided',
    'billing.invoice.number': 'Invoice {number}',
    'billing.confirm.yesCancel': 'Yes, cancel',
    'billing.confirm.cancelling': 'Cancelling…',
    'billing.membership.keepPlan': 'Keep my plan',
    'billing.cards.removing': 'Removing…',
    'billing.domain.cancelTitle': 'Cancel {domain}?',
    'billing.domain.keep': 'Keep domain',
    'billing.domain.disconnectedToast': '{domain} was disconnected from the site.',
    'billing.membership.resume': 'Resume',
    'billing.options': 'Options',
    'billing.domain.active': 'Active',
    'billing.domain.error': 'Needs attention',
    'billing.domain.disconnected': 'Cancelled',
    'billing.domain.purchasing': 'Registering',
    'billing.domain.pending': 'In progress',
    'billing.interval.year': 'Yearly',
    'billing.interval.month': 'Monthly',
    'billing.until.overdue': 'overdue',
    'billing.until.today': 'today',
    'billing.until.tomorrow': 'tomorrow',
    'billing.until.days': 'in {days} days',
    'billing.until.month': 'in 1 month',
    'billing.until.months': 'in {months} months',
    'billing.cardLabel': '{brand} ending in {last4}',
    'billing.upcoming.membership': 'Membership: {plan}',
    'billing.upcoming.membershipInterval': 'Membership: {plan} · {interval}',
    'billing.upcoming.renewal': 'Renewal scheduled',
    'billing.upcoming.domain': 'Domain: {hostname}',
    'billing.upcoming.domainMeta': 'Renewal · {project}',
    'billing.alert.cardExpired': 'Your default card ({card}) has expired. Add another one so the next charge does not fail.',
    'billing.alert.cardSoon': 'Your default card ({card}) expires this month.',
    'billing.alert.granted': 'Your plan is set directly on your account, without a Stripe subscription behind it. That is why there is no amount, no renewal and no invoices: nothing is charged and there is nothing to cancel.',
    'billing.alert.cancelled': 'You cancelled your membership. You keep everything until {date}; after that your sites move to the free plan, stay published and nothing is deleted.',
    'billing.alert.domainFailed': 'We charged for {hostname} but the registration did not go through. Write to us and we will fix it or refund you.',
    'billing.membership.title': 'Membership',
    'billing.membership.subtitle': 'Your current plan, how long it runs and its options.',
    'billing.membership.eyebrow': 'véltica membership',
    'billing.membership.noCharge': 'No charge',
    'billing.membership.cancelled': 'Cancelled',
    'billing.membership.active': 'Active',
    'billing.membership.starter': 'Starter',
    'billing.membership.plan': '{plan} plan',
    'billing.membership.free': 'Free',
    'billing.membership.endsOn': 'Ends on {date}.',
    'billing.membership.renewsOn': 'Next renewal on {date}.',
    'billing.membership.freeBody': 'It includes the essentials to start building.',
    'billing.membership.resumed': 'Your membership stays active. It will not be cancelled.',
    'billing.membership.change': 'Change plan',
    'billing.membership.cancelling': 'Cancelling…',
    'billing.membership.cancelRenewal': 'Cancel renewal',
    'billing.membership.cancel': 'Cancel membership',
    'billing.membership.perYear': 'per year',
    'billing.membership.perMonth': 'per month',
    'billing.membership.cancelTitle': 'Cancel your membership?',
    'billing.membership.cancelled.toast': 'Your membership will be cancelled at the end of the period.',
    'billing.domains.title': 'Domains',
    'billing.domains.subtitle': 'The domains you bought, how long they run and how they are connected.',
    'billing.domains.registering': 'Registering…',
    'billing.domains.manage': 'Manage domain',
    'billing.domains.empty': 'You have not bought any domain yet.',
    'billing.domains.search': 'Find a domain',
    'billing.upcomingTitle': 'Upcoming charges',
    'billing.upcomingSubtitle': 'Everything scheduled, from the nearest to the furthest.',
    'billing.upcomingNote': 'A domain renewal price can change from year to year; its expiration date appears in the domain list.',
    'billing.historyTitle': 'Billing history',
    'billing.historySubtitle': 'Membership and domains, from the most recent to the oldest.',
    'billing.viewInvoice': 'View the invoice',
    'billing.downloadPdf': 'Download the PDF',
    'billing.pagerAria': 'History pages',
    'billing.pagerPrevious': 'Previous',
    'billing.pagerNext': 'Next',
    'billing.pagerPage': 'Page {page}',
    'billing.opening': 'Opening…',
    'billing.openPortalShort': 'open its portal',
    'billing.openPortal': 'Open the Stripe portal',
    'billing.noInvoicesGranted': 'There are no invoices because this account has never been charged.',
    'billing.noInvoices': 'No invoices yet. Your charges will show up here as soon as there is one.',
    'billing.cards.title': 'Payment methods',
    'billing.cards.subtitle': 'Renewals are charged to the default one.',
    'billing.cards.add': 'Add',
    'billing.cards.addCard': 'Add card',
    'billing.cards.default': 'Default',
    'billing.cards.expired': 'Expired',
    'billing.cards.expiringSoon': 'Expiring soon',
    'billing.cards.expiry': 'Expires',
    'billing.cards.makingDefault': 'Changing…',
    'billing.cards.makeDefault': 'Make default',
    'billing.cards.defaultDone': 'Done. Future charges will use that card.',
    'billing.cards.saved': 'Card saved.',
    'billing.cards.removeTitle': 'Remove this card?',
    'billing.cards.removeBody': 'We will stop using the {card} for your charges.',
    'billing.domains.view': 'View domains',
    'billing.noUpcoming': 'No charges scheduled.',
    'billing.cards.remove': 'Remove',
    'billing.portalNote1': 'Invoices are issued by Stripe.',
    'billing.portalNote2': 'for your tax details and the receipt for each charge.',
    'billing.domain.disconnect.body1': 'The domain will be disconnected from',
    'billing.domain.disconnect.body2': 'right away. It stays yours until {date} and you can reconnect it during that period. The year already paid is not refundable.',
    'billing.cards.removed': 'Card removed.',
    'billing.cards.empty': 'You have no saved cards.',
    'billing.cards.emptyGranted': 'This account is not charged, so there is no card to save.',
    'billing.cards.emptyNoCharges': 'No charges on your account yet. The first card is saved when you take a plan.',
    // ── Bookings ──────────────────────────────────────────────────────────────
    'bookings.status.held': 'Held',
    'bookings.status.confirmed': 'Confirmed',
    'bookings.status.cancelled': 'Cancelled',
    'bookings.status.completed': 'Attended',
    'bookings.status.no_show': 'No-show',
    'bookings.exportCsv': 'Export CSV',
    /* La hora va dos veces: la que se lee, en la zona en que se reservó, y la
       ISO, que es la que ordena y resta bien en cualquier hoja. */
    'bookings.csv.filename': 'bookings',
    'bookings.csv.day': 'Day',
    'bookings.csv.time': 'Time',
    'bookings.csv.startIso': 'Start (ISO)',
    'bookings.csv.service': 'Service',
    'bookings.csv.customer': 'Customer',
    'bookings.csv.email': 'Email',
    'bookings.csv.phone': 'Phone',
    'bookings.csv.status': 'Status',
    'bookings.csv.note': 'Customer note',
    'bookings.csv.answers': 'Answers',
    'bookings.csv.createdAt': 'Booked on',
    'bookings.overdueHint': 'It already passed and the outcome is not recorded',
    'bookings.action.confirm': 'Confirm',
    'bookings.action.markAttended': 'Mark attendance',
    'bookings.action.noShow': 'No-show',
    'bookings.action.cancel': 'Cancel',
    'bookings.dur.minutes': '{minutes} min',
    'bookings.allDay': 'All day',
    'bookings.dur.oneDay': '1 day',
    'bookings.dur.days': '{days} days',
    'bookings.dur.hours': '{hours} h',
    'bookings.dur.hoursMinutes': '{hours} h {minutes} min',
    'bookings.dur.longHour': '1 hour',
    'bookings.dur.longHours': '{hours} hours',
    'bookings.dur.longMinute': '1 minute',
    'bookings.dur.longMinutes': '{minutes} minutes',
    'bookings.dur.zero': '0 minutes',
    'bookings.mode.none': 'No calendar',
    'bookings.mode.single': 'One-to-one',
    'bookings.mode.singleTitle': 'One person per appointment',
    'bookings.mode.group': 'Group · {capacity}',
    'bookings.mode.groupTitle': 'Up to {capacity} people per appointment',
    'bookings.people.one': '1 person',
    'bookings.people.many': '{count} people',
    'bookings.tally.held.one': '{count} held',
    'bookings.tally.held.many': '{count} held',
    'bookings.tally.confirmed.one': '{count} confirmed',
    'bookings.tally.confirmed.many': '{count} confirmed',
    'bookings.tally.cancelled.one': '{count} cancelled',
    'bookings.tally.cancelled.many': '{count} cancelled',
    'bookings.tally.completed.one': '{count} attended',
    'bookings.tally.completed.many': '{count} attended',
    'bookings.tally.no_show.one': '{count} no-show',
    'bookings.tally.no_show.many': '{count} no-shows',
    'bookings.filter.all': 'All',
    'bookings.filter.upcoming': 'Upcoming',
    'bookings.filter.confirmed': 'Confirmed',
    'bookings.filter.held': 'Held',
    'bookings.filter.cancelled': 'Cancelled',
    'bookings.group.eyebrow': 'Group class',
    'bookings.group.fallbackTitle': 'Class',
    'bookings.group.closePanel': 'Close panel',
    'bookings.group.reservations': 'Reservations',
    'bookings.group.schedule': 'Schedule',
    'bookings.group.scheduleRange': '{from} to {to}',
    'bookings.group.duration': 'Duration',
    'bookings.group.statusTitle': 'Group status',
    'bookings.group.statusAria': 'Breakdown by status',
    'bookings.group.seat': 'Seat {seat}',
    'bookings.detail.people': 'People',
    'bookings.detail.guests': "Guests",
    'bookings.detail.peopleCount': '{count} people',
    'bookings.detail.withWhom': 'With',
    'bookings.detail.artistDone': 'Done',
    'bookings.detail.artistChange': 'Change',
    'bookings.partyShort': '× {count}',
    'bookings.group.seats': 'Spots {from}–{to}',
    'bookings.group.viewDetail': 'View details',
    'bookings.group.view': 'View group',
    'bookings.group.count': '{label}',
    'bookings.noName': 'No name',
    'bookings.noEmail': 'No email',
    'bookings.noPhone': 'No phone',
    'bookings.noService': 'No service',
    'bookings.serviceFallback': 'Service',
    'bookings.loading': 'Loading your bookings…',
    'bookings.searchAria': 'Search bookings',
    'bookings.searchPlaceholder': 'Search by customer or service...',
    'bookings.clearSearch': 'Clear search',
    'bookings.from': 'From',
    'bookings.to': 'To',
    'bookings.filtersAria': 'Filters and sorting',
    'bookings.filtersDialogAria': 'Booking filters and sorting',
    'bookings.filterTitle': 'Filter bookings',
    'bookings.closeFilters': 'Close filters',
    'bookings.filterStatus': 'Status',
    'bookings.filterRange': 'Date range',
    'bookings.resetFilters': 'Reset filters',
    'bookings.filterByService': 'Filter by service',
    'bookings.filterByArtist': 'Artist',
    'bookings.allArtists': 'Whole team',
    'bookings.withArtist': 'With {name}',
    'bookings.allServices': 'All services',
    'bookings.new': 'New booking',
    'bookings.newShort': 'New',
    'bookings.loadFailed': 'We could not load your bookings.',
    'bookings.retry': 'Try again',
    'bookings.empty.title': 'No bookings in these dates',
    'bookings.noResults.title': 'No booking matches',
    'bookings.noResults.body': 'Try another search or clear the filters.',
    'bookings.clearFilters': 'Clear filters',
    'bookings.col.customer': 'Customer',
    'bookings.col.service': 'Service',
    'bookings.col.date': 'Date',
    'bookings.col.time': 'Time',
    'bookings.col.duration': 'Duration',
    'bookings.col.status': 'Status',
    'bookings.view': 'View',
    'bookings.empty.body': 'When someone books from your site it shows up here. You can also write an appointment down by hand if they ask over the phone.',
    'bookings.clear': 'Clear',
    'bookings.unit': 'appointments',
    'bookings.viewAria': 'View {customer}’s booking',
    'bookings.optionsAria': 'Options for {customer}',
    'bookings.unnamedCustomer': 'unnamed customer',
    'bookings.viewTooltip': 'View booking',
    'bookings.cal.title': 'Appointments',
    'calsync.open': "Sync calendars",
    'calsync.other.title': "Connect another calendar",
    'calsync.other.hint': "Outlook or Apple, and any calendar by link.",
    'calsync.google.title': "Connect Google Calendar",
    'calsync.google.hint': "The simplest way: your bookings show up in your calendar right away and your events block times, without copying any link.",
    'calsync.google.connect': "Connect with Google",
    'calsync.google.schedule': "Connect for",
    'calsync.google.reconnect': "Connect another account",
    'calsync.google.permissions': "We only ask permission to create bookings in your calendar and see your busy times. We do not read the contents of your events.",
    'calsync.google.connected': "Google account connected",
    'calsync.google.working': "Connected · bookings are written and your busy times are blocked",
    'calsync.google.write': "Write my bookings to their calendar",
    'calsync.google.block': "Block times when I am busy",
    'calsync.google.remove': "Disconnect",
    'calsync.google.removeAria': "Disconnect the account {email}",
    'calsync.google.removeTitle': "Disconnect Google Calendar?",
    'calsync.google.removeBody': "We will stop writing your bookings and reading your busy times, and we will revoke véltica’s access in your Google account. Events already in your calendar stay there.",
    'calsync.google.error.reconnect': "The account needs to be connected again: Google revoked the permission.",
    'calsync.google.error.forbidden': "Google refused the operation. Check that the calendar still exists.",
    'calsync.google.error.unreachable': "We could not reach Google. We will try again on our own.",
    'calsync.toast.googleConnected': "Google Calendar connected",
    'calsync.toast.googleCancelled': "No account was connected",
    'calsync.toast.googleFailed': "Could not connect with Google. Please try again.",
    'calsync.openShort': "Sync",
    'calsync.title': "Sync with your calendar",
    'calsync.lead': "See your bookings in your calendar and avoid being booked when you are busy.",
    'calsync.close': "Close",
    'calsync.done': "Done",
    'calsync.copy': "Copy",
    'calsync.retry': "Try again",
    'calsync.loadFailed': "Could not load calendar sync. Please try again in a moment.",
    'calsync.provider.google': "Google Calendar",
    'calsync.provider.outlook': "Outlook",
    'calsync.provider.apple': "Apple",
    'calsync.export.title': "See my bookings in my calendar",
    'calsync.export.hint': "Pick your calendar and confirm. New bookings will show up on their own.",
    'calsync.export.localNote': "You are running locally: Google, Outlook and Apple cannot read a “localhost” link, so subscribing only works once the dashboard is deployed. You can create the link and open it in your browser to see the bookings.",
    'calsync.export.createLocal': "Create the link to test it",
    'calsync.export.addTo': "Add to {provider}",
    'calsync.export.calendarName': "Bookings",
    'calsync.export.more': "Copy the link or other options",
    'calsync.export.urlAria': "Bookings calendar link",
    'calsync.export.delay': "This link is private: it includes your customers’ details. Your calendar can take a few hours to show new bookings.",
    'calsync.export.rotate': "Create a new link",
    'calsync.export.stop': "Stop sharing",
    'calsync.import.title': "Don’t offer times when I’m busy",
    'calsync.import.hint': "Connect your personal calendar and its events will be blocked on your booking page.",
    'calsync.import.pickAria': "Pick your calendar",
    'calsync.import.pastePlaceholder': "Paste your calendar’s private link here",
    'calsync.import.connect': "Connect",
    'calsync.import.schedule': "Block on",
    'calsync.import.wrongLink.google': "That is the link to the Google Calendar page. You need the “Secret address in iCal format” from step 2.",
    'calsync.import.wrongLink.outlook': "That is the link to the Outlook page. You need the “ICS” link shown when you publish the calendar (step 2).",
    'calsync.import.wrongLink.apple': "That does not look like the calendar link. Copy the link shown when you turn on “Public Calendar”.",
    'calsync.guide.open': "Open {provider}",
    'calsync.guide.google.one': "Open Google Calendar settings.",
    'calsync.guide.google.two': "On the left, under “Settings for my calendars”, pick your calendar and scroll to “Integrate calendar”.",
    'calsync.guide.google.three': "Copy the “Secret address in iCal format” and paste it below.",
    'calsync.guide.outlook.one': "Open Outlook’s shared calendars.",
    'calsync.guide.outlook.two': "Under “Publish a calendar”, pick your calendar, choose “Can view when I’m busy” and click “Publish”.",
    'calsync.guide.outlook.three': "Copy the “ICS” link and paste it below.",
    'calsync.guide.apple.one': "Open Calendar on iCloud.com (or the Calendar app on your Mac).",
    'calsync.guide.apple.two': "Next to your calendar, click the share icon and turn on “Public Calendar”.",
    'calsync.guide.apple.three': "Copy the link that appears and paste it below.",
    'calsync.feed.allSchedules': "all schedules",
    'calsync.feed.pending': "Connecting…",
    'calsync.feed.synced': "Connected · updated {when} · {count} events",
    'calsync.feed.sync': "Update now",
    'calsync.feed.syncAria': "Update {name} now",
    'calsync.feed.remove': "Disconnect",
    'calsync.feed.removeAria': "Disconnect {name}",
    'calsync.error.notIcal': "That link is not your calendar’s. Follow the steps above to copy the private link.",
    'calsync.error.notFound': "The calendar was not found. If you created a new link in your calendar, paste it again.",
    'calsync.error.timeout': "Your calendar took too long to respond. We will try again on our own.",
    'calsync.error.tooLarge': "Your calendar is too large to connect.",
    'calsync.error.unreachable': "We could not read your calendar. We will try again on our own.",
    'calsync.error.secret': "The saved link could not be read. Disconnect it and connect it again.",
    'calsync.toast.copied': "Link copied",
    'calsync.toast.added': "Calendar connected · {count} events",
    'calsync.rotate.title': "Create a new link?",
    'calsync.rotate.body': "The current link will stop working and you will need to add it to your calendar again. Use this if you shared it by mistake.",
    'calsync.rotate.confirm': "Create new link",
    'calsync.stop.title': "Stop sharing your bookings?",
    'calsync.stop.body': "The link will stop working and bookings will disappear from the calendars where you added it.",
    'calsync.stop.confirm': "Stop sharing",
    'calsync.remove.title': "Disconnect {name}?",
    'calsync.remove.body': "Its events will no longer block times on your booking page.",
    'calsync.remove.confirm': "Disconnect",
    'bookings.cal.subtitle': 'Check and manage all your bookings · {timezone}',
    'bookings.cal.viewAria': 'Appointment view',
    'bookings.cal.calendar': 'Calendar',
    'bookings.cal.list': 'List',
    'bookings.cal.prevMonth': 'Previous month',
    'bookings.cal.nextMonth': 'Next month',
    'bookings.cal.today': 'Today',
    'bookings.cal.filterByStatus': 'Filter by status',
    'bookings.cal.allStatuses': 'All statuses',
    'bookings.cal.allArtists': 'Everyone',
    'bookings.cal.viewClass': 'View class',
    'bookings.cal.noServices': 'You have no bookable services yet.',
    'bookings.cal.noServicesTitle': 'No bookable services yet',
    'bookings.cal.noServicesBody': 'A booking always hangs off a service: its length, its opening hours and its free slots come from there. Create one and the calendar starts working.',
    'bookings.cal.noServicesCta': 'Create scheduled service',
    'bookings.cal.noneThisMonth': 'No appointments this month.',
    'bookings.cal.noneFiltered': 'No appointments this month match these filters.',
    'bookings.cal.dayCount.one': '1 appointment',
    'bookings.cal.dayCount.many': '{count} appointments',
    'bookings.cal.addOnDay': 'New appointment on the {day}',
    'bookings.cal.loadingAgenda': 'Loading your agenda',
    'bookings.cal.loadingList': 'Loading your appointments',
    'bookings.cal.loadingBooking': 'Loading the booking',
    'bookings.cal.loadingServices': 'Loading your services',
    'bookings.cal.sectionTitle': 'Bookings',
    'bookings.statusSaved': 'Status updated',
    'bookings.kind.group': 'Group',
    'bookings.kind.single': 'One-to-one',
    'bookings.list.title': 'Appointments',
    'bookings.list.subtitle': 'Everything booked with you, across all your services · {timezone}',
    'bookings.services.subtitle': 'Each service has its own page to book from · {timezone}',
    'bookings.col.mode': 'Format',
    'bookings.col.bookings': 'Bookings',
    'bookings.liveCount': '{count} bookings still standing',
    'bookings.fallbackTitle': 'Appointment',
    'bookings.detail.eyebrow': 'Booking',
    'bookings.detail.unnamed': 'Unnamed customer',
    'bookings.detail.serviceUnavailable': 'Service unavailable',
    'bookings.detail.modeGroup': 'Group · seat {seat}',
    'bookings.detail.modeSingle': 'One-to-one',
    'bookings.detail.closePanel': 'Close panel',
    'bookings.detail.statusLabel': 'Status',
    'bookings.detail.pastNotice': 'The appointment already passed. Record the outcome.',
    'bookings.detail.overviewAria': 'Appointment details',
    'bookings.detail.when': 'Date & time',
    'bookings.detail.date': 'Date',
    'bookings.detail.time': 'Time',
    'bookings.detail.hoursRange': '{from} to {to}',
    'bookings.detail.saved': 'Appointment updated',
    'bookings.detail.reschedule': 'Change date & time',
    'bookings.detail.rescheduleTitle': 'Change appointment time',
    'bookings.detail.rescheduleBody': 'Choose an available time for this service.',
    'bookings.detail.rescheduleDay': 'New date',
    'bookings.detail.rescheduleTime': 'Available times',
    'bookings.detail.rescheduleConfirm': 'Save new time',
    'bookings.detail.moreActions': 'More actions',
    'bookings.detail.emailCustomer': 'Email the customer',
    'bookings.detail.call': 'Call',
    'bookings.detail.copyEmail': 'Copy email',
    'bookings.detail.copied': 'Copied',
    'bookings.detail.viewContact': 'View contact',
    'bookings.detail.viewService': 'View the service',
    'bookings.detail.client': 'Customer',
    'bookings.detail.name': 'Name',
    'bookings.detail.email': 'Email',
    'bookings.detail.phone': 'Phone',
    'bookings.detail.payment': 'Payment',
    'bookings.detail.viewFull': 'View full',
    'bookings.detail.loadingPayment': 'Loading the payment…',
    'bookings.detail.method': 'Method',
    'bookings.detail.viaStripe': 'Processed by Stripe',
    'bookings.detail.pay.failedTitle': 'Payment unavailable',
    'bookings.detail.pay.failedBody': 'The payment details could not be loaded.',
    'bookings.detail.pay.pendingTitle': 'Payment pending',
    'bookings.detail.pay.pendingBody': 'The appointment is confirmed once the payment goes through.',
    'bookings.detail.pay.noneTitle': 'No online payment',
    'bookings.detail.pay.noneBody': 'This booking has no Stripe purchase attached.',
    'bookings.detail.paidOn': 'Paid on',
    'bookings.detail.paid': 'Paid',
    'bookings.detail.refunded': 'Refunded',
    'bookings.detail.partiallyRefunded': 'Partly refunded',
    'bookings.detail.tabsAria': 'Appointment detail',
    'bookings.detail.tab.form': 'Form',
    'bookings.detail.tab.events': 'History',
    'bookings.detail.tab.note': 'Notes',
    'bookings.detail.noAnswer': 'No answer',
    'bookings.detail.noQuestions': 'This service asks for nothing beyond the contact details.',
    'bookings.detail.customerNote': 'Note from the customer',
    'bookings.detail.notePlaceholder': 'Add a note about this appointment…',
    'bookings.detail.savingNote': 'Saving…',
    'bookings.detail.savesOnBlur': 'Saved when you leave the field',
    'bookings.notes.loading': 'Loading notes…',
    'bookings.notes.emptyTitle': 'No internal notes yet',
    'bookings.notes.emptyBody': 'Add the first note for your team about this appointment.',
    'bookings.event.created': 'The booking was created',
    'bookings.event.held': 'Slot held, waiting for payment',
    'bookings.event.paid': 'Payment received',
    'bookings.event.confirmed': 'Confirmed',
    'bookings.event.rescheduled': 'Moved to another date',
    'bookings.event.refunded': 'Automatic refund',
    'bookings.event.refundPending': 'Refund pending',
    'bookings.event.refundRetry': 'retrying automatically',
    'bookings.event.reassigned': 'Changed artist',
    'bookings.event.cancelled': 'Cancelled',
    'bookings.event.completed': 'Attended',
    'bookings.event.no_show': 'No-show',
    'bookings.timeline.failed': 'We could not load the history.',
    'bookings.timeline.loading': 'Loading the history…',
    'bookings.timeline.empty': 'Nothing has happened on this booking yet.',
    'bookings.timeline.actor.customer': 'The customer',
    'bookings.timeline.actor.team': 'Someone on the team',
    'bookings.timeline.actor.auto': 'Automatic',
    'bookings.timeline.before': 'Before: {when}',
    'bookings.timeline.meta': '{when} · {who}',
    'bookings.timeline.guessed': ' · inferred',
    'bookings.svc.needsPublish': 'Publish the site to get the link',
    'bookings.svc.linkCopied': 'Link copied',
    'bookings.svc.copyFailed': 'We could not copy the link',
    'bookings.svc.searchAria': 'Search services',
    'bookings.svc.searchPlaceholder': 'Search services...',
    'bookings.svc.filtersDialogAria': 'Service filters and sorting',
    'bookings.svc.filterTitle': 'Filter services',
    'bookings.svc.filter.all': 'All',
    'bookings.svc.filter.active': 'Public',
    'bookings.svc.filter.draft': 'Draft',
    'bookings.svc.new': 'New service',
    'bookings.svc.newShort': 'New',
    'bookings.svc.loadFailed': 'We could not load your services.',
    'bookings.svc.empty.title': 'No bookable services yet',
    'bookings.svc.empty.body': 'Create services with a schedule and share their link so your customers can book.',
    'bookings.svc.createFirst': 'Create the first one',
    'bookings.svc.noResults.title': 'No service matches',
    'bookings.svc.unit': 'services',
    'bookings.svc.col.service': 'Service',
    'bookings.svc.optionsAria': 'Options for {name}',
    'bookings.svc.onsite': 'On site',
    'bookings.svc.col.price': 'Price',
    'bookings.svc.col.actions': 'Actions',
    'bookings.svc.open': 'Open',
    'bookings.svc.viewPublic': 'View public page',
    'bookings.svc.copyLink': 'Copy link',
    'bookings.svc.settings': 'Settings',
    'bookings.new.title': 'New appointment',
    'bookings.new.close': 'Close',
    'bookings.team.title': 'Team',
    'bookings.team.addRole': 'Add role',
    'bookings.team.bookable': 'Bookable',
    'bookings.team.hidden': 'Hidden',
    'bookings.team.cancel': 'Cancel',
    'bookings.team.lead': 'Who provides your services. With several people, customers choose who or “Anyone available”.',
    'bookings.team.photo': 'Change {name}’s photo',
    'bookings.team.name': 'Name',
    'bookings.team.role': 'Role',
    'bookings.team.rolePlaceholder': 'Stylist, dentist…',
    'bookings.team.active': 'Active',
    'bookings.team.remove': 'Remove {name}',
    'bookings.team.newName': 'Add person',
    'bookings.team.newNamePlaceholder': 'Name',
    'bookings.team.add': 'Add',
    'bookings.team.assignment': 'With “Anyone available”, the booking goes to…',
    'bookings.team.assignmentHint': 'Only among those free at that time. If a customer picks a specific person, the booking is theirs.',
    'bookings.team.assignmentTitle': 'With “Anyone available”, the booking goes to…',
    'bookings.team.rule.least_busy': 'Least busy',
    'bookings.team.rule.least_busy.hint': 'Whoever has the fewest bookings that day',
    'bookings.team.rule.order': 'In order',
    'bookings.team.rule.order.hint': 'The first one on the list who is free',
    'bookings.team.rule.round_robin': 'Taking turns',
    'bookings.team.rule.round_robin.hint': 'Shared out one by one among everyone',
    'bookings.team.assign.least_busy': 'Whoever has the fewest bookings that day',
    'bookings.team.assign.order': 'The first one on the list who is free',
    'bookings.team.assign.round_robin': 'Taking turns',
    'bookings.team.scheduleNote': 'Each person’s hours are set in the Schedule step of their services. Inactive people don’t appear on the booking page but keep their bookings.',
    'bookings.new.lead1': 'Write down an appointment requested over the phone for',
    'bookings.new.lead2': '.',
    'bookings.new.whenTitle': 'Date and time',
    'bookings.new.minutes': '{count} min',
    'bookings.new.capacity': 'Up to {count} people',
    'bookings.new.leadEmpty': 'Choose a service to begin. Its schedule and available times will load automatically.',
    'bookings.new.noServiceTitle': 'Choose a service',
    'bookings.new.noServiceBody': 'Select the service for this appointment to load its duration, price and available times.',
    'bookings.new.servicePlaceholder': 'Select a service…',
    'bookings.new.pickService': 'Select a service to continue',
    'bookings.new.needService': 'Select the service for this appointment.',
    'bookings.new.needName': 'Add the customer name',
    'bookings.new.required': 'Required',
    'bookings.new.service': 'Service',
    'bookings.new.days': 'Days',
    'bookings.new.day': 'Day',
    'bookings.new.slot': 'Time',
    'bookings.new.searching': 'Looking for slots…',
    'bookings.new.slotsAria': 'Available times',
    'bookings.new.seatsLeft': '{count} seats',
    'bookings.new.available': 'Available',
    'bookings.new.whoTitle': 'Customer details',
    'bookings.new.name': 'Customer name',
    'bookings.new.namePlaceholder': 'Full name',
    'bookings.new.email': 'Email',
    'bookings.new.emailPlaceholder': 'customer@email.com',
    'bookings.new.phone': 'Phone',
    'bookings.new.note': 'Note',
    'bookings.new.optional': 'Optional',
    'bookings.new.notePlaceholder': 'Instructions or anything important…',
    'bookings.new.pickSlot': 'Pick a time to continue',
    'bookings.new.next': 'Next',
    'bookings.new.back': 'Back',
    'bookings.new.book': 'Book',
    'bookings.new.stepOf': 'Step {current} of {total}',
    'bookings.new.noSlotsTitle': "No times available",
    'bookings.new.noSlotsBody': "Pick another date or check the service schedule.",
    'bookings.new.cancel': 'Cancel',
    'bookings.new.create': 'Create appointment',
    'bookings.new.needSlot': 'Pick a time.',
    'bookings.new.phonePlaceholder': '(555) 000-0000',
    'bookings.field.index': 'Question {index}',
    'bookings.field.moveUp': 'Move up',
    'bookings.field.moveDown': 'Move down',
    'bookings.field.placeholder': 'Is this your first visit?',
    'bookings.field.optionsLabel': 'Options, one per line',
    'bookings.field.optionsPlaceholder': 'Small\nMedium\nLarge',
    'bookings.field.needsOptions': 'It cannot be saved without options: an empty list leaves the page unable to submit.',
    'bookings.field.type': 'Type',
    'bookings.field.required': 'Required',
    'bookings.field.type.text': 'Short text',
    'bookings.field.type.textarea': 'Long text',
    'bookings.field.type.select': 'Option list',
    'bookings.field.type.checkbox': 'Checkbox (yes/no)',
    'bookings.field.type.email': 'Email',
    'bookings.field.type.tel': 'Phone',
    'bookings.field.head': 'Questions when booking',
    'bookings.field.headWizard': 'Additional questions',
    'bookings.field.headBody': 'On top of the name, email and phone, which are always asked.',
    'bookings.field.headBodyWizard': 'They show up after the contact details.',
    'bookings.field.count': '{count} of {max}.',
    'bookings.field.labelAria': 'Text of question {index}',
    'bookings.field.remove': 'Delete the question {name}',
    'bookings.field.add': 'Add question',
    'bookings.field.addWizard': 'Add another question',
    // ── Los tres índices públicos del catálogo ────────────────────────────────
    'catalogPage.bookings.subtitle': 'One address with all of your services, to send over WhatsApp or put on your profile.',
    'catalogPage.bookings.need': 'No service is published',
    'catalogPage.bookings.needBody': 'The page would look empty. Publish at least one service with a schedule so it shows up here.',
    'catalogPage.bookings.goTo': 'Go to Services',
    'catalogPage.bookings.count': '{count} services will be listed.',
    'catalogPage.bookings.countOne': '1 service will be listed.',
    'catalogPage.bookings.countNone': 'No service would be listed yet.',
    'catalogPage.digital.subtitle': 'One address with everything of yours that can be downloaded, to send over WhatsApp or put on your profile.',
    'catalogPage.digital.need': 'No digital product is published',
    'catalogPage.digital.needBody': 'The page would look empty. Publish at least one digital product so it shows up here.',
    'catalogPage.digital.goTo': 'Go to Digital products',
    'catalogPage.digital.count': '{count} products will be listed.',
    'catalogPage.digital.countOne': '1 product will be listed.',
    'catalogPage.digital.countNone': 'No product would be listed yet.',
    'catalogPage.products.subtitle': 'One address with your whole shop, to send over WhatsApp or put on your profile.',
    'catalogPage.products.need': 'No physical product is published',
    'catalogPage.products.needBody': 'The page would look empty. Publish at least one physical product so it shows up here.',
    'catalogPage.products.goTo': 'Go to Physical products',
    'catalogPage.products.count': '{count} products will be listed.',
    'catalogPage.products.countOne': '1 product will be listed.',
    'catalogPage.products.countNone': 'No product would be listed yet.',
    'catalogPage.services.subtitle': 'One address with everything you offer without a schedule, to send over WhatsApp or put on your profile.',
    'catalogPage.services.need': 'No service is published',
    'catalogPage.services.needBody': 'The page would look empty. Publish at least one service so it shows up here.',
    'catalogPage.services.goTo': 'Go to Services',
    'catalogPage.services.count': '{count} services will be listed.',
    'catalogPage.services.countOne': '1 service will be listed.',
    'catalogPage.services.countNone': 'No service would be listed yet.',
    // ── Ajustes de aspecto del índice y su vista previa ───────────────────────
    'catalogPage.group.texts': 'Texts',
    'catalogPage.group.colors': 'Colors',
    'catalogPage.group.typography': 'Typography',
    'catalogPage.titleStyle': 'Title',
    'catalogPage.cardTitleStyle': 'Card title',
    'catalogPage.bodyStyle': 'Body text',
    'catalogPage.group.layout': 'Cards',
    'catalogPage.free': 'Free',
    'catalogPage.price': 'Price: {price}',
    'catalogPage.priceStyle': 'Price',
    'catalogPage.samplesNote': 'Sample offers. Your published ones will show here as soon as you have any.',
    'catalogPage.sample.bookings.1.title': 'Initial consultation',
    'catalogPage.sample.bookings.1.body': 'A first conversation to understand what you need and how we can help.',
    'catalogPage.sample.bookings.2.title': 'Follow-up session',
    'catalogPage.sample.bookings.2.body': 'Review progress, answer questions and adjust the plan.',
    'catalogPage.sample.bookings.3.title': 'Group workshop',
    'catalogPage.sample.bookings.3.body': 'A hands-on class in a small group, with everything included.',
    'catalogPage.sample.digital.1.title': 'Starter template',
    'catalogPage.sample.digital.1.body': 'Everything you need to get going, ready to download and use today.',
    'catalogPage.sample.digital.2.title': 'Complete guide',
    'catalogPage.sample.digital.2.body': 'Step by step, from the basics to the details that make the difference.',
    'catalogPage.sample.digital.3.title': 'Resource pack',
    'catalogPage.sample.digital.3.body': 'Checklists, worksheets and examples, all in one file.',
    'catalogPage.sample.products.1.title': 'Handmade mug',
    'catalogPage.sample.products.1.body': 'Glazed ceramic, made by hand. Every piece is a little different.',
    'catalogPage.sample.products.2.title': 'Cotton tee',
    'catalogPage.sample.products.2.body': 'Organic cotton, classic fit, in four colors.',
    'catalogPage.sample.products.3.title': 'Scented candle',
    'catalogPage.sample.products.3.body': 'Soy wax and essential oils, about 40 hours of light.',
    'catalogPage.sample.services.1.title': 'Strategy call',
    'catalogPage.sample.services.1.body': 'An hour to set priorities and agree on the next steps.',
    'catalogPage.sample.services.2.title': 'Monthly retainer',
    'catalogPage.sample.services.2.body': 'Ongoing support, with a review of results every month.',
    'catalogPage.sample.services.3.title': 'Full project',
    'catalogPage.sample.services.3.body': 'From the first brief to the final delivery, done for you.',
    'catalogPage.columns': 'Columns',
    'catalogPage.columnsAuto': 'Auto',
    'catalogPage.text': 'Text',
    'catalogPage.background': 'Background',
    'catalogPage.card': 'Card',
    'catalogPage.button': 'Button',
    'catalogPage.bookings.previewTitle': 'Book an appointment',
    'catalogPage.bookings.previewSubtitle': 'Pick the service you need and we will show you the open times.',
    'catalogPage.bookings.previewCta': 'See times',
    'catalogPage.digital.previewTitle': 'Downloads',
    'catalogPage.digital.previewSubtitle': 'Everything you can get right now.',
    'catalogPage.digital.previewCta': 'Get it',
    'catalogPage.products.previewTitle': 'Shop',
    'catalogPage.products.previewSubtitle': 'Everything we can ship to you.',
    'catalogPage.products.previewCta': 'Buy now',
    'catalogPage.services.previewTitle': 'Services',
    'catalogPage.services.previewSubtitle': 'What we can do for you.',
    'catalogPage.services.previewCta': 'See details',
    'catalogPage.action': 'Page settings',
    'catalogPage.designInEditor': 'Design in the editor',
    'catalogPage.bookings.editPage': 'Edit category',
    'catalogPage.bookings.editPageHint': 'Edit the page that lists all your bookable services.',
    'catalogPage.digital.editPage': 'Edit category',
    'catalogPage.digital.editPageHint': 'Edit the page that lists all your digital products.',
    'catalogPage.products.editPage': 'Edit category',
    'catalogPage.products.editPageHint': 'Edit the page that lists all your physical products.',
    'catalogPage.services.editPage': 'Edit category',
    'catalogPage.services.editPageHint': 'Edit the page that lists all your services.',
    // ── Bookings · how a service page looks ───────────────────────────────────
    'bookings.page.title': 'Public page',
    'bookings.page.subtitleShort': 'The index of your bookable services.',
    'bookings.page.needSite': 'Publish your site to get the address',
    'bookings.page.publishSite': 'Publish the site',
    'bookings.page.needSiteBody': 'This page lives inside your site. Until the site is published there is no address to hand out, even with this switched on.',
    'bookings.page.visibility': 'Visibility',
    'bookings.page.visibilityBody': 'Who can open the page, and the address it lives at.',
    'bookings.page.on': 'Published',
    'bookings.page.off': 'Not published',
    'bookings.page.onBody': 'Anyone with the link can see it. It does not show up in your site menu: you share it yourself.',
    'bookings.page.offBody': 'The address answers as if the page did not exist. Nobody can see it, not even with the link.',
    'bookings.page.copyLink': 'Copy link',
    'bookings.page.open': 'Open the page',
    'catalogPage.publishToggle': 'Publish the page',
    'sitePage.chrome': 'Site header and footer',
    'sitePage.showNav': 'Site navigation bar',
    'sitePage.showNavBody': 'The same top bar as the rest of your site. If the site has none, nothing is added.',
    'sitePage.showFooter': 'Site footer',
    'sitePage.showFooterBody': 'The same footer as the rest of your site. If the site has none, nothing is added.',
    'catalogPage.address': 'Address',
    'catalogPage.shareWhatsapp': 'Share on WhatsApp',
    'catalogPage.listed': 'What it lists',
    'catalogPage.listedMore': '+{count} more',
    'catalogPage.lookBody': 'Colors, text styles, card and button, taken from your site.',
    'catalogPage.editLook': 'Edit appearance',
    'catalogPage.bookings.note': 'It lists your published services with a schedule, in the order you created them.',
    'catalogPage.digital.note': 'It lists your published digital products, in the order you created them.',
    'catalogPage.products.note': 'It lists your published physical products, in the order you created them. Sold-out ones show “Sold out”.',
    'catalogPage.services.note': 'It lists your published services without a schedule, in the order you created them.',
    'bookings.page.headline': 'Title',
    'bookings.page.intro': 'Intro text',
    'bookings.page.look': 'Appearance',
    'bookings.page.accent': 'Accent color',
    'bookings.page.accentHelp': 'Paints the button on each card and the price.',
    'bookings.page.savedToast': 'Page updated',
    'bookings.page.theme': 'Theme',
    'bookings.page.themeAuto': 'Automatic (follows the visitor)',
    'bookings.page.themeLight': 'Always light',
    'bookings.page.themeDark': 'Always dark',
    // ── Bookings · service detail ─────────────────────────────────────────────
    'bookings.svc.detail.back': 'Back to bookings',
    'bookings.svc.detail.tabsAria': 'Service sections',
    'bookings.svc.detail.tab.notices': 'Notifications',
    'bookings.svc.detail.tab.bookings': 'Appointments',
    'bookings.svc.detail.tab.details': 'Details',
    'bookings.svc.detail.tab.settings': 'Settings',
    'bookings.svc.detail.tab.contact': 'Contact',
    'bookings.svc.detail.card.session': 'Session & schedule',
    'bookings.svc.detail.card.sessionEdit': 'Edit schedule',
    'bookings.svc.detail.fact.buffers': 'Preparation buffer',
    'bookings.svc.detail.fact.notice': 'Minimum notice',
    'bookings.svc.detail.card.policy': 'Cancellation & rescheduling policy',
    'bookings.svc.detail.policyWindow': 'Notice deadline',
    'bookings.svc.detail.policyWindowVal': 'Up to {hours} hours before',
    'bookings.svc.detail.policyWindowNone': 'Anytime before session',
    'bookings.svc.detail.policyRefund': 'Refund',
    'bookings.svc.detail.policyLate': 'After deadline',
    'bookings.svc.detail.policyLateContact': 'Must contact directly',
    'bookings.svc.detail.policyLateMove': 'Can reschedule with fee',
    'bookings.svc.detail.policyLateNone': 'Non-refundable / no changes',
    'bookings.svc.detail.card.share': 'Share & booking link',
    'bookings.svc.detail.card.shareDirect': 'Direct booking link',
    'bookings.svc.detail.card.shareHint': 'Share this link directly with clients so they can book an appointment.',
    'bookings.svc.detail.card.appearanceAndContact': 'Appearance & contact',
    'bookings.svc.detail.draftNotice.title': 'This service is not active yet',
    'bookings.svc.detail.draftNotice.body': 'It is saved as a draft. Publish it so clients can book it from your site.',
    'bookings.svc.detail.draftNotice.publish': 'Publish',
    'bookings.svc.detail.look': 'How the page looks',
    'bookings.svc.detail.lookBody': 'The theme your booking page opens with. The color, the image and the logo are edited from “Edit”.',
    'bookings.svc.detail.history': 'Policy history',
    'bookings.svc.detail.historyBody': 'Every change is recorded with its date and time. It cannot be edited or deleted.',
    'bookings.svc.detail.historyLoading': 'Loading…',
    'bookings.svc.detail.historyEmpty': 'You have not changed this service’s policy yet. The moment you do, both the old and the new version will be kept here.',
    'bookings.svc.detail.historyCurrent': 'In force',
    'bookings.svc.detail.historyNoText': 'No text.',
    'bookings.svc.detail.delete': 'Delete service',
    'bookings.svc.detail.deleteBody': 'It is deleted permanently. This cannot be undone.',
    'bookings.svc.detail.deleteCopy1': 'The service and its page',
    'bookings.svc.detail.deleteCopy2': ' both disappear: anyone holding the link will no longer be able to book.',
    'bookings.svc.detail.deleteKeepOne': 'The upcoming appointment you already have is kept in Bookings, with the service name stored on it.',
    'bookings.svc.detail.deleteKeepMany': 'The {count} upcoming appointments you already have are kept in Bookings, with the service name stored on them.',
    'bookings.svc.detail.deleteKeepNone': 'Any existing appointments and charges are kept, with the service name stored on them.',
    'bookings.svc.detail.deleteBtn': 'Delete this service',
    'bookings.svc.detail.deleteAsk': 'Delete this service?',
    'bookings.svc.detail.deleteWarn': 'will be deleted permanently, along with its booking page and its prices. This cannot be undone.',
    'bookings.svc.detail.deleteWarnOne': 'Its upcoming appointment stays in Bookings, but you will no longer be able to open its service page.',
    'bookings.svc.detail.deleteWarnMany': 'Its {count} upcoming appointments stay in Bookings, but you will no longer be able to open its service page.',
    'bookings.svc.detail.deleteConfirm': 'Delete',
    'bookings.svc.detail.deleting': 'Deleting…',
    'bookings.svc.detail.deletedToast': 'Service deleted',
    'bookings.svc.detail.contact': 'How people reach you',
    'bookings.svc.detail.contactBody': 'What your customer sees once they can no longer cancel or move the appointment themselves.',
    'bookings.svc.detail.email': 'Contact email',
    'bookings.svc.detail.emailPlaceholder': 'hello@yourbusiness.com',
    'bookings.svc.detail.emailHelp': 'It is printed on the booking page. Leave it empty and the address where you get this project’s notices is used.',
    'bookings.svc.detail.emailInvalid': 'Write a valid email address',
    'bookings.svc.detail.phone': 'Phone',
    'bookings.svc.detail.phonePlaceholder': '+1 555 123 4567',
    'bookings.svc.detail.phoneHelp': 'Optional. Leave it empty if you would rather people wrote to you.',
    'bookings.svc.detail.summaryAria': 'Service information',
    'bookings.svc.detail.coverChangeAria': 'Change the thumbnail',
    'bookings.svc.detail.coverPickAria': 'Upload a thumbnail',
    'bookings.svc.detail.coverChange': 'Change thumbnail',
    'bookings.svc.detail.coverAdd': 'Upload thumbnail',
    'bookings.svc.detail.nameAria': 'Service name',
    'bookings.svc.detail.link': 'Booking link',
    'bookings.svc.detail.copyAria': 'Copy the booking link',
    'bookings.svc.detail.openAria': 'Open the booking page',
    'bookings.svc.detail.needSite': 'Publish the site to create the URL.',
    'bookings.svc.detail.team': 'Provided by',
    'bookings.svc.detail.teamChange': 'Change',
    'bookings.svc.detail.teamDone': 'Done',
    'bookings.svc.detail.teamEmpty': 'Add more people from Manage team to assign them to this service.',
    'bookings.svc.detail.teamManage': 'Manage team',
    'bookings.svc.detail.teamRequired': 'The service needs at least one person.',
    'bookings.svc.detail.fact.clients': 'Customers',
    'bookings.svc.detail.card.service': 'The service',
    'bookings.svc.detail.fact.form': 'Form',
    'bookings.svc.detail.formCount': '{count} extra question(s)',
    'bookings.svc.detail.formNone': 'Name and email only',
    'bookings.svc.detail.fact.duration': 'Duration',
    'bookings.svc.detail.fact.capacity': 'Capacity',
    'bookings.svc.detail.fact.price': 'Price',
    'bookings.svc.detail.fact.schedule': 'Schedule',
    'bookings.svc.detail.fact.cancel': 'Cancellation',
    'bookings.svc.detail.fact.refund': 'Refund',
    'bookings.svc.detail.fact.reminder': 'Reminder',
    'bookings.svc.detail.fact.name': 'Name',
    'bookings.svc.detail.priceOnsite': 'No online payment',
    'bookings.svc.detail.priceNone': 'No price',
    'bookings.svc.detail.daysNone': 'No schedule',
    'bookings.svc.detail.daysOne': '1 day open',
    'bookings.svc.detail.daysMany': '{count} days open',
    'bookings.svc.detail.refundFull': 'Full if in time',
    'bookings.svc.detail.refundNone': 'No refund',
    'bookings.svc.detail.refundPartial': '{percent}% if in time',
    'bookings.svc.detail.editFact': 'Edit {label}',
    'bookings.svc.detail.edit': 'Edit',
    'bookings.svc.detail.editAll': 'Edit everything',
    'userMenu.aria': 'Account options',
    'userMenu.settings': 'User settings',
    'userMenu.plans': 'Plans',
    'userMenu.usage': 'Account usage',
    'userMenu.billing': 'Billing',
    'userMenu.domains': 'Domains',
    'userMenu.theme': 'Appearance',
    'userMenu.themeLight': 'Light',
    'userMenu.themeDark': 'Dark',
    'userMenu.themeSystem': 'Automatic (follows your device)',
    'userMenu.color': 'Color',
    'userMenu.colorPanel': 'Panel color',
    'userMenu.signOut': 'Sign out',
    /* Los catorce tonos del selector de acento. La clave lleva el nombre del
       atributo de `<html>` —`azul`, `ambar`— y no lo que se lee en pantalla: el
       slug identifica el color, el texto lo traduce. */
    'accent.azul': 'Blue',
    'accent.indigo': 'Indigo',
    'accent.violeta': 'Violet',
    'accent.fucsia': 'Fuchsia',
    'accent.rosa': 'Pink',
    'accent.rojo': 'Red',
    'accent.naranja': 'Orange',
    'accent.ambar': 'Amber',
    'accent.amarillo': 'Mustard',
    'accent.verde': 'Green',
    'accent.esmeralda': 'Emerald',
    'accent.turquesa': 'Teal',
    'accent.cian': 'Cyan',
    'accent.grafito': 'Graphite',
    'home.grid.aria': 'Customisable dashboard widgets',
    'home.grid.moveUp': 'Move up',
    'home.grid.moveDown': 'Move down',
    'home.grid.remove': 'Remove from the dashboard',
    'home.grid.resize': 'Drag to change the width',
    'home.grid.emptyTitle': 'Your home is empty',
    'home.grid.emptyBody': 'You removed every widget. Put back the ones you use and leave the rest out: this is saved for this site.',
    'home.grid.restore': 'Put them all back',
    'home.grid.edit': 'Edit widgets',
    'home.widget.project': 'Project status',
    'home.widget.pages': 'Pages',
    'home.widget.cms': 'CMS content',
    'home.widget.offers': "Catalogue",
    'home.widget.usage': 'Plan usage',
    'home.widget.domain': 'Domain and SSL',
    'home.widget.notes': 'Notes',
    'home.widget.sales': 'Sales summary',
    'home.grid.reorder': 'Change the position of {label}',
    'home.grid.moveUpOne': 'Move {label} up',
    'home.grid.moveDownOne': 'Move {label} down',
    'home.grid.removeOne': 'Remove {label} from the dashboard',
    'home.grid.widen': 'Widen {label}',
    'home.grid.narrow': 'Narrow {label}',
    'role.owner.label': 'Owner',
    'role.owner.summary': 'Runs everything, including what is charged and deleting the project.',
    'role.admin.label': 'Administrator',
    'role.admin.summary': 'The whole project, plus inviting other people.',
    'role.editor.label': 'Editor',
    'role.editor.summary': 'Edits the site, its content and its settings. No access to finances.',
    'role.design.label': 'Design',
    'role.design.summary': 'Pages, visual editor and images.',
    'role.content.label': 'Content',
    'role.content.summary': 'Collections, forms and contacts.',
    'role.finance.label': 'Finance',
    'role.finance.summary': 'Orders, charges, bookings and sales.',
    'role.viewer.label': 'Read-only',
    'role.viewer.summary': 'Sees everything. Changes nothing.',
    'role.admin.description': 'Manages the settings, the team and every working area of the project.',
    'role.editor.description': 'Manages the site, its content and its settings, with no access to financial information.',
    'role.design.description': 'Works on the pages, the visual design and the site’s graphic assets.',
    'role.content.description': 'Manages collections, forms, contacts and content assets.',
    'role.finance.description': 'Manages orders, payments, bookings and commercial metrics.',
    'role.viewer.description': 'Looks at every area of the project without changing anything.',
    'role.guest': '{role} (guest)',
    'role.ownerLine': 'Project owner',
    'role.togglePermissions': '{action} {role} permissions',
    'role.show': 'Show',
    'role.hide': 'Hide',
    'plans.feat.offersUnlimited': 'Unlimited offers',
    'plans.feat.fee': '{fee}% fee per sale',
    'plans.feat.analyticsReports': 'Full analytics + reports',
    'plans.feat.inboxMarketingOff': 'Inbox and email marketing',
    'plans.feat.support': 'Support: {level}',
    'plans.feat.aiGenerations': 'AI-generated sites: {amount}',
    'plans.feat.projects': '{count} projects',
    'plans.feat.projectOne': '{count} project',
    'plans.feat.projectsUnlimited': 'Unlimited projects',
    'plans.feat.pages': '{count} pages',
    'plans.feat.cms': '{collections} collections · {items} CMS items',
    'plans.feat.contacts': '{count} contacts',
    'plans.feat.contactsUnlimited': 'Unlimited contacts',
    'plans.feat.subdomain': 'Véltica subdomain',
    'plans.feat.password': 'Password protection',
    'plans.feat.analyticsBasic': 'Basic analytics',
    'plans.feat.badge': '“Built with véltica” badge',
    'plans.feat.freeDomain': 'A free domain for one year',
    'plans.feat.customDomain': 'Custom domain',
    'plans.feat.noBadge': 'No véltica badge',
    'plans.feat.analyticsFull': 'Full analytics',
    'plans.feat.allOfPro': 'Everything in Pro',
    'plans.feat.unlimitedPagesContacts': 'Unlimited pages and contacts',
    'plans.feat.forms': 'Forms: {limit}',
    'plans.feat.inboxMarketing': 'Inbox and Marketing: {limit}',
    'plans.feat.bookingsIncluded': 'Bookings, with your own calendar',
    'plans.feat.sales': 'Sales: {limit}',
    'plans.feat.sellWithFee': 'Get paid with Stripe · {fee}% fee per sale',
    'plans.feat.courses': "Sell your courses: {limit}",
    'plans.feat.team': '{count} team members',
    'plans.feat.supportPriority': 'Priority support',
    'plans.feat.unlimitedPages': 'Unlimited pages',
    'plans.limit.submissions': '{count} submissions/month',
    'plans.limit.offers': '{count} published offers',
    'plans.limit.unlimitedF': 'Unlimited',
    'plans.limit.unlimitedM': 'Unlimited',
    'plans.limit.soon': 'Coming soon',
    'plans.cancel.lead1': 'Your {plan} plan ',
    'plans.cancel.leadStrong': 'will be cancelled on {date}',
    'plans.cancel.lead2': ', when the period you already paid for ends.',
    'plans.cancel.keepUntil': 'You keep every {plan} feature until that date. After it, your account moves to the free plan.',
    'plans.cancel.reactivate': 'You can reactivate your plan at any point before {date}.',
    'plans.cancel.losing': 'What you stop having',
    'plans.cancel.gone': 'No longer available',
    'plans.cancel.kept': 'Your sites stay published and editable, and nothing is deleted: pages, content, contacts and messages all stay. Your domains remain yours until they renew.',
    'plans.cancel.overOne': 'You already have {count}{cap} in {site}. Nothing is deleted: what exists stays and keeps showing, but you will not be able to create more until you return to a paid plan.',
    'plans.cancel.overMany': 'You already have {count}{cap} spread across {sites} sites. Nothing is deleted: what exists stays and keeps showing, but you will not be able to create more until you return to a paid plan.',
    'plans.cancel.overCap': ' of {limit}',
    'plans.noun.pages.one': '{count} page',
    'plans.noun.pages.many': '{count} pages',
    'plans.noun.collections.one': '{count} collection',
    'plans.noun.collections.many': '{count} collections',
    'plans.noun.cmsItems.one': '{count} CMS item',
    'plans.noun.cmsItems.many': '{count} CMS items',
    'plans.noun.contacts.one': '{count} contact',
    'plans.noun.contacts.many': '{count} contacts',
    'plans.noun.teamMembers.one': '{count} guest',
    'plans.noun.teamMembers.many': '{count} guests',
    'plans.noun.offers.one': "published offer",
    'plans.noun.offers.many': "published offers",
    'plans.noun.blogPosts.one': "published post",
    'plans.noun.blogPosts.many': "published posts",
    'plans.over.title': 'You went past your {plan} plan',
    'plans.over.mobileTitle': 'Plan limit exceeded',
    'plans.over.more': '{count} more',
    'plans.over.detail': '{count} of {limit}',
    'plans.over.body': 'Everything stays published and editable; you just cannot add more.',
    'plans.over.seePlans': 'See plans',
    'plans.title': 'Site plans',
    'plans.subtitle': 'Publish today and add capacity when you need it. Every plan includes managed hosting, SSL and a global CDN.',
    'plans.bannerAria': 'Launch offer',
    'plans.betaEyebrow': 'Beta offer',
    'plans.betaDetails': 'How the offer works',
    'plans.betaTitle': "Beta: {percent}% off your first year on the annual plan",
    'plans.betaBody': "It is {percent}% off the annual price for your first {months} months. Example with Pro: ${monthly}/month paying monthly, ${annual}/month on the annual plan and ${now}/month with the Beta discount (${total} for your whole first year). It applies automatically at checkout; after that, the plan renews at the regular annual price. Cancel anytime.",
    'plans.cycle': 'Billing period',
    'plans.cycleBody': 'Prices per month. The annual saving includes the Beta offer for your first {months} months; after that, the plan renews yearly at the regular annual price.',
    'plans.monthly': 'Monthly',
    'plans.annual': 'Annual',
    'plans.annualSaving': 'Save {percent}%',
    'plans.recommended': 'Recommended',
    'plans.soon': 'Coming soon',
    'plans.current': 'Current',
    'plans.custom': 'Custom',
    'plans.perMonth': 'USD/month',
    'plans.vsMonthly': "Beta · {percent}% off",
    'plans.onLaunch': 'At launch',
    'plans.todayYouPay': 'You pay today',
    'plans.afterBeta': 'After {months} months',
    'plans.pricePerMonth': '${price}/month',
    'plans.afterFirstYear': 'After the first year',
    'plans.pricePerYear': '${price}/year',
    'plans.includes': 'What you get',
    'plans.includesPlus': 'Everything in {plan}, plus:',
    'plans.freeForever': 'Free forever, no card needed',
    'plans.free': 'Free',
    'plans.trust.aria': 'Guarantees',
    'plans.trust.secure': 'Secure payment with Stripe',
    'plans.trust.cancel': 'Cancel anytime from Billing',
    'plans.trust.keep': 'Downgrading never deletes anything from your site',
    'plans.faq.title': 'Frequently asked questions',
    'plans.faq.lead': 'What people usually ask before choosing a plan.',
    'plans.faq.q.switch': 'Can I change plans anytime?',
    'plans.faq.a.switch': 'Yes. A paid plan starts as soon as you finish paying. If you cancel, you keep what you already paid for until the end of your period, then move to the free plan.',
    'plans.faq.q.downgrade': 'What happens to my site if I downgrade?',
    'plans.faq.a.downgrade': 'Nothing is deleted. Your sites stay published and you can keep editing everything you have. If something is over the new plan\'s limit, you just can\'t add more of it until you upgrade or get back under the limit.',
    'plans.faq.q.account': 'Is the plan per site or per account?',
    'plans.faq.a.account': 'Per account. One plan covers all your projects, up to the number of projects it includes. Projects you join as a guest are paid for by their owner.',
    'plans.faq.q.beta': 'How does the Beta offer work?',
    'plans.faq.a.beta': 'If you pay yearly, you get an extra {beta}% Beta discount on the annual price for your first {months} months: in total, at least {percent}% less than paying month to month. It applies automatically at checkout. After that, the plan continues at the regular annual price. Monthly billing doesn\'t include the discount.',
    'plans.faq.q.domain': 'Is a domain included?',
    'plans.faq.a.domain': 'With a paid yearly plan, the first year of your domain is on us. From the second year it renews separately, and we let you know before every renewal. The domain is in your name and you can take it with you anytime.',
    'plans.faq.q.fee': 'Do you take a fee on my sales?',
    'plans.faq.a.fee': 'Yes, a small fee that goes down with your plan: {free}% on Starter, {pro}% on Pro and {business}% on Business. Stripe\'s own processing fee is separate. The money from your sales goes straight to your account.',
    'plans.faq.q.payment': 'How do I pay?',
    'plans.faq.a.payment': 'By card, through Stripe. Your card details are stored by Stripe, not by us. You manage your invoices and subscription from Billing.',
    'plans.annualOnly': ' · annual plan only',
    'plans.toFree': 'Switch to free',
    'plans.opening': 'Opening…',
    'plans.manageSubscription': 'Manage subscription',
    'plans.currentPlan': 'Current plan',
    'plans.redirecting': 'Redirecting…',
    'plans.fineprint': 'Prices in USD per account: the plan covers all your projects. The annual option is billed up front.',
    'plans.allFeatures': 'Every site feature',
    'plans.confirmFree': 'Switch to the free plan?',
    'plans.confirmFreeYes': 'Yes, switch to free',
    'plans.cancelling': 'Cancelling…',
    'plans.stayOn': 'Stay on {plan}',
    'plans.untilPeriodEnd': 'the end of your period',
    'plans.card.starter.eyebrow': 'To try it out',
    'plans.card.starter.body': 'Publish a simple idea and get to know how véltica works end to end.',
    'plans.card.starter.cta': 'Free plan',
    'plans.card.pro.eyebrow': 'Build your site',
    'plans.card.pro.body': 'Everything to build and publish your professional site: pages, CMS and your own domain.',
    'plans.card.pro.cta': 'Choose Pro',
    'plans.card.business.eyebrow': 'Start selling',
    'plans.card.business.body': 'Your site plus the business apps, with quotas sized to get going: forms, inbox, marketing, bookings, payments and team.',
    'plans.card.elite.eyebrow': "Built for courses",
    'plans.card.elite.body': "Everything in Business, with room for a full course catalog (up to 25), a large team and dedicated support. For people who sell what they know.",
    'plans.card.elite.allBusiness': 'Everything in Business, with quotas to spare',
    'plans.card.elite.team': '{count} team members with roles',
    'plans.card.elite.support': 'Dedicated support',
    'plans.card.elite.bookingsSales': 'Bookings and sales: {limit}',
    'plans.checkout.billedAnnually': 'Billed annually · ${amount} USD today',
    'plans.checkout.billedMonthly': 'Billed every month',
    'plans.checkout.back': 'Back to plans',
    'plans.checkout.legal1': 'By subscribing you accept our ',
    'plans.checkout.terms': 'Terms and conditions',
    'plans.checkout.legal2': ' and our ',
    'plans.checkout.privacy': 'Privacy policy',
    'plans.checkout.legal3': '. The subscription renews automatically and you can cancel it whenever you want.',
    'plans.table.title': 'Compare every feature',
    'plans.table.lead': 'Check the limits and features before you pick a plan.',
    'plans.table.aria': 'Plan comparison table',
    'plans.table.feature': 'Feature',
    'plans.table.included': 'Included',
    'plans.table.notIncluded': 'Not included',
    'plans.table.sec.site': 'Site and publishing',
    'plans.table.sec.cms': 'CMS and content',
    'plans.table.sec.capacity': 'Resources and capacity',
    'plans.table.sec.apps': 'Business apps',
    'plans.table.sec.support': 'Analytics and support',
    'plans.table.row.projects': 'Projects',
    'plans.table.row.pages': 'Pages',
    'plans.table.row.subdomain': 'Publish on a véltica subdomain',
    'plans.table.row.customDomain': 'Custom domain',
    'plans.table.row.freeDomain': 'A free domain for the first year',
    'plans.table.row.noBadge': 'Remove the véltica badge',
    'plans.table.row.ssl': 'SSL and global CDN',
    'plans.table.row.collections': 'CMS collections',
    'plans.table.row.cmsItems': 'CMS items',
    'plans.table.row.contacts': 'Contacts',
    'plans.table.row.search': 'Site search',
    'plans.table.row.visits': 'Site visits',
    'plans.table.row.storage': 'Storage',
    'plans.table.row.ai': 'Monthly AI assistant usage',
    'plans.table.row.forms': 'Forms',
    'plans.table.row.inbox': 'Inbox',
    'plans.table.row.marketing': 'Email marketing',
    'plans.table.row.bookings': 'Bookings',
    'plans.table.row.sales': 'Sales and payments',
    'plans.table.row.fee': 'véltica fee per sale',
    'plans.table.val.feePercent': '{percent}%',
    'plans.table.row.courses': "Sell your courses",
    'plans.table.row.team': 'Team members',
    'plans.table.row.roles': 'Per-member roles and permissions',
    'plans.table.row.analytics': 'Analytics',
    'plans.table.row.password': 'Password protection',
    'plans.table.row.support': 'Support level',
    'plans.table.val.withAnnual': 'With an annual plan',
    'plans.table.val.noLimit': 'No limit',
    'plans.table.val.standard': 'Standard',
    'plans.table.val.aiTimes': '{times}× more',
    'plans.table.row.aiGenerations': 'AI-generated sites',
    'plans.table.val.generationsTotal': '{count} in total',
    'plans.table.val.generationsMonthly': '{count} per month',
    'plans.table.val.analyticsBasic': 'Basic',
    'plans.table.val.analyticsFull': 'Full',
    'plans.table.val.analyticsReports': 'Full + reports',
    'plans.table.val.supportCommunity': 'Community',
    'plans.table.val.supportEmail': 'Email',
    'plans.table.val.supportPriority': 'Priority',
    'plans.table.val.supportDedicated': 'Dedicated',
    'invite.kicker': 'Team invitation',
    'invite.fromSomeone': 'You were invited to',
    'invite.from': '{name} invited you to',
    'invite.asRole': 'As',
    'invite.expiresOne': 'Expires in {count} day',
    'invite.expiresMany': 'Expires in {count} days',
    'invite.reject': 'Decline',
    'invite.accept': 'Accept',
    'invite.entering': 'Entering…',
    'domain.ssl.active': 'Active',
    'domain.ssl.pending_validation': 'Being validated',
    'domain.ssl.pending_issuance': 'Being issued',
    'domain.ssl.pending_deployment': 'Being deployed',
    'domain.ssl.pending_deletion': 'Being withdrawn',
    'domain.ssl.expired': 'Expired',
    'domain.ssl.deleted': 'Withdrawn',
    'domain.ssl.initializing': 'Getting ready',
    'domain.status.active': 'Active',
    'domain.status.verifying': 'Verifying',
    'domain.status.pending_dns': 'Waiting for DNS',
    'domain.status.purchasing': 'Registering',
    'domain.status.disconnected': 'Disconnected',
    'domain.status.error': 'With an error',
    'domain.type.A': 'Points the domain at an IP address.',
    'domain.type.AAAA': 'Like A, but for IPv6 addresses.',
    'domain.type.CNAME': 'Points a subdomain at another address.',
    'domain.type.MX': 'Says which server receives your email.',
    'domain.type.TXT': 'Free text. Google, Microsoft and others ask for it to verify the domain is yours.',
    'domain.certificate': 'Certificate',
    'domain.expires': 'Expires',
    'domain.inDaysOne': 'in {count} day',
    'domain.inDaysMany': 'in {count} days',
    'domain.expired': 'already expired',
    'domain.registeredOn': 'Registered on',
    'domain.domain': 'Domain',
    'domain.copied': 'Copied',
    'domain.copy': 'Copy',
    'domain.dns': 'DNS records',
    'domain.dnsBody': 'Point subdomains, connect your email or verify the domain with other services.',
    'domain.addRecord': 'Add a record',
    'domain.field.type': 'Type',
    'domain.field.name': 'Name',
    'domain.field.value': 'Value',
    'domain.field.priority': 'Priority',
    'domain.field.ttl': 'TTL',
    'domain.emptyMeans': 'Empty = {hostname}',
    'domain.valuePlaceholderMx': 'mail.yourserver.com',
    'domain.valuePlaceholderCname': 'target.example.com',
    'domain.saveChanges': 'Save changes',
    'domain.add': 'Add',
    'domain.loadingDns': 'Reading the DNS…',
    'domain.retry': 'Try again',
    'domain.noRecords': 'This domain has no records yet.',
    'domain.actions': 'Actions',
    'domain.lockedTip': 'Keeps your site online and its certificate working',
    'domain.editRecord': 'Edit {type} {name}',
    'domain.deleteRecord': 'Delete {type} {name}',
    'domain.transfer': 'Transfer to another registrar',
    'domain.codeRequested': 'Code requested',
    'domain.codeRequestedBody': 'It will be here and in your email within 24 business hours.',
    'domain.yourCode': 'Your authorisation code',
    'domain.codeHelp': 'Give it to the registrar you are moving the domain to. Do not share it with anyone else: with this code anyone can take it.',
    'domain.codeKept': ' We keep it here until {date}.',
    'domain.codeSent': 'Code sent',
    'domain.codeSentBody': 'Check your email and your spam folder.',
    'domain.asking': 'Requesting…',
    'domain.askCode': 'Request a transfer code',
    'domain.unlockNote': 'When the code is issued, we unlock the domain so you can transfer it.',
    'domain.transferableFrom': 'Transferable from {date}',
    'domain.icann': 'ICANN blocks transfers during the first 60 days.',
    'domain.confirmDeleteAria': 'Confirm deletion',
    'domain.confirmDelete': 'Delete this record?',
    'domain.confirmDeleteNote': 'DNS changes take between a few minutes and a few hours to propagate. If this connects something (your email, another service) it stops working in the meantime.',
    'domain.delete': 'Delete',
    /* A domain's renewal, on the account card. */
    'accountDomains.autoRenew': 'Renew automatically',
    'accountDomains.autoRenewOn': "We'll charge your card a month before it expires.",
    'accountDomains.autoRenewOff': "We'll warn you before it expires, but you'll have to pay for it yourself.",
    'accountDomains.autoRenewFailed': "We couldn't change the automatic renewal.",
    'accountDomains.renewLastFailed': "The last charge didn't go through. Check your card or pay the renewal now.",
    'accountDomains.renewLocked': "Locked while we review a refund or payment dispute.",
    'accountDomains.renewNow': 'Renew now',
    'accountDomains.renewFailed': "We couldn't open the renewal payment.",
    'accountDomains.renewSummary': 'One more year of registration, starting from the current expiry date.',
    'accountDomains.renewUnit': 'USD',
    'accountDomains.renewBilled': 'A single charge. It does not create a subscription.',
    'accountDomains.renewLegal': "When you pay, we renew the domain at the registrar and its expiry moves a year out. If anything went wrong, we refund you in full.",
    'accountDomains.title': 'Domains',
    'accountDomains.subtitle': 'The domains on your account and the site each one is on.',
    'accountDomains.cardTitle': 'Your domains',
    'accountDomains.cardBody': 'Choose which site each one is used on, or open its settings to touch the DNS.',
    'accountDomains.loading': 'Loading…',
    'accountDomains.emptyTitle': 'No domains yet',
    'accountDomains.emptyBody': 'Domains you buy through Veltica will appear here. External domains stay with their registrar.',
    'accountDomains.status.active': 'Connected',
    'accountDomains.status.verifying': 'Verifying',
    'accountDomains.status.pending_dns': 'Waiting for DNS',
    'accountDomains.status.purchasing': 'Registering',
    'accountDomains.status.disconnected': 'Not connected',
    'accountDomains.status.error': 'Needs attention',
    'accountDomains.codeReady': 'Code ready',
    'accountDomains.codeRequested': 'Code requested',
    'accountDomains.expiresOn': 'The registration expires on {date}',
    'accountDomains.noExpiry': 'No expiry date',
    'accountDomains.site': 'Site',
    'accountDomains.connecting': 'Connecting…',
    'accountDomains.connect': 'Connect',
    'accountDomains.move': 'Move',
    'accountDomains.connectedHere': 'Connected here',
    'accountDomains.settingsOf': '{hostname} settings',
    'accountDomains.dnsAndTransfer': 'DNS and transfer',
    'accountDomains.goTo': 'Go to {project}',
    'accountDomains.openSite': 'Open the site',
    'usage.title': 'Usage and limits',
    'usage.description': 'How much of your plan’s per-project limits this site uses.',
    'usage.planConsumption': '{plan} plan usage',
    'usage.currentCycle': 'Current cycle · {cycle}',
    'usage.renewsOn': 'Renews on {date}',
    'usage.freeNoCycle': 'Free plan · no billing cycle',
    'usage.noCycle': 'No active cycle',
    'usage.groupContent': 'Site content',
    'usage.of': 'of {limit}',
    'usage.raiseLimit': 'Raise the limit',
    'usage.unlimited': 'Unlimited usage',
    'usage.percentUsed': '{percent}% used',
    'usage.about': 'About {label}',
    'usage.noLimit': 'No limit',
    'usage.resetsInDays': 'Resets in {count} days',
    'usage.resetsInDay': 'Resets in {count} day',
    'usage.resetsInHours': 'Resets in {count} hours',
    'usage.resetsInHour': 'Resets in {count} hour',
    'usage.resetsInMinutes': 'Resets in {count} min',
    'usage.resetsSoon': 'Resets soon',
    'usage.stat.pages': 'Pages',
    'usage.stat.pagesBody': 'The static pages of your site.',
    'usage.stat.collections': 'CMS collections',
    'usage.stat.collectionsBody': 'Collections of dynamic content.',
    'usage.stat.cmsItems': 'CMS items',
    'usage.stat.cmsItemsBody': 'Every item across all of your collections.',
    'usage.stat.offers': "Published offers",
    'usage.stat.offersBody': "Everything on sale from your site: digital products, services and bookable services. Drafts, appointments and sales do not count towards this.",
    'usage.stat.contacts': "Contacts",
    'usage.stat.contactsBody': "People who wrote to you, bought or booked, gathered in one place.",
    'usage.stat.team': "Collaborators",
    'usage.stat.blogPostsBody': 'Blog posts live on your site. Drafts don’t count.',
    'usage.stat.teamBody': "People invited to this project. The owner does not take a seat.",
    'usage.stat.bandwidth': 'Site traffic',
    'usage.stat.bandwidthBody': 'Estimated volume of data served to visitors of all your sites this month. No limit: it is for information.',
    'usage.stat.storage': 'Storage',
    'usage.stat.storageBody': 'Images and files from all your projects, in one space.',
    'usage.stat.forms': 'Form submissions',
    'usage.stat.formsBody': 'Submissions received this month across the forms of all your sites.',
    'usage.stat.ai': 'AI assistant',
    'usage.stat.aiBody': 'How much of the editor assistant you have used, across all your projects.',
    'usage.stat.projects': 'Projects',
    'usage.stat.projectsBody': 'Projects you own. Projects others share with you don’t count.',
    'usage.stat.generations': 'AI generations',
    'usage.stat.generationsBody': 'Each site or page the AI creates from scratch uses one.',
    'usage.noReset': 'Included with your plan: they don’t renew',
    'usage.shared.title': 'Shared across your projects',
    'usage.shared.body': 'AI, storage and form submissions come from a single allowance on your account, not from each site.',
    'usage.shared.open': 'View account usage',
    'accountUsage.viewProjects': 'View by project',
    'accountUsage.trafficProjects': 'Traffic by project',
    'accountUsage.trafficEstimate': 'Estimated data served this calendar month, based on page views. Only projects you own are included.',
    'accountUsage.project': 'Project',
    'accountUsage.estimatedData': 'Estimated data',
    'accountUsage.total': 'Total',
    'accountUsage.noProjects': 'Your projects will appear here when you create one.',
    'accountUsage.breakdownUnavailable': 'The project breakdown is not available yet. Please try again later.',
    'accountUsage.title': 'Account usage',
    'accountUsage.subtitle': 'What all your projects use together, from the allowance your plan includes.',
    'accountUsage.groupAi': 'Artificial intelligence',
    'accountUsage.groupResources': 'Projects and resources',
    'accountUsage.perProject': 'Each site’s own limits (pages, CMS, offers, contacts) are under “Usage and limits” inside each project.',
    'usage.noun.pages': 'pages',
    'usage.effect.pages': 'you will not be able to create new pages',
    'usage.noun.collections': 'collections',
    'usage.effect.collections': 'you will not be able to create new collections',
    'usage.noun.cmsItems': 'CMS items',
    'usage.effect.cmsItems': 'you will not be able to add more items to your collections',
    'usage.noun.offers': "published offers",
    'usage.effect.offers': "you will not be able to publish another until you take one down or move up a plan",
    'usage.noun.contacts': 'contacts',
    'usage.effect.contacts': 'your list reaches the maximum the plan includes',
    'usage.noun.ai': 'AI usage',
    'usage.effect.ai': 'the assistant stops answering until the quota resets',
    'usage.noun.forms': 'form submissions',
    'usage.effect.forms': 'new messages keep being saved, but they now count outside your plan',
    'usage.noun.storage': 'storage',
    'usage.effect.storage': 'you will not be able to upload more images or files',
    'usage.noun.blogPosts': 'published posts',
    'usage.effect.blogPosts': 'you won’t be able to publish another until you move one to draft or upgrade',
    'usage.noun.teamMembers': 'collaborators',
    'usage.effect.teamMembers': 'you won’t be able to invite more people to this project',
    'usage.noun.projects': 'projects',
    'usage.effect.projects': 'you won’t be able to create new projects',
    'usage.noun.generations': 'AI generations',
    'usage.effect.generations': 'you won’t be able to create sites or pages with AI until they renew',
    'usage.noun.bandwidth': 'traffic',
    'usage.effect.bandwidth': 'your site stays online as usual',
    'usage.alert.warn': 'You are at {percent}% of the {noun} in your {plan} plan. At 100%, {effect}.',
    'usage.alert.full': 'You reached the {noun} limit of your {plan} plan: {effect}. {upsell}',
    'usage.alert.upgrade': 'Move up to {plan} to raise it.',
    'usage.alert.contact': 'Write to us to raise it.',
    'cwa.businessName': "Business name",
    'cwa.businessNameHint': "It shows in the title, the logo and wherever the text names your business. Changing it here changes it everywhere.",
    'cwa.brandLead': "All optional: skip anything you don't have yet and add it later in the editor.",
    'cwa.logoHint': "Replaces the logo in the navigation bar and the footer. Edit it anytime in Style › Logo.",
    'cwa.contactEmail': "Contact email",
    'cwa.contactEmailPlaceholder': "Your account email if left empty",
    'cwa.contactEmailInvalid': "That email doesn't look right: it won't be saved. Leave it empty to use your account email.",
    'cwa.contactEmailHint': "Where contact messages arrive. It also goes in your privacy policy and terms.",
    'cwa.address': "Address",
    'cwa.addressPlaceholder': "Street, city",
    'cwa.sectionVisible': "Show this section",
    'cwa.pages.aria': "Site pages",
    'cwa.pageSections.one': "1 section",
    'cwa.pageSections.many': "{count} sections",
    'cwa.pageInclude': "Include this page",
    'cwa.pageCatalog.tab': "Automatic catalog",
    'cwa.pageCatalog.title': "This page fills itself",
    'cwa.pageCatalog.body.products': "Your products show up here, newest first, 12 per page. New ones appear on their own. You can style it in the editor.",
    'cwa.pageCatalog.body.digital': "Your digital products show up here, newest first, 12 per page. New ones appear on their own. You can style it in the editor.",
    'cwa.pageCatalog.body.bookings': "Your bookable services show up here, newest first, 12 per page. New ones appear on their own. You can style it in the editor.",
    'cwa.pageCatalog.body.services': "Your services show up here, newest first, 12 per page. New ones appear on their own. You can style it in the editor.",
    'cwa.pageCatalog.body.blog': "Your blog posts show up here, newest first, 12 per page. New ones appear on their own. You can style it in the editor.",
    'cwa.pageIncludeHint': "It's created and shown in the menu. If you remove it, you can add it later in the editor.",
    'cwa.pageExcludedHint': "It won't be created or shown in the menu. You can preview it here before deciding.",
    'cwa.pageExcluded': "Won't be created",
    'cwa.palettes': "More palettes",
    'cwa.fontSample': "Body text in {font}",
    'cwa.step.combination': "Combination",
    'cwa.step.motion': "Animation",
    'cwa.wz.combination.title': "Choose a combination",
    'cwa.wz.combination.lead': "Style, colors, and fonts together. Start with the one the AI picked or another one; you'll fine-tune it in the next steps.",
    'cwa.wz.motion.title': "Choose an animation",
    'cwa.wz.motion.lead': "How content appears as visitors scroll your site. Hover over a card to preview it; you can customize it later in the editor.",
    'cwa.combination.ai': "Picked by AI",
    'cwa.combination.aiName': "Your site's",
    'cwa.combination.aiHint': "What the AI designed for your business, as generated.",
    'cwa.motion.suggested': "Recommended",
    'cwa.step.style': "Style",
    'cwa.styleBase': "Base style",
    'cwa.styleBaseHint': "Sets the structure: shapes, borders, shadows and fonts. Change anything below on top of it.",
    'cwa.brandColor': "Brand color",
    'cwa.fromStyle': "From the style",
    'cwa.customColor': "Other",
    'cwa.fontPair': "Fonts",
    'cwa.buttons': "Buttons",
    'cwa.cards': "Cards",
    'cwa.spacing': "Space between sections",
    'cwa.sectionsHint': "Reorder them, turn them off or try another variant. A new variant keeps the same text.",
    'cwa.variant': "Another variant",
    'cwa.variantPrev': "Previous variant",
    'cwa.variantNext': "Next variant",
    'cwa.variantOriginal': "Original",
    'cwa.variantOf': "Variant {n} of {total}",
    'cwa.variantBackOriginal': "Back to the original",
    'cwa.variantFailed': "That variant could not be loaded. Try again.",
    'cwa.moveUp': "Move up",
    'cwa.moveDown': "Move down",
    'cwa.trimmed': "You can add more pages and sections from the editor anytime.",
    'cwa.exampleContent': "Prices, testimonials and numbers are examples: review them before publishing.",
    'cwa.step.data': 'Details',
    'cwa.step.type': 'Type',
    'cwa.step.colors': 'Colors',
    'cwa.step.sections': 'Sections',
    'cwa.step.brand': 'Brand',
    'welcome.business.title': "What kind of business do you have?",
    'welcome.business.lead': "We'll use it to start your site with an idea that fits. You can change everything later.",
    'welcome.business.other': "Something else",
    'welcome.business.services.desc': "Consulting, health, legal, agencies…",
    'welcome.business.restaurant.desc': "Restaurants, cafés, bars, catering…",
    'welcome.business.shop.desc': "Apparel, beauty, crafts, products…",
    'welcome.business.wellness.desc': "Spa, yoga, therapy, aesthetics…",
    'welcome.business.portfolio.desc': "Design, photography, art, freelance…",
    'welcome.business.other.desc': "Tell us in your own words.",
    'welcome.goal.bookings.desc': "Appointments and classes with times and payment.",
    'welcome.goal.services.desc': "Packages and services with their price.",
    'welcome.goal.products.desc': "Physical or digital products.",
    'welcome.goal.blog.desc': "News, guides and stories.",
    'welcome.goal.showcase.desc': "Who you are, what you do and how to reach you.",
    'welcome.business.fitness': "Fitness",
    'welcome.business.fitness.desc': "Gyms, trainers, yoga, sports…",
    'welcome.business.health': "Health",
    'welcome.business.health.desc': "Clinics, dentists, therapy, nutrition…",
    'welcome.business.education': "Education",
    'welcome.business.education.desc': "Courses, schools, tutoring, coaching…",
    'welcome.business.realestate': "Real estate",
    'welcome.business.realestate.desc': "Agents, listings, rentals…",
    'welcome.business.events': "Events",
    'welcome.business.events.desc': "Weddings, venues, planning, conferences…",
    'welcome.business.hospitality': "Hotels & travel",
    'welcome.business.hospitality.desc': "Hotels, vacation rentals, tours…",
    'welcome.business.trades': "Home services",
    'welcome.business.trades.desc': "Construction, cleaning, repairs…",
    'welcome.business.creator': "Personal brand",
    'welcome.business.creator.desc': "Creators, speakers, coaches…",
    'welcome.business.tech': "Tech",
    'welcome.business.tech.desc': "Software, apps, SaaS…",
    'welcome.business.nonprofit': "Nonprofit",
    'welcome.business.nonprofit.desc': "Charities, communities, churches…",
    'welcome.business.otherLabel': "What does your business do?",
    'welcome.business.otherPlaceholder': "E.g. tattoo studio, music school…",
    'welcome.goals.title': "What should your site do for you?",
    'welcome.goals.lead': "Pick as many as you like.",
    'welcome.goal.bookings': "Take bookings",
    'welcome.goal.services': "Sell services",
    'welcome.goal.products': "Sell products",
    'welcome.goal.blog': "Publish a blog",
    'welcome.goal.showcase': "Showcase my business",
    'brief.aria': "What the AI is told about this site",
    'brief.business': "Industry",
    'brief.goals': "I want to",
    'brief.removeGoal': "Remove “{name}”",
    'brief.addGoal': "Add goal",
    'brief.goalShort.bookings': "Bookings",
    'brief.goalShort.services': "Services",
    'brief.goalShort.products': "Store",
    'brief.goalShort.blog': "Blog",
    'brief.goalShort.showcase': "Showcase",
    'brief.none': "Not specified",
    'brief.photos': "Photos",
    'brief.photosAdd': "Add your photos",
    'brief.photosDrop': "Drop your photos: the AI will place them on your site",
    'brief.photosHint': "Your photos: the AI places them on your site, the first ones on the home page",
    'brief.photosCount': "Photos · {count}/{max}",
    'brief.photosRemove': "Remove photo {n}",
    'brief.photoAlt': "Your photo {n}",
    'brief.photosUploading': "Uploading your photos…",
    'brief.photosFailed': "Some photos couldn't be uploaded. Try again.",
    'brief.photosLimit': "Your plan allows up to {max} photos here. You can add more later in the editor.",
    'welcome.skip': "Skip",
    'start.idea.services.1': "Consultancy",
    'start.idea.services.1.prompt': "A professional consultancy. I want to explain how we help, show success stories and get people to book a discovery call.",
    'start.idea.services.2': "Law firm",
    'start.idea.services.2.prompt': "A trustworthy, approachable law firm. I want to present our practice areas and team, and make it easy to request a consultation.",
    'start.idea.services.3': "Creative agency",
    'start.idea.services.3.prompt': "A marketing and design agency. I want to show our services and recent projects, and receive quote requests.",
    'start.idea.restaurant.1': "Taquería",
    'start.idea.restaurant.1.prompt': "A family-run taquería with homemade flavor. I want to show the menu, hours and location, and take orders to go.",
    'start.idea.restaurant.2': "Specialty café",
    'start.idea.restaurant.2.prompt': "A cozy specialty coffee shop. I want to tell where our coffee comes from, show the menu and let groups reserve a table.",
    'start.idea.restaurant.3': "Event restaurant",
    'start.idea.restaurant.3.prompt': "An elegant restaurant with a private room. I want to show the seasonal menu and make reservations and event quotes easy.",
    'start.idea.shop.1': "Apparel",
    'start.idea.shop.1.prompt': "A clothing and accessories brand with its own style. I want to show the collections, tell the brand story and guide people to buy.",
    'start.idea.shop.2': "Natural cosmetics",
    'start.idea.shop.2.prompt': "A natural cosmetics shop. I want to highlight each product's ingredients and benefits and build trust with reviews.",
    'start.idea.shop.3': "Handmade",
    'start.idea.shop.3.prompt': "A workshop making handmade products. I want to show the process and available pieces, and accept custom orders.",
    'start.idea.wellness.1': "Spa",
    'start.idea.wellness.1.prompt': "A relaxation and massage spa. I want to present the treatments with prices and let people book online.",
    'start.idea.wellness.2': "Beauty salon",
    'start.idea.wellness.2.prompt': "A modern beauty salon. I want to show our services and the team's work, and make booking easy.",
    'start.idea.wellness.3': "Skincare studio",
    'start.idea.wellness.3.prompt': "An aesthetics and skincare studio. I want to explain each treatment, answer common questions and take appointments.",
    'start.idea.fitness.1': "Gym",
    'start.idea.fitness.1.prompt': "A neighborhood gym with a great vibe. I want to show the facilities, membership plans and class schedule.",
    'start.idea.fitness.2': "Personal trainer",
    'start.idea.fitness.2.prompt': "A personal trainer. I want to present my programs, show client results and let people book a trial session.",
    'start.idea.fitness.3': "Yoga & pilates",
    'start.idea.fitness.3.prompt': "A yoga and pilates studio. I want to present the classes and instructors and let people reserve their spot.",
    'start.idea.health.1': "Dental clinic",
    'start.idea.health.1.prompt': "A family dental clinic. I want to present our treatments and team, build trust and let patients book appointments.",
    'start.idea.health.2': "Therapy practice",
    'start.idea.health.2.prompt': "A psychology practice. I want to explain my approach and the therapies I offer, and let people book a first session.",
    'start.idea.health.3': "Nutrition",
    'start.idea.health.3.prompt': "A nutrition practice. I want to present my meal plans, share tips and take both online and in-person consultations.",
    'start.idea.education.1': "Online course",
    'start.idea.education.1.prompt': "An online course. I want to explain what you'll learn, who teaches it and the syllabus, and sell access.",
    'start.idea.education.2': "Private lessons",
    'start.idea.education.2.prompt': "Private lessons in languages or school subjects. I want to present the levels and prices and let students book a lesson.",
    'start.idea.education.3': "Coaching",
    'start.idea.education.3.prompt': "A coaching program. I want to share my method, show testimonials and let people book a discovery session.",
    'start.idea.realestate.1': "Real estate agent",
    'start.idea.realestate.1.prompt': "An independent real estate agent. I want to show featured listings and my experience, and receive viewing requests.",
    'start.idea.realestate.2': "New development",
    'start.idea.realestate.2.prompt': "A new residential development. I want to present the floor plans, amenities and location, and capture leads.",
    'start.idea.realestate.3': "Rentals",
    'start.idea.realestate.3.prompt': "An apartment rental company. I want to show available units and requirements, and make it easy to get in touch.",
    'start.idea.events.1': "Weddings",
    'start.idea.events.1.prompt': "A wedding planner. I want to show weddings we've done and our packages, and receive quote requests.",
    'start.idea.events.2': "Event venue",
    'start.idea.events.2.prompt': "An event venue. I want to present the spaces, capacity and packages, and let people hold a date.",
    'start.idea.events.3': "Conference",
    'start.idea.events.3.prompt': "An annual conference. I want to present the speakers and agenda, and sell tickets.",
    'start.idea.hospitality.1': "Boutique hotel",
    'start.idea.hospitality.1.prompt': "A boutique hotel. I want to show the rooms and local experiences, and make reservations easy.",
    'start.idea.hospitality.2': "Vacation rental",
    'start.idea.hospitality.2.prompt': "A vacation rental home. I want to show the spaces, amenities and house rules, and take bookings.",
    'start.idea.hospitality.3': "Tours",
    'start.idea.hospitality.3.prompt': "A local tour company. I want to present the tours with duration and price, and let people book their spot.",
    'start.idea.trades.1': "Construction",
    'start.idea.trades.1.prompt': "A construction and remodeling company. I want to show finished projects and our services, and receive estimate requests.",
    'start.idea.trades.2': "Cleaning",
    'start.idea.trades.2.prompt': "A home and office cleaning service. I want to explain our packages, build trust and let people schedule a visit.",
    'start.idea.trades.3': "Repairs",
    'start.idea.trades.3.prompt': "A plumbing and electrical service. I want to show the areas we cover and our services, and let people reach us fast.",
    'start.idea.portfolio.1': "Photography",
    'start.idea.portfolio.1.prompt': "A wedding and portrait photographer. I want to show my best work and packages, and receive date requests.",
    'start.idea.portfolio.2': "Graphic design",
    'start.idea.portfolio.2.prompt': "An independent graphic designer. I want to show projects with their process and my services, and attract new clients.",
    'start.idea.portfolio.3': "Architecture",
    'start.idea.portfolio.3.prompt': "An architecture studio. I want to present completed work and our philosophy, and receive project inquiries.",
    'start.idea.creator.1': "Content creator",
    'start.idea.creator.1.prompt': "A content creator. I want to present who I am, my channels and collaborations, and receive brand proposals.",
    'start.idea.creator.2': "Speaker",
    'start.idea.creator.2.prompt': "A speaker. I want to show my topics and the events I've spoken at, and get booked for events.",
    'start.idea.creator.3': "Life coach",
    'start.idea.creator.3.prompt': "A life coach. I want to share my story and programs, and let people book a free call.",
    'start.idea.tech.1': "Mobile app",
    'start.idea.tech.1.prompt': "A mobile app. I want to explain the problem it solves, show its features and get people to download it.",
    'start.idea.tech.2': "SaaS",
    'start.idea.tech.2.prompt': "Subscription software for businesses. I want to show the benefits, plans and pricing, and get people to start a free trial.",
    'start.idea.tech.3': "Custom software",
    'start.idea.tech.3.prompt': "A custom software development company. I want to show case studies and technologies, and receive project requests.",
    'start.idea.nonprofit.1': "Foundation",
    'start.idea.nonprofit.1.prompt': "A nonprofit foundation. I want to tell our cause, show our impact and receive donations.",
    'start.idea.nonprofit.2': "Community",
    'start.idea.nonprofit.2.prompt': "A community association. I want to present our activities and upcoming events, and get people to join as members.",
    'start.idea.nonprofit.3': "Church",
    'start.idea.nonprofit.3.prompt': "A church. I want to share service times, ministries and events, and welcome new visitors.",
    'cwa.title': 'Tell us what you want to build',
    'cwa.promptPlaceholder': 'Describe your business, what you offer and what the site is for.',
    'cwa.ideaTry': "No ideas? Try an example",
    'cwa.ideaTryShort': "Try an example",
    'cwa.ideaAnother': "Another example",
    'cwa.minChars': '{missing} more characters',
    'cwa.canChange': 'You can change all of this in the next step',
    'cwa.generate': 'Generate my site',
    'cwa.generating': 'Generating your site…',
    'cwa.created': "Your site is ready!",
    'cwa.createdSub': "Getting the preview ready…",
    'cwa.projectName': 'Project name',
    'cwa.slugPlaceholder': 'my-project',
    'cwa.slugTaken': 'That URL is already taken, pick another.',
    'cwa.typography': 'Type pairing',
    'cwa.palette': 'Global colors',
    'cwa.auto': 'Automatic (AI)',
    'cwa.sections': 'Sections',
    'cwa.logo': 'Logo',
    'cwa.phone': 'Business number',
    'cwa.instagram': 'Instagram',
    'cwa.facebook': 'Facebook',
    'cwa.back': 'Back',
    'cwa.next': 'Next',
    'cwa.creating': 'Creating…',
    'cwa.create': 'Create project',
    'cwa.tpl.services': 'Services',
    'cwa.tpl.servicesPrompt': 'A professional services business. I want to explain clearly what we offer, build trust and receive enquiries.',
    'cwa.tpl.restaurant': 'Restaurant',
    'cwa.tpl.restaurantPrompt': 'A restaurant with a warm, current identity. I want to present the menu, tell the story of the place and make booking easy.',
    'cwa.tpl.shop': 'Shop',
    'cwa.tpl.shopPrompt': 'A modern online shop that is easy to browse. I want to highlight the products, their benefits and guide people towards buying.',
    'cwa.tpl.wellness': 'Wellness',
    'cwa.tpl.wellnessPrompt': 'A professional, welcoming wellness brand. I want to present the services, answer common questions and make booking easy.',
    'cwa.tpl.portfolio': 'Portfolio',
    'cwa.tpl.portfolioPrompt': 'A portfolio with a memorable visual identity. I want to show projects, explain how I work and attract new opportunities.',
    'start.promptAria': 'Describe the project you want to create',
    'start.template': 'From a template',
    'start.templateBody': 'Pick a finished design and change its colors, type and content.',
    'start.blank': 'Blank project',
    'start.blankBody': 'An empty canvas. For when you already know exactly what you want to build.',
    'start.site': "Your edited page",
    'start.siteBodyStyle': "The one you changed in the veltica.com demo, in the {design} style: your text, your photos and your sections.",
    'start.siteBody': "The one you changed in the veltica.com demo: your text, your photos and your sections.",
    'start.siteNamed': "Continue with {name}",
    'start.siteBodyExample': "The page the AI built on veltica.com, with its texts and photos, and its shop ready for your prices.",
    'start.describeExample': "Describe {name}",
    'start.siteGo': "Continue with my page",
    'start.siteDrop': "Remove the page you brought from veltica.com",
    'start.go': 'Start',
    'svcw.weekday.0': 'Sun',
    'svcw.weekday.1': 'Mon',
    'svcw.weekday.2': 'Tue',
    'svcw.weekday.3': 'Wed',
    'svcw.weekday.4': 'Thu',
    'svcw.weekday.5': 'Fri',
    'svcw.weekday.6': 'Sat',
    'svcw.step.info': 'Details',
    'svcw.step.settings': 'Settings',
    'svcw.step.price': 'Price',
    'svcw.step.form': 'Form',
    'svcw.step.schedule': 'Schedule',
    'svcw.step.cancel': 'Cancellation',
    'svcw.step.review': 'Review',
    'svcw.pay.free': 'Free',
    'svcw.pay.freeHint': 'No cost: the booking is confirmed right away.',
    'svcw.price.freeLabel': 'Free',
    'svcw.price.onsiteLabel': '{price} · pay on site',
    'svcw.price.onsiteAmountHint': 'What they’ll pay on site. Shown on the page, not charged online.',
    'svcw.pay.onsite': 'Pay on site',
    'svcw.pay.onsiteHint': 'The price is shown, but paid there, not online.',
    'svcw.pay.prepaid': 'Paid when booking',
    'svcw.pay.prepaidHint': 'The customer pays before it is confirmed.',
    'svcw.pay.deposit': 'A deposit is left',
    'svcw.pay.depositHint': 'Part when booking and the rest on site.',
    'svcw.membership.manageHint': "You can also create them and pick their bookings in Catalog › Memberships & packs.",
    'nav.memberships': "Memberships",
    'section.memberships': "Memberships",
    'memberships.title': "Memberships & packs",
    'memberships.subtitle': "Recurring memberships and one-time packs: included bookings, digital products and discounts.",
    'memberships.new': "New membership",
    'memberships.needBookingsTitle': "Create an offer first",
    'memberships.needBookingsBody': "A membership or pack includes bookings, digital products or a discount on your catalog. Create at least one offer so it has something to give.",
    'memberships.needBookingsCta': "Go to offers",
    'memberships.form.discount': "Member discount",
    'memberships.form.discountLead': "A percentage off products, services without booking and digital items while the membership is active.",
    'memberships.form.discountPercent': "Discount",
    'memberships.form.discountScope': "Applies to",
    'memberships.form.discountAll': "Whole catalog",
    'memberships.form.discountSome': "Choose",
    'memberships.form.discountNone': "You don't have products or one-time services yet.",
    'memberships.form.discountHint': "Applied at checkout when the customer is signed in. Coupons still apply on top.",
    'memberships.discountAll': "{percent}% off for members on the whole catalog",
    'memberships.discountSome': "{percent}% off for members on {count} offers",
    'memberships.wizard.step.info': "Info",
    'memberships.wizard.step.access': "Price and access",
    'memberships.wizard.step.review': "Review",
    'memberships.wizard.info.kicker': "Step 1",
    'memberships.wizard.info.title': "What are you offering?",
    'memberships.wizard.info.lead': "A membership is charged on a schedule; a pack is a single payment.",
    'memberships.wizard.descriptionFoot': "Shown on the card and on the purchase page.",
    'memberships.wizard.needName': "Give it a name.",
    'memberships.wizard.access.kicker': "Step 2",
    'memberships.wizard.access.title': "Price and how often it's charged",
    'memberships.wizard.access.titlePack': "Price and how long it lasts",
    'memberships.wizard.perPeriodHint': "How many they can make in each billing period.",
    'memberships.wizard.needPrice': "Enter a price above zero.",
    'memberships.wizard.needRule': "Enter how many bookings or days.",
    'memberships.wizard.needDiscount': "Enter a percentage and pick at least one offer.",
    'memberships.wizard.review.title': "Review your membership",
    'memberships.wizard.previewHint': "How your customer sees it",
    'memberships.wizard.more': "and {count} more",
    'memberships.wizard.cta': "Become a member",
    'memberships.wizard.ctaPack': "Buy pack",
    'memberships.detail.back': "Back to memberships",
    'memberships.detail.draftTitle.membership': "This membership is not active yet",
    'memberships.detail.draftTitle.pack': "This pack is not active yet",
    'memberships.detail.draftBody': "It is saved as a draft. When you are ready, publish it so customers can buy it from your page.",
    'memberships.wizard.review.draftWarnOne': "1 included service is a draft: your customers won't be able to book it.",
    'memberships.wizard.review.draftWarn': "{count} included services are drafts: your customers won't be able to book them.",
    'memberships.wizard.review.publishDraftsOne': "Publish that service too",
    'memberships.wizard.review.publishDrafts': "Publish those services too",
    'memberships.wizard.review.empty': "To publish it, it must give something that is already published: bookings, digital products or a discount. You can save it as a draft.",
    'memberships.wizard.publishDraftFailed': "Couldn't publish “{title}”. Check it in Bookings.",
    'memberships.detail.emptyTitle.membership': "This membership has no members yet",
    'memberships.detail.emptyBody.membership': "When someone becomes a member, the first charge and every renewal show up here as soon as Stripe confirms them.",
    'memberships.detail.emptyTitle.pack': "This pack has not sold yet",
    'memberships.detail.emptyBody.pack': "When someone buys it, the payment shows up here as soon as Stripe confirms it.",
    'memberships.wizard.step.benefits': "What's included",
    'memberships.wizard.benefits.kicker': "Step 3",
    'memberships.wizard.benefits.title': "What's included?",
    'memberships.wizard.benefits.lead': "Turn on at least one.",
    'memberships.wizard.benefits.leadPack': "Turn on at least one.",
    'memberships.wizard.benefits.classes': "Included bookings",
    'memberships.wizard.benefits.classesHint': "They book without paying each time.",
    'memberships.wizard.benefits.discountHint': "A % off products and services.",
    'memberships.wizard.benefits.noClasses': "You don't have bookable services yet.",
    'memberships.wizard.needClasses': "Pick at least one bookable service.",
    'memberships.wizard.needBenefit': "Turn on at least one: bookings, digital products or a discount.",
    'memberships.wizard.priceMode': "Price",
    'memberships.wizard.paid': "Paid",
    'memberships.wizard.free': "Free",
    'memberships.wizard.freeHint': "They join with their account. No included bookings.",
    'memberships.wizard.benefits.leadFree': "A free membership gives a discount.",
    'memberships.wizard.benefits.classesFree': "Not available on a free membership.",
    'memberships.wizard.whyTitle': "A free membership can't include bookings",
    'memberships.wizard.whyBody': "Anyone could join and book for free with no limit. To include bookings, give it a price (even a low one) or create a pack.",
    'memberships.wizard.whyOk': "Got it",
    'memberships.wizard.kindLockedTitle': "The type can't be changed anymore",
    'memberships.wizard.kindLockedBody': "This offer already has members or purchases. Switching it between membership and pack would cancel what they already paid for. Create a new one of the other type.",
    'memberships.free.title': "Members",
    'memberships.free.count': "{count} active",
    'memberships.free.since': "Since {date}",
    'memberships.free.active': "Active",
    'memberships.free.left': "Left",
    'memberships.free.emptyBody': "When someone joins from your site, they show up here.",
    'memberships.form.perCycle': "per period",
    'memberships.wizard.validity': "Validity",
    'memberships.wizard.validityHint': "The pack's bookings and digital products are valid for this long.",
    'memberships.wizard.benefits.digital': "Digital products",
    'memberships.wizard.benefits.digitalHintMembership': "They download them from their account while the membership is active.",
    'memberships.wizard.benefits.digitalHintPack': "They download them from their account while the pack is valid.",
    'memberships.wizard.benefits.noDigital': "You don't have digital products yet.",
    'memberships.wizard.needDigital': "Pick at least one digital product.",
    'memberships.wizard.needCredits': "Enter how many bookings it includes.",
    'memberships.wizard.howMany': "How many",
    'memberships.wizard.review.digital': "Digital products",
    'memberships.wizard.digitalKind': "Digital product",
    'memberships.wizard.draftLabel': "Draft",
    'memberships.emptyTitle': "No memberships yet",
    'memberships.emptyBody': "Create a membership or a pack and choose what it gives: included bookings, digital products or a discount on your catalog.",
    'memberships.proBody': "Memberships and packs are part of the Pro plan.",
    'memberships.kind.membership': "Membership",
    'memberships.kind.pack': "Pack",
    'memberships.noPrice': "No price",
    'memberships.perMonth': "{price} a month",
    'memberships.perYear': "{price} a year",
    'memberships.unlimited': "Unlimited bookings",
    'memberships.perPeriod': "{count} bookings per period",
    'memberships.packRule': "{count} bookings",
    'memberships.packRuleDays': "{count} bookings · valid {days} days",
    'memberships.draft': "Draft",
    'memberships.includesNone': "Doesn't include bookings yet",
    'memberships.members': "{count} with an active membership",
    'memberships.viewPage': "View page",
    'memberships.saved': "Membership saved.",
    'memberships.saveFailed': "The membership couldn’t be saved.",
    'memberships.publishFailed': "Saved as a draft: it couldn’t be published.",
    'memberships.form.newTitle': "New membership",
    'memberships.form.editTitle': "Edit membership",
    'memberships.form.lead': "What it charges and what it includes.",
    'memberships.form.name': "Name",
    'memberships.form.namePlaceholder': "Unlimited membership",
    'memberships.form.namePackPlaceholder': "10-session pack",
    'memberships.form.description': "Short description",
    'memberships.form.descriptionPlaceholder': "Everything it includes, in one sentence.",
    'memberships.form.type': "Type",
    'memberships.form.membershipHint': "Charged on a schedule until the customer cancels.",
    'memberships.form.packHint': "A single payment for bookings, digital products or both.",
    'memberships.form.price': "Price",
    'memberships.form.monthly': "Monthly",
    'memberships.form.yearly': "Yearly",
    'memberships.form.oneTime': "One-time payment",
    'memberships.form.perMonth': "a month",
    'memberships.form.perYear': "a year",
    'memberships.form.includes': "Bookings included",
    'memberships.form.noBookings': "You don't have bookable services yet. Create them in “Bookings” and come back to include them.",
    'memberships.form.bookingKind': "Booking",
    'memberships.form.includesHint': "The services you tick are booked with this membership or pack.",
    'memberships.form.priceSection': "Price and access",
    'memberships.form.billing': "Billing",
    'memberships.form.limited': "A set number",
    'memberships.form.howMany': "How many",
    'memberships.form.classesUnit': "bookings",
    'memberships.form.validity': "Validity",
    'memberships.form.expiresShort': "Expires",
    'memberships.form.daysUnit': "days",
    'memberships.form.publishTitle': "Published",
    'memberships.form.publishOn': "Can be bought on your site.",
    'memberships.form.publishOff': "Draft: not shown on your site.",
    'memberships.form.needFields': "Name, price or what it includes is missing.",
    'memberships.form.create': "Create membership",
    'svcw.pay.membership': "Members only",
    'svcw.pay.membershipHint': "Only customers with one of your memberships or packs can book it.",
    'svcw.pay.alsoIncluded': "Also included in memberships and packs",
    'svcw.pay.alsoIncludedHint': "Customers with one of the chosen ones book it at no cost; everyone else pays the normal price.",
    'svcw.price.membershipLabel': "Included with membership",
    'svcw.cancel.membershipNote': "No charge at booking: if it’s cancelled, the class goes back to the membership or pack.",
    'svcw.invalid.membership': "Choose at least one membership or pack, and how many classes each pack gives.",
    'svcw.membership.lead': "Choose which memberships or packs include this service.",
    'svcw.membership.kindMembership': "Membership",
    'svcw.membership.kindPack': "Pack",
    'svcw.membership.perPeriod': "Bookings per period",
    'svcw.membership.unlimited': "Unlimited",
    'svcw.membership.limited': "A number",
    'svcw.membership.credits': "Included bookings",
    'svcw.membership.validFor': "Valid for",
    'svcw.membership.noExpiry': "No expiry",
    'svcw.membership.days': "Days",
    'svcw.membership.shared': "What each membership or pack gives applies to every service that includes it.",
    'svcw.membership.empty': "You don't have memberships or packs yet. Create them in Catalog › Memberships & packs.",
    'svcw.membership.proTitle': "Available from the Pro plan",
    'svcw.membership.proBody': "Bookings included in memberships and packs are part of the Pro plan.",
    'svcw.membership.seePlans': "See plans",
    'svcw.membership.notReady': "This feature isn’t ready on your account yet.",
    'svcw.membership.loadFailed': "We couldn’t load your memberships. Please try again.",
    'svcw.taken.held': 'Held',
    'svcw.taken.confirmed': 'Confirmed',
    'svcw.taken.completed': 'Completed',
    'svcw.min.nothing': 'nothing',
    'svcw.min.minutes': '{count} min',
    'svcw.min.oneDay': 'a day',
    'svcw.min.days': '{count} days',
    'svcw.min.oneHour': 'an hour',
    'svcw.min.hours': '{count} hours',
    'svcw.min.oneHourHalf': 'an hour and a half',
    'svcw.min.hoursHalf': '{count} and a half hours',
    'svcw.min.hoursRest': '{hours} and {rest} min',
    'svcw.dur.minutes': '{count} min',
    'svcw.dur.hours': '{count} h',
    'svcw.dur.hoursMinutes': '{hours} h {minutes} min',
    'svcw.day.one': '{count} day',
    'svcw.day.many': '{count} days',
    'svcw.person.one': '{count} person',
    'svcw.person.many': '{count} people',
    'svcw.newTitle': 'New bookable service',
    'svcw.editAria': 'Edit {name}',
    'svcw.progressAria': 'Steps of the creator',
    'svcw.saveAndClose': 'Save and close',
    'svcw.saveChanges': 'Save changes',
    'svcw.saving': 'Saving…',
    'svcw.info.kicker': 'The basics',
    'svcw.info.title': 'What are they booking?',
    'svcw.info.lead': 'This is the first thing your customer will see.',
    'svcw.info.name': 'Name',
    'svcw.info.namePlaceholder': 'e.g. First consultation',
    'svcw.info.description': 'Description',
    'svcw.info.image': 'Service image',
    'svcw.info.optional': 'Optional',
    'svcw.info.imageAlt': 'Preview of the service',
    'svcw.info.logo': 'Logo',
    'svcw.info.logoAlt': 'Preview of the logo',
    'svcw.info.accent': 'Accent color',
    'svcw.set.kicker': 'Settings',
    'svcw.set.title': 'Set how it works',
    'svcw.set.duration': 'How long is each appointment?',
    'svcw.set.capacity': 'How many people per slot?',
    'svcw.set.capacityHint': 'One-to-one takes them one at a time. Group lets several book the same hour, like a class.',
    'svcw.set.single': 'One-to-one',
    'svcw.page.oneToOne': 'One-to-one',
    'svcw.page.spots': '{count} spots',
    'svcw.set.group': 'Group',
    'svcw.set.perSlot': 'People per slot',
    'svcw.set.people': 'people',
    'svcw.set.seatsHint': 'How many places each slot has. Once full, that hour stops being offered.',
    'svcw.spots.title': 'Spots left, on the page',
    'svcw.spots.low': 'Only when few are left',
    'svcw.spots.lowHint': 'At 15% or less it says “A few left” or “Last spot”.',
    'svcw.spots.all': 'Always the number',
    'svcw.spots.allHint': '“8 spots left”, with an occupancy bar.',
    'svcw.spots.none': 'Don’t show',
    'svcw.spots.noneHint': 'Only says when it’s full.',
    'svcw.set.maxParty': 'Spots per purchase',
    'svcw.set.maxPartyHint': 'How many spots one person can buy at once, for themselves and their guests. 1 = one spot per purchase.',
    'svcw.unit.title': 'How it’s booked',
    'svcw.unit.time': 'By the hour',
    'svcw.unit.day': 'By the day',
    'svcw.unit.timeHint': 'Appointments with a start and end time: a consultation, a haircut, a class.',
    'svcw.unit.dayHint': 'Whole days, midnight to midnight: a photo shoot, an event, a rental. Blocks the full day on your schedule.',
    'svcw.days.title': 'How many days',
    'svcw.days.hint': 'Fixed, or let the customer choose how many. Your schedule only sets which days you work.',
    'svcw.days.full': 'Full day',
    'svcw.days.count': '{count} days',
    'svcw.days.range': '{min}–{max} days',
    'svcw.days.custom': 'Number of days',
    'svcw.days.flexible': 'Customer chooses',
    'svcw.days.from': 'From',
    'svcw.days.to': 'Up to',
    'svcw.days.unit': 'days',
    'svcw.days.perDay': 'When customers choose the days, the price is per day.',
    'svcw.team.who': 'Who provides this service',
    'svcw.team.whoHint': 'With several people, customers choose who or “Anyone available”.',
    'svcw.team.onlyOne': 'Right now it’s just you. Add someone below to have several people provide this service.',
    'svcw.team.scheduleOf': 'Schedule for',
    'svcw.team.editingHint': 'Each person has one schedule: changes here apply to all of {name}’s services.',
    'svcw.team.addSave': 'Add',
    'svcw.team.addCancel': 'Cancel',
    'svcw.team.addRole': 'Role (optional)',
    'svcw.team.addName': 'Name',
    'svcw.team.add': 'Add person',
    'svcw.set.onePerSlot': 'One person per slot.',
    'svcw.set.reminder': 'Reminder',
    'svcw.set.reminderHint': 'An email to the customer before their appointment, with the link to change or cancel it.',
    'svcw.set.reminderOn': 'Send an email reminder',
    'svcw.set.reminderOnHint': 'Cuts no-shows: people who cannot make it let you know in time and the slot opens up.',
    'svcw.set.reminderSend': 'Send it',
    'svcw.set.reminderSkip': 'Appointments booked with less notice do not get one: they just received their confirmation.',
    'svcw.set.reminderOff': 'Off',
    'svcw.form.kicker': 'Form',
    'svcw.form.title': 'Prepare the booking questions',
    'svcw.form.lead': 'The contact details are already included. Add only what you need to know before the appointment.',
    'svcw.form.included': 'Included automatically',
    'svcw.form.name': 'Name',
    'svcw.form.email': 'Email',
    'svcw.form.phone': 'Phone',
    'svcw.form.noSetup': 'You do not have to set these fields up.',
    'svcw.sch.kicker': 'Availability',
    'svcw.sch.title': 'Set up your schedule',
    'svcw.sch.zoneNote1': 'This site keeps its schedule in',
    'svcw.sch.zoneNote2': 'and you are in',
    'svcw.sch.zoneNote3': '. The hours you write here are {city} time. You can change the site’s zone in Settings.',
    'svcw.sch.localNote': 'Write your hours in your local time. You can add breaks and exceptions afterwards.',
    'svcw.sch.howSimple': 'One time range for every day you pick.',
    'svcw.sch.howAdvanced': 'Different hours, and more than one shift in the same day.',
    'svcw.sch.rangeSep': 'to',
    'svcw.sch.howTitle': 'How you want to set it up',
    'svcw.sch.daysAria': 'Available days',
    'svcw.sch.from': 'From',
    'svcw.sch.to': 'To',
    'svcw.sch.pickDay': 'Open at least one day so your calendar has room.',
    'svcw.sch.multiRange': 'This schedule uses more than one range.',
    'svcw.sch.multiRangeBody': 'Your hours are untouched; edit them under More options.',
    'svcw.sch.openAdvanced': 'Open More options',
    'svcw.sch.exceptions': 'Exceptions',
    'svcw.sch.exceptionsHint': 'One-off days that do not follow the week: a holiday, a bank holiday, or a Saturday you do open.',
    'svcw.sch.day': 'Day',
    'svcw.sch.whatHappens': 'What happens that day',
    'svcw.sch.closedDay': 'Closed all day',
    'svcw.sch.closedRange': 'Closed from',
    'svcw.sch.openRange': 'Also open from',
    'svcw.sch.note': 'Note',
    'svcw.sch.notePlaceholder': 'Reason (optional)',
    'svcw.sch.removeException': 'Remove the exception',
    'svcw.sch.addException': 'Add an exception',
    'svcw.sch.advanced': 'Advanced options',
    'svcw.sch.advancedHint': 'Buffers around each appointment, minimum notice and how far ahead your calendar is visible.',
    'svcw.sch.none': 'None',
    'svcw.sch.noNotice': 'no notice',
    'svcw.sch.noticeOf': '{amount} of notice',
    'svcw.sch.withBuffers': 'with buffers',
    'svcw.adv.stepLabel': 'An appointment starts every',
    'svcw.adv.stepSame': 'An appointment starts where the previous one ends: every {amount}.',
    'svcw.adv.stepOverlap': 'Slots start every {amount}, so they overlap and {offer} are offered. Only one can be booked at a time.',
    'svcw.adv.perHour': '{count} per hour',
    'svcw.adv.moreOptions': 'more options',
    'svcw.adv.beforeLabel': 'Free time before',
    'svcw.adv.beforeNone': 'No prep time: someone can book right before another appointment.',
    'svcw.adv.before': '{amount} is set aside before every booked appointment, to get ready. Nobody can book in that time.',
    'svcw.adv.afterLabel': 'Free time after',
    'svcw.adv.afterNone': 'No wrap-up time: the next appointment can start the moment the previous one ends.',
    'svcw.adv.after': '{amount} is set aside after every booked appointment, to tidy up or take notes. The next one cannot start before that.',
    'svcw.adv.noBookingsYet': 'There are no appointments yet, so it is not cutting any slots short.',
    'svcw.adv.noticeLabel': 'Minimum notice',
    'svcw.adv.notice': 'Nobody can book for less than {amount} away. The soonest slot will always be that far out.',
    'svcw.adv.noticeNone': 'The next free slot can be booked, even if it is ten minutes away.',
    'svcw.adv.horizonLabel': 'Bookable up to',
    'svcw.adv.horizonUnit': 'days',
    'svcw.adv.horizon': 'Your calendar is visible {days} ahead{extra}. Past that, no slot shows up.',
    'svcw.adv.aboutMonths': ' (about {count} months)',
    'svcw.adv.aboutOneMonth': ' (about a month)',
    'svcw.cancel.kicker': 'Cancellation',
    'svcw.cancel.title': 'Set up cancellations and refunds',
    'svcw.cancel.lead': 'Set the deadlines, amounts and alternatives that apply to every booking.',
    'svcw.cancel.windows': 'Cancellation and change deadlines',
    'svcw.cancel.windowsHint': 'Set how late they can manage the booking from their link.',
    'svcw.cancel.cancelUntil': 'Cancellation allowed until',
    'svcw.cancel.moveUntil': 'Date change allowed until',
    'svcw.cancel.hoursBefore': 'hours before',
    'svcw.cancel.refundWho': 'Who issues the refund',
    'svcw.cancel.refundManual': 'I do it in Stripe',
    'svcw.cancel.refundManualHint': 'We tell you about the cancellation and you decide when and how much to refund.',
    'svcw.cancel.refundAuto': 'Automatic on cancel',
    'svcw.cancel.refundAutoHint': 'The % above is refunded on its own. If you cancel from the dashboard, it’s refunded in full. If your account has no balance, it retries every hour.',
    'svcw.cancel.refundAutoShort': 'automatic',
    'svcw.cancel.refund': 'Refund policy',
    'svcw.cancel.refundHint': 'Set what percentage is refundable depending on when they cancel.',
    'svcw.cancel.late': 'Handling past the deadline',
    'svcw.cancel.lateHint': 'Set what is available once the deadline has passed.',
    'svcw.cancel.refill': 'Full refund if the slot is taken again',
    'svcw.cancel.refillHint': 'The full amount is refunded when the freed slot gets booked again.',
    'svcw.cancel.credit': 'Credit towards a future booking',
    'svcw.cancel.creditHint': 'The amount is kept as a balance for a new appointment.',
    'svcw.cancel.forgive': 'An exception the first time',
    'svcw.cancel.forgiveHint': 'The late policy is not applied on the first late cancellation.',
    'svcw.cancel.noLimit': 'No limit',
    'svcw.cancel.beforeAmount': '{amount} before',
    'svcw.cancel.cancelMove': 'Cancel {cancel} · move {move}',
    'svcw.cancel.notApplicable': 'Not applicable',
    'svcw.cancel.refundSummary': '{inTime}% within the deadline · {late}% past it',
    'svcw.cancel.manual': 'Manual review',
    'svcw.cancel.onlyMove': 'Rescheduling only',
    'svcw.cancel.noChanges': 'No changes',
    'svcw.cancel.conditionOne': '{count} condition',
    'svcw.cancel.conditionMany': '{count} conditions',
    'svcw.cancel.summaryWith': '{label} · {extras}',
    'svcw.cancel.untilStart': '{action} is available right up to the start time.',
    'svcw.cancel.closesBefore': '{action} online closes {amount} before the appointment.',
    'svcw.cancel.theCancel': 'Cancelling',
    'svcw.cancel.theMove': 'Changing the date',
    'svcw.price.kicker': 'Price',
    'svcw.price.title': 'How is it charged?',
    'svcw.price.how': 'How it is charged',
    'svcw.price.noOnline': 'The appointment is confirmed without charging online.',
    'svcw.price.noOnlineLabel': 'No online payment',
    'svcw.price.pending': 'Price pending',
    'svcw.price.stripeTitle': 'You cannot charge online yet',
    'svcw.review.kicker': 'All set',
    'svcw.review.title': 'Check it before creating',
    'svcw.review.service': 'Service',
    'svcw.review.duration': 'Duration',
    'svcw.review.capacity': 'Capacity',
    'svcw.review.payment': 'Payment',
    'svcw.review.schedule': 'Schedule',
    'svcw.review.cancel': 'Cancellation',
    'svcw.review.reminder': 'Reminder',
    'svcw.review.edit': 'Edit',
    'svcw.review.publishTitle': 'To publish it, connect Stripe',
    'svcw.review.draft': 'Draft',
    'svcw.review.published': 'Published',
    'svcw.back': 'Back',
    'svcw.next': 'Next',
    'svcw.previewAria': 'Preview of the booking page',
    'svcw.tester': 'Try your schedule',
    'svcw.testerHint': 'The slots it produces and the appointments you already have',
    'svcw.tester.eyebrow': 'Availability',
    'svcw.tester.title': 'Pick a date and time',
    'svcw.tester.sub': 'Choose the time that works best for you.',
    'svcw.tester.of': 'of',
    'svcw.tester.month': 'Month',
    'svcw.tester.year': 'Year',
    'svcw.tester.prevDays': 'Earlier days',
    'svcw.tester.nextDays': 'Later days',
    'svcw.tester.pickTime': 'Pick a time',
    'svcw.tester.freeOne': '{count} free slot that day',
    'svcw.tester.freeMany': '{count} free slots that day',
    'svcw.tester.inDays': ' · {count} across {days} days',
    'svcw.preview': 'Preview',
    'svcw.previewHint': 'It updates as you type',
    'svcw.page.logo': 'Logo',
    'svcw.page.date': 'Date',
    'svcw.page.slotsTotal': '{count} slots that day · {total} in total',
    'svcw.invalid.title': 'Write the name of the service to continue.',
    'svcw.invalid.duration': 'Write a duration between 5 and 1440 minutes.',
    'svcw.invalid.amount': 'Write a price greater than zero.',
    'svcw.invalid.schedule': 'Open at least one day and check the hours.',
    'svcw.set.lead': 'How long each appointment is, how many people fit and when it can be booked.',
    'svcw.sch.dayFrom': '{day}, from',
    'svcw.sch.dayTo': '{day}, to',
    'svcw.sch.removeRange': 'Remove the {day} range',
    'svcw.sch.anotherRange': 'Another range',
    'svcw.sch.closed': 'Closed',
    'svcw.sch.at': 'to',
    'svcw.sch.settingsPath': 'in Settings → General.',
    'svcw.exc.closedAll': 'Nothing can be booked that day.',
    'svcw.exc.closedRange': 'That day loses {from} to {to}. The rest of your schedule stays the same.',
    'svcw.exc.openRange': 'That day gains {from} to {to}, on top of what you already open. If you were already open then, nothing changes.',
    'svcw.cancel.moveEmpty': 'Left empty, the cancellation deadline applies.',
    'svcw.cancel.onsiteNote': 'Not applicable: this service is paid on site and does not take payment up front.',
    'svcw.cancel.inTime': 'Cancelling within the deadline',
    'svcw.cancel.outOfTime': 'Cancelling past the deadline',
    'svcw.cancel.noShow': 'No-shows without notice are not refunded.',
    'svcw.cancel.refundFull': 'The full amount is refunded.',
    'svcw.cancel.refundNone': 'Nothing is refunded.',
    'svcw.cancel.refundPartial': '{percent}% is refunded and {kept}% is kept.',
    'svcw.cancel.lateContact': 'Manual review',
    'svcw.cancel.lateContactHint': 'The customer has to contact you to ask for an exception.',
    'svcw.cancel.lateMove': 'Allow rescheduling only',
    'svcw.cancel.lateMoveHint': 'Cancelling is disabled; the customer can move the appointment.',
    'svcw.cancel.lateNone': 'Allow no changes',
    'svcw.cancel.lateNoneHint': 'The booking stands, with no cancelling or rescheduling.',
    'svcw.cancel.refillHint2': 'The full amount is refunded when the cancelled slot goes to another customer.',
    'svcw.cancel.forgiveHint2': 'The late policy is not applied on the customer’s first slip.',
    'svcw.cancel.footNote': 'The deadlines are applied automatically. The extra conditions are shown to the customer and serve as a reference when handling each case by hand.',
    'svcw.price.lead': 'The amount is saved as the offer’s price; you can add more later from Offers.',
    'svcw.price.amount': 'Price',
    'svcw.price.amountHint': 'This is what will be charged when booking.',
    'svcw.cancel.moveVerb': 'move',
    'svcw.cancel.cancelVerb': 'cancel',
    'svcw.stripe.connecting': 'Connecting…',
    'svcw.stripe.connect': 'Connect Stripe',
    'svcw.stripe.priceBody': 'You can finish creating the service: it is saved as a draft and you publish it as soon as you connect a Stripe account.',
    'svcw.stripe.reviewBody': 'This service charges online, so it needs an account for the money to land in. It is saved as a draft and you can publish it as soon as you connect one.',
    'svcw.review.lead': 'It is saved as a draft so you can check its page before publishing it.',
    'svcw.review.openDays': '{count} days open',
    'svcw.review.onSave': 'When saving',
    'svcw.review.onCreate': 'When creating the service',
    'svcw.review.publishedHint': 'Anyone with the link can book the moment it exists.',
    'svcw.review.draftHint': 'You can adjust buffers, notices and exceptions before publishing it.',
    'svcw.createPublish': 'Create and publish',
    'svcw.createService': 'Create service',
    'svcw.tester.bookedOne': ' · {count} appointment already booked',
    'svcw.tester.bookedMany': ' · {count} appointments already booked',
    'svcw.tester.seatsEach': ' · {count} places each',
    'svcw.tester.noSlots': 'This schedule leaves no slot at all. Check the buffers and the minimum notice under the advanced options.',
    'svcw.tester.openADay': 'Open at least one day to see the slots it produces.',
    'svcw.info.descPlaceholder': 'Briefly explain what it includes…',
    'svcw.info.change': 'Change',
    'svcw.info.remove': 'Remove',
    'svcw.info.addImage': 'Add an image',
    'svcw.info.addLogo': 'Add a logo',
    'svcw.info.reset': 'Reset',
    'svcw.set.durationHint': 'It is how long your calendar is blocked when someone books.',
    'svcw.set.other': 'Other',
    'svcw.set.otherDuration': 'Another duration',
    'svcw.sch.simple': 'Simple',
    'svcw.sch.more': 'More options',
    'svcw.preview.noteFull': "The final page will use your site's logo, colors and fonts.",
    'svcw.preview.noteZoom': 'Zoomed in on what you are editing. You will see it whole in the last step.',
    'svcw.page.slugFallback': 'my-service',
    'svcw.page.cta.book': 'Book',
    'svcw.page.cta.pay': 'Continue to payment',
    'svcw.page.book': 'Book',
    'svcw.page.of': 'of',
    'svcw.set.minutes': 'minutes',
    'handover.shortfall': '{count} (your plan allows {cap})',
    'handover.step.plan': 'Plan',
    'handover.step.payments': 'Payments',
    'handover.step.business': 'Your business',
    'handover.loading': 'Opening the review',
    'handover.yoursNow': '{name} is yours now',
    'handover.title': 'Check the last details',
    'handover.oneLeft': 'One thing is still pending before you carry on.',
    'handover.manyLeft': '{count} things are still pending before you carry on.',
    'handover.stepsAria': 'Steps',
    'handover.skipped': ' (skipped)',
    'handover.back': 'Back',
    'handover.skipStep': 'Skip this step',
    'handover.skipAll': 'Skip and go into the site',
    'handover.pay.title': 'Set up your payments with Stripe',
    'handover.pay.body': 'Every owner connects their own Stripe account. Link yours so the payments for your products and services land straight in your account.',
    'handover.pay.needsPlan': 'Connecting Stripe comes with Pro or Business. What you received stays published and untouched. The only thing you cannot do yet is charge for it.',
    'handover.pay.seePlans': 'See plans',
    'handover.pay.aside': 'You will finish the setup on Stripe and come back here when you are done.',
    'handover.pay.opening': 'Opening Stripe…',
    'handover.pay.connect': 'Connect with Stripe',
    'handover.biz.title': 'Add your business details',
    'handover.biz.stillSays': 'The site’s privacy notice and terms still say',
    'handover.biz.withAddress': ', with their address and their contact details.',
    'handover.biz.fromGiver': 'The details published on the site are those of whoever handed it to you.',
    'handover.biz.traveled': 'They travelled with the project because they belong to the site and not to the account, and now they represent you.',
    'handover.biz.aside': 'The rest (tax ID, currency, data controller) is in the site settings, at your own pace. Only what is printed on your pages goes here.',
    'handover.biz.saving': 'Saving…',
    'handover.biz.save': 'Save and carry on',
    'handover.biz.tradeName': 'Business name',
    'handover.biz.tradeNameHint': 'The one your customers know you by',
    'handover.biz.legalName': 'Legal name',
    'handover.biz.legalNameHint': 'The one on your invoices; it can be your own name',
    'handover.biz.address': 'Address',
    'handover.biz.city': 'City',
    'handover.biz.state': 'State or province',
    'handover.biz.email': 'Contact email',
    'handover.biz.phone': 'Phone',
    'handover.plan.title': 'Keep your site whole and published',
    'handover.plan.body': 'Your site holds {list}. Move up a plan to keep all of its content and carry on growing without limits.',
    'handover.plan.grace': ' It stays published unchanged until {date}; pick a plan that fits to keep it online after that date.',
    'handover.plan.noGrace': ' Pick the option that best matches what you received.',
    'handover.plan.aside': 'All of your content is safe and kept exactly as you received it.',
    'handover.plan.upgrade': 'Upgrade my plan',
    'handover.done': 'Done',
    'handover.doneTitleNamed': '{name} is yours',
    'handover.doneTitle': 'The site is yours',
    'handover.doneAll': 'Everything that was there moved to your account and nothing is left to sort out.',
    'handover.donePartial': 'The site is yours and it works. What you left for later is waiting up top, on its home screen.',
    'handover.entering': 'Going in…',
    'handover.enter': 'Go into the site',
    'handover.notice.planTitle': 'Your plan falls short',
    'handover.notice.planBody': 'What you received goes past your current plan: {list}.',
    'handover.notice.planGrace': ' The site stays published until {date} so you can decide without rushing.',
    'handover.notice.seePlans': 'See plans',
    'transfer.loading': 'Opening the invitation',
    'transfer.toPanel': 'Go to my dashboard',
    'transfer.kicker': 'Site transfer',
    'transfer.lead': 'Look over the site and the content included before you decide.',
    'transfer.includedAria': 'What you get',
    'transfer.included': 'Content included',
    'transfer.overLimit': 'Goes past the limits of your plan',
    'transfer.membershipAria': 'Plan needed',
    'transfer.needsMembership': 'You will need a plan that fits',
    'transfer.needsMembershipBody': 'This site goes past the limits of your current plan. After accepting you can pick one that covers all of its content.',
    'transfer.expiresOn': 'The invitation expires on {date}.',
    'transfer.previewAria': 'Preview of the site',
    'transfer.nothingDrawn': 'Nothing has been designed yet',
    'transfer.nothingDrawnBody': 'The project travels whole all the same, but its pages are blank.',
    'transfer.notPublished': 'Not published yet',
    'transfer.wrongAccount': 'This invitation is for another account',
    'transfer.unavailable': 'This invitation is not available',
    'transfer.unavailableBody': 'It may have expired, been cancelled, or already been accepted.',
    'transfer.signOutFailed': 'We could not close this session. Try again.',
    'transfer.stock.pages': 'Pages',
    'transfer.stock.collections': 'Collections',
    'transfer.stock.entriesOne': '{count} entry inside',
    'transfer.stock.entriesMany': '{count} entries inside',
    'transfer.stock.contacts': 'Contacts',
    'transfer.stock.forms': 'Forms',
    'transfer.stock.messagesOne': '{count} message received',
    'transfer.stock.messagesMany': '{count} messages received',
    'transfer.stock.images': 'Images',
    'transfer.stock.offers': 'Products and services',
    'transfer.stock.salesOne': '{count} sale made',
    'transfer.stock.salesMany': '{count} sales made',
    'transfer.stock.bookings': 'Upcoming bookings',
    'transfer.stock.bookingsNote': 'Appointments already committed to',
    'transfer.stock.domain': 'Domain',
    'transfer.seePlans': 'See plans',
    'transfer.rejecting': 'Declining…',
    'transfer.reject': 'Decline',
    'transfer.accepting': 'Accepting…',
    'transfer.accept': 'Accept the site',
    'handover.notice.aria': 'Review of the site you received',
    'handover.notice.yours': '{name} is yours now',
    'handover.notice.oneLeft': 'One thing is missing for it to be fully yours',
    'handover.notice.manyLeft': '{count} things are missing for it to be fully yours',
    'handover.notice.oneBody': 'The site works and it is yours, but there is something the transfer cannot do for you. You can leave it for later.',
    'handover.notice.manyBody': 'The site works and it is yours, but there are things the transfer cannot do for you. You can leave them for later.',
    'handover.notice.payTitle': 'Connect your account to get paid',
    'handover.notice.payOne': 'The site has {count} thing for sale and right now it cannot charge for it: the Stripe account belonged to whoever handed it over and was disconnected in the transfer.',
    'handover.notice.payMany': 'The site has {count} things for sale and right now it cannot charge for them: the Stripe account belonged to whoever handed it over and was disconnected in the transfer.',
    'handover.notice.payAction': 'Connect payments',
    'handover.notice.bizTitle': 'Add your business details',
    'handover.notice.bizNamed': 'The site’s privacy notice and terms still say “{name}”, with their address and their tax ID. Those details travelled with the site and now they represent you.',
    'handover.notice.bizUnnamed': 'The tax and contact details published on the site are those of whoever handed it over. They travelled with the project and now they represent you.',
    'handover.notice.bizAction': 'Check the details',
    'handover.notice.opening': 'Opening…',
    'handover.notice.later': 'Not now',
    'handover.notice.savingDismiss': 'Saving…',
    'handover.notice.dismiss': 'Do not show again',
    'handover.notice.done': 'Done',
    'newPage.aria': 'Create a page',
    'newPage.backToDash': 'Back to the dashboard',
    'newPage.beta': 'Beta',
    'newPage.nameAria': 'Page name',
    'newPage.stepOf': 'Step {current} of 3',
    'newPage.categoriesAria': 'Template categories',
    'newPage.categories': 'Categories',
    'newPage.all': 'All',
    'newPage.blank': 'Blank page',
    'newPage.blankCategory': 'Blank',
    'newPage.generalCategory': 'General',
    'newPage.stepsAria': 'Customisation steps',
    'newPage.customize': 'Customise',
    'newPage.type': 'Type',
    'newPage.colors': 'Colors',
    'newPage.loadingTemplates': 'Loading templates…',
    'newPage.templatesAria': 'Templates for the new page',
    'newPage.typosAria': 'Type pairings',
    'newPage.siteOriginal': 'The site’s own',
    'newPage.fontLibrary': 'Type library',
    'newPage.palettesAria': 'Color palettes',
    'newPage.paletteLibrary': 'Color library',
    'newPage.brandNote': 'The colors and the type belong to your project and apply to every page. The new page inherits them.',
    'newPage.editBrand': 'Edit the style →',
    'newPage.back': 'Back',
    'newPage.preparing': 'Preparing the page…',
    'newPage.create': 'Create page',
    'newPage.next': 'Next',
    'newPage.previewAria': 'Preview of the page',
    'newPage.applyingStyle': 'Applying your style…',
    'newPage.loadingPreview': 'Loading the preview…',
    'newPage.previewOf': 'Preview of {name}',
    'newPage.defaultName': 'New page',
    'pageSettings.notImage': 'Pick an image file',
    'pageSettings.tooBig': 'The image has to weigh less than 10 MB',
    'pageSettings.uploadFailed': 'We could not upload the image',
    'pageSettings.back': 'Back to pages',
    'pageSettings.kicker': 'Page settings',
    'pageSettings.withPassword': 'Password protected',
    'pageSettings.published': 'Published',
    'pageSettings.general': 'General information',
    'pageSettings.generalBody': 'Set how this page is identified within the site.',
    'pageSettings.pageTitle': 'Page title',
    'pageSettings.slug': 'URL slug',
    'pageSettings.copied': 'Copied',
    'pageSettings.copyLink': 'Copy link',
    'pageSettings.unpublished': 'Not published',
    'pageSettings.makeHome': 'Make it the home page',
    'pageSettings.password': 'Page password',
    'pageSettings.passwordBody': 'Manage access to this page in particular.',
    'pageSettings.protect': 'Protect with a password',
    'pageSettings.protectBody': 'Visitors will have to enter a password to see this page.',
    'pageSettings.passwordField': 'Password',
    'pageSettings.passwordHint': 'At least 6 characters. It is asked for when opening this page on the published site.',
    'pageSettings.passwordPlaceholder': 'At least 6 characters',
    'pageSettings.passwordShort': 'It has to be at least 6 characters.',
    'pageSettings.seo': 'SEO',
    'pageSettings.seoBody': 'Tune the title, the description and the URL search engines will see.',
    'pageSettings.seoTitle': 'Title (title tag)',
    'pageSettings.seoTitleHint': 'The browser tab title and the blue link in Google results. Left empty, the page name is used.',
    'pageSettings.seoTitlePlaceholder': 'Title for Google',
    'pageSettings.seoChars': '{count} / {max} characters recommended',
    'pageSettings.seoDesc': 'Description (meta description)',
    'pageSettings.seoDescHint': 'The text Google shows under the title in search results.',
    'pageSettings.seoDescPlaceholder': 'A short summary of this page',
    'pageSettings.canonical': 'Canonical URL',
    'pageSettings.canonicalHint': 'The “official” URL of this page. Use it to avoid duplicate content in search engines.',
    'pageSettings.share': 'Preview when shared',
    'pageSettings.shareBody': 'Set the card that shows up on social networks and in messages.',
    'pageSettings.changeCover': 'Change the cover image',
    'pageSettings.uploadCover': 'Upload a cover image',
    'pageSettings.customImage': 'Custom image. Click to change it.',
    'pageSettings.defaultImage': 'By default the page screenshot is used. Upload one to customise it.',
    'pageSettings.useCapture': 'Use the screenshot',
    'pageSettings.sameAsSeo': 'Same as SEO',
    'pageSettings.sameAsSeoBody': 'Use the SEO title and description for social networks too.',
    'pageSettings.ogTitle': 'Title for social',
    'pageSettings.ogTitleHint': 'The title shown when this page is shared on social networks. It uses the SEO one by default.',
    'pageSettings.ogDesc': 'Description for social',
    'pageSettings.ogDescHint': 'The text alongside the image when shared on social networks. It uses the SEO description by default.',
    'pageSettings.visibility': 'Visibility in search engines',
    'pageSettings.visibilityBody': 'Decide how this page is found inside and outside the site.',
    'pageSettings.index': 'Index in search engines',
    'pageSettings.advanced': "Advanced",
    'pageSettings.advancedBody': "Send this address somewhere else and add code to its head.",
    'pageSettings.redirect': "Redirect to another address",
    'pageSettings.redirectHint': "Visitors to this page go to the one you write, like /contact or https://…. Leave it empty to show the page. Applied when you publish.",
    'pageSettings.redirectInvalid': "Write an address on your site, like /contact, or a full one with https://.",
    'pageSettings.redirectHome': "The home page can't be redirected.",
    'pageSettings.redirectPlaceholder': "/contact",
    'pageSettings.headCodePlaceholder': '<meta name="google-site-verification" content="…" />',
    'pageSettings.headCode': "Code in the head",
    'pageSettings.headCodeHint': "Pasted as-is into this page's <head> when you publish: Google verification, pixels or tags from other tools.",
    'pageSettings.indexBody': 'Let Google and other search engines find this page.',
    'pageSettings.sitemap': 'Include in the sitemap',
    'pageSettings.sitemapBody': 'Add this page to the site’s sitemap.xml.',
    'pageSettings.delete': 'Delete page',
    'pageSettings.deleteHome': 'The home page cannot be deleted. Make another page the home page first.',
    'pageSettings.deleteLast': 'The site needs to keep at least one page.',
    'pageSettings.deleteBody': 'Delete this page and all of its content from the project.',
    'pageSettings.sure': 'Are you sure?',
    'pageSettings.yesDelete': 'Yes, delete it',
    'backups.created': 'Backup created',
    'backups.deleted': 'Backup deleted',
    'backups.loading': 'Loading your backups',
    'backups.title': 'Backups',
    'backups.versions': 'Versions available',
    'backups.versionsBody': 'A backup is made with every publish. Once the plan limit is reached, the oldest version is removed.',
    'backups.create': 'Make a backup',
    'backups.loadFailed': 'We could not load the backups',
    'backups.empty': 'No backups available',
    'backups.emptyBody': 'One will be made automatically the next time you publish the site.',
    'backups.moreOptions': 'More options',
    'backups.view': 'See this version',
    'backups.restore': 'Restore',
    'backups.delete': 'Delete the backup',
    'backups.confirmDelete': 'Delete this backup?',
    'backups.description': 'Look through the versions saved automatically on publish and restore the site when you need to.',
    'backups.quota': 'Backups',
    'backups.full': 'Limit reached: your plan keeps up to {limit} backups',
    'backups.kind.publish': 'On publish',
    'backups.kind.manual': 'Manual',
    'backups.kind.preRestore': 'Before restoring',
    'backups.contentPageOne': '{count} page',
    'backups.contentPageMany': '{count} pages',
    'backups.contentCollectionOne': '{count} collection',
    'backups.contentCollectionMany': '{count} collections',
    'backups.contentItemOne': '{count} item',
    'backups.contentItemMany': '{count} items',
    'backups.note': 'Every backup includes the pages, the CMS content, the theme and the site settings. It does not include form messages, contacts, sales or uploaded files; those are not touched during a restore.',
    'backups.options': 'Options',
    'backups.deleteMessage': 'The backup from {date} will be deleted permanently. The other versions are not touched.',
    'backups.deleteConfirm': 'Delete',
    'backups.deleting': 'Deleting…',
    'subdomain.saved': 'Address saved',
    'subdomain.saveFailed': 'We could not change the address.',
    'subdomain.live': 'It answers now',
    'subdomain.applying': 'Applying the change…',
    'subdomain.change': 'Change the address',
    'subdomain.movingTo': 'We are moving the site to',
    'subdomain.movingBody': '. The new address can take a few minutes to open; we check on our own and this updates when it answers. The change is already saved, so you can carry on working.',
    'subdomain.slow': 'The new address does not answer yet. The change is done and it usually sorts itself out within minutes; if it stays like this, write to us.',
    'subdomain.aria': 'Site address',
    'subdomain.saving': 'Saving…',
    'subdomain.save': 'Save',
    'subdomain.rules': 'Lower case, numbers and hyphens. Once changed, the old address stops answering.',
    'subdomain.free': '{host} is free.',
    'admin.users.title': 'Users',
    'admin.users.search': 'Search by email…',
    'admin.users.count': '{shown} of {total}',
    'admin.users.loading': 'Loading users…',
    'admin.users.none': 'No users match.',
    'admin.users.col.user': 'User',
    'admin.users.col.role': 'Role',
    'admin.users.col.plan': 'Plan',
    'admin.users.col.projects': 'Projects',
    'admin.users.col.lastSeen': 'Last seen',
    'admin.users.col.signup': 'Signed up',
    'admin.users.noEmail': '(no email)',
    'admin.users.never': 'Never',
    'admin.users.neverIn': 'Has never signed in',
    'admin.users.now': 'Just now',
    'admin.users.agoMin': '{count} min ago',
    'admin.users.agoHours': '{count} h ago',
    'admin.users.agoDayOne': '{count} day ago',
    'admin.users.agoDayMany': '{count} days ago',
    'admin.users.agoMonthOne': '{count} month ago',
    'admin.users.agoMonthMany': '{count} months ago',
    'admin.users.agoYearOne': '{count} year ago',
    'admin.users.agoYearMany': '{count} years ago',
    'admin.users.back': 'Users',
    'admin.users.loadingOne': 'Loading…',
    'admin.users.registeredOn': 'Signed up on {date}',
    'admin.users.role': 'Role',
    'admin.users.roleHintAdmin': 'Admin',
    'admin.users.roleHintDesigner': 'Designer',
    'admin.users.roleHintUser': 'User',
    'admin.users.roleHint1': ': full access. ',
    'admin.users.roleHint2': ': Templates and Blocks. ',
    'admin.users.roleHint3': ': a normal account.',
    'admin.users.saving': 'Saving…',
    'admin.users.savedMark': 'Saved ✓',
    'admin.users.save': 'Save',
    'admin.users.locked': 'This user is a superadmin by configuration and cannot be edited here.',
    'admin.users.subscription': 'Subscription',
    'admin.users.status': 'Status',
    'admin.users.renews': 'Renews',
    'admin.users.stripeCustomer': 'Stripe customer',
    'admin.users.projects': 'Projects ({count})',
    'admin.users.noProjects': 'No projects.',
    'admin.users.published': 'Published',
    'admin.users.draft': 'Draft',
    'admin.users.updated': ' · updated {date}',
    'admin.users.editor': 'Editor',
    'admin.users.site': 'Site',
    'app.retry': 'Try again',
    'admin.users.loadFailed': 'We could not load the users.',
    'admin.users.loadOneFailed': 'We could not load the user.',
    'admin.users.roleFailed': 'We could not update the role.',
    'error.project.gone': 'That project no longer exists.',
    'error.invite.gone': 'This invitation is no longer available.',
    'error.invite.expired': 'This invitation expired. Ask for another one.',
    'error.invite.alreadyMember': 'You are already part of this project.',
    'error.transfer.alreadyYours': 'This project is already yours.',
    'error.domain.taken': 'That domain is already connected to a project.',
    'error.backup.notFound': 'That backup does not exist.',
    'error.offer.notFound': 'We could not find that offer.',
    'error.resource.notFound': 'We could not find that calendar resource.',
    'legal.goHome': 'Go to véltica',
    'legal.back': 'Back to sign in',
    'legal.eyebrow': 'Legal information',
    'teamInvite.unavailable': "This invitation is no longer available.",
    'teamInvite.actionFailed': "We could not complete that.",
    'teamInvite.wrongAccountTitle': "This invitation is for another account",
    'teamInvite.unavailableTitle': "This invitation is not available",
    'teamInvite.goToDashboard': "Go to my dashboard",
    'teamInvite.signOutFailed': "We could not sign you out. Try again.",
    'teamInvite.switching': "Switching…",
    'teamInvite.switchAccount': "Switch account",
    'teamInvite.loading': "Loading the invitation…",
    'teamInvite.eyebrow': "Team invitation",
    'teamInvite.someone': "Someone",
    'teamInvite.invitedBy': "invited you to work on this site as",
    'teamInvite.whatYouGet': "What you get access to",
    'teamInvite.scopeStrong': "this site only",
    'teamInvite.scopePrefix': "You are joining ",
    'teamInvite.scopeSuffix': ". The other projects belonging to whoever invited you stay theirs and you will not see them. You can leave whenever you want, and they can change your role or remove your access.",
    'teamInvite.decline': "No, thanks",
    'teamInvite.joining': "Joining…",
    'teamInvite.accept': "Accept and join",
    'teamInvite.expiry': "This invitation is for {email} and expires on {date}.",
    'deleted.restoreFailed': "We could not restore the project.",
    'deleted.countOne': "One deleted project",
    'deleted.countMany': "{count} deleted projects",
    'deleted.explainOne': "Restore it with all its content before it is permanently deleted. You will need to publish it again to put it back online.",
    'deleted.explainMany': "Restore them with all their content before they are permanently deleted. You will need to publish them again to put them back online.",
    'deleted.noName': "Untitled",
    'deleted.soon': "Deleted soon",
    'deleted.today': "Deleted today",
    'deleted.inDaysOne': "Deleted in {count} day",
    'deleted.inDaysMany': "Deleted in {count} days",
    'deleted.restoring': "Restoring…",
    'deleted.restore': "Restore",
    'upsell.eyebrow': "Paid plans",
    'upsell.seePlans': "See plans",
    'upsell.availableIn': "Included in Pro and Business",
    'upsell.stripeNote': 'Payments run on Stripe',
    'upsell.dismiss': "Don't show again",
    'upsell.payments.saleTitle': 'Sell from your own site',
    'upsell.payments.saleDescription': 'Building the catalogue is free: write your offers, price them, leave them ready. Charging for them comes with Pro or Business.',
    'upsell.payments.point1': 'Card, Apple Pay and Google Pay',
    'upsell.payments.point2': 'The money goes into your own account',
    'upsell.payments.point3': 'Sales, customers and refunds in one place',
    'upsell.payments.point4': 'Your balance and payout dates, without leaving here',
    'upsell.analytics.saleTitle': "Full analytics",
    'upsell.analytics.saleDescription': "Understand where your traffic comes from and which pages work. Included in the paid plans. Pick the one that fits you.",
    'upsell.analytics.point1': "Visitors, views and trends",
    'upsell.analytics.point2': "Traffic sources and campaigns",
    'upsell.analytics.point3': "Country map and devices",
    'upsell.analytics.point4': "Most popular pages",
    'upsell.orders.saleTitle': "Sales in your dashboard",
    'upsell.orders.saleDescription': "Every payment Stripe confirms shows up here, with who bought and how much came in. The money still goes straight to your account.",
    'upsell.orders.point1': "Your latest transactions, right on your home",
    'upsell.orders.point2': "Buyer, amount and status of every payment",
    'upsell.orders.point3': "Fee and net received on every payment",
    'upsell.orders.point4': "Stripe receipt one click away",
    'mediaPicker.title': "Choose an image",
    'mediaPicker.pickedCount': '{count} of {max} selected',
    'mediaPicker.addPicked': 'Add {count}',
    'mediaPicker.cancel': 'Cancel',
    'mediaPicker.subtitle': "Pick one you already have, or upload a new one.",
    'mediaPicker.close': "Close",
    'mediaPicker.tabUploads': "Your uploads",
    'mediaPicker.tabGallery': "Gallery",
    'mediaPicker.search': "Search the gallery",
    'mediaPicker.uploading': "Uploading…",
    'mediaPicker.upload': "Upload an image",
    'mediaPicker.formats': "JPG, PNG or WebP",
    'mediaPicker.loading': "Loading images…",
    'mediaPicker.emptyGallery': "No images found.",
    'mediaPicker.uploadsFailed': "We could not load your files.",
    'mediaPicker.galleryFailed': "We could not load the gallery.",
    'mediaPicker.uploadFailed': "We could not upload the image. Try again.",
    'deleteOverlay.noName': "Untitled",
    'deleteOverlay.dialogLabel': "Deleting {name}",
    'deleteOverlay.srDeleting': "Deleting the project",
    'deleteOverlay.srDone': "Project deleted",
    'deleteOverlay.srProject': "Project {name}",
    'deleteOverlay.srNew': "Create a new site",
    'deleteOverlay.firstSite': "Create your first site",
    'deleteOverlay.deleting': "Deleting…",
    'deleteOverlay.done': "Deleted · you can restore it for 30 days",
    'deleteOverlay.switching': "Switching project…",
    'deleteOverlay.fromScratch': "Let’s start from scratch",
    'addCard.title': "Add a card",
    'addCard.subtitle': "It is saved for your membership and domain charges.",
    'addCard.loading': "Loading the secure form…",
    'addCard.privacy': "The details go straight to Stripe. véltica never sees your card number.",
    'addCard.cancel': "Cancel",
    'addCard.saving': "Saving…",
    'addCard.save': "Save card",
    'addCard.missingKey': "The Stripe publishable key is missing (VITE_STRIPE_PUBLISHABLE_KEY).",
    'addCard.openFailed': "We could not open the form.",
    'addCard.saveFailed': "We could not save the card.",
    'addCard.stripeUnavailable': "Stripe is not available.",
    'colorPicker.close': "Close picker",
    'colorPicker.edit': "Edit {label}",
    'colorPicker.hexOf': "{label} HEX",
    'nav.backToDashboard': "Back to the dashboard",
    'createAi.previewTitle': "Preview",
    'createAi.searchCountry': "Search country…",
    'createAi.noResults': "No results",
    'mascotColor.change': "Change the dashboard color",
    'mascotColor.title': "Dashboard color",
    'skeleton.openEditor': "Open editor",
    'shell.goToEditor': "Go to editor",
    'shell.goToEditorHint': "Back to the canvas to design your page.",
    'skeleton.openInEditor': "Open in editor",
    'skeleton.searchPage': "Search pages...",
    'skeleton.newPage': "New page",
    'templateFacets.blockType': "Block type",
    'templateFacets.blockTypeHint': "Which repeatable unit this block is, so the AI can drop it into the right section.",
    'checkoutSuccess.titlePlan': "You’re on {plan}",
    'checkoutSuccess.titleThanks': "Thanks for subscribing!",
    'checkoutSuccess.leadActive': "Your plan is active and everything it includes is ready to use.",
    'checkoutSuccess.leadPending': "We are confirming the payment with our provider. It takes a few seconds and there is nothing for you to do.",
    'checkoutSuccess.next1': "Stripe will email you the receipt.",
    'checkoutSuccess.next2': "The subscription renews on its own; you can cancel whenever you want.",
    'checkoutSuccess.next3': "Manage the plan, the card and the invoices from Plans and billing.",
    'checkoutSuccess.cta': "Start building",
    'domainSuccess.titleRegistered': "{domain} is yours",
    'domainSuccess.titleFailed': "Payment received, registration pending",
    'domainSuccess.titleThanks': "Thanks for your purchase!",
    'domainSuccess.leadRegistered': "We registered it in your name and it already points to your site. The SSL certificate is issued automatically over the next few minutes.",
    'domainSuccess.leadFailed': "We charged for the domain but the registration could not be completed. Do not try again. Write to us and we will sort it out or refund you.",
    'domainSuccess.leadSlow': "Registration is taking longer than usual. It can finish without you: close this and check your domain list in a few minutes.",
    'domainSuccess.leadPending': "We are registering {domain} and setting up its DNS. It takes a few seconds and there is nothing for you to do.",
    'domainSuccess.next1': "Stripe will email you the receipt.",
    'domainSuccess.next2': "You do not have to touch any DNS: the domain already lives in our account.",
    'domainSuccess.next3': "The registration lasts a year and we will remind you before it renews.",
    'domainSuccess.ctaSee': "See my domain",
    'domainSuccess.ctaBack': "Back to my domains",
    'nav.back': "Back",
    'barChart.submissions': "submissions",
    'barChart.perDay': "{label} per day",
    'stripe.embedFailed': "We could not open the Stripe view.",
    'stripe.popupBlocked': "Your browser blocked the Stripe window. Allow pop-ups and try again.",
    'device.mobile': "Mobile",
    'device.desktop': "Desktop",
    'device.tablet': "Tablet",
    'overview.fact.views': "Your site got {count} visits this period.",
    'overview.fact.viewsOne': "Your site got {count} visit this period.",
    'overview.fact.viewsUp': "Your visits are up {percent}% on the previous period.",
    'overview.fact.viewsDown': "Your visits are down {percent}% on the previous period.",
    'overview.fact.topPage': "Your most-visited page is “{page}”.",
    'overview.fact.notPublished': "Your site is not published yet.",
    'overview.fact.collections': "You have {count} collections in the CMS.",
    'overview.fact.collectionsOne': "You have {count} collection in the CMS.",
    'overview.fact.onePage': "Your site has a single page. A couple more would give people a way in.",
    'overview.fact.seeAnalytics': "See analytics",
    'overview.fact.openEditor': "Open the editor",
    'overview.fact.goContent': "Go to Content",
    'overview.fact.goPages': "Go to Pages",
    'overview.waiting.transferOne': "Site transfer pending",
    'overview.waiting.transferMany': "Site transfers pending",
    'overview.waiting.inviteOne': "You have an invitation",
    'overview.waiting.inviteMany': "You have {count} invitations",
    'overview.waiting.stepOne': "You have one step left",
    'overview.waiting.stepMany': "You have {count} steps left",
    'restoreOverlay.dialogLabel': "Restoring {name}",
    'restoreOverlay.srRestoring': "Restoring the project",
    'restoreOverlay.srDone': "Project restored",
    'restoreOverlay.srProject': "Project {name}",
    'restoreOverlay.restoring': "Restoring…",
    'restoreOverlay.done': "Restored · publish it again to put it back online",
    'restoreOverlay.opening': "Opening the project…",
    'embeddedCheckout.missingKey': "The Stripe publishable key is missing (VITE_STRIPE_PUBLISHABLE_KEY).",
    'embeddedCheckout.loadFailed': "We could not load the payment.",
    'transferBanner.kicker': "Site transfer",
    'transferBanner.fromWho': "{name} wants to transfer you",
    'transferBanner.anon': "Someone wants to transfer you",
    'transferBanner.body': "It would move to your account with its pages, content, contacts and domain.",
    'transferBanner.expiresOne': "Expires in {count} day",
    'transferBanner.expiresMany': "Expires in {count} days",
    'transferBanner.cta': "See what I get",
    'createBlank.dialogLabel': "Blank project",
    'createBlank.close': "Close",
    'createBlank.title': "What is your project called?",
    'createBlank.subtitle': "It is all we need to start. You can change it whenever you like.",
    'createBlank.placeholder': "My company",
    'imagePicker.change': "Change image",
    'imagePicker.tabUpload': "Upload",
    'imagePicker.tabStock': "Stock",
    'imagePicker.formats': "JPG · PNG · WebP · max 10 MB",
    'imagePicker.search': "Search photos…",
    'imagePicker.empty': "Search free professional images.",
    'imagePicker.remove': "Remove image",
    'createBlank.hint': "The editor will open with an empty page.",
    'audienceMap.label': "Audience map by country. Drag to pan and use the controls to zoom in or out.",
    'audienceMap.zoomIn': "Zoom in",
    'audienceMap.zoomOut': "Zoom out",
    'audienceMap.center': "Center the map",
    'audienceMap.dragHint': "Drag to move the map",
    'audienceMap.less': "Fewer",
    'audienceMap.more': "More",
    'backupPreview.dialogLabel': "Backup preview",
    'backupPreview.restoreThis': "Restore this one",
    'backupPreview.close': "Close",
    'backupPreview.pages': "Pages in the backup",
    'backupPreview.opening': "Opening the backup…",
    'backupPreview.exact': "Published renderer",
    'backupPreview.noPages': "This backup has no pages to preview.",
    'backupPreview.renderFailed': "This backup could not be rendered.",
    'backupPreview.note': "Approximate preview: it is drawn with the dashboard renderer, not the one that builds the published site, so some details may look different.",
    'backupPreview.noteCms': " Only the site pages show here; the {count} collection pages are generated by the CMS on publish, but they are saved in the backup and come back when you restore.",
    'transferCard.title': "Transfer the site",
    'transferCard.body': "You hand it to another account with its pages, content, contacts and domain. The subscription does not travel: from the handover on, the site is on whoever receives it.",
    'transferCard.pending': "Invitation pending",
    'transferCard.pendingMeta': "{email} · expires on {date}",
    'transferCard.cancelInvite': "Cancel invitation",
    'transferCard.emailLabel': "Email of whoever receives it",
    'transferCard.emailPlaceholder': "client@example.com",
    'transferCard.sending': "Sending…",
    'transferCard.send': "Send invitation",
    'transferCard.hint': "An email goes to that address with what they would receive from “{project}”. Until they accept, the site is still yours and you can cancel the invitation whenever you want.",
    'transferCard.sentTo': "Invitation sent to {email}",
    'transferCard.cancelled': "Invitation cancelled",
    'transferCard.consequences.title': "What happens when they accept",
    'transferCard.consequences.owner': "The site stops being yours. You lose access to it unless the new owner invites you back.",
    'transferCard.consequences.team': "Everyone else on the team loses access. The new owner starts with an empty team.",
    'transferCard.consequences.stripe': "Your Stripe account is disconnected and the site stops taking payments until the new owner connects theirs.",
    'transferCard.consequences.data': "Pages, content, contacts, orders and upcoming appointments travel with the site.",
    'transferCard.consequences.plan': "The subscription does not travel. From the handover on, the site runs on the new owner’s plan.",
    'transferCard.resend': "Resend",
    'transferCard.resent': "Invitation sent again to {email}",
    'transferCard.history': "Transfers you have sent",
    'transferCard.historyEmpty': "You have not sent any transfer yet.",
    'transferCard.historyEmptyBody': "When you hand a site over, its invitation and how it ended up show here.",
    'transferCard.status.pending': "Waiting for an answer",
    'transferCard.status.accepted': "Accepted",
    'transferCard.status.rejected': "Declined",
    'transferCard.status.cancelled': "Cancelled",
    'transferCard.status.expired': "Expired",
    'transferCard.acceptedBy': "{name} accepted it",
    'transferCard.handoverPending': "Accepted, but the new owner has not connected a payment account yet. The site cannot charge in the meantime.",
    'transferCard.handoverDone': "Handover finished.",
    'transferCard.sentOn': "Sent on {date}",
    'transferCard.resolvedOn': "Answered on {date}",
    'templateCard.noThumbnail': "No screenshot",
    'templateCard.openCanvas': "Open canvas",
    'templateCard.premium': "Premium",
    'templateCard.unpublished': "Unpublished changes",
    'templateCard.editData': "Edit details",
    'templateCard.publish': "Publish changes",
    'templateCard.discard': "Discard draft",
    'templateCard.activate': "Activate",
    'templateCard.archive': "Deactivate",
    'templateCard.delete': "Delete",
    'cms.limit.pages': "pages",
    'stripe.fact.fee': 'véltica fee',
    'platformFee.example.heading': 'From every {sample} sale',
    'platformFee.sales.heading': 'In the last 30 days you sold {gross}',
    'platformFee.stripeNote': "What reaches you after the véltica fee. Stripe's payment processing fee is separate.",
    'platformFee.tile.current': '{plan} · your plan',
    'platformFee.tile.next': 'With {plan}',
    'platformFee.tile.fee': 'véltica keeps {amount} ({fee}%)',
    'platformFee.tile.noFee': 'No véltica fee',
    'platformFee.tile.more': '{amount} more for you',
    'platformFee.perSale': '{fee}% per sale',
    'platformFee.paysForItself': 'That\'s more than {plan} costs: the plan would pay for itself.',
    'platformFee.seePlans': 'See {plan}',
    'planLimit.dialogLabel': "Raise the limits",
    'planLimit.close': "Close",
    'planLimit.eyebrow': "Limit reached",
    'planLimit.title': "You have hit the {resource} limit of your {plan} plan",
    'planLimit.topPlan': "You are on {plan}, our highest plan. If you need more room, write to us and we will put together a plan that fits.",
    'planLimit.contactNote': "We will answer the same day.",
    'planLimit.contactSubject': "I need more capacity (Business)",
    'planLimit.contact': "Contact véltica",
    'planLimit.upgradeLead': "Move up to {plan} to keep creating {resource} and unlock more room.",
    'planLimit.upgradeCta': "Upgrade to {plan}",
    'planLimit.notNow': "Not now",
    'planLimit.blogPosts.point': "{count} published posts",
    'planLimit.blogPosts.unlimited': "Unlimited published posts",
    'planLimit.pro.point1': "5 projects",
    'planLimit.pro.point2': "30 pages",
    'planLimit.pro.point3': "20 collections · 500 items",
    'planLimit.pro.point4': "Your own domain, no badge",
    'planLimit.price': "from ${price}/month",
    'planLimit.offers.lead': "With {plan} you can publish up to {count} offers and each sale pays a {fee}% fee instead of {currentFee}%.",
    'planLimit.offers.leadUnlimited': "With {plan} you can publish as many offers as you want and each sale pays a {fee}% fee instead of {currentFee}%.",
    'planLimit.offers.fee': "{fee}% fee per sale, instead of {currentFee}%",
    'planLimit.business.point1': "20 projects",
    'planLimit.business.point2': "Unlimited pages",
    'planLimit.business.point3': "100 collections · 5,000 items",
    'planLimit.business.point4': "Business apps (forms, inbox, sales)",
    'emails.title': "Email accounts",
    'emails.subtitle': "Custom addresses and forwarding rules.",
    'emails.newRule': "New rule",
    'emails.needDomainTitle': "Connect a domain to use email",
    'emails.needDomainBody': "To create addresses like {example}, you first need to connect a custom domain in the Publishing section.",
    'emails.connectDomain': "Connect a domain",
    'emails.rulesTitle': "Forwarding rules",
    'emails.colAlias': "Alias (receives)",
    'emails.colDestination': "Destination (forwards to)",
    'emails.colStatus': "Status",
    'emails.colActions': "Actions",
    'emails.active': "Active",
    'emails.pending': "Pending",
    'emails.deleteRule': "Delete rule",
    'omnisend.description': "Connect your Omnisend account so the contacts coming in through your forms land in your lists.",
    'omnisend.checking': "Checking…",
    'omnisend.keyBroken': "The key stopped working",
    'omnisend.connected': "Account connected",
    'omnisend.notConnected': "Not connected",
    'omnisend.loadingBody': "Checking the state of the integration.",
    'omnisend.invalidBody': "Omnisend rejected the last key you saved. Contacts are not being sent until you paste a new one.",
    'omnisend.connectedBody': "Forms with sending turned on deliver their contacts to this account. Key {hint}.",
    'omnisend.emptyBody': "Paste your Omnisend account key to start. You can change or remove it whenever you want.",
    'omnisend.needsAttention': "Needs attention",
    'omnisend.statusOk': "Connected",
    'omnisend.changeKey': "Change the key",
    'omnisend.apiKey': "API key",
    'omnisend.placeholder': "Paste your Omnisend key here",
    'omnisend.whereKeyPart1': "You will find it in Omnisend, under",
    'omnisend.openOmnisend': "Open Omnisend",
    'omnisend.stored': "It is stored encrypted and never shown again: you will only see its last four characters.",
    'omnisend.saveNewKey': "Save the new key",
    'omnisend.connect': "Connect account",
    'omnisend.confirmDisconnect': "Yes, disconnect",
    'omnisend.cancel': "Cancel",
    'omnisend.disconnect': "Disconnect",
    'omnisend.disconnectNote': "The saved key is deleted. Contacts that already arrived stay in your Omnisend account, and the forms stop sending until you connect again.",
    'omnisend.adminOnly': "Only a project admin can connect or change this account.",
    'omnisend.stepsTitle': "What is left before anything arrives",
    'omnisend.stepsLead': "Connecting the account does not send anything by itself: each form decides whether it sends its contacts.",
    'omnisend.step1': "Turn on sending to Omnisend in whichever forms you want. A contact form and a newsletter sign-up are not the same thing, so you choose one by one.",
    'omnisend.step2Part1': "Add a “send me updates” checkbox to the form if you want to subscribe whoever ticks it. Without it the contact still arrives, but",
    'omnisend.step2Strong': "without",
    'omnisend.step2Part2': "signing up for your campaigns: writing to you is not asking for the newsletter, and anyone already subscribed is left alone.",
    'omnisend.goToForms': "Go to Forms",
    'omnisend.disconnectFailed': "We could not disconnect the account.",
    'omnisend.connectFailed': "We could not connect the account.",
    'palette.warmEarth': "Warm Earth (Ed.)",
    'palette.brassObsidian': "Brass & Obsidian",
    'palette.monochromeVolt': "Monochrome Volt",
    'palette.nordicBlue': "Nordic Blue",
    'palette.obsidianTech': "Obsidian Tech",
    'palette.burgundyRose': "Burgundy & Rose",
    'palette.oceanHealth': "Ocean Health",
    'palette.cyberpunkJapan': "Cyberpunk Japan",
    'section.header': "Header",
    'section.hero': "Hero",
    'section.cards': "Cards",
    'section.testimonials': "Testimonials",
    'section.faq': "FAQ",
    'section.pricing': "Pricing",
    'section.gallery': "Gallery",
    'section.stats': "Stats",
    'section.logos': "Logos",
    'section.about': "About",
    'section.cta': "Call to action",
    'section.contact': "Contact",
    'section.footer': "Footer",
    'section.numbered': "Section {n}",
    'fakeOrders.item1': "Intro consultation",
    'fakeOrders.item2': "Monthly plan",
    'fakeOrders.item3': "Full course",
    'fakeOrders.item4': "Design session",
    'fakeOrders.item5': "Downloadable guide",
    'fakeOrders.buyer1': "Ana Rios",
    'fakeOrders.buyer2': "Luis Herrera",
    'fakeOrders.buyer3': "Marta Solis",
    'fakeOrders.buyer4': "Diego Paz",
    'fakeOrders.buyer5': "Sofia Lara",
    'fakeOrders.buyer6': "Ivan Mora",
    'mascot.playful.1': "Stare at me and I blink. Seems fair.",
    'mascot.playful.2': "Feeling hexagonal today. Same as every day, really.",
    'mascot.playful.3': "You can change my color. I choose not to comment on your taste.",
    'mascot.playful.4': "Word is today is a good day to publish something.",
    'mascot.playful.5': "I follow your cursor around the screen. Not weird. It’s the job.",
    'mascot.playful.6': "A website is like a plant: a little water, often.",
    'mascot.playful.7': "Your project is in good hands. Well, good corners.",
    'mascot.playful.8': "Every time you publish I do a victory lap. Nobody sees it.",
    'mascot.playful.9': "I’m made of six sides and a lot of enthusiasm.",
    'mascot.playful.10': "Nothing urgent today. Make the most of it.",
    'mascot.playful.11': "I work better when someone’s watching. Like everyone.",
    'mascot.playful.12': "Your site looks good from in here.",
    'mascot.playful.13': "Mondays count as publishing days too.",
    'mascot.playful.14': "Two eyes and no opinions on typefaces. That’s a lie: I have several.",
    'mascot.playful.15': "One of these days I’ll learn to wave.",
    'mascot.playful.16': "This dashboard is tidier than my desk. I don’t have a desk.",
    'mascot.playful.17': "I could be on any screen. I picked this one.",
    'mascot.playful.18': "Sites that get looked after show it. Yours shows it.",
    'mascot.playful.19': "Good light for working today.",
    'mascot.playful.20': "I come with the logo on and no holidays booked.",
    'mascot.playful.21': "I like how this is coming along.",
    'mascot.playful.22': "Six sides, no favourite.",
    'mascot.playful.23': "I count your visits while you get on with other things.",
    'mascot.playful.24': "Good moment to write that page you’ve been thinking about.",
    'mascot.playful.25': "Today’s for moving a little forward. A little is enough.",
    'mascot.playful.26': "Click me and I’ll let you pick my color.",
    'mascot.playful.27': "I spend all day looking at your dashboard. It looks good.",
    'mascot.playful.28': "Every corner of mine is rounded by hand. So to speak.",
    'mascot.playful.29': "The good projects get started on some ordinary Tuesday.",
    'mascot.playful.30': "Here I am, logo on, shift started.",
    'mascot.tip.1': "A page takes as long to load as its biggest image weighs.",
    'mascot.tip.2': "Page titles are the first thing Google reads. Sometimes the only thing.",
    'mascot.tip.3': "A form with three fields gets filled in. With ten, it gets abandoned.",
    'mascot.tip.4': "Connecting your own domain makes a site look like a business.",
    'mascot.tip.5': "Publish before it’s perfect. Perfect doesn’t arrive on its own.",
    'mascot.tip.6': "Check how your site looks on a phone: that’s where nearly everyone arrives.",
    'mascot.tip.7': "Alt text on every image reads better in Google and in a screen reader.",
    'mascot.tip.8': "The home page doesn’t have to tell everything, just what comes next.",
    'mascot.tip.9': "If a page has no clear button, it has no clear purpose.",
    'mascot.tip.10': "Visitors decide whether to stay in three seconds. Three.",
    'mascot.tip.11': "Answer form messages the same day. By the second they’ve forgotten you.",
    'mascot.tip.12': "A blog with no dates ages worse than one with old dates.",
    'mascot.tip.13': "Broken links don’t announce themselves. Check them now and then.",
    'mascot.tip.14': "Fewer typefaces, more character.",
    'mascot.tip.15': "One real photo of your business beats ten from a stock library.",
    'mascot.tip.16': "The privacy notice isn’t paperwork: it’s what covers you.",
    'mascot.tip.17': "Your domain renews itself, but it’s worth knowing when.",
    'mascot.tip.18': "Write for whoever arrives lost, not for whoever already knows you.",
    'mascot.tip.19': "A site with SSL ranks better and feels safer. Yours has it.",
    'mascot.tip.20': "Name your pages the way a customer would search for them, not the way you call them.",
    'mascot.tip.21': "A week of analytics says nothing. A month says almost everything.",
    'mascot.tip.22': "Saving isn’t publishing. Publishing is what people see.",
    'mascot.tip.23': "A button that says “Send” convinces less than one that says what happens next.",
    'mascot.tip.24': "If you have prices, show them. Hunting for them is tiring.",
    'mascot.tip.25': "The footer is where people look for the phone number. Put it there.",
    'mascot.tip.26': "One CMS collection saves you building thirty pages by hand.",
    'mascot.tip.27': "Landscape images fit better in almost every block.",
    'mascot.tip.28': "If you sell something, say what happens after paying.",
    'mascot.tip.29': "Fast sites look more professional even when they say the same thing.",
    'mascot.tip.30': "Repeat your address and phone on the site and on Google. Identical.",
    'mascot.tip.31': "A specific headline beats a clever one.",
    'mascot.tip.32': "Fill in your own form once in a while.",
    'mascot.tip.33': "People don’t read: they scan. Write in short chunks.",
    'mascot.tip.34': "A video that starts on its own scares off more than it draws in.",
    'mascot.tip.35': "Every page should be explainable in one sentence.",
    'mascot.tip.36': "When torn between two texts, pick the shorter one.",
    'mascot.tip.37': "Testimonials work when they have a name and a face.",
    'mascot.tip.38': "Updating an old page pays off more than writing a new one.",
    'mascot.tip.39': "The best moment for a backup is before touching anything.",
    'mascot.tip.40': "A short domain can be read out over the phone without repeating it.",
    'mascot.product.1': "Everything you publish here goes out with a certificate and a CDN included.",
    'mascot.product.2': "You can change your site’s address whenever you want, from Domain.",
    'mascot.product.3': "Every project keeps automatic backups. They’re in Settings.",
    'mascot.product.4': "Your site’s visits are counted without cookies or trackers.",
    'mascot.product.5': "The editor saves on its own. No save button to forget.",
    'mascot.product.6': "The form messages you receive also land in Contacts.",
    'mascot.product.7': "You can point several domains at the same site.",
    'mascot.product.8': "The CMS is for whatever repeats: blog, catalogue, listings, services.",
    'mascot.product.9': "Your pages publish in two copies: the test one and the one on your domain.",
    'mascot.product.10': "Connect Stripe and you take payments from your own site.",
    'mascot.product.11': "Bookings get their own public page, with nothing to install.",
    'mascot.product.12': "You can invite your team and hand out permissions per person.",
    'mascot.product.13': "Plans can change mid-month; it prorates itself.",
    'mascot.product.14': "Every page has its own settings for search engines.",
    'mascot.product.15': "You can password-protect a whole site while you get it ready.",
    'mascot.product.16': "Analytics tells visits from visitors apart. They’re not the same.",
    'mascot.product.17': "From the editor you can see your site the way a phone sees it.",
    'mascot.product.18': "Drafts aren’t indexed. Publish when you’re ready.",
    'mascot.product.19': "You can duplicate a page and change only what changes.",
    'mascot.product.20': "Your images are served already optimised. Nothing for you to do.",
    'mascot.product.21': "You can keep project notes in the notes widget.",
    'mascot.product.22': "The widgets on this screen can be reordered and removed.",
    'mascot.product.23': "Changing the dashboard color is clicking me and picking one.",
    'templateModal.editTemplate': "Edit template",
    'templateModal.newTemplate': "New template",
    'templateModal.editSite': "Edit template",
    'templateModal.newSite': "New template",
    'templateModal.siteLead': "Metadata for the template shown in the wizard. The page design is done on the canvas.",
    'templateModal.blockLead': "This data feeds the library, search and AI selection. The visual design lives on the canvas.",
    'templateModal.name': "Name",
    'templateModal.namePlaceholder': "Premium hero",
    'templateModal.slug': "Slug",
    'templateModal.kind': "Type",
    'templateModal.fullPage': "Full page (Template)",
    'templateModal.kindPage': "Page",
    'templateModal.kindSection': "Section",
    'templateModal.kindHeader': "Header",
    'templateModal.kindFooter': "Footer",
    'templateModal.kindComponent': "Component",
    'templateModal.category': "Category",
    'templateModal.language': "Copy language",
    'templateModal.languageAny': "Any (no fixed copy)",
    'templateModal.language.es': "Spanish",
    'templateModal.language.en': "English",
    'templateModal.pickCategory': "Choose a category…",
    'templateModal.industry': "Industry",
    'templateModal.pickIndustry': "Choose an industry…",
    'templateModal.descriptionPlaceholderSite': "Which business it's for, in English: e.g. Warm site for a café with menu, gallery and reservations.",
    'templateModal.description': "Description",
    'templateModal.descriptionPlaceholder': "How it's laid out, in English: e.g. Headline and button on the left, product photo on the right.",
    'templateModal.sectionBasics': "The basics",
    'templateModal.sectionAi': "Help the AI pick it",
    'templateModal.sectionAiHint': "A block is structure: the AI picks it by how it's laid out and its background. The site decides how it looks and which business it's for.",
    'templateModal.descriptionHint': "One line in English about when to use it. The AI reads it to break ties.",
    'templateModal.more': "More details",
    'templateModal.moreHint': "Optional: slug and premium.",
    'templateAi.progress': "{done} of {total}",
    'templateAi.slotsInferred': "No AI slots marked: the AI guesses them from the layout. Marking them in the editor makes the copy land exactly where it should.",
    'templateAi.required': "Required",
    'templateAi.detected': "Detected from the canvas: {list}",
    'templateAi.step.category': "Category",
    'templateAi.step.slots': "AI slots on the editable texts (set in the editor)",
    'templateAi.step.description': "One line in English about when to use it",
    'templateAi.step.layout': "How it's laid out",
    'templateAi.step.colorScheme': "Background",
    'templateCard.status.published': "Published",
    'templateCard.status.archived': "Archived",
    'templateCard.status.draft': "Draft",
    'templateCard.aiReady': "AI ready",
    'templateCard.aiMissing': "Not used by AI: {missing}",
    'templateCard.noDescription': "No description yet",
    'templateAi.short.category': "no category",
    'templateAi.short.slots': "no AI slots",
    'templateList.sitesTitle': "Site templates",
    'templateList.sitesSubtitle': "Complete pages people can start from. They show up in the assistant when creating a project.",
    'templateList.sitesEmptyTitle': "No site templates yet",
    'templateList.sitesEmptyDesc': "Create one, open the canvas and design a complete page.",
    'templateList.blocksTitle': "Blocks",
    'templateList.blocksSubtitle': "Sections, headers, footers and components. They fill the Insert panel and are what the AI builds sites from.",
    'templateList.blocksEmptyTitle': "No blocks yet",
    'templateList.blocksEmptyDesc': "Create your first block and open the canvas to design it.",
    'templateList.newSite': "New site template",
    'templateList.newBlock': "New block",
    'templateList.areas': "Library areas",
    'templateList.area.sections': "Sections",
    'templateList.area.catalog': "Catalog",
    'templateList.area.blog': "Blog",
    'templateList.area.cms': "CMS",
    'templateList.area.components': "Components & banners",
    'templateList.groupSections': "Sections",
    'templateList.design.blog-index': "Blog index design",
    'templateList.design.blog-post': "Blog post design",
    'templateList.design.cms-collection': "Collection page design",
    'templateList.design.cms-item': "Item page design",
    'templateList.createSite': "Create site template",
    'templateList.createBlock': "Create block",
    'templateList.truncated': "Showing the {shown} most recent of {total}. Older ones are not in this list: it needs pagination.",
    'templateList.howTitle': "How a template reaches the AI",
    'templateList.step1': "Design it on the canvas using the style system colors and fonts, so it follows any style.",
    'templateList.step2': "Mark every editable text, image and button with an AI slot.",
    'templateList.step3': "In its details pick the category and who it suits, then publish.",
    'templateList.filterAll': "All",
    'templateList.filterNeedsAi': "Not used by AI",
    'templateList.filterUnpublished': "Unpublished changes",
    'templateList.filterDrafts': "Drafts",
    'templateList.search': "Search by name",
    'templateList.sort': "Sort",
    'templateList.sort.recent': "Newest",
    'templateList.sort.oldest': "Oldest",
    'templateList.sort.used': "Most used",
    'templateList.sort.updated': "Recently edited",
    'templateList.sort.name': "Name (A–Z)",
    'templateList.empty': "Nothing matches this filter.",
    'templateAi.title': "AI readiness",
    'templateAi.ready': "The AI can choose and fill this template.",
    'templateAi.notReady': "The AI won't use it until this is fixed:",
    'templateAi.improve': "Would help the AI choose it better:",
    'templateAi.issue.category': "Pick a category",
    'templateAi.issue.description': "Write one line, in English, about when to use it",
    'templateAi.issue.slots': "Mark the editable texts with AI slots in the editor",
    'templateAi.issue.style': "Choose its style",
    'templateAi.issue.layout': "Choose its layout",
    'templateAi.issue.colorScheme': "Choose its background",
    'templateAi.issue.goal': "Choose its goal",
    'templateAi.issue.bestFor': "Choose which businesses it suits",
    'templateAi.issue.unslottedText': "{count} texts have no slot: the AI won't rewrite them",
    'templateAi.issue.manualOnly': "Marked «manual only»: the AI does not use it",
    'templateModal.manualOnly': "Manual only",
    'templateModal.manualOnlyHint': "The AI never uses it when creating sites. It still shows in the library.",
    'templateModal.aiUse': "The AI uses it when creating sites",
    'templateModal.aiUseHint': "Off, the block stays in the library to add by hand, but the AI never picks it.",
    'templateCard.aiOn': "Use in the AI",
    'templateCard.aiOff': "Remove from the AI",
    'templateCard.aiDisabled': "AI disabled",
    'templateAi.short.manualOnly': "removed from the AI",
    'templateModal.locations': "Locations",
    'templateModal.locations.one': "One address",
    'templateModal.locations.two': "Two locations",
    'templateModal.locations.three': "Three locations",
    'templateModal.locations.list': "List (any number)",
    'templateModal.locationsHint': "The AI only uses a multi-location block when the business has that many.",
    'templateModal.thumbnail': "Thumbnail",
    'templateModal.uploading': "Uploading…",
    'templateModal.changeImage': "Change image",
    'templateModal.uploadImage': "Upload an image",
    'templateModal.removeImage': "Remove",
    'templateModal.thumbnailHint': "Shown in the create-project wizard. JPG, PNG or WebP, max 5 MB.",
    'templateModal.premium': "Premium",
    'templateModal.publishOnCreate': "Publish on create",
    'templateModal.cancel': "Cancel",
    'templateModal.saving': "Saving...",
    'templateModal.save': "Save",
    'authCodes.title': "Auth codes",
    'authCodes.subtitle': "Requests for the authorization code needed to transfer a domain away from véltica.",
    'authCodes.filterPending': "Pending",
    'authCodes.filterSent': "Sent",
    'authCodes.filterAll': "All",
    'authCodes.retry': "Try again",
    'authCodes.loading': "Loading…",
    'authCodes.emptyPending': "Nothing pending",
    'authCodes.emptyAll': "No requests",
    'authCodes.emptyPendingBody': "When someone asks for their domain code, it will show up here.",
    'authCodes.emptyAllBody': "Nobody has asked for a domain code yet.",
    'authCodes.late': "Past the deadline",
    'authCodes.sent': "Sent",
    'authCodes.unknownAccount': "unknown account",
    'authCodes.writeTo': "Write to {email}",
    'authCodes.replyByEmail': "Reply by email",
    'authCodes.mailSubject': "Transfer code for {domain}",
    'authCodes.paste': "Paste the code",
    'authCodes.srLabel': "Authorization code for {domain}",
    'authCodes.placeholder': "Paste the registrar’s code here",
    'authCodes.sending': "Sending…",
    'authCodes.sendToClient': "Send to the customer",
    'authCodes.cancel': "Cancel",
    'authCodes.sendNote': "It is emailed to them and shows up in their domain settings.",
    'authCodes.note': "The code is pulled by hand from the registrar’s panel: no API exposes it. Pasting it here emails it to them, shows it in their domain settings and closes the request. It is kept for 30 days and then deleted on its own. With it, anyone can take the domain.",
    'authCodes.agoNow': "just now",
    'authCodes.agoMinutes': "{count} min ago",
    'authCodes.agoHourOne': "{count} hour ago",
    'authCodes.agoHours': "{count} hours ago",
    'authCodes.agoDayOne': "{count} day ago",
    'authCodes.agoDays': "{count} days ago",
    'templateModal.slugPlaceholder': "premium-hero",
    'adminImages.title': "Images",
    'adminImages.subtitle': "Professional library shared with every user and available to the AI assistant.",
    'adminImages.pickFile': "Choose an image or video",
    'adminImages.filesPicked': "{count} images selected",
    'adminImages.manyHint': "With several images, each one is uploaded with the title “test” and no tags. You can edit them afterwards.",
    'adminImages.uploadMany': "Upload {count} images",
    'adminImages.someFailed': "{count} of {total} images could not be uploaded.",
    'adminImages.formats': "JPG, PNG, WebP, GIF or AVIF up to 10 MB · MP4 or WebM video up to 95 MB",
    'adminImages.videoBadge': "Video",
    'adminImages.videoType': "MP4 or WebM videos only.",
    'adminImages.videoTooBig': "The video is over the 95 MB limit.",
    'adminImages.titleField': "Title",
    'adminImages.titlePlaceholder': "e.g. Premium facial treatment",
    'adminImages.hashtagsField': "Hashtags for search and AI",
    'adminImages.hashtagsPlaceholder': "#beauty #spa #facial #premium",
    'adminImages.uploadingPercent': "Uploading {percent}%",
    'adminImages.compressing': "Compressing…",
    'adminImages.upload': "Upload an image",
    'adminImages.search': "Search by title or hashtag…",
    'adminImages.searchBtn': "Search",
    'adminImages.loading': "Loading the library…",
    'adminImages.empty': "No images yet",
    'adminImages.emptyBody': "Upload the library’s first professional image.",
    'adminImages.edit': "Edit",
    'adminImages.delete': "Delete",
    'adminImages.loadMore': "Load more",
    'adminImages.editTitle': "Edit image",
    'adminImages.editLead': "This data helps search and the AI pick the right image.",
    'adminImages.hashtags': "Hashtags",
    'adminImages.editHashtagsPlaceholder': "#beauty #spa #premium",
    'adminImages.cancel': "Cancel",
    'adminImages.save': "Save",
    'adminImages.confirmDelete': "Delete “{title}” from the library for every user?",
    'error.domain.planRequired': "Connecting your own domain requires the Pro or Business plan.",
    'error.domain.buyPlanRequired': "Buying a domain requires the Pro or Business plan.",
    'error.domain.invalid': "Enter a valid domain, for example www.yourcompany.com.",
    'error.domain.reserved': "That domain belongs to véltica; use your own.",
    'error.domain.limitReached': "You have reached this project’s domain limit.",
    'error.domain.notFound': "We could not find that domain.",
    'error.domain.onlyActivePrimary': "Only an active domain can be the primary one.",
    'error.domain.registering': "We are registering that domain. Wait for it to finish.",
    'error.domain.recordGone': "That record no longer exists.",
    'error.domain.notBoughtHere': "That domain was not bought here: connect it with the wizard.",
    'error.domain.searchTooShort': "Type at least two letters, with no spaces or dots.",
    'error.domain.purchaseUnavailable': "Buying domains is not set up yet.",
    'error.domain.unavailable': "That domain is no longer available.",
    'error.domain.premium': "It is a premium domain and cannot be bought from here.",
    'error.domain.priceUnavailable': "We could not work out the price for that domain.",
    'error.domain.creditUsed': "Your domain credit has already been used. Try again.",
    'error.booking.slotTaken': "That time slot is already taken.",
    'error.booking.notFound': "We could not find that booking.",
    'error.booking.noSchedule': "This offer does not have a schedule set up yet.",
    'error.booking.noResource': "The schedule has no resources.",
    'error.booking.invalidDate': "That date is not valid.",
    'error.booking.rangeTooLong': "The date range is too long.",
    'error.contact.notFound': "We could not find that contact.",
    'error.offer.invalidInclusions': "The selected memberships aren’t valid.",
    'error.offer.inclusionsUnavailable': "This feature isn’t ready on your account yet.",
    'error.offer.inclusionsNeedPlan': "Bookings included in memberships are part of the Pro plan.",
    'error.contact.noAccount': "This person doesn’t have an account on your site.",
    'error.contact.membershipNotFound': "That membership doesn’t belong to this person.",
    'error.contact.membershipEnded': "That membership has already ended.",
    'error.contact.membershipCancelFailed': "Stripe couldn’t cancel the membership. Please try again.",
    'error.contact.membershipGranted': "That membership was given from Contacts: remove it under “Access”.",
    'error.grant.unavailable': "This feature isn't ready yet.",
    'error.grant.noEmail': "This person has no email.",
    'error.grant.pastDate': "The end date has already passed.",
    'error.grant.offerNotFound': "That offer can't be given.",
    'error.grant.notFound': "That access no longer exists.",
    'error.contact.invalid': "Check the contact details.",
    'error.message.notFound': "We could not find that message.",
    'error.message.invalidStatus': "That status is not valid.",
    'error.team.selfInvite': "You cannot invite yourself to this project.",
    'error.team.alreadyOwner': "That person already owns the project.",
    'error.team.alreadyMember': "That person is already part of the project.",
    'error.team.invitePending': "There is already a pending invitation for that email.",
    'error.team.memberGone': "That member is no longer in the project.",
    'error.team.selfRole': "You cannot change your own role. Ask someone else with permission.",
    'error.integration.notFound': "That integration does not exist.",
    'error.integration.keyFormat': "The key is not in the expected format.",
    'error.integration.keyRejected': "Omnisend does not recognize that key.",
    'error.domain.externalDns': "This domain is registered outside véltica, so its DNS is managed at your registrar.",
    'error.domain.renewInProgress': "There is already an operation in progress for that domain. Wait for it to finish.",
    'error.domain.renewUnavailable': "We couldn't set up the renewal right now. Try again in a few minutes or write to us.",
    'error.domain.systemRecordCreate': "That name is taken by the record that keeps your site online and its certificate valid. Pick another.",
    'error.domain.systemRecordEdit': "That record keeps your site online and its certificate valid. It cannot be edited from here.",
    'error.domain.systemRecordDelete': "That record keeps your site online and its certificate valid. It cannot be deleted from here.",
    'error.domain.connectedElsewhere': "That domain is already connected to another project. Disconnect it there first.",
    'error.booking.resourceCreateFailed': "We could not create the resource, try again.",
    'error.booking.resourceIsDefault': 'The first team member can’t be removed.',
    'error.collection.limit': 'You’ve reached the maximum number of collections.',
    'error.collection.notFound': 'That collection no longer exists.',
    'error.booking.resourceHasBookings': 'They have bookings: mark them inactive instead of removing them.',
    'error.booking.artistBusy': 'That person already has a booking at that time.',
    'error.booking.rangeMissing': "A start date and an end date are required.",
    'error.booking.durationMissing': "A duration or an offer with a schedule is required.",
    'error.contact.missing': "No contact was given.",
    'error.contact.unknown': "We do not recognize that contact.",
    'error.message.spamOnly': "A submission with no email address can only be marked as spam.",
    'error.team.seatsUnavailable': "Your current plan does not include guests. Upgrade to share this project.",
    'error.team.seatsFull': "Your plan allows {limit} guests and they are all taken. Cancel an invitation or upgrade.",
    'error.domain.registrarUnknown': "The registrar does not recognize this domain. Write to us and we will look into it.",
    /* Billing. */
    'error.billing.planUnavailable': "That plan is not available yet.",
    'error.billing.subscriptionExists': "This account already has a membership.",
    'error.domain.transferLocked': "This domain is locked while we review a refund or payment dispute.",
    'error.account.domainsOwned': "Transfer your domains away from véltica before deleting your account.",
    'error.account.domainChoiceNeeded': "Choose what to do with each domain before deleting your account.",
    'error.account.domainTransferLocked': "That domain is locked by a refund or dispute and can't be transferred right now. Choose to let it expire.",
    'error.account.notScheduled': "Your account has no pending deletion.",
    'error.account.deletionScheduled': "Your account is scheduled for deletion. Restore it to keep using it.",
    'error.account.purchasePending': "A domain purchase is in progress. Wait for it to finish.",
    'error.account.cancelFailed': "We could not cancel the membership, so the account was not deleted.",
    'error.billing.checkoutFailed': "The payment could not be started.",
    'error.billing.noSubscription': "You do not have an active subscription.",
    'error.billing.portalFailed': "The billing portal could not be opened.",
    'error.billing.overviewFailed': "Billing could not be loaded.",
    'error.billing.downgradePreviewFailed': "We could not work out what changes if you move to a lower plan.",
    'error.billing.invalidCursor': "Invalid cursor.",
    'error.billing.historyFailed': "The history could not be loaded.",
    'error.billing.noCustomer': "There are no charges on your account yet.",
    'error.billing.cardSetupFailed': "The card could not be set up.",
    'error.billing.cardNotYours': "That card does not belong to your account.",
    'error.billing.cardUpdateFailed': "The card could not be changed.",
    'error.billing.lastCard': "It is the only card on your membership. Add another one before removing it.",
    'error.billing.cardRemoveFailed': "The card could not be removed.",
    'error.billing.noMembership': "You do not have an active membership.",
    'error.billing.cancelFailed': "The membership could not be cancelled.",
    'error.billing.membershipEnded': "That membership has ended. Sign up again from Plans.",
    'error.billing.resumeFailed': "The membership could not be resumed.",
    'error.team.inviteInvalid': "Enter a valid email and choose a role.",
    'error.team.roleUnknown': "Unknown role.",
    'error.booking.invalidRequest': "Invalid request",
    /* Projects. */
    'error.subdomain.tooShort': "Use at least 3 characters.",
    'error.subdomain.tooLong': "Use at most 63 characters.",
    'error.subdomain.format': "Lowercase letters, numbers and hyphens only, and not starting or ending with a hyphen.",
    'error.subdomain.reserved': "That address is reserved.",
    'error.subdomain.taken': "That address is already in use. Try another one.",
    'error.subdomain.tooManyChanges': "The address was already changed {limit} times today. Try again tomorrow.",
    'error.page.slugTaken': "There is already a page at that address. Choose another one.",
    'error.backup.contentGone': "The contents of that backup are no longer available.",
    'error.backup.limitReached': "Your plan keeps {limit} backups and you have them all. Delete one or upgrade to create another.",
    'error.backup.unchanged': "Nothing has changed since the last backup, so another one was not needed.",
    'error.backup.tooLarge': "This project is too large to back up. Write to us.",
    'error.project.notDeleted': "That project is not deleted.",
    'error.project.notPublished': "That project is not published.",
    'error.policy.notFound': "That policy does not exist.",
    'error.theme.missing': "The theme is missing.",
    'error.theme.tooLarge': "The theme is too large.",
    /* Store and payments. */
    'error.commerce.stripePlanRequired': "Connecting Stripe requires a paid plan. You can create and edit offers on the free plan; to charge for them you need Pro or Business.",
    'error.commerce.stripeRequiredToPublish': "Connect Stripe before publishing. In the meantime the offer stays a draft: you can keep editing it and nobody sees it.",
    'error.commerce.connectForNotices': "Connect Stripe to set up notices.",
    'error.calendar.invalidUrl': "Paste your calendar’s secret address in iCal format (it starts with https:// or webcal://).",
    'error.calendar.googleUnavailable': "The Google Calendar connection is not configured on the server.",
    'error.calendar.resourceNotFound': "That schedule no longer exists.",
    'error.calendar.tooMany': "You already have the maximum of 10 connected calendars.",
    'error.calendar.secretMissing': "Integration encryption is not configured on the server (INTEGRATIONS_SECRET).",
    'error.calendar.saveFailed': "Could not save the calendar.",
    'error.calendar.notFound': "Calendar not found.",
    'error.coupon.stripeMissing': "Connect Stripe to create coupons.",
    'error.coupon.stripeFailed': "Stripe did not accept the coupon. Check the details and try again.",
    'error.coupon.offerNotFound': "One of the selected offers no longer exists.",
    'error.coupon.offersRequired': "Choose at least one offer or apply it to all of them.",
    'error.coupon.codeTaken': "You already have a coupon with that code.",
    'error.coupon.notFound': "Coupon not found.",
    'error.commerce.connectForTax': "Connect Stripe to set up taxes.",
    'error.commerce.taxUnavailable': "Could not check your tax settings in Stripe. Please try again in a few minutes.",
    'error.commerce.taxNotReady': "Finish your tax settings in Stripe before turning on taxes.",
    'error.commerce.connectForCharges': "Connect Stripe to see the charge here.",
    'error.commerce.connectForPayouts': "Connect Stripe to see your payouts.",
    'error.commerce.embedRejected': "Stripe did not authorize the embedded view.",
    'error.commerce.balanceUnavailable': "We could not check your Stripe balance.",
    'error.commerce.bookableOnlyCreate': "Your role only allows creating bookable services, not store offers.",
    'error.commerce.bookableOnlyEdit': "Your role only allows editing bookable services, and they cannot stop being one.",
    'error.order.notFound': "Order not found.",
    'error.offer.createFailed': "The offer could not be created.",
    'error.offer.priceRequired': "Add a price before putting the offer on sale.",
    'error.offer.physicalPrice': "A physical product needs a one-time price above zero.",
    'error.offer.variantsPhysicalOnly': "Only a physical product can have variants.",
    'error.offer.variantsTooMany': "A product can have up to 100 combinations. Remove some values.",
    'error.offer.shippingRequired': "Add at least one shipping option before putting the product on sale.",
    'error.shipping.rateLimit': "You already have the maximum number of shipping options.",
    'error.shipping.rateNotFound': "Shipping option not found.",
    'error.price.notFound': "Price not found.",
    'error.price.lastOnLiveOffer': "It is the only price on an offer that is on sale. Pause the offer first.",
    /* Pages. */
    'error.page.notFound': "That page does not exist.",
    'error.page.limitOver': "Your plan includes {limit} pages and this site has {used}. You can keep editing and publishing the ones you have, but to create another you need to upgrade.",
    'error.page.limitReached': "You have reached the {limit} pages your plan includes. Upgrade to create more.",
    /* CMS limits. */
    'error.cms.collectionLimitOver': "Your plan includes {limit} collections and this site has {used}. You can keep editing what you have, but to add more you need to upgrade.",
    'error.cms.collectionLimitReached': "You have reached {limit} collections, the most your plan includes. Upgrade to add more.",
    'error.cms.itemLimitOver': "Your plan includes {limit} CMS items and this site has {used}. You can keep editing what you have, but to add more you need to upgrade.",
    'error.cms.itemLimitReached': "You have reached {limit} CMS items, the most your plan includes. Upgrade to add more.",
    'error.offers.publishLimitReached': "You have reached {limit} published offers, the most your plan includes. Upgrade, or take another one down to publish this.",
    'error.blog.notFound': "That post doesn't exist.",
    'error.blog.invalidSlug': "The address can only have letters, numbers and hyphens.",
    'error.blog.slugTaken': "You already have another post with that address.",
    'error.contacts.invalidTag': "That tag isn't valid.",
    'error.blog.invalidPath': "That address isn't available for the blog.",
    'error.blog.authorInvalid': "Check the author's links: each one needs a valid address, like instagram.com/your-name.",
    'error.blog.authorsNotReady': "Author profiles aren't available yet. Try again later.",
    'error.blog.publishLimitReached': "You have reached {limit} published posts, the most your plan includes. Upgrade, or move another one to draft to publish this.",
    'error.blog.saveFailed': "The post couldn't be saved.",
    'error.bookings.serviceLimitReached': "You have reached {limit} services, the most your plan includes. Upgrade to add more.",
    'ai.noContact': "The AI assistant could not be reached.",
    'ai.badResponse': "The server returned an incompatible AI response.",
    'ai.badBlock': "The AI picked an invalid block.",
    'ai.blockDownloadFailed': "The selected block could not be downloaded.",
    'ai.blockEmpty': "The published block is empty or incompatible.",
    /* The AI assistant. */
    'error.ai.contextInvalid': "The editor context is not valid.",
    'error.ai.contextTooLarge': "The editor context is too large.",
    'error.ai.batchExpired': "The batched-changes session expired. Try the request again.",
    'error.ai.batchOutOfOrder': "The batches arrived out of order. Try the request again.",
    'auth.error.disposable': "Please use a permanent email: temporary addresses aren’t accepted.",
    'error.request.tooLarge': "What you’re trying to save is too large. Split the content into smaller parts.",
    'error.form.tooMany': "Too many submissions in a row. Wait a moment and try again.",
    'error.claim.tooMany': "Too many attempts in a row. Wait a moment and try again.",
    'error.ai.tokenLimitMonthly': "You have reached your plan's monthly AI token limit.",
    'error.ai.tokenLimitDaily': "You reached your plan’s monthly AI token limit.",
    'error.ai.providerBusy': "The AI provider is temporarily out of capacity. Try again.",
    'error.ai.notConfigured': "The AI assistant is not set up.",
    'error.ai.unsupportedChanges': "The AI proposed changes the editor does not support.",
    'error.ai.requestFailed': "The editor request could not be processed.",
    'error.ai.requestInvalid': "The request is not valid.",
    'error.ai.describePage': "Describe the page in at least 15 characters.",
    'error.ai.describeSite': "Describe the site in at least 20 characters and fewer than 5000.",
    'error.ai.projectCreateFailed': "The project could not be created.",
    'error.ai.dailyGenerationLimit': "You have reached the daily AI generation limit.",
    'error.ai.dailyAssistantLimit': "You have reached the daily AI assistant limit.",
    'error.ai.invalidProject': "The AI did not return a valid project.",
    'error.ai.invalidJson': "The AI returned invalid JSON.",
    'error.ai.incompleteProject': "The AI returned an incomplete project.",
    /* Transfers and files. */
    'error.transfer.badEmail': "Enter a valid email.",
    'error.transfer.toYourself': "You cannot transfer a project to your own account.",
    'error.transfer.invitePending': "There is already a pending invitation. Cancel it before sending another.",
    'error.transfer.noPending': "There is no pending invitation to resend.",
    'error.asset.invalidSvg': "The file is not a valid SVG.",
    'error.file.notMultipart': 'The upload did not arrive as a file. Try again.',
    'error.file.missing': 'No file came through.',
    'error.file.tooMany': 'This offer already has all the files it can hold.',
    'error.file.tooLarge': 'That file is too heavy. The limit is 15 MB per file.',
    'error.file.empty': 'That file is empty.',
    'error.file.notFound': 'That file is not here any more.',
    'error.file.nameRequired': 'The file needs a name.',
    /* Template taxonomy. */
    'tpl.allSections': "The whole section catalog",
    'tpl.previewOf': "Preview of {name}",
    'tax.facet.category': "Category",
    'tax.facet.style': "Style",
    'tax.facet.layout': "Layout",
    'tax.facet.columns': "Columns",
    'tax.facet.colorScheme': "Background",
    'tax.facet.media': "Media",
    'tax.facet.goal': "Goal",
    'tax.facet.bestFor': "Best for",
    'tax.kind.section': "Section",
    'tax.kind.section.hint': "Full-width band of the page",
    'tax.kind.block': "Block",
    'tax.kind.block.hint': "Repeatable unit inside a section",
    'tax.category.navbar': "Navigation",
    'tax.category.navbar.hint': "Headers, menus and top bars",
    'tax.category.hero': "Hero",
    'tax.category.hero.hint': "First screen, main heading",
    'tax.category.features': "Features",
    'tax.category.features.hint': "Benefits and functionality",
    'tax.category.cards': "Cards",
    'tax.category.cards.hint': "Grids and card content modules",
    'tax.category.bento': "Bento",
    'tax.category.bento.hint': "Asymmetric bento-style grid",
    'tax.category.gallery': "Gallery",
    'tax.category.gallery.hint': "Images, portfolio, mosaic",
    'tax.category.logos': "Logos",
    'tax.category.logos.hint': "Row of client or brand logos",
    'tax.category.stats': "Metrics",
    'tax.category.stats.hint': "Key numbers and KPIs",
    'tax.category.testimonials': "Testimonials",
    'tax.category.testimonials.hint': "Reviews, quotes and social proof",
    'tax.category.pricing': "Pricing",
    'tax.category.pricing.hint': "Plans, tiers and comparisons",
    'tax.category.faq': "FAQ",
    'tax.category.faq.hint': "Frequently asked questions, accordion",
    'tax.category.cta': "Call to action",
    'tax.category.cta.hint': "Conversion bands",
    'tax.category.contact': "Contact",
    'tax.category.contact.hint': "Contact and lead-capture forms",
    'tax.category.map': "Map",
    'tax.category.map.hint': "Maps, locations and branches",
    'tax.category.reservations': "Table reservations",
    'tax.category.reservations.hint': "Restaurant bookings with OpenTable",
    'tax.category.menu': "Menu",
    'tax.category.menu.hint': "Restaurant dishes and prices",
    'tax.category.team': "Team",
    'tax.category.team.hint': "People, profiles and roles",
    'tax.category.steps': "Process",
    'tax.category.steps.hint': "Steps, timeline, how it works",
    'tax.category.content': "Content",
    'tax.category.content.hint': "Rich text, articles",
    'tax.category.about': "About",
    'tax.category.about.hint': "Our story: paragraphs and photos",
    'tax.category.comparison': "Comparison",
    'tax.category.comparison.hint': "Side-by-side tables and comparisons",
    'tax.category.banner': "Banner",
    'tax.category.banner.hint': "Announcement and promo bars",
    'tax.category.blog': "Blog",
    'tax.category.blog.hint': "Lists of posts and news",
    'tax.category.commerce': "Products",
    'tax.category.commerce.hint': "Product cards and listings",
    'tax.category.footer': "Footer",
    'tax.category.footer.hint': "Closing links and legal",
    'tax.layout.stack': "Stacked",
    'tax.layout.stack.hint': "Items in one centered column",
    'tax.layout.grid': "Grid",
    'tax.layout.grid.hint': "Uniform grid of cells",
    'tax.layout.columns': "Columns",
    'tax.layout.columns.hint': "Several side-by-side columns",
    'tax.layout.split': "Split",
    'tax.layout.split.hint': "Text on one side, media on the other",
    'tax.layout.carousel': "Carousel",
    'tax.layout.carousel.hint': "Horizontal slider",
    'tax.layout.masonry': "Masonry",
    'tax.layout.masonry.hint': "Uneven heights, masonry style",
    'tax.layout.list': "List",
    'tax.layout.list.hint': "Stacked rows",
    'tax.layout.table': "Table",
    'tax.layout.table.hint': "Grid with rows and columns",
    'tax.layout.overlay': "Overlay",
    'tax.layout.overlay.hint': "Text over image or video",
    'tax.columns.1': "1 column",
    'tax.columns.1.hint': "A single column",
    'tax.columns.2': "2 columns",
    'tax.columns.2.hint': "Two per row",
    'tax.columns.3': "3 columns",
    'tax.columns.3.hint': "Three per row",
    'tax.columns.4': "4 columns",
    'tax.columns.4.hint': "Four per row",
    'tax.columns.5': "5 columns",
    'tax.columns.5.hint': "Five per row",
    'tax.columns.6': "6 columns",
    'tax.columns.6.hint': "Six per row",
    'tax.columns.auto': "Auto",
    'tax.columns.auto.hint': "Columns to fit the content",
    'tax.style.minimal': "Minimal",
    'tax.style.minimal.hint': "Clean, plenty of white space",
    'tax.style.modern': "Modern",
    'tax.style.modern.hint': "Contemporary and balanced",
    'tax.style.bold': "Bold",
    'tax.style.bold.hint': "High contrast, large type",
    'tax.style.elegant': "Elegant",
    'tax.style.elegant.hint': "Refined and understated",
    'tax.style.playful': "Playful",
    'tax.style.playful.hint': "Bright colors, soft shapes",
    'tax.style.corporate': "Corporate",
    'tax.style.corporate.hint': "Serious and professional",
    'tax.style.editorial': "Editorial",
    'tax.style.editorial.hint': "Typographic, magazine-like",
    'tax.style.glass': "Glass",
    'tax.style.glass.hint': "Translucent surfaces",
    'tax.colorScheme.light': "Light",
    'tax.colorScheme.light.hint': "Light background",
    'tax.colorScheme.dark': "Dark",
    'tax.colorScheme.dark.hint': "Dark background",
    'tax.colorScheme.muted': "Muted",
    'tax.colorScheme.muted.hint': "Soft grey background",
    'tax.colorScheme.gradient': "Gradient",
    'tax.colorScheme.gradient.hint': "Gradient background",
    'tax.colorScheme.image': "Image",
    'tax.colorScheme.image.hint': "Image or video background",
    'tax.media.none': "No media",
    'tax.media.none.hint': "Text only",
    'tax.media.icon': "Icons",
    'tax.media.icon.hint': "Illustrative icons",
    'tax.media.image': "Images",
    'tax.media.image.hint': "Photographs or illustrations",
    'tax.media.video': "Video",
    'tax.media.video.hint': "Video content",
    'tax.media.avatar': "Avatars",
    'tax.media.avatar.hint': "Photos of people",
    'tax.media.logo': "Logos",
    'tax.media.logo.hint': "Brands and logotypes",
    'tax.goal.conversion': "Convert",
    'tax.goal.conversion.hint': "Push toward the action",
    'tax.goal.trust': "Trust",
    'tax.goal.trust.hint': "Social proof and credibility",
    'tax.goal.education': "Educate",
    'tax.goal.education.hint': "Explain how it works",
    'tax.goal.capture': "Capture",
    'tax.goal.capture.hint': "Collect the visitor's details",
    'tax.goal.showcase': "Showcase",
    'tax.goal.showcase.hint': "Display work or products",
    'tax.bestFor.general': "Any business",
    'tax.bestFor.general.hint': "Works for any kind of business",
    'tax.bestFor.saas': "Software & apps",
    'tax.bestFor.saas.hint': "Digital products, SaaS, apps",
    'tax.bestFor.agency': "Agency & studio",
    'tax.bestFor.agency.hint': "Marketing, design and dev agencies",
    'tax.bestFor.consulting': "Professional services",
    'tax.bestFor.consulting.hint': "Consulting, legal, accounting",
    'tax.bestFor.ecommerce': "Online store",
    'tax.bestFor.ecommerce.hint': "Shops and product catalogs",
    'tax.bestFor.restaurant': "Food & drink",
    'tax.bestFor.restaurant.hint': "Restaurants, cafés, bakeries",
    'tax.bestFor.health': "Health & clinics",
    'tax.bestFor.health.hint': "Clinics, dentists, therapists",
    'tax.bestFor.wellness': "Beauty & wellness",
    'tax.bestFor.wellness.hint': "Salons, spas, beauty",
    'tax.bestFor.fitness': "Fitness & sports",
    'tax.bestFor.fitness.hint': "Gyms, trainers, studios",
    'tax.bestFor.education': "Courses & education",
    'tax.bestFor.education.hint': "Courses, schools, coaching",
    'tax.bestFor.realestate': "Real estate",
    'tax.bestFor.realestate.hint': "Agents, properties, rentals",
    'tax.bestFor.finance': "Finance",
    'tax.bestFor.finance.hint': "Fintech, banking, insurance",
    'tax.bestFor.creator': "Creator & personal brand",
    'tax.bestFor.creator.hint': "Creators, speakers, coaches",
    'tax.bestFor.portfolio': "Portfolio & creative",
    'tax.bestFor.portfolio.hint': "Photographers, designers, artists",
    'tax.bestFor.events': "Events & weddings",
    'tax.bestFor.events.hint': "Events, venues, weddings",
    'tax.bestFor.hospitality': "Travel & hospitality",
    'tax.bestFor.hospitality.hint': "Hotels, tours, rentals",
    'tax.bestFor.trades': "Home services & trades",
    'tax.bestFor.trades.hint': "Construction, cleaning, repair",
    'tax.bestFor.nonprofit': "Nonprofit & community",
    'tax.bestFor.nonprofit.hint': "Charities, churches, communities",
    'tax.blockType.feature-card': "Feature card",
    'tax.blockType.feature-card.hint': "Icon, title and text",
    'tax.blockType.pricing-tier': "Pricing tier",
    'tax.blockType.pricing-tier.hint': "A plan column",
    'tax.blockType.testimonial': "Testimonial",
    'tax.blockType.testimonial.hint': "A quote with its author",
    'tax.blockType.faq-item': "Question",
    'tax.blockType.faq-item.hint': "A question and answer row",
    'tax.blockType.stat': "Metric",
    'tax.blockType.stat.hint': "A number with its label",
    'tax.blockType.team-member': "Member",
    'tax.blockType.team-member.hint': "A person with their role",
    'tax.blockType.step': "Step",
    'tax.blockType.step.hint': "A numbered step of the process",
    'tax.blockType.gallery-item': "Gallery item",
    'tax.blockType.gallery-item.hint': "An image in the mosaic",
    'tax.blockType.logo': "Logo",
    'tax.blockType.logo.hint': "A brand logotype",
    'tax.blockType.nav-link': "Menu link",
    'tax.blockType.nav-link.hint': "A navigation item",
    'tax.blockType.form-field': "Form field",
    'tax.blockType.form-field.hint': "A form input",
    'tax.blockType.accordion-item': "Accordion item",
    'tax.blockType.accordion-item.hint': "A collapsible row",
    'toolbar.duplicate': "Duplicate",
    'toolbar.openLinkedPage': "Open “{page}” in the editor",
    'toolbar.goToSection': "Go to section",
    'toolbar.lock': "Lock",
    'toolbar.saveAsSection': "Save as a section",
    'toolbar.copyStyle': "Copy style",
    'toolbar.pasteStyle': "Paste style",
    'toolbar.resetSettings': "Reset settings",
    'toolbar.delete': "Delete",
    'toolbar.size': "Size",
    'toolbar.borderColor': "Border color",
    'border.width': "Width",
    'toolbar.borderWidth': "Border width",
    'toolbar.cornerRadius': "Corner radius",
    'toolbar.textStyle': "Global text style",
    'toolbar.color': "Color",
    'toolbar.align': "Align",
    'toolbar.buttonStyle': "Global button style",
    'toolbar.appearance': "Appearance",
    'toolbar.layoutGroup': "Layout",
    'toolbar.border': "Border",
    'toolbar.corners': "Corners",
    'toolbar.background': "Background",
    'toolbar.textColor': "Text color",
    'toolbar.adjust': "Size & fit",
    'toolbar.fitHeading': "Fit",
    'img.fitWhole': "Whole",
    'toolbar.noBorder': "No border",
    'toolbar.fit': "Fit",
    'toolbar.iconStyle': "Global icon style",
    'toolbar.icon': "Icon",
    'toolbar.logoStyle': "Global logo style",
    'toolbar.sectionStyle': "Global section style",
    'toolbar.cardStyle': "Global card style",
    'toolbar.spacing': "Spacing",
    'toolbar.verticalSpacing': "Vertical spacing",
    'toolbar.horizontalSpacing': "Horizontal spacing",
    'toolbar.gap': "Gap",
    'toolbar.columns': "Columns",
    'toolbar.link': "Link",
    'toolbar.cms': "Content (CMS)",
    'toolbar.cmsBlog': "Content (Blog)",
    'toolbar.cmsOffer': "Content (Offer)",
    'toolbar.insertInside': "Insert inside",
    'toolbar.insertAfter': "Insert after",
    'toolbar.imageSettings': "Image settings",
    'toolbar.askAi': "Ask the AI",
    'toolbar.move.up': "Move up",
    'toolbar.move.down': "Move down",
    'toolbar.move.left': "Move left",
    'toolbar.move.right': "Move right",
    'toolbar.moveUp': "Move up a row",
    'toolbar.moveDown': "Move down a row",
    'toolbar.backToTools': "Tools",
    'toolbar.short.style': "Style",
    'toolbar.short.insert': "Insert",
    'toolbar.short.more': "More",
    'toolbar.short.back': "Back",
    'toolbar.short.ai': "AI",
    'toolbar.moreActions': "More actions",
    'nav.addLink': "+ Link",
    'nav.addMega': "+ Mega menu",
    'nav.addDropdown': "+ Dropdown",
    'popover.openWith': "Open with",
    'nav.addToMenu': "Add to the menu",
    'gallery.onOpen': "On open",
    'faq.onOpen': "When it opens",
    'nav.onScroll': "On scroll",
    'navm.views': "Navigation views",
    'navm.auto.label': "Automatic",
    'navm.auto.catalog': "Catalog",
    'navm.auto.collections': "Collections",
    'navm.auto.seeAll': "See all",
    'navm.auto.desc.services': "Hire what you need.",
    'navm.auto.desc.bookings': "Book your appointment online.",
    'navm.auto.desc.digital': "Downloads and digital products.",
    'navm.auto.desc.products': "Shop our products.",
    'navm.menu': "Menu",
    'navm.bar': "Bar",
    'navm.untitled': "Untitled",
    'navm.noLink': "No link yet",
    'navm.text': "Text",
    'navm.goesTo': "Goes to",
    'navm.megaLinks': "Links",
    'navm.options': "Options",
    'navm.columns': "Columns",
    'navm.look': "Layout",
    'navm.look.mega': "Mega (wide)",
    'navm.look.list': "List",
    'navm.showIcons': "Icons and photos",
    'navm.showDescriptions': "Descriptions",
    'navm.nColumns': "{count} col.",
    'navm.newOption': "Option",
    'navm.addOption': "Add option",
    'navm.megaCount': "Mega menu · {count} links",
    'navm.optionCount': "{count} options",
    'navm.yourPages': "Your pages",
    'navm.other': "Other",
    'navm.newLink': "Link",
    'navm.addLink': "Link",
    'navm.add': "Add to menu",
    'navm.style': "Style",
    'navm.newTab': "Open in a new tab",
    'navm.addButtonItem': "Button",
    'navm.ctaDefault': "Get started",
    'navm.pick.link.hint': "To a page, section or another website",
    'navm.pick.button.hint': "Highlight an action, like booking or buying",
    'navm.pick.dropdown': "Dropdown menu",
    'navm.pick.dropdown.hint': "Group several links under one name",
    'navm.pick.mega': "Mega menu",
    'navm.pick.mega.hint': "Columns of links with descriptions",
    'menuf.sections': "On this page",
    'menuf.section': "Section",
    'menuf.onThisPage': "Section of this page",
    'menuf.choose': "Choose where it goes",
    'footm.views': "Footer views",
    'footm.columns': "Columns",
    'footm.legal': "Legal",
    'footm.brand': "Brand",
    'footm.brandDetail': "Logo and description",
    'footm.description': "Description",
    'footm.logoHint': "The logo comes from your style and always links to the home page.",
    'footm.title': "Title",
    'footm.links': "Links",
    'footm.linkCount': "{count} links",
    'footm.addColumn': "Add column",
    'footm.newColumn': "New column",
    'footm.addLink': "Add link",
    'footm.copyright': "Copyright text",
    'footm.legalLinks': "Legal links",
    'nav.layout': "Shape",
    'nav.layout.full': "Full",
    'nav.layout.floating': "Floating",
    'nav.layout.pill': "Pill",
    'nav.inset': "Spacing",
    'nav.overlay': "Over content",
    'nav.scrollBlur': "Blur",
    'gallery.onClick': "On click",
    'countdown.onEnd': "When it ends",
    'slider.autoplay': "Autoplay",
    'carousel.advance': "Advance",
    'list.moveDown': "Move down",
    'widget.block': "Block",
    'cms.field': "Field",
    'reviews.metaPlaceholder': "Role, city or date",
    'widget.carousel': "Interactive carousel",
    'nav.collapseAt': "Collapses at",
    'cms.collection': "Collection",
    'cms.collectionLocked': "Set by this page: only its entries show here.",
    'layout.columns': "Columns",
    'widget.countdown': "Countdown",
    'slider.slides': "Slides",
    'marquee.clockwise': 'Clockwise',
    'marquee.counterclockwise': 'Counterclockwise',
    'marquee.direction': "Direction",
    'faq.design': "Design",
    'countdown.endPlaceholder': "Available now",
    'layout.arrangement': "Layout",
    'layout.direction': 'Direction',
    'layout.directionDown': 'Down',
    'layout.directionRight': 'Across',
    'layout.order': 'Order',
    'layout.orderNormal': 'Normal',
    'layout.orderReverse': 'Reversed',
    'slider.dots': "Dots",
    'countdown.day': "Day",
    'marquee.addItem': "Add card",
    'marquee.cards': "Cards",
    'marquee.axis': "Axis",
    'nav.editHint': "The logo, the text and the sub-menus are edited straight on the canvas. Select them there. Here you set the behavior.",
    'reviews.pickPhoto': "Choose a photo",
    'reviews.pickLogo': "Choose a logo",
    'faq.betweenQuestions': "Between questions",
    'reviews.stars': "Stars",
    'marquee.fade': "Fade",
    'slider.arrows': "Arrows",
    'reviews.photo': "Photo",
    'reviews.source': "Source",
    'widget.marquee': "Endless gallery",
    'countdown.time': "Time",
    'gallery.images': "Images",
    'slider.interval': "Interval",
    'faq.questionPlaceholder': "The question",
    'faq.answerPlaceholder': "The answer",
    'countdown.label': "Label",
    'faq.markerSide': "Marker side",
    'countdown.labelPlaceholder': "Launch",
    'reviews.textPlaceholder': "What they wrote",
    'reviews.sourceLogo': "Source logo",
    'slider.loop': "Loop",
    'faq.divider': "Line between questions",
    'nav.mobileMenu': "Mobile menu",
    'gallery.max': "Maximum",
    'reviews.name': "Name",
    'reviews.sourceName': "Source name",
    'cms.source': "Source",
    'tabs.panels': "Panels",
    'tabs.style.segmented': "Segmented",
    'tabs.style.pills': "Pills",
    'tabs.style.underline': "Underline",
    'tabs.style.classic': "Classic",
    'tabs.style.previewFirst': "Monthly",
    'tabs.style.previewSecond': "Annual",
    'marquee.pause': "Pause",
    'widget.tabs': "Tabs",
    'widget.popover': "Popover",
    'reviews.perRow': "Per row",
    'carousel.position': "Position",
    'faq.questionAndMarker': "Question and marker",
    'faq.questions': "Questions",
    'popover.presentation': "Presentation",
    'gallery.ratio': "Ratio",
    'nav.currentPage': "Current page",
    'list.remove': "Remove",
    'image.remove': "Remove the image",
    'reviews.clampTo': "Clamp to",
    'reviews.reviews': "Reviews",
    'tabs.selectOnCanvas': "Select it on the canvas",
    'faq.marker': "Marker",
    'carousel.snap': "Snap",
    'carousel.items': "Cards",
    'carousel.itemsCount': "{count} in the rail",
    'carousel.itemN': "Card {n}",
    'carousel.addCard': "Add card",
    'carousel.addImages': "Add photos",
    'carousel.perView': "Visible at once",
    'nav.sticky': "Sticky",
    'list.moveUp': "Move up",
    'tabs.tabs': "Tabs",
    'faq.markerSize': "Marker size",
    'slider.controls': "Arrows and dots",
    'slider.controlsInside': "Over the card",
    'slider.controlsOutside': "Outside the card",
    'slider.slideN': "Slide {n}",
    'slider.moveUp': "Move up",
    'slider.moveDown': "Move down",
    'slider.duplicate': "Duplicate",
    'slider.remove': "Delete",
    'slider.transition': "Transition",
    'countdown.units': "Units",
    'marquee.shape': "Shape",
    'marquee.shape.line': "Line",
    'marquee.shape.wheel': "Wheel",
    'marquee.shape.orbit': "Circle",
    'marquee.gap': "Spacing",
    'marquee.cardWidth': "Card width",
    'marquee.curve': "Curve",
    'marquee.clip': "Clip to section",
    'marquee.clipInfo': "Cuts the cards at the edge of the section, not the block: they follow the curve all the way down without spilling into the next section.",
    'marquee.speed': "Speed",
    'list.moveUpNamed': "Move {name} up",
    'list.moveDownNamed': "Move {name} down",
    'list.removeNamed': "Remove {name}",
    'faq.addQuestion': "Add a question",
    'reviews.add': "Add a review",
    'slider.next': "Next",
    'slider.add': "Add",
    'tabs.addPanel': "Add a panel",
    'faq.cmsHint': "To unlink it, select it on the canvas and use the CMS button.",
    'faq.cmsBoth': "The question and the answer both come from the CMS.",
    'faq.cmsQuestion': "The question comes from the CMS; the answer is the one written here.",
    'faq.cmsAnswer': "The answer comes from the CMS; the question is the one written here.",
    'faq.startsOpen': "Starts open",
    'gallery.pickImages': "Choose images",
    'gallery.imagesCount': "{count} images",
    'gallery.imageOne': "1 image",
    'reviews.one': "1 review",
    'opt.bottom': "Bottom",
    'opt.atEnd': "At the end",
    'opt.atStart': "At the start",
    'opt.appears': "Appears",
    'opt.top': "Top",
    'opt.sidebar': "Sidebar",
    'opt.change': "Change",
    'opt.carousel': "Carousel",
    'opt.center': "Center",
    'faq.closeOthers': "Close the others",
    'opt.click': "Click",
    'opt.compact': "Compact",
    'opt.withLine': "With a line",
    'opt.crossfade': "Crossfade",
    'opt.square': "Square",
    'faq.keepOpen': "Leave them open",
    'opt.right': "Right",
    'opt.slide': "Slide",
    'opt.dropdown': "Dropdown",
    'opt.expandBelow': "Expand below",
    'opt.fade': "Fade",
    'opt.days': "Days",
    'opt.chooseFem': "Choose one",
    'opt.chooseMasc': "Choose one",
    'opt.slideIn': "Slides in",
    'opt.arrow': "Arrow",
    'opt.background': "Background",
    'opt.hours': "Hours",
    'opt.horizontal': "Horizontal",
    'opt.horizontal43': "Landscape (4:3)",
    'opt.hover': "Hover",
    'opt.left': "Left",
    'opt.eachImage': "Each image’s own",
    'opt.underline': "Underline",
    'opt.minutes': "Min",
    'gallery.myImages': "My images",
    'gallery.offerImages': "Offer photos",
    'gallery.showAll': "Show all (grid)",
    'gallery.rail': "Rail with arrows",
    'gallery.skip': "Skip first photos",
    'opt.modal': "Modal",
    'opt.plus': "Plus (+)",
    'opt.mobile': "Mobile",
    'opt.nothing': "Nothing",
    'opt.noneMasc': "None",
    'opt.no': "No",
    'opt.doNothing': "Do nothing",
    'opt.hide': "Hide",
    'opt.other': "Other…",
    'opt.drawer': "Side panel",
    'opt.fullscreen': "Full screen",
    'opt.screenFull': "Screen",
    'opt.popup': "Popup",
    'opt.page': "Page",
    'tabs.removePanel': "Remove this panel and its button",
    'opt.grid': "Grid",
    'opt.seconds': "Sec",
    'opt.noAnimation': "No animation",
    'slider.noSlides': "No slides",
    'opt.noLine': "No line",
    'reviews.noRating': "No rating",
    'opt.yes': "Yes",
    'opt.tablet': "Tablet",
    'opt.card': "Card",
    'opt.highlightedText': "Highlighted text",
    'gallery.cmsField': "A CMS field",
    'gallery.cmsChooseCollection': "Choose a collection",
    'gallery.cmsChooseCollectionBody': "This gallery shows the photos of a CMS collection. Pick which one.",
    'gallery.cmsChooseField': "Choose a field",
    'gallery.cmsChooseFieldBody': "Pick the image field whose photos this gallery shows.",
    'gallery.cmsOpenSettings': "Open settings",
    'gallery.offer': "Offer",
    'gallery.pageOffer': "This page's offer",
    'gallery.chooseOffer': "Choose an offer",
    'gallery.chooseOfferBody': "This gallery shows an offer's photos. Pick which one.",
    'opt.stacked': "Stacked",
    'tabs.needOnePanel': "Tabs need at least one panel",
    'gallery.lightbox': "Open it large",
    'opt.vertical': "Vertical",
    'opt.vertical34': "Portrait (3:4)",
    'reviews.count': "{count} reviews",
    'reviews.untitled': "Review {n}",
    'slider.position': "{current} of {total}",
    'panels.backToStyles': "Back to Styles",
    'panels.globalEditor': "Global editor",
    'panels.scrollLeft': "Scroll left",
    'panels.scrollRight': "Scroll right",
    'panels.inUse': "In use",
    'common.default': "Default",
    'type.weight': "Weight",
    'type.align': "Alignment",
    'type.uppercase': "Uppercase",
    'common.style': "Style",
    'type.italic': "Italic",
    'type.underline': "Underline",
    'type.strikethrough': "Strikethrough",
    'type.font': "Font",
    'type.textColor': "Text color",
    'type.textSize': "Text size",
    'box.paddingY': "Vertical padding",
    'box.paddingX': "Horizontal padding",
    'box.background': "Background",
    'box.border': "Border",
    'box.borderOpacity': "Border opacity",
    'box.allSides': "All",
    'opt.rightFull': "Right",
    'opt.leftFull': "Left",
    'box.radius': "Radius",
    'box.shadow': "Shadow",
    'box.shadowBlur': "Shadow blur",
    'box.shadowX': "Shadow X",
    'box.shadowY': "Shadow Y",
    'box.spacing': "Spacing",
    'nav.identity': "Identity",
    'common.type': "Type",
    'nav.company': "Company",
    'image.alt': "Image alt text",
    'panels.visualStyle': "Visual style",
    'common.color': "Color",
    'nav.items': "Items",
    'nav.separator': "Separator",
    'nav.showCta': "Show the CTA",
    'common.text': "Text",
    'common.link': "Link",
    'nav.inheritsFromButtons': "Inherited from Components → Buttons",
    'nav.background': "Nav background",
    'common.image': "Image",
    'image.url': "Image URL",
    'nav.transparency': "Transparency",
    'panels.behavior': "Behavior",
    'footer.legalSocial': "Legal and social",
    'footer.copyright': "Copyright",
    'footer.social': "Social links",
    'common.logo': "Logo",
    'common.content': "Content",
    'form.required': "Required",
    'form.control': "Control",
    'form.accent': "Accent",
    'common.size': "Size",
    'icon.library': "Library",
    'icon.stroke': "Stroke",
    'box.box': "Box",
    'image.view': "Image view",
    'image.focus': "Focus",
    'image.frameCrop': "Frame & crop",
    'image.aspectRatio': "Aspect ratio",
    'image.shape': "Shape",
    'image.shapeAuto': "Automatic",
    'image.shapeAutoHint': "The photo's own",
    'image.shapeFill': "Fill the space",
    'image.shapeFillHint': "Its box's height",
    'image.shapeVertical': "Vertical",
    'image.shapeHorizontal': "Horizontal",
    'image.fit': "Fit",
    'image.fitCrop': "Crop to fill",
    'image.fitShowWhole': "Show whole",
    'size.hintAuto': "Takes whatever its box allows.",
    'size.hintColumns': "How many grid columns it spans.",
    'size.hintManual': "A share of its box's width.",
    'image.ratioCurrent': "Current",
    'image.ratioOriginal': "Original",
    'image.ratioUnconstrained': "Free",
    'image.ratioFree': "Remove ratio",
    'veil.title': "Overlay",
    'veil.style': "Style",
    'bg.anchoredLabel': "Background",
    'bg.colorFromStyle': "The color comes from this block’s style. The background photo and video can be changed here.",
    'bg.advancedLayers': "Advanced layers",
    'bg.imageRow': "Background image",
    'bg.imageOff': "Off",
    'bg.autoCover': "Automatic",
    'bg.backToAuto': "Back to automatic photo",
    'veil.none': "None",
    'veil.bottom': "Bottom shade",
    'veil.even': "Even veil",
    'veil.edges': "Top and bottom",
    'veil.tint': "Brand tint",
    'veil.gradient': "Gradient",
    'veil.strength': "Strength",
    'veil.strengthTo': "End strength",
    'veil.color': "Color",
    'veil.colors': "Colors",
    'veil.from': "From",
    'veil.to': "To",
    'veil.direction': "Direction",
    'veil.start': "Starts at",
    'veil.band': "Band width",
    'veil.edges.vertical': "Top and bottom",
    'veil.edges.sides': "Sides",
    'veil.remove': "Remove overlay",
    'veil.dir.down': "Downwards",
    'veil.dir.up': "Upwards",
    'veil.dir.right': "To the right",
    'veil.dir.left': "To the left",
    'veil.dir.radial': "From the center",
    'image.ratio.square': "Square",
    'image.ratio.portrait': "Portrait",
    'image.ratio.classicTall': "Classic tall",
    'image.ratio.photoTall': "Photo tall",
    'image.ratio.story': "Story",
    'image.ratio.classic': "Classic",
    'image.ratio.photo': "Photo",
    'image.ratio.wide': "Widescreen",
    'image.ratio.cinema': "Cinema",
    'image.ratioHint': "The frame's shape on the page. The sizes are an example for exporting the photo at that shape.",
    'image.cropReposition': "Crop & reposition",
    'image.crop': "Crop",
    'image.cropHint': "Drag the photo inside the frame. Use zoom to adjust the crop.",
    'image.cropZoom': "Zoom",
    'image.cropReset': "Reset crop",
    'image.cropApply': "Apply",
    'preview.card': "Card preview",
    'card.surface': "Surface",
    'preview.testimonial': "Testimonial preview",
    'preview.badge': "Badge preview",
    'footer.rights': "© 2026 Veltica. All rights reserved.",
    'border.solid': "Solid",
    'border.dashed': "Dashed",
    'border.dotted': "Dotted",
    'border.center': "Center",
    'border.inside': "Inside",
    'border.outside': "Outside",
    'box.shadowSpread': "Spread",
    'common.preview': "Preview",
    'icon.set': "Set",
    'badge.dot': "Dot",
    'badge.uppercase': "Uppercase",
    'nav.shrinkOnScroll': "Shrink on scroll",
    'card.hoverLift': "Lift on hover",
    'testimonial.autoplay': "Auto-advance",
    'type.addStyle': "Add a style",
    'panels.moreOptions': "More options",
    'badge.new': "New",
    'border.none': "None",
    'type.sansModern': "Sans / Modern",
    'type.script': "Script",
    'type.serifClassic': "Serif / Classic",
    'type.uppercaseSample': "UPPERCASE",
    'type.lowercaseSample': "lowercase",
    'type.capitalize': "Capitalize",
    'type.noTransform': "No transform",
    'nav.sampleHome': "Home",
    'nav.sampleServices': "Services",
    'nav.sampleAbout': "About",
    'nav.sampleContact': "Contact",
    'nav.sampleCta': "Get started",
    'cmp.overrides': "{count} overrides",
    'cmp.overrideOne': "1 override",
    'filter.all': "All",
    'filter.modern': "Modern",
    'filter.elegant': "Elegant",
    'filter.warm': "Warm",
    'filter.dark': "Dark",
    'logo.altDefault': "Company logo",
    'logo.footerAlt': "Footer logo",
    'footer.colCompany': "Company",
    'footer.colProduct': "Product",
    'footer.colResources': "Resources",
    'footer.colLegal': "Legal",
    'footer.sampleLinks': "Link 1\\nLink 2\\nLink 3",
    'bp.desktop': 'Desktop',
    'bp.tablet': 'iPad',
    'bp.mobile': 'Mobile',
    'bp.editingFor': "Editing for",
    'form.errorLabel': "Error",
    'type.lowercase': "lowercase",
    'cmp.components': "Components",
    'logo.typeText': "Text",
    'logo.typeImage': "Image",
    'form.label': "Label",
    'el.section': "Section",
    'el.bloque': "Block",
    'el.texto': "Text",
    'el.titulo-destacado': "Display heading",
    'el.imagen': "Image",
    'el.icono': "Icon",
    'el.badge': "Badge",
    'el.rating': "Rating",
    'el.avatares': "Avatars",
    'el.stat': "Stat",
    'el.boton': "Button",
    'el.link': "Link",
    'el.navegacion': "Navigation",
    'el.marca': "Brand",
    'el.logo-marca': "Brand mark",
    'el.nombre-de-marca': "Brand name",
    'el.menu-principal': "Main menu",
    'el.acciones-de-navegacion': "Nav actions",
    'el.boton-primario': "Primary button",
    'el.seccion-hero': "Hero section",
    'el.contenido-hero': "Hero content",
    'el.etiqueta-hero': "Hero eyebrow",
    'el.titulo-principal': "Main heading",
    'el.parrafo-hero': "Hero paragraph",
    'el.botones-hero': "Hero buttons",
    'el.boton-secundario': "Secondary button",
    'el.prueba-social': "Social proof",
    'el.rating-hero': "Hero rating",
    'el.texto-de-prueba-social': "Social proof text",
    'el.visual-hero': "Hero visual",
    'el.efecto-visual': "Visual effect",
    'el.imagen-hero': "Hero image",
    'el.tarjeta-metrica': "Metric card",
    'el.seccion-servicios': "Services section",
    'el.encabezado-servicios': "Services heading",
    'el.etiqueta-servicios': "Services eyebrow",
    'el.titulo-servicios': "Services heading",
    'el.grid-de-servicios': "Services grid",
    'el.seccion-cta': "CTA section",
    'el.bloque-cta': "CTA block",
    'el.contenido-cta': "CTA content",
    'el.titulo-cta': "CTA heading",
    'el.parrafo-cta': "CTA paragraph",
    'el.boton-cta': "CTA button",
    'el.footer': "Footer",
    'el.seccion': "Section",
    'el.titulo-1': "Heading 1",
    'el.titulo-2': "Heading 2",
    'el.titulo-3': "Heading 3",
    'el.titulo-4': "Heading 4",
    'el.titulo-5': "Heading 5",
    'el.titulo-6': "Heading 6",
    'el.parrafo': "Paragraph",
    'el.etiqueta': "Eyebrow",
    'el.tarjeta': "Card",
    'panels.nothingSelected': "Nothing selected",
    'panels.clickAnElement': "Click an element on the canvas.",
    'panels.propGroups': "Property groups",
    'panels.aiAssistant': "AI assistant",
    'panels.switchToSimple': "Switch to the simple mode",
    'panels.simpleMode': "Simple mode",
    'panels.simpleModeHint': "Context bar, no inspector.",
    'panels.globalStyle': "Global style",
    'panels.manyElements': "{count} elements",
    'el.pagina': "Page",
    'cms.openInEditorLong': "Open in the editor",
    'cms.actions': "Actions",
    'cms.bulkActions': "Actions on the selection",
    'cms.addImagesHint': "Add one or more images to this content",
    'cms.addField': "Add a property",
    'cms.seoSettings': "SEO settings",
    'cms.pageSettings': "Page settings",
    'cms.previous': "Previous",
    'cms.dragField': "Drag to move the field",
    'cms.dragColumn': "Drag to move the column",
    'cms.ascending': "Ascending",
    'cms.add': "Add",
    'cms.addOrChangeImages': "Add or change images",
    'cms.search': "Search",
    'cms.searchCollection': "Search the collection",
    'cms.searchOrCreateCategory': "Search or create a category",
    'cms.searchOrCreateOption': "Search or create an option",
    'cms.rename': "Rename",
    'cms.changeIconColor': "Change the icon and color",
    'cms.fieldDuplicated': "Field duplicated",
    'cms.fieldDeleted': "Field deleted",
    'cms.categoryDeleted': "Category deleted",
    'cms.closePanel': "Close the panel",
    'cms.collections': "Collections",
    'cms.contentCollections': "Content",
    'cms.color': "Color",
    'cms.hiddenColumns': "Hidden columns",
    'cms.copyId': "Copy the ID",
    'cms.createFirst': "Create the first one to get going.",
    'cms.created': "Created",
    'cms.create': "Create",
    'cms.descending': "Descending",
    'cms.postDetail': "Post detail",
    'cms.duplicate': "Duplicate",
    'cms.editCollection': "Edit the collection",
    'cms.pickDate': "Choose a date",
    'cms.itemCreated': "CMS item created",
    'cms.itemDuplicated': "CMS item duplicated",
    'cms.itemDeleted': "CMS item deleted",
    'cms.itemSaved': "CMS item saved",
    'cms.itemToDraft': "CMS item moved to draft",
    'cms.itemPublished': "CMS item published",
    'cms.inDraft': "Item in draft",
    'cms.isPublished': "Item published",
    'cms.writeContent': "Write the post’s content…",
    'cms.invalidLink': "Enter a valid link",
    'cms.cannotUndo': "This cannot be undone.",
    'cms.status': "Status",
    'cms.publishStatus': "Publish status",
    'cms.date': "Date",
    'cms.filters': "Filters",
    'cms.finish': "Finish",
    'cms.saved': "Saved",
    'cms.clickToEdit': "Click to edit",
    'cms.time': "Time",
    'cms.endTime': "End time",
    'cms.startTime': "Start time",
    'cms.idCopied': "Collection ID copied",
    'cms.collectionIconColor': "Collection icon and color",
    'cms.image': "Image",
    'cms.insert': "Insert",
    'cms.insertImage': "Insert an image",
    'cms.insertLink': "Insert a link",
    'cms.insertYouTube': "Insert a YouTube video",
    'cms.urlRequired': "The URL cannot be empty",
    'cms.countryCode': "Country code",
    'cms.clear': "Clear",
    'cms.list': "List",
    'cms.modified': "Modified",
    'cms.showLess': "Show less",
    'cms.showFewerImages': "Show fewer images",
    'cms.showAll': "Show all",
    'cms.bold': "Bold",
    'cms.idCopyFailed': "The ID could not be copied",
    'cms.linkCopyFailed': "The link could not be copied",
    'cms.name': "Name",
    'cms.columnName': "Column name",
    'cms.fieldNameOrType': "Property name or type",
    'cms.newPost': "New post",
    'pgnav.collectionOwnDesign': 'Own',
    'designs.collectionScope': 'Apply to',
    'designs.collectionScope.all': 'All',
    'designs.collectionScope.one': 'Only “{name}”',
    'designs.collectionUseShared': 'Use the shared design',
    'designs.collectionOwnHint': '“{name}” has its own design: changes here only affect it.',
    'cms.cardLook': "Cards",
    'cms.direction': "Direction",
    'cms.fieldOf': "Field of {name}",
    'cms.fieldMissing': "Field not in this collection · pick another",
    'schedule.always': "Always",
    'cms.tab.items': "Items",
    'cms.tab.content': "Content",
    'cms.tab.design': "Design",
    'cms.which': "Which",
    'cms.which.latest': "Most recent",
    'cms.which.manual': "Pick by hand",
    'cms.which.picked': "Picked",
    'cms.which.pickedCount': "{n} picked · change",
    'cms.order.newest': "Newest first",
    'cms.order.oldest': "Oldest first",
    'cms.order.az': "A → Z",
    'cms.order.za': "Z → A",
    'cms.order.byDateNew': "{name}: newest first",
    'cms.order.byDateOld': "{name}: oldest first",
    'cms.onlyPublished': "Published only",
    'cms.noDesignHere': "This list has no cards to design.",
    'cms.pick.title': "Pick from {name}",
    'cms.pick.search': "Search by title…",
    'cms.pick.published': "Published",
    'cms.pick.empty': "This collection has no entries yet.",
    'cms.sortCreated': "Date created",
    'cms.blogField.title': "Title",
    'cms.blogField.excerpt': "Excerpt",
    'cms.blogField.image': "Cover",
    'cms.blogField.content': "Content",
    'cms.blogField.author': "Author",
    'cms.blogField.date': "Date",
    'cms.blogField.categories': "Categories",
    'cms.blogField.readingTime': "Reading time",
    'cms.blogField.authorAvatar': "Author photo",
    'cms.blogField.slug': "Address (slug)",
    'cms.cardColumnsAuto': "From design",
    'cms.cardAlignAuto': "From design",
    'cms.listSettings': "List settings",
    'cms.newEntry': "New entry",
    'cms.phoneNumber': "Phone number",
    'cms.fieldOptions': "Property options",
    'cms.moveToDraft': "Move to draft",
    'cms.pasteCode': "Paste HTML, CSS or JavaScript",
    'cms.pasteVideoHint': "Paste the video link and it will be embedded as a player.",
    'cms.pasteYouTube': "Paste the YouTube URL",
    'cms.pasteImageUrl': "Paste the image URL",
    'cms.postDuplicated': "Post duplicated",
    'cms.posts': "Posts",
    'cms.primary': "Primary",
    'cms.fieldAdded': "Property added",
    'cms.fieldAddedImage': "Property added. The image feeds the row thumbnail.",
    'cms.fieldDuplicatedToast': "Property duplicated",
    'cms.fieldDeletedToast': "Property deleted",
    'cms.tryAnotherSearch': "Try other words or another filter.",
    'cms.publish': "Publish",
    'cms.clearSelection': "Clear the selection",
    'cms.hiddenInTable': "Hidden in the table",
    'cms.pickOrCreate': "Select or create a collection.",
    'cms.pickCollection': "Select a collection",
    'cms.selectAllVisible': "Select everything visible",
    'cms.next': "Next",
    'cms.noDate': "No date",
    'cms.noPosts': "No posts",
    'cms.noResults': "No results",
    'cms.noContentYet': "No content yet.",
    'cms.all': "All",
    'cms.imageUrl': "Image URL",
    'cms.urlOrPath': "URL or /path",
    'cms.empty': "Empty",
    'cms.deletePostConfirm': "Delete this post?",
    'cms.deleteCollectionLead': "The collection will be deleted along with its",
    'cms.deleteCollectionTail': "(listing and detail). This cannot be undone.",
    'cms.sitePages': "site pages",
    'cms.categories': "categories",
    'cms.images': "images",
    'cms.changes': "changes",
    'cms.createCollection': "Create a collection",
    'cms.createNew': "Create new",
    'cms.duplicateField': "Duplicate the field",
    'cms.duplicateProperty': "Duplicate the property",
    'cms.editInRecord': "Edit in the record",
    'cms.deleteField': "Delete the field",
    'cms.deleteProperty': "Delete the property",
    'cms.insertRight': "Insert to the right",
    'cms.insertLeft': "Insert to the left",
    'cms.hideColumn': "Hide the column",
    'cms.hideInTable': "Hide in the table",
    'cms.sort': "Sort",
    'cms.emptyIt': "Clear it",
    'cms.itemOne': "item",
    'cms.itemMany': "items",
    'cms.noOptionsYet': "No {kind} yet. Type one above to create the first.",
    'cms.andMore': "and {count} more…",
    'cms.willDelete': "{count} items will be deleted:",
    'cms.willDeleteOne': "1 item will be deleted:",
    'cms.paragraph': "Paragraph",
    'cms.emptyCell': "Empty",
    'cms.showNImages': "Show all {count} images",
    'cms.manyPublished': "{count} items published",
    'cms.manyToDraft': "{count} items moved to draft",
    'cms.manyDeleted': "{count} items deleted",
    'cms.imageOne': "{count} image · Drag to reorder",
    'cms.imagesCount': "{count} images · Drag to reorder",
    'cms.seeNImages': "See all {count} images",
    'cms.manyDuplicated': "{count} items duplicated",
    'shell.backToDashboard': "Back to the dashboard",
    'shell.publishSite': "Publish the site",
    'shell.publishTemplate': "Publish the template",
    'shell.newPage': "New page",
    'shell.canvasWidth': "Canvas width",
    'shell.fitMode': "Fit mode",
    'shell.fitModeHint': "Fits the window width automatically.",
    'shell.zoomHint': "Drag to zoom · click for more options",
    'shell.zoomDesktopOnly': "Zoom is only available on desktop",
    'shell.velticaMenu': "véltica menu",
    'shell.userSettings': "User settings",
    'shell.account': "Account",
    'shell.billing': "Billing",
    'shell.signOut': "Sign out",
    'shell.editorColor': "Editor color",
    'shell.advancedOptions': "Advanced options",
    'shell.fullRightPanel': "Full panel on the right",
    'shell.advancedLargeOnly': "Large screens only",
    'shell.contextBar': "Context bar on select",
    'elements.search': "Search for an element",
    'elements.searchPlaceholder': "Search for an element…",
    'elements.type': "Element type",
    'elements.seeAll': "See all",
    'elements.seeAllElements': "See all elements",
    'elements.onlyFavorites': "See only favorites",
    'elements.onlyMyFavorites': "See only my favorites",
    'elements.noFavorites': "No favorites",
    'elements.favoritesHint': "Star any element to keep it handy here.",
    'elements.favoritesFilterHint': "Star an element to be able to filter by favorites",
    'elements.dragHint': "Drag a block onto the canvas.",
    'elements.brand': "Style",
    'elements.brandStyle': "Brand Style",
    'elements.components': "Components",
    'elements.media': "Media",
    'elements.layout': "Layout",
    'elements.interaction': "Interaction",
    'layers.expandAll': "Expand all layers",
    'layers.collapseAll': "Collapse all layers",
    'layers.empty': "No elements",
    'layers.siteNav': 'Nav',
    'layers.siteFooter': 'Footer',
    'layers.addNav': 'Add nav',
    'layers.addFooter': 'Add footer',
    'layers.hiddenHere': 'hidden on this page',
    'layers.sharedHint': 'Shared across every page',
    'layers.pageSettings': 'Page settings',
    'layers.lock': "Lock the element",
    'layers.unlock': "Unlock the element",
    'layers.show': "Show on the canvas",
    'layers.hide': "Hide from the canvas",
    'layers.boundToBlock': "Bound to the block",
    'layers.reusableHint': "Reusable section: what you change here changes on every page that uses it",
    'layers.hardcodedColor': "Uses a hard-coded color or a custom token: it will not adapt when the template is placed. Change it to a theme token (Primary, Text, and so on).",
    'search.section': "section container layout row column spacing",
    'search.div': "block box container flex stack",
    'search.grid': "grid columns rows layout",
    'search.image': "photo picture media visual",
    'search.form': "contact newsletter fields email message input",
    'search.navbar': "menu navigation header links",
    'search.footer': "footer navigation links legal",
    'search.slider': "carousel slideshow gallery slides",
    'search.cardRail': "carousel slider cards",
    'search.testimonial': "testimonial review opinion quote",
    'search.stat': "data number metric statistic",
    'search.countdown': "countdown date event launch",
    'search.embed': "code html iframe video youtube",
    'elements.text': "Text",
    'elements.forms': "Forms",
    'elements.navigation': "Navigation",
    'elements.cms': 'CMS',
    'elements.shop': "Shop",
    'elements.blog': "Blog",
    'bp.blogGrid': "Latest posts",
    'bp.blogList': "Post list",
    'bp.blogFeatured': "Featured post",
    'elements.catalog': 'Catalog',
    /* Los mandos de un bloque de catálogo; ver `CatalogGroup`. */
    'catalog.manageShort': "Manage offers",
    'contentPanel.title': "Content",
    'catalogPanel.title': "Catalog",
    'blogPanel.title': "Blog",
    'collectionsPanel.title': "Content",
    'collectionsPanel.desc': "Your CMS collections: put them on the page as a list or a single entry.",
    'collectionsPanel.emptyTitle': "No content yet",
    'collectionsPanel.emptyHint': "A collection keeps similar things (pets for adoption, projects, team) and shows them on your site in the design you choose.",
    'collectionsPanel.create': "New collection",
    'collectionsPanel.entriesTitle': "Entries",
    'collectionsPanel.editContent': "Edit content",
    'collectionsPanel.newEntry': "New entry",
    'collectionsPanel.specific': "Specific content",
    'collectionsPanel.editEntry': "Edit entry",
    'collectionsPanel.noEntries': "This collection has no entries yet.",
    'blogPanel.desc': "Your posts: drag them onto the page or press + to add them.",
    'blogPanel.viewPageHint': "All posts share the same design.",
    'blogPanel.art.cta': "Read more",
    'blogPanel.group.lists': "Post lists",
    'blogPanel.group.posts': "Posts",
    'blogPanel.layout.latest-grid': "Grid",
    'blogPanel.layout.latest-list': "List",
    'blogPanel.layout.latest-featured': "Featured and two",
    'blogPanel.layout.hero-split': "Split",
    'blogPanel.layout.hero-cover': "Background cover",
    'blogPanel.layout.hero-center': "Centered",
    'blogPanel.layout.post-card': "Card",
    'blogPanel.published': "Published",
    'blogPanel.write': "Write in the dashboard",
    'blogPanel.noDate': "No date",
    'blogPanel.new': "New post",
    'blogPanel.newHint': "You write the full text later in the dashboard.",
    'blogPanel.emptyTitle': "Share what you know",
    'blogPanel.emptyHint': "Create your first post with its title and cover. You write the text later.",
    'blogPanel.createFirst': "Create my first post",
    'blogPanel.postTitle': "Title",
    'blogPanel.titlePlaceholder': "E.g. 5 tips to get started",
    'blogPanel.excerpt': "Summary",
    'blogPanel.excerptPlaceholder': "What it's about, in one or two sentences…",
    'blogPanel.addCover': "Add cover",
    'blogPanel.previewTitle': "Your post's title",
    'blogPanel.previewExcerpt': "The summary goes here: what the post is about.",
    'blogPanel.createFailed': "Couldn't create it. Try again.",
    'blogPanel.pendingHint': "It's created as “To complete”: it isn't published until you write the text in the dashboard.",
    'blogPanel.create': "Create post",
    'bp.postCover': "Post cover",
    'bp.postDate': "Post date",
    'bp.postTitle': "Post title",
    'bp.postExcerpt': "Post summary",
    'bp.posts': "Posts",
    'bp.blogSection': "Blog",
    'bp.blogHeading': "Blog heading",
    'bp.collectionHeading': "Collection title",
    'bp.postCard': "Post card",
    'bp.postsGrid': "Posts",
    'bp.readMore': "Read more",
    'sample.latestPosts': "Latest posts",
    'sample.post.date': "March 12",
    'sample.post.title': "Post title",
    'sample.post.excerpt': "A short summary of the post.",
    'catalogPanel.yours': "Your catalog",
    'catalogPanel.yoursHint': "Your offers as sections",
    'catalogPanel.changeOffer': "Change offer",
    'catalogPanel.desc': "Your offers: drag them onto the page or press + to add them.",
    'catalogPanel.kinds': "Offer types",
    'catalogPanel.all': "All",
    'catalogPanel.kind.services': "Service",
    'catalogPanel.kind.bookings': "Booking",
    'catalogPanel.kind.digital': "Digital",
    'catalogPanel.kind.products': 'Product',
    'catalogPanel.new': "New offer",
    'catalogPanel.add': 'Add',
    'catalogPanel.listSettings': "Catalog list",
    'catalogPanel.group.offers': 'Offers',
    'catalogPanel.group.lists': "Offer lists",
    'catalogPanel.list.newest': 'Newest',
    'catalogPanel.list.bestselling': 'Best sellers',
    'catalogPanel.list.all': 'Whole catalog',
    'catalogPanel.list.free': 'Free',
    'catalogPanel.list.carousel': 'Carousel',
    'catalogPanel.list.compact': 'Compact list',
    'sample.offers.newest': 'New arrivals',
    'sample.offers.bestselling': 'Best sellers',
    'sample.offers.all': 'Our catalog',
    'sample.offers.free': 'Free',
    'sample.offers.carousel': 'Featured',
    'sample.offers.compact': 'Our offers',
    'bp.catalogHeading': 'Catalog heading',
    'catalogPanel.free': "Free",
    'catalogPanel.viewPageHint': "Every offer of this type shares the same design.",
    'catalogPanel.viewPage': "See its page in the editor",
    'catalogPanel.moreOptions': "More options",
    'catalogPanel.art.cta.services': "Learn more",
    'catalogPanel.art.cta.bookings': "Book now",
    'catalogPanel.art.cta.digital': "Get it",
    'catalogPanel.art.cta.products': "Buy now",
    'catalogPanel.live': "On sale",
    'catalogPanel.complete': "Finish in the dashboard",
    'catalogPanel.openInDashboard': "Open in the dashboard",
    'catalogPanel.layout.featured': "Featured",
    'catalogPanel.layout.card': "Card",
    'catalogPanel.layout.row': "Row",
    'catalogPanel.layout.grid': "With the rest",
    'catalogPanel.group.sections': "Sections",
    'catalogPanel.group.cards': "Cards",
    'catalogPanel.layout.hero-split': "Split",
    'catalogPanel.layout.hero-cover': "Background photo",
    'catalogPanel.layout.hero-center': "Centered",
    'catalogPanel.layout.hero-band': "Photo on the left",
    'catalogPanel.addToPage': "Add “{layout}” to the page",
    'catalogPanel.emptyTitle': "Put what you sell on your page",
    'catalogPanel.emptyHint': "Create your first offer: a service, a booking or something digital. You can finish it later.",
    'catalogPanel.name': "Name",
    'catalogPanel.namePlaceholder': "E.g. Photo session",
    'catalogPanel.quickShortPlaceholder': "A brief summary for your offer card.",
    'catalogPanel.quickLongHint': "Shown below the purchase section.",
    'catalogPanel.quickPriceHint': "0 or empty = Free",
    'catalogPanel.quickPendingHint': "Finish setup in the dashboard before selling.",
    'catalogPanel.createFailed': "Couldn't create it. Try again.",
    'catalogPanel.pendingHint': "It's created as “To complete”: it isn't sold until you finish it in the dashboard.",
    'catalogPanel.create': "Create offer",
    'catalogPanel.priceHelp': "Empty or 0 shows as free.",
    'catalogPanel.priceHelpBooking': "What each booking costs. Empty or 0 is free.",
    'catalogPanel.formTitle': "New offer",
    'catalogPanel.changeKind': "Change type",
    'catalogPanel.optional': "Optional",
    'catalogPanel.description': "Description",
    'catalogPanel.price': "Price",
    'catalogPanel.pricePerBooking': "Price per booking",
    'catalogPanel.preview': "How it will look on your page",
    'catalogPanel.previewTitle': "Your offer's name",
    'catalogPanel.previewDescription': "The description goes here: what it includes and who it's for.",
    'catalogPanel.addImage': "Add image",
    'catalogPanel.changeImage': "Change",
    'catalogPanel.removeImage': "Remove image",
    'catalogPanel.pickImage': "Choose an image",
    'catalogPanel.done': "Done",
    'catalogPanel.bookingBody': "An appointment on your calendar, with its schedule.",
    'catalogPanel.kindLead': "Pick what it is and we'll get it ready for your page. You finish it later in the dashboard.",
    'catalogPanel.descriptionPlaceholder': "What it includes, who it's for…",
    'catalogPanel.image': "Image",
    'catalogPanel.imageSource.gallery': "Gallery",
    'catalogPanel.imageSource.uploads': "My images",
    'catalogPanel.noImages': "No images for that search.",
    'catalogPanel.noOffersMatch': "No offers match that search.",
    'catalogPanel.noUploads': "You haven't uploaded images yet.",
    'catalogPanel.upload': "Upload image",
    'catalogPanel.createFirst': "Create my first offer",
    'catalog.fieldOfOffer': "Offer data",
    'catalog.linksToOffer': "Links to the offer",
    'catalog.field.title': "Name",
    'catalog.field.duration': "Duration",
    'catalog.field.cta': "Call to action",
    'catalog.field.more': "More info",
    'catalog.field.options': "Options (sizes, colors…)",
    'catalog.field.badge': "Badge (New, Sold out…)",
    'catalog.field.brand': "Brand",
    'catalog.field.compareAt': "Compare-at price (struck)",
    'catalog.field.discount': "Discount (-10%)",
    'catalog.field.stock': "Stock (3 left)",
    'catalog.field.spots': "Spots (Up to 25 people)",
    'catalog.field.with': "With (team)",
    'catalog.field.priceAmount': "Price amount only ($29)",
    'catalog.field.period': "Billing period (per month…)",
    'catalog.field.features': "What it includes (bullet list)",
    'catalog.field.type': "Type",
    'cms.offersCollection': "Offers (catalog)",
    'catalog.showing': "Showing",
    'catalog.pick.title': "Choose offers",
    'catalog.pick.count': "{n} picked · in the order you check them",
    'catalog.pick.search': "Search by name",
    'catalog.pick.all': "All",
    'catalog.pick.onlyPicked': "Picked only",
    'catalog.pick.live': "Live",
    'catalog.pick.noMatch': "Nothing matches your search.",
    'catalog.pick.clear': "Clear all",
    'catalog.pick.done': "Done",
    'catalog.pick.picked': "Picked",
    'catalog.pick.open': "Choose ({n})",
    'catalog.pickMode': "Which",
    'catalog.pickMode.auto': "Automatic",
    'catalog.pickMode.manual': "Hand-picked",
    'catalog.pickEmpty': "No offers of this type yet.",
    'catalog.pickOverLimit': "{n} picked don't fit: raise “Maximum” to show them.",
    'catalog.showingOf': "{shown} of {total}",
    'catalog.manage': "Add or edit offers in the dashboard",
    'catalog.sort.catalog': "The catalog's own",
    'catalog.sort.priceAsc': "Price, low to high",
    'catalog.sort.priceDesc': "Price, high to low",
    'catalog.sort.title': "Name",
    'catalog.sort.duration': "Duration",
    'catalog.sort.newest': 'Newest first',
    'catalog.sort.oldest': "Oldest first",
    'catalog.sort.titleAsc': "Name: A–Z",
    'catalog.sort.titleDesc': "Name: Z–A",
    'catalog.sort.bestselling': 'Best sellers',
    'catalog.sort.created': 'Date added',
    'catalog.card.none': "This list has no card to edit.",
    'catalog.card.block': "Block",
    'catalog.card.show': "Show",
    'catalog.card.hide': "Hide",
    'catalog.card.up': "Move up",
    'catalog.card.down': "Move down",
    'catalog.card.add': "Add info",
    'catalog.card.remove': "Remove",
    'catalog.card.edit': "Edit",
    'catalog.card.flatten': 'Pieces in a box',
    'catalog.card.flattenDo': 'Separate',
    'catalog.card.flattenHint': 'Takes the texts, price and buttons out of their box so each can be moved on its own on the canvas, even above the photo.',
    'catalog.card.addPick': "Choose…",
    'catalog.photos.label': "Photos",
    'catalog.photos.hint': "With several photos: what happens when you hover (on phones, swipe).",
    'catalog.photos.single': "Just one",
    'catalog.photos.hover': "Change on hover",
    'catalog.photos.scrub': "Browse",
    'catalog.price.paid': "Paid only",
    'catalog.price.free': "Free only",
    'catalog.offset': "Skip",
    'catalog.token.default': "Default",
    'catalog.cardToken': "Card",
    'catalog.titleToken': "Name",
    'catalog.bodyToken': "Description",
    'catalog.priceToken': "Price",
    'catalog.buttonToken': "Button",
    'catalog.ctaText': "Button text",
    'catalog.ctaTextAuto': "Per offer",
    'catalog.emptyText': "When empty",
    'catalog.emptyTextAuto': "Per family",
    'catalog.shows': "Shows",
    'catalog.kindLocked': 'Set by this page: only offers of its type show here.',
    'catalog.kind.all': "Whole catalog",
    'catalog.kind.bookings': "Bookings",
    'catalog.kind.digital': "Digital products",
    'catalog.kind.products': 'Physical products',
    'catalog.kind.memberships': "Memberships",
    'catalog.kind.services': "Services",
    'catalog.layout': "Layout",
    'catalog.layout.grid': "Grid",
    'catalog.layout.list': "List",
    'catalog.layout.carousel': "Carousel",
    'catalog.layout.featured': "Featured",
    'catalog.featuredOffer': "Offer",
    'catalog.featuredAutomatic': "First available",
    'catalog.columns': "Columns",
    'catalog.columnsVisible': "Visible at once",
    'catalog.limit': "Maximum",
    'catalog.collectionChips': 'Collection filters',
    'catalog.collectionChipsInfo': 'Your collections show above the list (“All · Summer · Sale”) to filter it. Create them in the dashboard under Catalog › Collections. Shown on the published site.',
    'catalog.shopFilters': 'Shop filters',
    'catalog.shopFiltersInfo': 'Above the list: sort and filter by brand, size, color, price, availability, duration or who. Only the ones that make sense for what it shows appear. Visible in the preview and on the published site.',
    'cms.blogShow': "Show",
    'cms.blogShow.paged': "Paginated",
    'cms.blogShow.fixed': "Fixed number",
    'cms.perPage': "Posts per page",
    'cms.cardLayout': 'Layout',
    'cms.cardLayoutCards': 'Cards',
    'cms.cardLayoutList': 'List',
    'cms.listStyle.divided': 'Divided',
    'cms.listStyle.plain': 'No card',
    'cms.listStyle.card': 'Card',
    'cms.mediaSide': 'Photo side',
    'cms.mediaSide.right': 'Right',
    'catalog.look.style': 'Style',
    'catalog.look.card': 'Card',
    'catalog.look.minimal': 'Minimal',
    'catalog.look.grid': 'Bordered grid',
    'catalog.look.luxury': 'Luxury',
    'catalog.look.elevated': 'Elevated',
    'catalog.look.cardStyle': 'Card style',
    'catalog.look.ratio': 'Photo',
    'catalog.look.ratio.auto': 'As is',
    'catalog.look.ratio.square': 'Square (1:1)',
    'catalog.look.ratio.portrait': 'Portrait (4:5)',
    'catalog.look.ratio.tall': 'Tall (3:4)',
    'catalog.look.ratio.landscape': 'Landscape (4:3)',
    'catalog.look.ratio.wide': 'Wide (16:9)',
    'catalog.look.align': 'Text',
    'catalog.look.align.left': 'Left',
    'catalog.look.align.center': 'Center',
    'catalog.look.align.right': 'Right',
    'catalog.look.cta': 'Button',
    'catalog.look.compareAt': 'Compare-at price',
    'catalog.look.cta.always': 'Always',
    'catalog.look.cta.hover': 'On hover',
    'catalog.shopFiltersButton': 'Filter style',
    'catalog.shopFiltersButtonDefault': 'Outline (default)',
    'catalog.collectionSource': 'Collection',
    'catalog.collectionSourceAll': 'All offers',
    'catalog.perPage': "Per page",
    'catalog.perPageAll': "All",
    'catalog.field.image': "Photo",
    'catalog.field.description': "Description",
    'catalog.field.price': "Price",
    'elements.other': "Other",
    'elements.suggested': "Suggested",
    'insert.title': "Add element",
    'insert.subtitle': "Goes right after what you selected",
    'insert.subtitleInside': "Goes inside what you selected, at the end",
    'insert.categories': "Categories",
    'insert.hintPick': "Pick an element to see it on the page.",
    'insert.hintTrying': "This is how it looks on the page. Try another before confirming.",
    'shell.auto': "Auto",
    'shell.manual': "Manual",
    'insert.basics': "Basics",
    'insert.mySections': "My sections",
    'insert.reusable': "Reusable",
    'insert.saved': "Saved",
    'elements.noResults': "No results for “{query}”.",
    'layers.addSection': "Add",
    'layers.addFirstSection': 'Add section',
    'shell.modeDesign': "Editor",
    'shell.modePages': "Pages",
    'shell.modeCms': "Content",
    'bp.shortDesktop': "desktop",
    'bp.shortTablet': "tablet",
    'bp.shortMobile': "mobile",
    'layers.showAt': "Show on {bp}",
    'layers.hideAt': "Hide on {bp}",
    'link.newWindow': "Open in a new window",
    'nav.openMenuToEdit': "Open the menu to edit it",
    'nav.closeMenu': "Close the menu",
    'popover.openShort': 'Open popover',
    'popover.openToEdit': "Open the popover to edit it",
    'pos.absolute': "Absolute",
    'position.auto': "Auto",
    'position.unit': "Unit",
    'position.centerInParent': "Center in container",
    'position.translateX': "Offset X",
    'position.translateY': "Offset Y",
    'position.sidesToOffset': "Move into offset",
    'insp.rotation': 'Rotation',
    'insp.resetRotation': 'Reset rotation to 0°',
    'position.offsetHint': "Moves the element from its place without pushing the others. % is relative to the element itself.",
    'position.percentHint': "Position % is relative to the container. Offset % is relative to the element itself.",
    'pos.relative': "Relative",
    'pos.static': "Static",
    'pos.fixed': "Fixed",
    'pos.sticky': "Sticky",
    'text.contrastHint': "Adapts the text to the background, or lets you pick it by hand",
    'text.contrast': "Text contrast",
    'text.byBackground': "By background",
    'text.darkBackground': "Dark background",
    'text.light': "Light",
    'text.dark': "Dark",
    'cms.cardFields': 'On each card',
    'cms.listLines': "Line between rows",
    'cms.cardButton': "“Read more” button",
    'dynamic.title': "Dynamic content",
    'dynamic.sort': "Order",
    'dynamic.sort.newest': "Newest",
    'dynamic.sort.oldest': "Oldest",
    'dynamic.sort.bestselling': "Best sellers",
    'dynamic.sort.priceAsc': "Price: low to high",
    'dynamic.sort.priceDesc': "Price: high to low",
    'dynamic.sort.titleAsc': "A to Z",
    /* El botón «Ver todo» de los carruseles de Contenido dinámico. */
    'sample.dyn.seeAll': "See all",
    /* El botón de la barra lateral de servicios y reservas: a la página de contacto. */
    'sample.dyn.contact': "Contact us",
    'sample.dyn.blog.eyebrow': "Blog",
    'sample.dyn.blog.headline': "From our blog",
    'sample.dyn.blog.intro': "Ideas, guides and news from our team.",
    'sample.dyn.services.eyebrow': "Services",
    'sample.dyn.services.headline': "What we can do for you",
    'sample.dyn.services.intro': "Choose a service to see the details and get started.",
    'sample.dyn.bookings.eyebrow': "Book online",
    'sample.dyn.bookings.headline': "Reserve your spot",
    'sample.dyn.bookings.intro': "Pick a service and choose the time that works for you.",
    'sample.dyn.digital.eyebrow': "Digital products",
    'sample.dyn.digital.headline': "Instant downloads",
    'sample.dyn.digital.intro': "Get them right away and start today.",
    'sample.dyn.products.eyebrow': "Shop",
    'sample.dyn.products.headline': "Our products",
    'sample.dyn.products.intro': "Pick your favorites and get them delivered.",
    'sample.dyn.memberships.eyebrow': "Memberships",
    'sample.dyn.memberships.headline': "Join us",
    'sample.dyn.memberships.intro': "Choose the plan that fits you.",
    'sample.dyn.cms.intro': "Explore everything we have for you.",
    'dynamic.design': "Design",
    'dynamic.columns': "{n} columns",
    'dynamic.pickCollection': "Pick a collection to see its designs.",
    'dynamic.noCollections': "You have no collections yet. Create them in the CMS.",
    'dynamic.view.gallery': "Gallery",
    'dynamic.view.featured': "Featured",
    'dynamic.changeCollection': "Change collection",
    'dynamic.emptyTitle': "Nothing here yet",
    'dynamic.emptyOffers': "Create the first one and its designs show up here with your real content.",
    'dynamic.emptyEntries': "This collection has no entries. Add them in the Collections panel.",
    'dynamic.changeItem': "Change",
    'dynamic.cms': "CMS",
    'dynamic.designs': "Designs",
    'dynamic.badgeInfo': "Updates itself: whatever you publish shows up on the page without redesigning it.",
    'dynamic.noPosts': "No posts yet. Write them in the Blog panel.",
    'cms.imageOpensItem': 'Opens its page on click',
    'cms.cardFieldsCount': '{n} of {total}',
    'cms.addPostField': "Add a post field",
    'cms.addContent': "Add content",
    'cms.addPageContent': "Add page content",
    'cms.addCollectionDescription': "Add the collection description",
    'cms.addCollectionImage': "Add the collection image",
    'cms.addCollectionTitle': "Add the collection title",
    'size.height': "Height",
    'size.fixedFrameHint': "This layout floats its content over the photos, so its height can't follow it.",
    'size.heightScreenShare': "Height (% of screen)",
    'size.heightPx': "Height (px)",
    'size.width': "Width",
    'size.maxHeight': "Max height",
    'size.minHeight': "Min height",
    'size.maxWidth': "Max width",
    'size.minWidth': "Min width",
    'size.screenHeight': "Screen height",
    'size.screenWidth': "Screen width",
    'icon.beforeText': "Before the text",
    'icon.afterText': "After the text",
    'icon.none': "No icon",
    'icon.removeFromButton': "Remove the icon from the button",
    'ctl.dragToAdjust': "Drag to adjust",
    'ctl.dragToReorder': "Drag to reorder",
    'ctl.increase': "Increase",
    'ctl.decrease': "Decrease",
    'fill.add': "Add a fill",
    'visual.dropShadow': "Drop shadow",
    'visual.innerShadow': "Inner shadow",
    'visual.backgroundBlur': "Background blur",
    'fill.removeLayer': "Remove the layer",
    'fill.gradient': "Gradient",
    'state.changedHere': "Changed in this state: click to remove",
    'state.hasChanges': "This state differs from “Normal”",
    'state.removeOverride': "Remove this state’s override",
    'state.pick': "Pick a state to edit",
    'state.element': "Element state",
    'state.moreOptions': "More state options",
    'ctl.clickToRename': "Click to rename",
    'flex.column': "Column",
    'flex.columnReverse': "Column reverse",
    'flex.row': "Row",
    'flex.rowReverse': "Row reverse",
    'flex.columnsReverse': "Columns reverse",
    'flex.rows': "Rows",
    'flex.rowsReverse': "Rows reverse",
    'grid.span': "Columns it spans",
    'grid.rowSpan': "Rows it spans",
    'grid.rowUnit': "row",
    'flex.wrap': "Wrap",
    'flex.noWrap': "No wrap",
    'flex.wrapLabel': "Wrap",
    'flex.wrapReverse': "Wrap reverse",
    'flex.spaceAround': "Space around",
    'flex.spaceBetween': "Space between",
    'flex.spaceEvenly': "Space evenly",
    'flex.justify': "Distribution",
    'token.make': "Turn into a token",
    'token.unlink': "Unlink from the global style",
    'token.edit': "Edit the global style",
    'token.local': "Local style",
    'token.brand': "Style token",
    'token.unassigned': "Unassigned",
    'link.email': "Email",
    'link.phone': "Phone",
    'link.target': "Target",
    'link.page': "Page",
    'link.record': "Record",
    'ai.idHint': "Sets the stable ID the AI uses to personalize this block",
    'ai.idDuplicate': "This role goes once per block and another element already has it.",
    'ai.autoNumber': "It's {label} #{n} in this block, numbered automatically by order.",
    'ai.idLegacy': "Previous ID kept for compatibility.",
    'ai.semanticId': "Semantic ID",
    'ai.selector': "AI selector",
    'ai.blockProtocol': "Block protocol",
    'ai.exposed': "Exposed",
    'ai.noDirectContent': "This element takes no direct content.",
    'ai.notEditable': "This element will not be sent as an editable field of the block.",
    'ai.doNotExpose': "— Do not expose to the AI —",
    'box.eachCorner': "Edit each corner",
    'box.eachSide': "Edit each side",
    'box.allCorners': "Match all corners",
    'box.byAxis': "Edit by axis",
    'box.sides': "Sides",
    'box.groupByAxis': "By axis",
    'box.groupEachSide': "Each side",
    'box.topLeft': "Top left",
    'box.topRight': "Top right",
    'box.bottomLeft': "Bottom left",
    'box.bottomRight': "Bottom right",
    'box.rounding': "Rounding",
    'box.inner': "Inner",
    'box.outer': "Outer",
    'box.blur': "Blur",
    'insp.effects': "Effects",
    'insp.filter': "Filter",
    'insp.opacity': "Opacity",
    'insp.opacityPct': "Opacity (%)",
    'insp.properties': "Properties",
    'insp.selectedProperties': "Properties of the selected element",
    'insp.close': "Close the inspector",
    'insp.moreOptions': "More options",
    'insp.seeMore': "See more",
    'insp.breakpointOverride': "Override at this breakpoint",
    'size.shrink': "Shrink",
    'size.shrinkInfo': "When the row runs out of space, “Flexible” lets this element get narrower so everything fits; “Rigid” always keeps it at its size and the others shrink instead (or the row overflows).",
    'size.fill': "Fill the space",
    'size.fillNeedsLayout': "Fill requires a container that arranges its children in a row, column, or grid.",
    'size.fillOutOfFlow': "Fill does not apply to elements with absolute or fixed positioning.",
    'size.relativeGridHeightHint': "Percentage height depends on the row and can leave gaps when its height is automatic. Use Fit to cell in the Size menu to occupy all the space.",
    'size.fillGridCell': "Fit to cell",
    'size.fillGridCellHint': "Fit width and height to the grid space and release the aspect ratio.",
    'size.gridSpanHeightHint': "Spanning multiple rows does not change the element height. Use Fit to cell in the Size menu to cover them.",
    'size.relativeHeightHint': "Percentage height needs a definite container height; with a content-sized container it may have no effect.",
    'size.fillHeightHint': "To grow vertically, the container needs available vertical space. A content-sized container may have no space to fill.",
    'size.flexible': "Flexible",
    'size.rigid': "Rigid",
    'size.limit': "Limit",
    'size.limits': "Limits",
    'size.fraction': "Fraction",
    'size.pixels': "Pixels",
    'size.percent': "Percentage",
    'size.modeFixed': "Fixed (px)",
    'size.modeRelative': "Relative (%)",
    'size.modeScreenW': "Screen (vw)",
    'size.modeScreenH': "Screen (vh)",
    'common.custom': "Custom",
    'overflow.scroll': "Scroll",
    'overflow.clip': "Clip",
    'overflow.hidden': "Hidden",
    'overflow.visible': "Visible",
    'insp.order': "Order",
    'insp.position': "Position",
    'insp.show': "Show",
    'type.lineHeight': "Line height",
    'type.style': "Text style",
    'type.fontLabel': "Font",
    'common.title': "Title",
    'common.description': "Description",
    'schedule.window': "Schedule",
    'schedule.whileActive': "While it is active",
    'schedule.beforeStart': "Only before it starts",
    'schedule.afterEnd': "Only once it ends",
    'schedule.ongoing': "Only while ongoing",
    'schedule.duringOnly': "Only while it happens",
    'schedule.upcomingOnly': "Only upcoming",
    'schedule.finished': "Finished",
    'schedule.availableNow': "Available now",
    'schedule.launch': "Launch",
    'faq.newQuestion': "New question",
    'faq.theAnswer': "The answer.",
    'slider.slide': "Slide",
    'nav.megaMenu': "Mega menu",
    'logo.brand': "Brand logo",
    'logo.brandPath': "Style → Logo",
    'image.version': "Image version",
    'cms.public': "Public",
    'border.dots': "Dots",
    'border.dashes': "Dashes",
    'common.all': "All",
    'common.disabled': "Disabled",
    'el.logo': "Logo",
    'insp.deleteSettings': "Delete the settings",
    'ai.previousId': "Previous · {id}",
    'logo.editHint': "The logo content is edited in {ruta} and applies to the whole site.",
    'link.emailPlaceholder': "hello@example.com",
    'state.normal': "Normal",
    'state.pressed': "Pressed",
    'state.focus': "Focused",
    'state.current': "Current",
    'state.open': "Open",
    'sort.desc': "Descending",
    'sort.asc': "Ascending",
    'size.fitContent': "Fit content",
    'insp.overflow': "Overflow",
    'fill.label': "Fill",
    'token.global': "Global",
    'insp.editCode': "Edit the code",
    'link.urlPlaceholder': 'https://...',
    'token.pickBrandStyle': "Pick a style",
    'token.globalSuffix': " · Global",
    'popover.closeToEdit': 'Close the popover',
    'a11y.section': "Accessibility",
    'img.contain': "Fit",
    'img.stretch': "Stretch",
    'img.cover': "Fill",
    'img.original': "Original",
    'img.framing': "Framing",
    'layout.contentAlign': "Content alignment",
    'logo.width': "Logo width",
    'img.searchGallery': "Search the gallery",
    'icon.search': "Search for an icon",
    'icon.searchPlaceholder': "Search for an icon…",
    'icon.results': "{count} icons",
    'icon.category.all': "All",
    'icon.category.interface': "Interface",
    'icon.category.arrows': "Arrows",
    'icon.category.contact': "Contact",
    'icon.category.commerce': "Commerce",
    'icon.category.media': "Media",
    'icon.category.technology': "Technology",
    'icon.category.symbols': "Symbols",
    'icon.category.social': "Social",
    'icon.category.travel': "Travel & tourism",
    'icon.category.architecture': "Architecture & property",
    'icon.category.health': "Health",
    'icon.category.professional': "Professional services",
    'icon.category.education': "Education",
    'icon.category.wellness': "Beauty & fitness",
    'icon.category.events': "Events",
    'icon.category.food': "Food & dining",
    'icon.category.services': "Home services",
    'icon.category.transport': "Vehicles",
    'icon.category.pets': "Pets",
    'logo.versionHint': "Each logo picks its version from the background. You can force it in the right panel.",
    'logo.noDarkHint': "With no dark version, the light one is used on every background.",
    'common.change': "Change",
    'img.change': "Change the image",
    'common.choose': "Choose",
    'img.choose': "Choose an image",
    'img.select': "Select an image",
    'img.selectMany': "Select images",
    'img.upload': "Upload an image",
    'img.uploading': "Uploading your image…",
    'img.gallery': "Gallery",
    'img.uploaded': "Uploaded",
    'common.loading': "Loading…",
    'img.galleryFailed': "The gallery could not be loaded.",
    'common.noSearchResults': "No results for that search.",
    'img.noneSelected': "None selected",
    'img.altHint': "Describe the image: it's what search engines and screen readers read.",
    'img.altPlaceholder': "Alt text…",
    'panels.close': "Close the panel",
    'common.clearSearch': "Clear the search",
    'theme.light': "Light",
    'theme.dark': "Dark",
    'icon.color': "Icon color",
    'icon.background': "Icon background",
    'icon.size': "Icon size",
    'icon.weight': "Weight",
    'icon.families': "Icon families",
    'logo.nameColor': "Name color",
    'logo.showName': "Show the name",
    'logo.display': 'Show',
    'logo.settings': 'Logo',
    'logo.markSize': 'Logo size',
    'logo.nameSize': 'Text size',
    'logo.displayBrand': 'Follow brand',
    'logo.displayBoth': 'Logo and text',
    'logo.displayMark': 'Logo only',
    'logo.displayName': 'Text only',
    'logo.hideName': "Hide the name",
    'logo.showMark': "Show a mark",
    'logo.noMark': "No mark",
    'logo.markType': "Mark type",
    'logo.wordmark': "Wordmark",
    'logo.wordmarkHint': "Company name and typography",
    'logo.mark': "Logo",
    'logo.markHint': "Icon or uploaded artwork",
    'logo.backgroundOpacity': "Background opacity",
    'logo.cornerRadius': "Corner radius",
    'logo.lightColor': "Light color",
    'logo.darkColor': "Dark color",
    'logo.lightBackground': "Light background",
    'logo.darkBackground': "Dark background",
    'logo.previewIn': "Preview in",
    'logo.previewMode': "Logo color mode",
    'logo.lightMode': "Light mode",
    'logo.darkMode': "Dark mode",
    'logo.companyName': "Company name",
    'type.searchFonts': "Search fonts…",
    'type.noFontsFound': "No fonts found",
    'token.styleName': "Style name",
    'token.name': "Token name",
    'token.replaceWith': "Replace with",
    'common.create': "Create",
    'common.rename': "Rename",
    'common.remove': "Remove",
    'common.delete': "Delete",
    'common.builtIn': "Built-in",
    'brand.section': "Style",
    'common.name': "Name",
    'token.deleteTitle': "Delete “{name}”",
    'token.deleteBody': "This {kind} is used by {count}. If you delete it, those elements will move to the {kind} you pick here.",
    'token.deleteNoOther': "There is no other {kind} to move them to. Create one before deleting this one.",
    'icon.noneFor': "No icon for {query}",
    'color.add': "Add a color",
    'color.cardAuto': "Adapt card colors",
    'card.autoSurfaceHint': "Cards take a tone that contrasts with each section’s background. Applies to all cards.",
    'color.cardAutoOn': "Cards adjust their shade to stand out from each section’s background.",
    'color.cardAutoOff': "Cards keep the color you chose in every section.",
    'section.toneAuto': "Alternate backgrounds",
    'section.toneAutoOn': "Default and secondary section backgrounds alternate automatically. Your manual choices stay as set.",
    'section.toneAutoOff': "Each section keeps its chosen background.",
    'section.toneAutoPick': "Automatic",
    'section.toneAutoPickHint': "Alternates with its neighbours",
    'section.toneAutoNow': "now",
    'token.cardAdaptsNote': "Adjusts to each section’s background so it stands out. The swatches show this section’s shade.",
    'token.add': "Add a token",
    'img.queueProgress': "{done} of {total}",
    'img.noneYet': "You have no images yet.",
    'img.signInToUpload': "Sign in to upload and choose images.",
    'logo.autoWidth': "auto",
    'icon.clearBackground': "Remove the background",
    'panels.exploreAll': "Explore every option",
    'token.deleteAndReplace': "Delete and replace",
    'img.loadingMore': "Loading more images…",
    'img.saveCount': "Save ({count})",
    'link.newTab': "Open in a new tab",
    'pages.add': "Add a page",
    'token.addStyle': "Add a style",
    'img.fit': "Image fit",
    'flex.alignChildren': "Align children",
    'opt.wide': "Wide",
    'opt.narrow': "Narrow",
    'opt.generous': "Generous",
    'opt.little': "Little",
    'opt.tight': "Tight",
    'opt.spread': "Spread",
    'opt.verySpread': "Very spread",
    'opt.compactFem': "Compact",
    'size.fullWidth': "Full width",
    'common.automatic': "Automatic",
    'token.searchButton': "Search for a button…",
    'token.searchStyle': "Search for a style…",
    'type.searchFont': "Search for a font…",
    'link.allDestinations': "All",
    'link.currentDestination': "Current destination",
    'link.notLinked': "No link",
    'link.chooseDestination': "Choose a destination",
    'link.pages': "Pages",
    'link.content': "Content",
    'link.collections': 'Collections',
    'link.catalog': "Catalog",
    'link.searchAll': "Search, or paste a link, email or phone",
    'link.createPage': "Create a new page",
    'link.createNamedPage': "Create the page “{name}”",
    'link.createPageHint': "Choose how to create it; this link will point to it when finished",
    'link.nothingNamed': "Nothing is called “{query}”. Paste an address to link out.",
    'link.emptyGroup': "Nothing here yet.",
    'link.searchPage': "Search for a page or paste a link",
    'token.changeOnlyHere': "Customize this element only",
    'token.controlledBy': "Global style: ",
    'token.controlsCount': "Controls {count} properties",
    'token.editShort': "Edit",
    'token.inUse': "In use",
    'token.valueNormal': "Normal",
    'token.valueAuto': "Automatic",
    'opt.squareShape': "Square",
    'opt.circle': "Circle",
    'opt.pill': "Pill",
    'opt.straight': "Straight",
    'opt.rounded': "Rounded",
    'opt.round': "Round",
    'opt.veryRound': "Very round",
    'shell.undo': "Undo",
    'shell.redo': "Redo",
    'shell.undoKeys': "Undo (Cmd+Z)",
    'shell.redoKeys': "Redo (Cmd+Shift+Z)",
    'token.unlinkShort': "Unlink",
    'token.unlinkFrom': "Disconnect from global style",
    'token.syncedWithBrand': "Synced with Style",
    'token.editInBrand': "Edit in Style",
    'token.cardControlledDesc': "Background, border, radius, and shadow are governed globally by Style. Unlink if you want to customize only this element.",
    'token.textControlledDesc': "Typography, colors, and text styles are governed globally by Style. Unlink if you want to customize only this element.",
    'token.buttonControlledDesc': "Button appearance and styles are governed globally by Style. Unlink if you want to customize only this element.",
    'opt.two': "Two",
    'opt.three': "Three",
    'opt.one': "One",
    'common.duplicate': "Duplicate",
    'token.editButton': "Edit the global button",
    'fill.editStopColor': "Edit the stop color",
    'token.editColor': "Edit the global color",
    'fill.editGradient': "Edit the gradient",
    'token.editLogo': "Edit the global logo",
    'token.editIcon': "Edit the global icon",
    'token.editSection': "Edit the global section",
    'token.editCard': "Edit the global card",
    'fill.removeStop': "Remove the stop",
    'fill.minStops': "At least 2 stops",
    'img.chooseOne': "Choose an image",
    'ai.send': "Send",
    'ai.reply': "Reply",
    'ai.thinking': "Thinking…",
    'ai.replyPlaceholder': "Write your reply…",
    'box.corners': "Corners",
    'cms.fromCms': "This text comes from the CMS",
    'cms.useField': "Use a CMS field",
    'pos.fixedFem': "Fixed",
    'pos.floating': "Floating",
    'pos.free': "Free",
    'layout.gap': "Gap",
    'layout.rowGap': "Row gap",
    'grid.child': "Grid child",
    'border.dash': "Dash",
    'ai.promptPlaceholder': "Tell the AI what to change, e.g. “make it bigger” or “use a blue background”",
    'ai.promptTitle': "What do you want to change?",
    'ai.promptAria': "Request for the AI assistant",
    'type.justified': "Justified",
    'common.done': "Done",
    'ctl.finishEditing': "Finish editing",
    'ctl.moveRight': "Move right",
    'ctl.moveLeft': "Move left",
    'ctl.moveDown': "Move down",
    'ctl.moveUp': "Move up",
    'size.minHeightShort': "Min height",
    'size.clearMin': "Clear the minimum",
    'type.bold': "Bold",
    'type.clearFormat': "Clear the formatting",
    'color.recent': "Recent",
    'color.pick': "Pick a color",
    'bp.switcher': "Viewport switcher",
    'type.system': "System",
    'opt.subtle': "Subtle",
    'fill.overlay': "Overlay",
    'fill.linear': "Linear",
    'fill.radial': "Radial",
    'fill.gradientType': "Gradient type",
    'fill.gradientAngle': "Gradient direction",
    'color.transparent': "Transparent",
    'theme.section': "Theme",
    'el.buttonText': "Button text",
    'opt.large': "Large",
    'opt.topShort': "Top",
    'opt.leftShort': "Left",
    'fill.stopsSummary': "{count} stops · {kind}",
    'fill.noLayers': "No layers. Add one with the buttons below.",
    'fill.layersCount': "{count} layers",
    'insp.editDetails': "Edit {name}",
    'fill.display': "Display",
    'box.removeShadow': "Remove the shadow",
    'link.noPageNamed': 'No page is called “{query}”. Paste an address to link out.',
    'img.objectFit': "Object fit",
    'insp.zIndex': "Z-Index",
    'bp.viewName': "{name} view",
    'layout.grid': 'Grid',
    'border.thin': "Thin",
    'border.medium': "Medium",
    'border.thick': "Thick",
    'pub.publish': "Publish",
    'pub.publishing': "Publishing",
    'pub.stopped': "Publishing stopped",
    'pub.toSelected': "Publish to the selected domains",
    'pub.domains': "Publishing domains",
    'pub.domainsShort': "Domains",
    'pub.sitePublished': "Site published",
    'pubHint.eyebrow': 'From Settings',
    'pubHint.title': 'Publish from here',
    'pubHint.body': 'This button builds your pages and puts them online. Your booking pages get their address as soon as it finishes.',
    'publish.site.title': 'Your site',
    'publish.site.live': 'It is online',
    'publish.site.liveBody': 'Anyone with the address can open it, and your booking pages work.',
    'publish.site.off': 'Not published',
    'publish.site.offBody': 'Your changes are not online yet.',
    'publish.site.unpublish': 'Unpublish',
    'publish.site.unpublishing': 'Unpublishing…',
    'publish.site.confirmTitle': 'Unpublish the site?',
    'publish.site.confirmBody': 'It stops being reachable at its address, booking pages included. Nothing is deleted, and publishing again brings it back.',
    'publish.site.openEditor': 'Open in Editor',
    'publish.site.openEditorHint': 'Publishing builds every page, and that happens in the editor.',
    'pub.siteUnpublished': "Site unpublished",
    'pub.templateTitle': "Publish the template",
    'pub.templateHint': "Saves it to the library with its thumbnail and translations.",
    'pub.templatePublishing': "Publishing the template",
    'pub.templateStepSave': "Saving the draft",
    'pub.templateStepPublish': "Publishing, translating and capturing the thumbnail",
    'pub.templateDoneHint': "It is in the library and its thumbnail is ready.",
    'pub.templateDoneClose': "Done",
    'pub.templatePublished': "Template published",
    'pub.templatePublishedTranslated': "Template published · {count} texts translated with AI. Review them under Language.",
    'pub.unpublishing': "Unpublishing…",
    'pub.failed': "The site could not be published.",
    'pub.templateFailed': "The template could not be published.",
    'pub.unpublishFailed': "The site could not be unpublished.",
    'pub.files': "{count} files",
    'pub.filesOne': "1 file",
    'pub.uploadProgress': "{sent} of {total}",
    'pub.noChanges': "No changes to upload",
    'pub.noPages': "There are no pages to publish.",
    'pub.saveFirst': "Save this project before publishing it.",
    'pub.close': "Close publishing",
    'pub.unpublished': "Not published",
    'pub.customNeedsUpgrade': "Your own domain is part of the Pro plan",
    'pub.customNeedsUpgradeHint': "Upgrade to publish on yourdomain.com. Your véltica address keeps working.",
    'pub.seePlans': "See plans",
    'pub.headHint': "Your latest changes go live on the domains you pick.",
    'pub.publishingSite': "Publishing your site",
    'pub.publishedAgo': "Published {when}",
    'pub.subdomainChecking': "Checking…",
    'pub.subdomainRules': "Lowercase letters, numbers and hyphens.",
    'pub.subdomainWarn': "{host} will stop opening, and links you already shared with it won't work. We keep it reserved for you for 30 days in case you change your mind.",
    'pub.notPublishedYet': "Publish the site first: until then the link doesn't open anything.",
    'pub.neverOnDomain': "Never published on this domain",
    'pub.live': "Live",
    'pub.preparing': "Getting your site ready",
    'pub.generatingPages': "Generating pages",
    'pub.registeringForms': "Registering forms",
    'pub.updatingThumbnails': "Updating thumbnails",
    'pub.readingSettings': "Reading the site settings",
    'pub.uploadingFiles': "Uploading files",
    'pub.someStepsFailed': "Not every step could be completed",
    'pub.publishHint': "Publish so your changes show on the site. Saving only updates the draft.",
    'pub.changesStayInEditor': "Your changes are still in the editor.",
    'pub.freeSubdomain': "Free Veltica subdomain",
    'pub.connectOwnDomain': "Connect your own domain",
    'pub.useOwnDomain': "Use yourdomain.com instead of the subdomain",
    'pub.connect': "Connect",
    'pub.dnsPending': "Setting up DNS/SSL… manage it from the dashboard",
    'pub.openDomain': "Open the domain",
    'pub.openDomainNewTab': "Open the domain in a new tab",
    'pub.openPublished': "Open the published version",
    'pub.openPublishedNewTab': "Open the published version in a new tab",
    'save.saved': "Saved",
    'save.saving': "Saving",
    'save.savingChanges': "Saving your changes…",
    'save.allSaved': "All changes saved",
    'save.error': "Could not save",
    'save.failed': "Could not save",
    'save.sessionExpired': "Session expired",
    'save.offline': "No connection",
    'save.checkConnection': "Check your connection and try again.",
    'common.tryAgain': "Try again",
    'save.cannotOpen': "The project could not be opened",
    'clip.title': "Clipboard",
    'clip.section': "Section clipboard",
    'clip.close': "Close the clipboard",
    'clip.copySection': "Copy the section",
    'clip.pasteSection': "Paste the section",
    'clip.pasteFrom': "Paste a section from the clipboard",
    'clip.copied': "Section copied to the clipboard",
    'clip.pasted': "Section pasted",
    'clip.valid': "Valid section",
    'clip.invalid': "The code does not contain a valid section",
    'clip.badJson': "Check the JSON format.",
    'clip.cannotRead': "The browser clipboard could not be read",
    'clip.importFailed': "Could not import",
    'clip.codeCopied': "Code copied",
    'clip.pickToCopy': "Pick a section to copy",
    'clip.pickPageToPaste': "Pick a page to paste into",
    'brand.hint': "Your site’s colors and typography. They apply to the whole site.",
    'brand.palette': "Color palette",
    'brand.presets': "Presets",
    'brand.tabMine': "Your brand",
    'brand.tabStyles': "Styles",
    'brand.stylesHint': "Change how the whole site looks, all at once or part by part.",
    'brand.customize': "Customize",
    'brand.combo': "Style combination",
    'brand.textStyles': "Text styles",
    'brand.buttonStyles': "Button styles",
    'brand.cardStyles': "Card styles",
    'brand.sectionStyles': "Section styles",
    'brand.motion': "Animation",
    'motion.style.none': "None",
    'motion.style.subtle': "Subtle",
    'motion.style.smooth': "Smooth",
    'motion.style.elegant': "Elegant",
    'motion.style.dynamic': "Dynamic",
    'motion.style.slide': "Slide in",
    'motion.style.zoom': "Grow",
    'motion.style.reveal': "Reveal",
    'motion.style.cinematic': "Cinematic",
    'motion.style.flip': "Flip",
    'motion.styleHint.none': "Nothing moves",
    'motion.styleHint.subtle': "A short, quiet fade",
    'motion.styleHint.smooth': "Everything rises gently",
    'motion.styleHint.elegant': "Slower, with a soft blur",
    'motion.styleHint.dynamic': "Quick, with a little bounce",
    'motion.styleHint.slide': "Arrives from the side",
    'motion.styleHint.zoom': "Grows a little as it appears",
    'motion.styleHint.reveal': "Uncovers from the bottom, like a curtain",
    'motion.styleHint.cinematic': "Comes in close and settles slowly",
    'motion.styleHint.flip': "Tips into place; playful",
    'motion.customize': "Customize",
    'motion.chooseStyle': "Choose an animation style",
    'motion.stylesHint': "Movement styles for your whole site",
    'motion.play': "Play animation",
    'motion.role.heading': "Large titles",
    'motion.role.subheading': "Small titles",
    'motion.role.text': "Text",
    'motion.role.button': "Buttons",
    'motion.role.card': "Cards",
    'motion.role.image': "Photos",
    'motion.enter': "Entrance",
    'motion.enterAll': "Entrance (everything)",
    'motion.hover': "Hover",
    'motion.hover.scale': "Size on hover",
    'motion.hover.lift': "Lift",
    'motion.hover.color': "Effect color",
    'motion.hover.blur': "Blur",
    'motion.hover.opacity': "Intensity",
    'motion.hover.angle': "Angle",
    'motion.hover.outline': "Outline width",
    'motion.speed': "Speed",
    'motion.speed.slow': "Slow",
    'motion.speed.normal': "Normal",
    'motion.speed.fast': "Fast",
    'motion.speed.veryFast': "Very fast",
    'motion.reset': "Back to the style as it comes",
    'motion.hint': "Applies to every page. An element with its own animation keeps it.",
    'brand.icons': "Icons",
    'color.name': "Color name",
    'color.new': "New color",
    'token.newStyle': "New style",
    'token.newButton': "New button",
    'token.newCard': "New card",
    'token.newSection': "New section",
    'token.newIcon': "New icon",
    'brand.restartStyle': "Restart style",
    'brand.restartStyleConfirm': "This replaces every manual change in this style, including tablet and mobile, with the selected Style combination.",
    'brand.restartUnavailable': "No original value from a Style combination is available",
    'brand.restartCurrent': "This style already matches the selected combination",
    'a11y.topbar': "Editor top bar",
    'a11y.contextBar': "Element context bar",
    'a11y.canvas': "Editing canvas",
    'a11y.viewport': "Viewport controls",
    'a11y.canvasNav': "Canvas navigation and controls",
    'a11y.tools': "Editor tools",
    'a11y.elementProps': "Element properties",
    'a11y.designPanel': "Design panel",
    'a11y.whatIsEdited': "What is being edited",
    'a11y.currentArea': "Current editor area",
    'a11y.editPath': "Editing path",
    'a11y.pageBeingEdited': "Page being edited",
    'common.goTo': "Go to",
    'common.location': "Location",
    'pages.site': "Site pages",
    'pages.andContent': "Pages and content",
    'pages.created': "Page created",
    'pages.settings': "Page settings",
    'pages.settingsLong': "Page settings",
    'pages.settingsThis': "This page’s settings",
    'pages.config': "Page configuration",
    'pages.closeSettings': "Close the settings",
    'pages.select': "Select a page",
    'cms.selectCollection': "Select a collection",
    'cms.selectPost': "Select a post",
    'cms.closePost': "Close the post and go back to the collection",
    'cms.noDetailPage': "This collection has no detail page yet.",
    'shell.templateModeHint': "CMS and pages are off while editing templates.",
    'insp.pin': "Pin the inspector open",
    'insp.pinAlways': "Keep the inspector always open",
    'insp.pinShort': "Pin the panel open",
    'insp.pinAlwaysShort': "Keep the panel always open",
    'insp.autoHide': "Auto-hide the inspector",
    'insp.autoHideShort': "Auto-hide the panel",
    'img.uploaded2': "Image uploaded",
    'img.uploadFailed': "The image could not be uploaded",
    'img.signIn': "Sign in to upload images",
    'img.dropToUpload': "Drop to upload the image",
    'img.savedToFiles': "It will be saved to your Files",
    'img.files': "Files",
    'preview.title': "Preview",
    'preview.unpublished': "Preview · not published",
    'shell.myProject': "My project",
    'shell.template': "Template",
    'tplLang.title': "Language",
    'tplLang.name.en': "English",
    'tplLang.name.es': "Spanish",
    'tplLang.untranslated': "Untranslated: {count}",
    'tplLang.hint': "Text you change applies only to this language. Design changes apply to every language.",
    'time.year': "year",
    'time.years': "years",
    'time.day': "day",
    'time.days': "days",
    'time.page': "page",
    'time.pages': "pages",
    'preview.draftBadge': "Draft · publish it to make it visible",
    'clip.copyCode': "Copy the code",
    'save.lastTry': "Last attempt: {time}",
    'pub.configure': "Set up",
    'pub.seeLiveSite': "See the live site",
    'pub.unpublishSite': "Unpublish the site",
    'pub.alreadyOnline': "{host} is already online",
    'pub.openSite': "Open the site",
    'brand.logo': "Logo",
    'a11y.layers': "Layers",
    'a11y.layersHint': "Browse, select and organize the page’s structure.",
    'load.invalidTitle': "Invalid project",
    'load.invalidBody': "The project link has no valid ID.",
    'load.sessionTitle': "Sign-in required",
    'load.sessionBody': "Sign in again to open this project.",
    'load.unavailableTitle': "Project unavailable",
    'load.unavailableBody': "This project does not exist, or it does not belong to your account.",
    'load.serverSaid': "The server responded with HTTP {status}.",
    'ago.now': "just now",
    'ago.minuteOne': "{count} minute ago",
    'ago.minutes': "{count} minutes ago",
    'ago.hourOne': "{count} hour ago",
    'ago.hours': "{count} hours ago",
    'ago.dayOne': "{count} day ago",
    'ago.days': "{count} days ago",
    'ago.monthOne': "{count} month ago",
    'ago.months': "{count} months ago",
    'ago.yearOne': "{count} year ago",
    'ago.years': "{count} years ago",
    'pub.pageCount': "{count} pages",
    'pub.pageCountOne': "{count} page",
    'blk.add': "Add a block",
    'blk.more': "More blocks",
    'blk.turnInto': "Turn into",
    'blk.turnIntoAnother': "Turn into another block",
    'blk.actions': "Actions",
    'blk.duplicate': "Duplicate",
    'blk.delete': "Delete",
    'blk.blockOptions': "Block options",
    'blk.inlineCode': "Code",
    'blk.removeLink': "Remove link",
    'blk.moveUpShort': "Move up",
    'blk.moveDownShort': "Move down",
    'blk.align': "Alignment",
    'blk.align.left': "Align left",
    'blk.align.center': "Center",
    'blk.align.right': "Align right",
    'blk.align.justify': "Justify",
    'blk.moveUp': "Move the block up",
    'blk.moveDown': "Move the block down",
    'blk.noneNamed': "No block by that name.",
    'blk.placeholder': "Start writing, or press / to insert headings, images and more",
    'blk.placeholderLong': "Start writing, or press / to insert headings, images and more",
    'blk.paragraph': "Plain text",
    'blk.paragraphHint': "A normal paragraph",
    'blk.list': "List",
    'blk.listHint': "Unordered bullets",
    'blk.numbered': "Numbered list",
    'blk.numberedHint': "Steps, one after another",
    'blk.quote': "Quote",
    'blk.quoteHint': "What someone said",
    'blk.code': "Code",
    'blk.codeHint': "Monospaced, exactly as typed",
    'blk.dividerHint': "A line between two parts",
    'blk.calloutHint': "A notice you cannot miss",
    'blk.calloutPlaceholder': "Write what matters here",
    'blk.insertLink': "Insert a link",
    'blk.insertVideo': "Insert a video",
    'blk.videoLink': "Video link",
    'blk.pasteVideo': "Paste the YouTube or Vimeo link",
    'blk.videoHint': "Paste the video link and it will be embedded as a player.",
    'blk.youtubeOrVimeo': "YouTube or Vimeo",
    'blk.widenImage': "Widen the image",
    'blk.narrowImage': "Narrow the image",
    'blk.changeImage': "Change the image",
    'blk.link': "Link",
    'blk.remove': "Remove",
    'blk.copied': "Copied",
    'blk.ratio': "Aspect ratio",
    'blk.ratioOriginal': "Original",
    'blk.toTheLeft': "To the left",
    'blk.centered': "Centered",
    'blk.full': "Full",
    'cms.manageCollections': "Manage content",
    'cms.manageContent': "Manage content",
    'cms.collectionsTitle': "Content",
    'cms.collectionCreated': "Collection created",
    'cms.collectionSaved': "Collection saved",
    'cms.collectionInfo': "Collection information",
    'cms.generalInfo': "General information",
    'cms.collectionIdentityHint': "Sets how this collection is identified and where it is published.",
    'cms.collectionIconHint': "How this collection is recognized in the list and the table.",
    'cms.iconAndColor': "Icon and color",
    'cms.collectionPath': "Collection path",
    'cms.collectionPathHint': "This path is used for the collection and its published items.",
    'cms.itemUrl': "URL of each item",
    'cms.contentStructure': "Content structure",
    'cms.structureHint': "Organize the information each item will hold.",
    'cms.collectionFields': "Collection fields",
    'cms.systemFields': "System fields",
    'cms.fields': "Fields",
    'cms.fieldName': "Field name",
    'cms.removeField': "Remove the field",
    'cms.dragFieldHandle': "Drag the field",
    'cms.addOption': "Add an option",
    'cms.removeOption': "Remove the option",
    'cms.option': "Option",
    'cms.optionOne': "Option 1",
    'cms.startFromTemplate': "Pick a starting point",
    'cms.templateHint': "Each model comes with the usual fields; adjust them to fit afterwards.",
    'cms.yourCollection': "Your collection",
    'cms.namePlaceholder': "e.g. Posts",
    'cms.deleteCollectionWarning': "The collection and all its items will be deleted. This cannot be undone.",
    'cms.backToCollections2': "Back to collections",
    'cms.backToName': "Back to the name",
    'cms.openInCms': "Open in the CMS",
    'cms.contentGone': "This content no longer exists.",
    'cms.item': "Item",
    'cms.itemNumber': "Item {n}",
    'cms.items': "Items",
    'cms.noFields': "(no fields)",
    'cms.noRows': "(no rows)",
    'cms.tpl.posts': "Posts",
    'cms.tpl.post': "Post",
    'cms.tpl.authors': "Authors",
    'cms.tpl.author': "Author",
    'cms.tpl.projects': "Projects",
    'cms.tpl.events': "Events",
    'cms.tpl.recipes': "Recipes",
    'cms.tpl.clients': "Clients",
    'cms.tpl.client': "Client",
    'cms.tpl.team': "Team members",
    'cms.tpl.shows': "Shows",
    'cms.tpl.songs': "Songs",
    'cms.tpl.listings': "Listings",
    'cms.tpl.media': "Media",
    'cms.tpl.log': "Log",
    'cms.tpl.artist': "Artist",
    'cms.tpl.bio': "Bio",
    'cms.tpl.role': "Role",
    'cms.tpl.ingredients': "Ingredients",
    'cms.tpl.duration': "Duration",
    'cms.tpl.price': "Price",
    'cms.tpl.place': "Place",
    'cms.tpl.starts': "Starts",
    'cms.tpl.ends': "Ends",
    'cms.tpl.featured': "Featured",
    'cms.tpl.caseStudies': "Case studies",
    'cms.tpl.result': "Result",
    'cms.tpl.tickets': "Tickets",
    'cms.tpl.faq': "FAQ",
    'cms.tpl.answer': "Answer",
    'cms.tpl.partners': "Partners",
    'cms.tpl.portfolio': "Portfolio",
    'cms.tpl.viewProject': "View project",
    'cms.tpl.properties': "Properties",
    'cms.tpl.bedrooms': "Bedrooms",
    'cms.tpl.locations': "Locations",
    'cms.tpl.address': "Address",
    'cms.tpl.hours': "Opening hours",
    'cms.tpl.directions': "Directions",
    'cms.tpl.testimonials': "Testimonials",
    'cms.tpl.quote': "Quote",
    'cms.tpl.roleCompany': "Role or company",
    'cms.tpl.jobs': "Job openings",
    'cms.tpl.department': "Department",
    'cms.tpl.workMode': "Work mode",
    'cms.tpl.apply': "Apply",
    'cms.tpl.resources': "Resources",
    'cms.tpl.download': "Download",
    'cms.tpl.summary': "Summary",
    'cms.tpl.categories': "Categories",
    'cms.tpl.photo': "Photo",
    'cms.tpl.sale': "Sale",
    'cms.tpl.buyNow': "Buy now",
    'cms.tpl.ctaHint': "The action you want them to take",
    'cms.type.longText': "Long text",
    'cms.type.number': "Number",
    'cms.type.date': "Date",
    'cms.type.dateTime': "Date/Time",
    'cms.type.email': "Email",
    'cms.type.phone': "Phone",
    'cms.type.location': "Location",
    'cms.type.time': "Time",
    'cms.type.image': "Image",
    'cms.noSchedule': "No schedule",
    'cms.scheduleOptional': "Schedule (optional)",
    'cms.sameDay': "The same day",
    'cms.unlink': "Unlink from the CMS",
    'cms.unlinked': "Not linked",
    'cms.customText': "Custom text",
    'cms.textFieldOf': "Text from {name}",
    'cms.entryLink': "Entry link",
    'cms.noCompatibleFields': "The collection page has no compatible fields.",
    'cms.useItemImage': "Use the item’s image",
    'cms.useScreenshot': "Use the screenshot",
    'pg.settings': "Page settings",
    'pg.title': "Page title",
    'pg.itemTitle': "Item title",
    'pg.identityHint': "Sets how this page is identified within the site.",
    'pg.discoveryHint': "Decides how this page is found inside and outside the site.",
    'pg.seoHint': "Tune the title, description and URL that search engines will show.",
    'pg.itemSeoHint': "Customize how each collection item appears in search engines.",
    'pg.searchVisibility': "Search visibility",
    'pg.indexable': "Index in search engines",
    'pg.inSitemap': "Include in the sitemap",
    'pg.canonical': "Canonical URL",
    'pg.slug': "URL slug",
    'pg.slugShort': "Slug",
    'pg.titleTag': "Title tag",
    'pg.metaDescription': "Meta description",
    'pg.googleTitle': "Title for Google",
    'pg.summaryHint': "A short summary of this page",
    'pg.itemSummaryHint': "A short summary of this item",
    'pg.descriptionHint': "Add a clear description to improve how this page appears in search engines.",
    'pg.itemDescriptionHint': "Add a description to improve how this item is shared.",
    'pg.sharePreview': "Share preview",
    'pg.shareHint': "Set up the card that will appear on social networks and in messages.",
    'pg.ogImage': "Share image (OG)",
    'pg.ogTitle': "Title for social",
    'pg.ogDescription': "Description for social",
    'pg.sameAsSeo': "Same as the SEO",
    'pg.ogDefaultPage': "The page screenshot is used by default. Upload one to customize it.",
    'pg.ogDefaultItem': "The item’s image is used by default. Upload one to customize it.",
    'pg.ogCustom': "Custom image. Click to change it.",
    'pg.ogSources': "From your library, uploaded, or by URL",
    'pg.uploadCover': "Upload a cover image",
    'pg.changeCover': "Change the cover image",
    'pg.password': "Password",
    'pg.accessHint': "Controls who can access this page.",
    'pg.publishPage': "Publish this page",
    'pg.publishPageBody': "When off, it stays in the editor but the site shows “page not found” at its address. Takes effect when you publish.",
    'pg.publishPageHome': "The home page is always published: it is where everyone lands on your site.",
    'pg.unpublished': "Unpublished",
    'pg.passwordRule': "It must be at least 6 characters.",
    'pg.passwordMin': "At least 6 characters",
    'pg.deleteHint': "Deletes this page and all its content from the project.",
    'pg.needOnePage': "The site needs to keep at least one page.",
    'pg.cannotDeleteHome': "The home page cannot be deleted. Make another page the home page first.",
    'pg.deleted': "Page deleted",
    'pg.saved': "Page saved",
    'pg.homeUpdated': "Home page updated",
    'pg.collectionTemplate': "Collection template",
    'pg.mainTemplate': "Main template",
    'pg.templateHint': "This template defines how each collection item looks on the site.",
    'pg.noItemsForSeo': "This collection has no items yet. Create one in Content to edit its SEO.",
    'pg.menuItems': "Menu items",
    'pg.menu': "Menu",
    'pg.pages': "Pages",
    'common.saveChanges': "Save changes",
    'cms.unpublished': "Not published",
    'panels.dragWidth': "Drag to change the width",
    'img.tooBig': "The image must be under 10 MB",
    'cms.blockBadge': "CMS Block",
    'cms.pageBadge': "CMS Page",
    'cms.type.text': "Text",
    'cms.type.images': "Images",
    'cms.type.content': "Content",
    'cms.tpl.website': "Website",
    'cms.tpl.logo': "Logo",
    'cms.tpl.teamName': "Team",
    'cms.noCollectionsYet': "No collections yet. Create the first one to start storing content.",
    'cms.addFirstField': "Add the first custom field",
    'cms.fieldCount': "{count} fields",
    'cms.scheduleNote': "The schedule comes from your “{field}” field. Lists can filter by upcoming, ongoing or finished with nothing else to set up.",
    'cms.createFirstCollection': "Create your first collection",
    'pg.withPassword': "Password protected",
    'pg.public': "Public",
    'pg.makeHome': "Make it the home page",
    'pg.inThisSite': "{count} on this site",
    'pg.deleteConfirm': "Delete “{name}”? This cannot be undone.",
    'pg.charsRecommended': "{count} / {max} characters recommended",
    'cms.scheduleHint': "With this, a list can show only what is upcoming or already past, and it recalculates itself in the browser.",
    'cms.urlPlaceholder': "posts",
    'cms.editContent': "Edit the content",
    'blk.h1Hint': "A section’s headline",
    'blk.h2Hint': "A part within the section",
    'blk.h3Hint': "A point within the part",
    'blk.imageHint': "From your library, uploaded, or by URL",
    'blk.videoHint2': "YouTube or Vimeo",
    'blk.ctaHint': "The action you want them to take",
    'blk.groupText': "Text",
    'blk.groupMedia': "Media",
    'blk.groupSale': "Sale",
    'blk.divider': "Divider",
    'blk.callout': "Callout",
    'blk.image': "Image",
    'blk.video': "Video",
    'blk.cta': "Button",
    'blk.title1': "Heading 1",
    'blk.title2': "Heading 2",
    'blk.title3': "Heading 3",
    'blk.text': "Text",
    'blk.buyNow': "Buy now",
    'blk.codeSample': "code",
    'blk.widthFull': "Full",
    'blk.width': "Width {size}",
    'blk.widthS': "S",
    'blk.widthM': "M",
    'blk.widthL': "L",
    'blkKw.text': "paragraph p normal body",
    'blkKw.h1': "h1 title heading headline",
    'blkKw.h2': "h2 title subtitle heading",
    'blkKw.h3': "h3 title heading",
    'blkKw.bullet': "list bullets ul unordered",
    'blkKw.numbered': "list numbers ol steps",
    'blkKw.quote': "quote blockquote testimonial",
    'blkKw.callout': "callout highlight notice note",
    'blkKw.code': "code pre snippet",
    'blkKw.divider': "divider line hr separator",
    'blkKw.image': "image photo picture media",
    'blkKw.video': "video youtube vimeo player",
    'blkKw.cta': "button cta buy action link",
    'cms.collectionCount': "{count} collections",
    'cms.collectionCountOne': "{count} collection",
    'cms.postCount': "{count} posts",
    'cms.postCountOne': "{count} post",
    'cms.contentOf': "{name} content",
    'limit.resourcePages': "pages",
    'limit.resourceCollections': "collections",
    'limit.resourceItems': "items",
    'limit.reached': "Limit reached",
    'limit.raise': "Raise the limits",
    'limit.maxOf': "You have hit your {plan} plan’s {resource} limit",
    'limit.onTop': "You are on {plan}, our highest plan. If you need more capacity, write to us and we will put together something that fits.",
    'limit.contactUs': "Contact véltica",
    'limit.upgradeTo': "Upgrade to {plan} to keep creating {resource} and unlock more capacity.",
    'limit.upgradeButton': "Upgrade to {plan}",
    'limit.notNow': "Not now",
    'limit.proPrice': "from $9.50/month",
    'limit.businessPrice': "from $19.50/month",
    'limit.proPages': "30 pages",
    'limit.proCms': "20 collections · 500 items",
    'limit.proDomain': "Your own domain, no badge",
    'limit.proAnalytics': "Full analytics",
    'limit.bizPages': "Unlimited pages",
    'limit.bizCms': "100 collections · 5,000 items",
    'limit.bizApps': "Business apps (forms, inbox, sales)",
    'limit.bizSupport': "Priority support",
    'restore.title': "Restore a backup",
    'restore.confirm': "Restore this version?",
    'restore.yes': "Yes, restore it",
    'restore.keepEditing': "Keep editing",
    'restore.restoring': "Restoring…",
    'restore.gone': "That backup no longer exists.",
    'restore.cannotOpen': "The backup could not be opened",
    'restore.cannotRead': "The backup could not be read.",
    'restore.failed': "It could not be restored.",
    'restore.replaced': "Replaced",
    'restore.untouched': "Untouched",
    'restore.pages': "The pages and their content",
    'restore.cms': "The CMS collections and items",
    'restore.theme': "The theme and the site settings",
    'restore.forms': "Your form messages",
    'restore.images': "The images and files you uploaded",
    'restore.contacts': "Your contacts and your sales",
    'boot.loadingProject': "Loading the project",
    'boot.checkingSession': "Checking your session",
    'boot.redirecting': "Redirecting",
    'boot.otherAccount': "This project belongs to another account",
    'boot.signInFailed': "We could not sign you in to the editor",
    'autosave.title': "Autosave · CPU proxy",
    'autosave.hide': "Hide (Alt+M)",
    'autosave.perMinute': "Saves / min",
    'autosave.avgMaxKb': "Avg / Max KB",
    'autosave.lastReqs': "Reqs last",
    'autosave.duration': "Duration",
    'autosave.lastSend': "Last send",
    'autosave.none': "No saves yet…",
    'autosave.clear': "Clear",
    'ctx.elementActions': "Element actions",
    'color.linkGlobal': "Link a global color",
    'color.global': "Global color",
    'color.editGlobal': "Edit the global color",
    'boot.backToDashboard': "Back to the dashboard",
    'restore.willRevert': "Your site will go back to how it was on {when}",
    'restore.undoNote': "Before starting we save a copy of the current version, so this can be undone too.",
    'autosave.avgDuration': "Avg dur: {ms} ms",
    'autosave.errors': "Errors: {count}",
    'ai.title': "AI assistant",
    'ai.close': "Close the assistant",
    'ai.messageAria': "Message for the AI assistant",
    'ai.inputPlaceholder': "Describe what you want to change…",
    'ai.sendMessage': "Send the message",
    'ai.cancelRequest': "Cancel the request",
    'ai.clearSelection': "Clear the selection",
    'ai.copyAnswer': "Copy the AI answer",
    'ai.copied': "Copied",
    'ai.edit': "Edit",
    'ai.discard': "Discard",
    'ai.confirmApply': "Confirm and apply",
    'ai.mayErr': "The AI can make mistakes.",
    'ai.whatToChange': "What do you want to change?",
    'ai.page.confirmTitle': "Change the whole page",
    'ai.page.confirmBody': "{texts} texts · {photos} photos{style}",
    'ai.page.confirmStyle': " · colors and fonts",
    'ai.page.confirmCost': "Uses about {percent}% of your AI for this month. You can undo it afterwards.",
    'ai.page.confirmCostUnknown': "Uses quite a bit more AI than a normal change. You can undo it afterwards.",
    'ai.page.confirmGo': "Change the whole page",
    'ai.page.confirmCancel': "Cancel",
    'ai.page.adaptChip': "Adapt this page to my business",
    'ai.page.adaptDraft': "Adapt this whole page (text, photos and colors) to my business: ",
    'ai.user': "You",
    'ai.preparing': "Preparing",
    'ai.preparingChange': "Preparing the change…",
    'ai.preparingChanges': "Preparing the changes…",
    'ai.preparingDelete': "Preparing the deletion…",
    'ai.analyzing': "Analyzing…",
    'ai.analyzingRequest': "Analyzing the request…",
    'ai.analyzingElement': "Analyzing the element…",
    'ai.reviewingSection': "Reviewing the section…",
    'ai.reviewingStructure': "Reviewing the structure…",
    'ai.reviewingStyles': "Reviewing the styles…",
    'ai.searchingBest': "Looking for the best option…",
    'ai.creatingElements': "Creating the elements…",
    'ai.adjustingContent': "Adjusting the content…",
    'ai.adjustingDesign': "Adjusting the design…",
    'ai.verifyingChange': "Verifying the change…",
    'ai.verifyingResult': "Verifying the result…",
    'ai.applying': "Applying…",
    'ai.applyingSteps': "Applying the request step by step…",
    'ai.updatingBatches': "Updating the page in batches…",
    'ai.changesApplied': "Changes applied",
    'ai.changesUndone': "Changes undone",
    'ai.proposalDiscarded': "Proposal discarded",
    'ai.cancelled': "Cancelled",
    'ai.requestCancelled': "Request cancelled.",
    'ai.noChanges': "No changes",
    'ai.addItemFailed': "I couldn’t add the item to the list.",
    'ai.noChangesNeeded': "No changes needed",
    'ai.noTargets': "No compatible targets",
    'ai.notCompleted': "Not completed",
    'ai.iconsUpdated': "Icons updated",
    'ai.textsUpdated': "Texts updated",
    'ai.imageUpdated': "Professional image updated",
    'ai.step1Icons': "Step 1: icons updated",
    'ai.step2Texts': "Step 2: texts updated",
    'ai.cardsAdded': "Cards added.",
    'ai.cardsDuplicated': "Cards duplicated and content updated.",
    'ai.pageBySection': "Page updated section by section.",
    'ai.completedInSteps': "Done, request completed in steps.",
    'ai.compactCoordinated': "Compact changes coordinated.",
    'ai.solvedLocally': "This request was handled in the editor without calling the model.",
    'ai.cannotProcess': "The request could not be processed.",
    'ai.cannotApply': "The changes could not be applied.",
    'ai.noCompatibleChanges': "I found no compatible changes to apply.",
    'ai.noLocalTexts': "I found no editable local text. CMS, navigation and menus stay protected.",
    'ai.checkedAllSections': "I went through every section; there were no compatible changes to apply.",
    'ai.someBatchesIncomplete': "Some batches came back incomplete; you can retry them from the chat.",
    'ai.batchIncomplete': "A batch did not return every expected local text.",
    'ai.pageChanged': "The page changed during the request.",
    'ai.pageChangedAnalyzing': "The page changed while the AI was analyzing the canvas.",
    'ai.pageChangedCards': "The page changed while the cards were being personalized.",
    'ai.canvasChanged': "The canvas changed while the request was being analyzed. Select the section again and retry.",
    'ai.pickElementDirect': "Select an element before sending a request in “Direct” mode.",
    'ai.pickElementHint': "Select an element on the site and describe the result you are after.",
    'ai.pickPage': "Select a page before using the AI assistant.",
    'ai.savedProjectOnly': "The AI assistant is only available inside a saved project.",
    'ai.askLinkTarget': "Tell me the exact URL, path or anchor the link should use.",
    'ai.quotaExhausted': "You have used up this month’s AI allowance",
    'ai.modeDirect': "Direct: changes elements without touching global tokens.",
    'ai.modeBrand': "Style: changes the global tokens directly.",
    'ai.usageThisMonth': "Assistant usage this month",
    'ai.usageThisMonthColon': "Assistant usage this month:",
    'ai.usageUnlimited': "Assistant usage this month: unlimited",
    'ai.noLimit': "Your account has no limit.",
    'ai.tokensIn': "Input:",
    'ai.tokensCached': "Cached input:",
    'ai.tokensOut': "Output:",
    'ai.tokensReasoning': "Reasoning:",
    'ai.changesLabel': "Changes:",
    'ai.originalRequest': "Original request:",
    'ai.directLink': "Direct link",
    'ai.directChanges': "Direct changes",
    'ai.offerGrid': "This list shows your offers: each card comes from an offer. Create the new one in the dashboard (with its name and price) and it will show up here on its own.",
    'ai.offerGridCta': "Create the offer in the dashboard",
    'ai.cmsEntryAdded': "I added “{name}” to {collection} as a draft. Fill it in on its card and publish it when it’s ready.",
    'ai.cmsEntryAddedUnnamed': "I added a new entry to {collection} as a draft. Fill it in on its card and publish it when it’s ready.",
    'ai.cmsEntryOpen': "Open the card",
    'ai.cmsCollectionPropose': "There’s nowhere to keep this yet. I’ll create the “{collection}” collection with its page, add the first entry as a draft and put its list here.",
    'ai.cmsCollectionCreate': "Create “{collection}”",
    'ai.cmsCollectionCreated': "I created “{collection}” with its page and the first entry as a draft. Fill it in on its card and publish it when it’s ready.",
    'ai.cmsListPlaced': "Its list is now on this page, below the selected section.",
    'ai.addItemNeedsTexts': "I added a copy of the item. Tell me its texts and I’ll write them, or change them by hand.",
    'ai.retrying': "Retrying…",
    'ai.stepNoChanges': "“{step}” made no changes.",
    'ai.changesCount': "{count} changes",
    'ai.batchIntro': "Sure, I’ll make these changes:",
    'ai.changesCountOne': "1 change",
    'ai.literalMissing': "What you asked for word for word isn’t there: {list}. Check it or ask me again.",
    'ai.confirmRemoveOne': "Remove this element?",
    'ai.confirmRemoveMany': "Remove these {count} elements?",
    'ai.tomorrow': "tomorrow",
    'ai.days': "days",
    'ai.localTokens': "0 tokens · handled locally",
    'ai.tokensCount': "{count} tokens",
    'ai.calls': "{count} calls",
    'ai.cachedNote': "cached (no new usage)",
    'ai.inDays': "in {count} days",
    'ai.remainingPct': "You have {pct}% left this month.",
    'ai.howTo.typography': "Your site’s fonts are in Brand › Typography: pick one for headings and one for text. Or just ask me, for example: “change the font to something more elegant”.",
    'ai.howTo.colors': "Your site’s colors are in Brand › Colors: change one and it applies everywhere. Or just ask me, for example: “use green tones”.",
    'ai.howTo.buttons': "Button style is in Brand › Buttons: shape, color and size for the whole site. Or just ask me, for example: “rounder buttons”.",
    'ai.howTo.cards': "Card style is in Brand › Cards: background, border and shadow for the whole site.",
    'ai.howTo.icons': "Icon style is in Brand › Icons: color and box for the whole site.",
    'ai.howTo.logo': "Your logo is in Brand › Logo: upload it or type your business name.",
    'ai.open.typography': "Open Typography",
    'ai.open.colors': "Open Colors",
    'ai.open.buttons': "Open Buttons",
    'ai.open.cards': "Open Cards",
    'ai.open.icons': "Open Icons",
    'ai.open.logo': "Open Logo",
    'ai.resetsOn': "It resets on {date} ({when}).",
    'ai.out.title': "You’ve used all your AI for this month",
    'ai.out.body': "It comes back on {date} ({when}). Everything else keeps working as usual.",
    'ai.out.cta': "Upgrade plan",
    'ai.low': "You’re running low on AI this month: {pct}% left.",
    'ai.gen.out': "You’ve used your plan’s AI generations.",
    'ai.gen.outHint': "Start from a template or a blank page, or upgrade your plan.",
    'ai.meter.title': "AI usage this month",
    'ai.meter.left': "left",
    'ai.meter.resets': "Resets {date} · {when}",
    'ai.meter.unlimited': "No limit on your account",
    'ai.meter.aria': "AI usage this month: {pct}% left",
    'ai.usedOfPlan': "You have used {used} of your{free} plan. It resets on {date} ({when}).",
    'ai.freeSuffix': " free",
    'ai.sectionsProgress': "{done}/{total} sections",
    'ai.verifiedChanges': "{count} verified changes",
    'ai.undo': "Undo",
    'ai.anotherVariant': "Another variant",
    'ai.retry': "Retry",
    'ai.oops.general': "I couldn't complete this change. Please try again; if the problem continues, try describing it differently.",
    'ai.oops.apply.confirm': "That change would delete elements and needs your confirmation, so nothing was changed.",
    'ai.oops.apply.protected': "Part of the selection is locked or comes from the CMS or the menu, and can't be changed here. Nothing was changed.",
    'ai.oops.apply.changed': "Something I was editing changed or disappeared while I worked, so nothing was changed. Please try again.",
    'ai.oops.apply.invalid': "The AI proposed a change this element doesn't support, so nothing was changed. Try describing it differently.",
    'ai.oops.busy': "The service is receiving a high volume of requests right now. Please try again in a few minutes.",
    'ai.oops.tooLarge': "The selection is too large to change in one step. Select a section or a smaller element and try again.",
    'ai.oops.unsupported': "This change isn't available for this element yet. Try describing it differently or select another element.",
    'ai.oops.limit': "You've reached today's request limit. You can keep using the assistant tomorrow.",
    'ai.oops.offline': "You're offline. Check your internet connection and try again.",
    'ai.oops.upstream': "The AI service didn't respond in time or failed to process the request, so nothing was changed. Please try again.",
    'ai.oops.context': "The assistant couldn't read the editor's state; this usually happens after an update. Reload the page and try again.",
    'ai.oops.config': "The assistant isn't available right now because of a server configuration problem. Nothing is wrong with your site.",
    'ai.retryAgain': "Try again",
    'ai.brandMode': "Style",
    'ai.directMode': "Direct",
    'ai.expandPlan': "Get more with another plan",
    'ai.seePlans': "See the plans",
    'ai.quotaSpent': "You have used 100% of your{free} plan’s monthly quota. It resets on {date} ({when}), or you can extend it now.",
    'pgnav.group.pages': "Your pages",
    'pgnav.group.auto': "Automatic",
    'pgnav.group.collections': "Content",
    'pgnav.catalog.services': "Services",
    'pgnav.catalog.digital': "Digital products",
    'pgnav.catalog.products': 'Shop',
    'pgnav.catalog.physical': 'Physical products',
    'pgnav.catalog.bookings': "Bookings",
    'pgnav.viewingWith': "Viewing with “{name}”. Pick another entry",
    'pgnav.record': "Entry",
    'pgnav.catalogInDashboard': "See the offers in the dashboard",
    'pgnav.catalogCreated': "Page created with its default design. Offers show up live.",
    'designs.previewOnly': 'Create your first offer to apply a design.',
    'designs.contentRequired': 'Design applied. The page stays out of the menu and the site until you have an offer of this type.',
    'designs.catalogLoading': 'Your catalog is still loading. Please try again in a moment.',
    'pgnav.card.pages.one': "{count} page",
    'pgnav.card.pages.many': "{count} pages",
    'pgnav.card.posts.one': "{count} post",
    'pgnav.card.posts.many': "{count} posts",
    'pgnav.card.collections.one': "{count} collection",
    'pgnav.card.collections.many': "{count} collections",
    'pgnav.catalogEdit': "Edit the design",
    'pgnav.catalogDesign': "Design the page",
    'pgnav.catalogAuto': "{path} currently uses the automatic design. Open it to design it like your other pages.",
    'offerTemplate.pageName.products': 'Product page',
    'offerTemplate.pageName.services': 'Service page',
    'offerTemplate.pageName.digital': 'Digital product page',
    'offerTemplate.pageName.bookings': 'Booking page',
    'offerTemplate.card.products': 'Page for each product',
    'offerTemplate.card.services': 'Page for each service',
    'offerTemplate.card.digital': 'Page for each digital product',
    'offerTemplate.card.bookings': 'Page for each booking',
    'offerTemplate.card.meta': 'One design for all of them',
    'offerTemplate.hint.auto': 'Each one uses the standard page for now. Open it to design one page that applies to all of them.',
    'offerTemplate.hint.live': 'This design applies to all of them when you publish. Prices, photos and options are edited in the dashboard.',
    'offerTemplate.noOffers': 'No offers yet',
    'designs.empty.preview': 'Design preview',
    'contentHint.minimize': 'Minimize tip',
    'contentHint.expand': 'Show tip',
    'designs.edit.title': "Design here, content in the dashboard",
    'designs.edit.hint': "Adjust the layout here. Update your text, images and details in the dashboard.",
    'designs.edit.cta': "Open dashboard",
    'designs.empty.offer.item.title': 'This is a sample offer',
    'designs.empty.offer.list.title': 'Your first offer starts here',
    'designs.empty.blog.title': 'Prepare your blog’s design',
    'offerTemplate.sample.services': "Sample service",
    'offerTemplate.sample.bookings': "Sample session",
    'offerTemplate.sample.digital': "Sample digital product",
    'offerTemplate.sample.products': "Sample product",
    'offerTemplate.sample.description': "This is how each offer page will look. Once you create the first one, its details show up here.",
    'offerTemplate.sample.feature1': "Unlimited access",
    'offerTemplate.sample.feature2': "Cancel anytime",
    'offerTemplate.sample.feature3': "Members-only perks",
    'offerDetails.emptyHint': "Product information: it fills itself with each item’s “Additional information” fields (ingredients, how to use it…). This item has none filled in yet.",
    'offerPreview.title': "Preview: purchases are off",
    'offerPreview.body': "Here you can see how it looks. On the published page, this button goes to checkout or booking.",
    'offerPreview.close': "Got it",
    'offerDetails.layout': "Layout",
    'offerDetails.layout.tabs': "Tabs (accordion on phones)",
    'offerDetails.layout.accordion': "Accordion",
    'offerDetails.layout.stack': "One after another",
    'offerDetails.description': "Include description",
    'offerDetails.noFields': "This type has no fields yet. Add them in “Additional information” of any offer, or with “+ New field…” when linking a text.",
    'bp.offerDetails': "Product information",
    'sitemap.new.services': 'New service',
    'sitemap.new.bookings': 'New booking service',
    'sitemap.new.digital': 'New digital product',
    'sitemap.new.products': 'New product',
    'pgnav.catalogLive': "Your offers show up on {path} live: no need to republish when they change.",
    'pgnav.noPages': "No pages yet.",
    'pgnav.noCollections': "No content yet.",
    'pgnav.shopCollections': 'Collections',
    'pgnav.newCollection': 'New collection',
    'pgnav.noShopCollections': 'No collections yet. Create them in the dashboard.',
    'pgnav.collectionOpen': 'Open its page on the site',
    'pgnav.collectionPublishFirst': 'Publish the site to see its page',
    'pgnav.collectionEdit': 'Edit in the dashboard',
    'pgnav.collectionTemplate': 'Shared collection design',
    'pgnav.collectionPreviews': 'Preview by collection',
    'pgnav.collectionPreview': 'See the template with this collection',
    'collectionTemplate.pageName': 'Collection page',
    'collectionTemplate.field.title': 'Collection name',
    'collectionTemplate.field.description': 'Collection description',
    'collectionTemplate.field.image': 'Collection image',
    'pgnav.manageContent': "Manage the content",
    'pgnav.pickRecord': "Choose a record",
    'pgnav.pickRecordHint': "Choose which record it previews with",
    'pgnav.viewWith': "View with",
    'pgnav.pagePreview': "Page preview",
    'pgnav.restricted': "Restricted",
    'pgnav.listing': "Listing",
    'pgnav.createListing': "Create a listing page",
    'frm.newField': "New field",
    'frm.editField': "Edit the field",
    'frm.fieldType': "Field type",
    'frm.noLabel': "No label",
    'frm.checkbox': "Checkbox",
    'frm.consent': "Consent checkbox",
    'frm.onSubmit': "Message on submit",
    'frm.onMessage': "When a message arrives",
    'frm.texts': "Texts",
    'frm.titleField': "Title",
    'frm.notifyEmail': "Notify by email",
    'frm.alsoSendTo': "Also send to",
    'frm.invalidEmail': "Enter a valid email",
    'frm.alreadyAdded': "Already added",
    'frm.maxReached': "Maximum reached",
    'frm.titleHint': "It shows as the heading and names the message inbox.",
    'frm.hiddenHint': "Hidden on the page. It still names the message inbox.",
    'frm.descriptionPlaceholder': "Add a short description",
    'frm.namePlaceholder': "contact, quote…",
    'frm.emailPlaceholder': "name@company.com",
    'frm.samplePlaceholder': "e.g. John",
    'frm.moveUp': "Move up",
    'frm.moveDown': "Move down",
    'frm.noneFem': "None",
    'frm.tags': "Tags",
    'code.title': "Custom code",
    'code.editorAria': "Custom code editor",
    'code.linkCms': "Link CMS code",
    'code.linkedToCms': "Code linked to the CMS",
    'code.pickFieldHint': "Pick a Code field. In a list, each record’s value is used.",
    'newpg.templates': "Templates for the new page",
    'newpg.catalog': "Template catalogue",
    'newpg.categories': "Template categories",
    'newpg.createTemplate': "Create a template",
    'newpg.loading': "Loading templates…",
    'newpg.loadFailed': "The templates could not be loaded.",
    'newpg.createFailed': "The page could not be created.",
    'newpg.preparing': "Preparing the page…",
    'newpg.applyingStyle': "Applying your style…",
    'newpg.blankPage': "Blank page",
    'newpg.blank': "Blank",
    'newpg.pageType.home': "Home",
    'newpg.pageType.about': "About",
    'newpg.pageType.services': "Services",
    'newpg.pageType.pricing': "Pricing",
    'newpg.pageType.contact': "Contact",
    'newpg.pageType.landing': "Landing",
    'newpg.pageType.portfolio': "Portfolio",
    'newpg.editBrand': "Edit the style →",
    'newpg.template': "Template",
    'nav.contact': "Contact",
    'frm.submissionsHint': "Every message lands in the dashboard inbox. Here you choose what else happens.",
    'frm.typeEnter': "Type and press Enter",
    'frm.whatTitle': "the heading",
    'frm.whatDescription': "the description",
    'frm.inbox': "Inbox",
    'frm.viewsAria': "Form sections",
    'frm.fieldLabel': "Label",
    'frm.form': "Form",
    'frm.omnisendNone': "Connect your account in Settings → Omnisend, in the dashboard, to be able to turn this on.",
    'frm.omnisendInvalid': "The Omnisend key stopped working. Nothing is sent until you change it in the dashboard.",
    'frm.consentHint': "With the box unchecked the contact still arrives, but is not subscribed to your campaigns. Writing to you is not asking for the newsletter.",
    'frm.tagsHint': "They sort the dashboard inbox. If sending to Omnisend is on, they travel with the contact too.",
    'frm.addCheckbox': "Add a checkbox",
    'frm.addField': "Add a field",
    'newpg.kicker': "New page",
    'newpg.title': "Choose how to start",
    'newpg.lead': "Generate the page with AI or start from a template. It uses your project's colors and typography.",
    'newpg.templatesTitle': "Templates",
    'newpg.previewTitle': "Preview",
    'newpg.previewNote': "With your project's colors and typography",
    'newpg.ai.card': "Generate with AI",
    'newpg.ai.cardHint': "Describe the page and the AI builds it in your site's style.",
    'newpg.ai.promptTitle': "What page do you want to create?",
    'newpg.ai.placeholder': "A services page with pricing, frequently asked questions and a clear way to contact us…",
    'newpg.ai.ideas': "Ideas",
    'newpg.ai.minChars': "Write at least {min} characters ({count}/{min})",
    'newpg.ai.generate': "Generate page",
    'newpg.ai.generating': "Generating your page…",
    'newpg.ai.step.plan': "Figuring out which sections it needs…",
    'newpg.ai.step.copy': "Writing the copy…",
    'newpg.ai.step.sections': "Choosing the design of each section…",
    'newpg.ai.step.images': "Finding images…",
    'newpg.ai.errorTitle': "We couldn't generate the page",
    'newpg.ai.errorLead': "Something went wrong while the AI was building the page. Try again; your description is still here.",
    'newpg.ai.limitTitle': "You've used today's generations",
    'newpg.ai.limitLead': "You can generate with AI again tomorrow. In the meantime, start from a template or a blank page.",
    'newpg.ai.edit': "Edit description",
    'newpg.ai.retry': "Try again",
    'newpg.ai.idea.about': "About us",
    'newpg.ai.idea.aboutPrompt': "An \"About us\" page that tells the story of the business, its team and its values, and ends inviting people to get in touch.",
    'newpg.ai.idea.services': "Services",
    'newpg.ai.idea.servicesPrompt': "A services page with a short intro, all our services, how we work in three steps and a call to action to request information.",
    'newpg.ai.idea.pricing': "Pricing",
    'newpg.ai.idea.pricingPrompt': "A plans page with our monthly plans and what each one includes, frequently asked questions about payments and a button to get started.",
    'newpg.ai.seeded': "We added what was missing to your catalog as drafts to complete.",
    'newpg.ai.seedFailed': "The page was added, but we couldn't create what was missing. Add it from the catalog.",
    'newpg.ai.blogOpened': "Your blog is ready: this page lists all your posts.",
    'newpg.ai.idea.faq': "FAQ",
    'newpg.ai.idea.faqPrompt': "A frequently asked questions page that answers customers' most common questions and offers contact if anything is left.",
    'newpg.ai.idea.contact': "Contact",
    'newpg.ai.idea.contactPrompt': "A contact page with the ways to reach us, opening hours and a simple form.",
    'newpg.sections.kicker': "Step 2 of 2",
    'newpg.sections.title': "Your page sections",
    'newpg.sections.lead': "Reorder them, turn them off or try another variant. Switching variants doesn't use AI: it keeps the same copy.",
    'newpg.sections.back': "Choose again",
    'newpg.sections.variant': "Another variant",
    'newpg.sections.variantHint': "Another design with the same copy",
    'newpg.sections.variantNone': "There are no other variants of this section yet.",
    'newpg.sections.up': "Move up",
    'newpg.sections.down': "Move down",
    'newpg.sections.visible': "Show this section",
    'newpg.brandNote': "The colors and typography belong to your project and apply to every page. The new page inherits them.",
    'pgnav.new': "New",
    'reuse.none': "No reusable sections",
    'reuse.inThisSite': "Reusable on this site",
    'reuse.dragHint': "Drag it onto the canvas to place it on this page",
    'reuse.stopKeeping': "Stop keeping it reusable",
    'reuse.notPlaced': "It is not placed on any page.",
    'reuse.inOnePlace': "In 1 place",
    'reuse.inPlaces': "In {count} places",
    'reuse.unused': "Unused",
    'reuse.placedStays': "The placed section stays",
    'files.locked': "Files locked",
    'files.signIn': "Sign in to upload and manage files.",
    'files.loading': "Loading files…",
    'files.none': "No files",
    'files.uploadToStart': "Upload an image to get going.",
    'files.more': "More options",
    'files.replaceSelected': "Use in selected image",
    'files.addToPage': "Add to page",
    'files.showUse.one': "Show where it's used (1)",
    'files.showUse.many': "Show where it's used ({count})",
    'files.unused': "Not used on the site",
    'files.deleteUsedTitle': "Delete this image?",
    'files.deleteUsedBody.one': "It's used in 1 place on the site. If you delete it, that spot will be left without an image.",
    'files.deleteUsedBody.many': "It's used in {count} places on the site. If you delete it, those spots will be left without an image.",
    'lib.locked': "Library locked",
    'lib.empty': "Library empty",
    'lib.signIn': "Sign in to browse the professional library.",
    'lib.searchPlaceholder': "Search by topic or hashtag…",
    'lib.searchAria': "Search professional images",
    'lib.loadFailed': "The library could not be loaded.",
    'lib.searching': "Searching images…",
    'lib.loadingImages': "Loading images…",
    'lib.loadingMore': "Loading more…",
    'lib.tryAnother': "Try another topic or keyword.",
    'lib.willAppear': "The images you add will show up here.",
    'files.uploadMany': "Upload images",
    'files.uploading': "Uploading…",
    'files.dropOne': "Drag an image here or click to choose one",
    /* Found by hand: the lint rule does not look inside template literals. */
    'img.uploadedMany': "{count} images uploaded",
    'img.tabUploads': "Uploads",
    'img.tabGallery': "Gallery",
    'img.uploadingOne': "Uploading your image…",
    'img.uploadingMany': "Uploading {count} images…",
    'cms.imagesOf': "Images from {name}",
    'el.sectionN': "Section {n}",
    'common.aboutX': "About {title}",
    'el.columnTitleN': "Column {n} title",
    'common.addX': "Add {label}",
    'type.format': "Format",
    'token.tabOff': "{label} is off.",
    'token.tabTurnOn': "Turn it on to edit it.",
    'common.enableX': "Enable {label}",
    'common.disableX': "Disable {label}",
    'common.reset': "Reset",
    'common.resetX': "Reset {label}",
    'form.hideOnPage': "Hide {what} on the page",
    'form.showOnPage': "Show {what} on the page",
    'form.maxTags': "At most {max}",
    'cms.optionN': "Option {n}",
    /* Left panel schema. */
    'panel.styles': "Styles",
    'panel.combinations': "Combinations",
    'panel.showMore': "Show more",
    'panel.colorPalettes': "Color palettes",
    'panel.palettes': "Palettes",
    'panel.fontPairing': "Font pairing",
    'panel.fontCombos': "Font combinations",
    'panel.globalColors': "Global colors",
    'panel.quickActions': "Quick actions",
    'panel.shift': "Shift",
    'panel.random': "Random",
    'panel.primary': "Primary",
    'panel.secondary': "Secondary",
    'panel.surface': "Surface",
    'panel.neutralLight': "Light neutral",
    'panel.neutralMid': "Mid neutral",
    'panel.neutralDark': "Dark neutral",
    'panel.accent1': "Accent 1",
    'panel.accent2': "Accent 2",
    'panel.solid': "Solid",
    'panel.gradient': "Gradient",
    'panel.recent': "Recent",
    'panel.mainHeadings': "Main headings",
    'panel.subHeadings': "Secondary headings",
    'panel.tertiaryHeadings': "Tertiary headings",
    'panel.cardHeadings': "Card headings",
    'panel.featuredLabels': "Featured labels",
    'panel.microcopy': "Microcopy",
    'panel.paragraphs': "Paragraphs",
    'panel.smallText': "Small text",
    'brand.eyebrow': "Eyebrow",
    'panel.typefaces': "Typefaces",
    'panel.textStyles': "Text styles",
    'panel.components': "Components",
    'panel.navigation': "Navigation",
    'panel.menu': "Menu",
    'panel.actions': "Actions",
    'panel.navBackground': "Nav background",
    'panel.behavior': "Behavior",
    'panel.sections': "Sections",
    'panel.height': "Height",
    'panel.contentWidth': "Content width",
    'panel.containers': "Containers",
    'panel.childGap': "Gap between children",
    'panel.columns': "Columns",
    'panel.footerLogo': "Footer logo",
    'panel.cards': "Cards",
    'panel.variant': "Variant",
    'panel.withImage': "With image",
    'panel.withIcon': "With icon",
    'panel.contentAlign': "Content alignment",
    'panel.images': "Images",
    'panel.fitMode': "Fit mode",
    'panel.radius': "Radius",
    'panel.filter': "Filter",
    'panel.icons': "Icons",
    'panel.primaryIcons': "Primary icons",
    'panel.secondaryIcons': "Secondary icons",
    'panel.buttons': "Buttons",
    'panel.size': "Size",
    'panel.forms': "Forms",
    'panel.textInput': "Text input",
    'panel.errorMessages': "Error messages",
    'panel.reviews': "Reviews / Testimonials",
    'panel.bigQuote': "Large quote",
    'panel.showStars': "Show stars",
    'panel.showPhoto': "Show photo",
    'panel.showUserCount': "Show user count",
    'panel.badges': "Labels / Badges",
    'panel.paletteN': "Palette {n}",
    /* Built-in brand colors and styles. */
    'brand.accent': "Accent",
    'color.globalX': "Global color: {name}",
    'common.editX': "Edit {name}",
    'brand.card': "Card",
    'brand.borders': "Borders",
    'brand.paragraph': "Paragraph",
    'brand.buttonPrimary': "Primary button",
    'brand.buttonSecondary': "Secondary button",
    'brand.cardBase': "Base card",
    'brand.contentWidth': "Content width",
    'brand.contentWidthMode': "Width",
    'brand.contentAuto': "Auto",
    'brand.contentCustom': "Custom",
    'brand.contentFull': "Full",
    'brand.contentLimited': "Limited",
    'brand.contentMax': "Max width",
    'brand.contentWidthHint': "Auto: each section keeps its own width.",
    'brand.sectionBase': "Default section",
    'brand.sectionSecondary': "Secondary section",
    'brand.sectionNav': "Navigation",
    'brand.sectionFooter': "Footer",
    'brand.cardSoft': "Bordered card",
    'brand.cardColor': "Color card",
    'brand.iconPrimary': "Primary icon",
    'brand.iconPlain': "Icon without background",
    'brand.iconSoft': "Soft icon",
    'brand.iconAccent': "Accent icon",
    /* Looks listos por familia, en el panel Style. */
    'looks.color': "Color",
    'looks.colorHint': "Palettes that work together",
    'looks.fontHint': "Font pairs for headings and text",
    'looks.buttonsHint': "Button shapes and styles",
    'looks.cardsHint': "Corners, borders and shadows",
    'looks.sectionsHint': "Spacing between sections and the menu",
    'looks.font': "Font",
    'looks.buttons': "Buttons",
    /* Estilos de diseño de Combinations. */
    'design.hint': "Changes the whole site at once: colors, fonts, buttons, cards and spacing. Every part can still be adjusted afterwards.",
    'design.product': "Product",
    'design.product.desc': "Bright white, pearl gray and one action blue. Tight headings, lots of air",
    'design.precision': "Precision dark",
    'design.precision.desc': "Near-black software look with hairline borders and small light buttons",
    'design.notebook': "Notebook 2D",
    'design.notebook.desc': "Paper white, ink lines and flat offset shadows",
    'design.brutalist': "Brutalist",
    'design.brutalist.desc': "Bone, black and orange with 2px borders and hard shadows",
    'design.studio': "Studio",
    'design.studio.desc': "Black and white with a vivid blue, large rounded cards",
    'design.wireframe': "Wireframe",
    'design.wireframe.desc': "Structure on show: black lines, square corners",
    'design.creator': "Creator",
    'design.creator.desc': "Clean course-platform look with a trusted blue",
    'design.marketplace': "Marketplace",
    'design.marketplace.desc': "Dense and orderly, yellow buy button, thin borders",
    'design.editorial': "Editorial",
    'design.editorial.desc': "Large light serif headlines on warm paper",
    'design.luxury': "Quiet luxury",
    'design.luxury.desc': "Ivory, near-black and muted gold with spaced capitals",
    'design.swiss': "Swiss",
    'design.swiss.desc': "Tight grotesk, black and red, nothing rounded",
    'design.fintech': "Fintech",
    'design.fintech.desc': "Midnight blue headings, violet actions, floating white cards",
    'design.consulting': "Consulting",
    'design.consulting.desc': "Deep navy, sober serif, square blocks",
    'design.gallery': "Gallery",
    'design.gallery.desc': "Warm stone, one terracotta note, lots of air",
    'design.calm': "Calm",
    'design.calm.desc': "Off-white and forest green with a gentle serif",
    'design.heritage': "Heritage",
    'design.heritage.desc': "Ink blue and old gold with a classic serif",
    'design.developer': "Developer",
    'design.developer.desc': "Pure black, white buttons, hairline borders",
    'design.clay': "Warm tech",
    'design.clay.desc': "Cream, near-black and clay with serif headings",
    'design.retail': "Retail",
    'design.retail.desc': "Black and white with wide uppercase buttons",
    'design.nordic': "Nordic",
    'design.nordic.desc': "Fog gray, slate and steel blue, soft and light",
    'looks.cards': "Card",
    /* La revisión de plantillas antes de publicarlas (ver `templateContract`). */
    'contract.title': "Template review",
    'contract.clean': "Everything follows the style system: it will change with any style.",
    'contract.summary': "Errors: {errors} · Warnings: {warnings}. Anything with an error stays the same when someone picks another style.",
    'contract.blocked': "Fix the errors to publish it to the library.",
    'contract.fixAll': "Link automatically ({count})",
    'contract.publishAnyway': "Publish anyway",
    'contract.view': "View",
    'contract.autoFix': "links automatically",
    'contract.prop.color': "text color",
    'contract.prop.background': "background",
    'contract.prop.backgroundColor': "background",
    'contract.prop.borderColor': "border color",
    'contract.kind.color-unmatched': "Color written by hand in the {detail}, not from the palette",
    'contract.kind.color-auto': "The {detail} matches a palette color but isn't linked to it",
    'contract.kind.custom-token': "Uses a style that only this template has ({detail}); other sites won't have it",
    'contract.kind.gradient': "Gradient with fixed colors",
    'contract.kind.font-family': "Font set on the element: it won't follow the style's fonts",
    'contract.kind.font-size': "Own size instead of its text style's",
    'contract.kind.no-typography': "Text without a text style",
    'contract.kind.no-button-style': "Button without a global button style",
    'contract.kind.card-unlinked': "Looks like a card but doesn't use a card style",
    'color.alternate': "Alternate background",
    'color.mutedText': "Secondary text",
    'looks.group.shape': "Shape",
    'looks.group.shadow': "Shadow",
    'looks.group.inner': "Inner shadow",
    'looks.group.size': "Size",
    'looks.group.text': "Text",
    'looks.group.weight': "Weight",
    'looks.group.spacing': "Spacing",
    'looks.button.pill': "Pill",
    'looks.button.rounded': "Rounded",
    'looks.button.square': "Soft square",
    'looks.button.sharp': "Sharp",
    'looks.button.tonal': "Tonal pill",
    'looks.button.tonalRounded': "Tonal",
    'looks.button.outlinePill': "Outline pill",
    'looks.button.outline': "Outline",
    'looks.button.ghost': "Ghost",
    'looks.button.link': "Text link",
    'looks.button.inked': "Ink line",
    'looks.button.brutal': "Brutalist",
    'looks.shadow.none': "None",
    'looks.shadow.hairline': "Hairline",
    'looks.shadow.subtle': "Subtle",
    'looks.shadow.soft': "Soft",
    'looks.shadow.medium': "Medium",
    'looks.shadow.large': "Large",
    'looks.shadow.hard2d': "Flat 2D",
    'looks.shadow.hard': "Hard offset",
    'looks.inner.none': "None",
    'looks.inner.highlight': "Top highlight",
    'looks.inner.ring': "Inner ring",
    'looks.inner.bevel': "Bevel",
    'looks.inner.soft': "Soft inset",
    'looks.size.small': "Small",
    'looks.size.compact': "Compact",
    'looks.size.regular': "Regular",
    'looks.size.large': "Large",
    'looks.size.wide': "Wide",
    'looks.text.normal': "Normal",
    'looks.text.tight': "Tight",
    'looks.text.uppercase': "Uppercase",
    'looks.text.spaced': "Spaced caps",
    'looks.weight.regular': "Regular",
    'looks.weight.medium': "Medium",
    'looks.weight.semibold': "Semibold",
    'looks.weight.bold': "Bold",
    'looks.card.hairline': "Hairline",
    'looks.card.outlined': "Outlined",
    'looks.card.box': "Box",
    'looks.card.soft': "Soft",
    'looks.card.rounded': "Rounded",
    'looks.card.flat': "Flat",
    'looks.card.square': "Plain square",
    'looks.card.sharp': "Sharp",
    'looks.card.ink': "Ink line",
    'looks.card.bold': "Bold",
    'looks.spacing.compact': "Compact",
    'looks.spacing.regular': "Regular",
    'looks.spacing.comfortable': "Comfortable",
    'looks.spacing.roomy': "Roomy",
    'looks.spacing.spacious': "Spacious",
    'looks.sections': "Sections",
    'looks.section.spacingHint': "Space above and below every section. It scales down on iPad and mobile.",
    'looks.section.spacingTab': "Spacing",
    'looks.nav.tab': "Navigation bar",
    'looks.nav.hint': "How the bar separates from the page. Applies to the bar across the site.",
    'looks.nav.none': "No separation",
    'looks.nav.line': "Hairline",
    'looks.nav.ink': "Ink line",
    'looks.nav.bold': "Thick line",
    'looks.nav.tinted': "Tinted bar",
    'looks.nav.tintedLine': "Tinted with line",
    'looks.section.tight': "Tight",
    'looks.section.spacious': "Spacious",
    'looks.section.compact': "Compact",
    'looks.section.balanced': "Balanced",
    'looks.section.airy': "Airy",
    /* The canvas right-click menu. */
    'flex.grid': "Grid",
    'menu.resetLayout': "Reset layout",
    'menu.bringForward': "Bring forward",
    'menu.sendBackward': "Send backward",
    'menu.selectContainer': "Select container",
    'menu.block': "Block",
    'menu.section': "Section",
    'menu.cut': "Cut",
    'menu.copy': "Copy",
    'menu.paste': "Paste",
    'menu.duplicate': "Duplicate",
    'menu.groupIntoBlock': "Group into a block",
    'menu.wrapIn': "Wrap in",
    'menu.design': "Design",
    'menu.saveToMySections': "Save to My sections",
    'menu.reuse': "Reuse",
    'menu.delete': "Delete",
    'menu.lock': "Lock element",
    'menu.unlock': "Unlock element",
    'menu.showOn': "Show on {device}",
    'menu.hideOn': "Hide on {device}",
    'menu.makeReusable': "Make reusable",
    'menu.unlinkReusable': "Unlink from reusable",
    /* Right panel. */
    'panel.content': "Content",
    'panel.after': "After",
    'panel.iconOne': "Icon",
    'panel.stars': "Stars",
    'panel.avatars': "Avatars",
    'panel.direction': "Direction",
    'panel.element': "Element",
    'panel.fit': "Fit",
    'panel.focus': "Focus",
    'panel.crop': "Crop",
    'panel.iconPx': "Icon px",
    'panel.starPx': "Star px",
    'panel.avatarPx': "Avatar px",
    'panel.border': "Border",
    'panel.effects': "Effects",
    /* Project overview. */
    'common.user': "there",
    'greet.morning': "Good morning, {name}",
    'greet.afternoon': "Good afternoon, {name}",
    'greet.evening': "Good evening, {name}",
    'time.inOneDay': "in 1 day",
    'time.inNDays': "in {n} days",
    'overview.unnamedSubmission': "Unnamed submission",
    'pages.home': "Home",
    'overview.stats': "Statistics",
    'overview.payouts': "Payouts",
    'overview.nextPayout': "Next payout",
    'overview.yourBalance': "Your balance",
    'overview.stripeNotEnabled': "Stripe has not enabled them yet",
    'overview.perStripeSchedule': "On your Stripe schedule",
    'overview.deductedNext': "Deducted from the next payout",
    'overview.readyToPayout': "Ready to pay out",
    'overview.analyticsSummary': "Visits",
    'overview.visitsSoon': "Visits to your site will show up here as they come in.",
    'overview.publishToMeasure': "Publish your site to start measuring traffic.",
    'overview.underReview': "Under review",
    'overview.transferInvite': "You have been invited to accept the transfer of a site. Check its details and what it includes above.",
    'overview.teamInvite': "You have been invited to a team. The invitation is waiting above.",
    'onboard.pages': "Add pages to your site",
    'onboard.pagesBody': "Build your site’s structure and navigation.",
    'onboard.goPages': "Go to Pages",
    'onboard.content': "Create content with the CMS",
    'onboard.contentBody': "Organize posts and dynamic content.",
    'onboard.goContent': "Go to Content",
    'onboard.offer': "Create your first offer",
    'onboard.offerBody': "Sell a service, a digital product or bookings.",
    'onboard.goOffer': "Create offer",
    'onboard.publish': "Publish your site",
    'onboard.publishBody': "Put your project online and share it with everyone.",
    'onboard.goEditor': "Open Editor",
    'overview.editWidgets': "Edit widgets",
    'overview.editingWidgets': "Move them, resize them or take one out. Nothing here is permanent. Put it back whenever you like.",
    'overview.editingWidgetsGreeting': "Let's rearrange this",
    'widgets.allPlaced': "Every widget is in place",
    'widgets.editingLabel': "Editing widgets",
    'widgets.addPlaceholder': 'Add a widget',
    'widgets.add': "Add widget ({n})",
    'overview.seeMore': "See more",
    'overview.seeAll': "See all",
    'time.today': "Today",
    'time.yesterday': "Yesterday",
    'time.daysAgo': "{n} days ago",
    'overview.linkCopied': "Link copied",
    'overview.copyLink': "Copy link",
    'common.copied': "Copied",
    'overview.previousPeriod': "Previous period",
    'overview.moreActionsFor': "More actions for {name}",
    'overview.seeNMore': "See {n} more",
    'overview.openInEditor': "Open in editor",
    'common.settings': "Settings",
    'overview.openPublished': "Open published",
    'overview.livesite': "Published site",
    'overview.tipPublished': "Last published",
    'overview.tipEdited': "Last edited in the editor",
    'overview.revenue': "Revenue",
    'overview.sales': "Sales",
    'chart.range': "{from} to {to}",
    'chart.aria': "{what}. Maximum {max}.",
    'pages.deletedOne': "{n} page deleted",
    'pages.deletedMany': "{n} pages deleted",
    'pages.subtitle': "Create, organize and manage your site’s pages.",
    'pages.internal': "Internal pages",
    'pages.thisPage': "this page",
    'pages.lastEdited': "Last edited",
    'list.deselectAll': "Clear the selection",
    'list.selectAllOnPage': "Select every one on this page",
    'list.selectX': "Select {name}",
    'list.starX': "Star {name}",
    'forms.subtitle': "Manage the messages your site receives.",
    'forms.monthlySubmissions': "Submissions this month",
    'forms.markRead': "Mark as read",
    'forms.markUnread': "Mark as unread",
    'forms.unit': "submissions",
    'style.modern': "Modern",
    'style.elegant': "Elegant",
    'style.warm': "Warm",
    'style.night': "Night",
    'font.serifClassic': "Serif / Classic",
    'font.sansModern': "Sans / Modern",
    'language.suggest': "Looks like you are somewhere {language} is spoken.",
    'language.suggestSwitch': "Switch",
    /* The editor tutorial. */
    'svcw.info.accentBrand': "Your brand color",
    'svcw.info.accentOther': "A different one",
    'svcw.info.themeHint': "How the booking page looks. \u00abAutomatic\u00bb follows the device of whoever is booking.",
    'svcw.cancel.contact': 'Who the client writes to',
    'svcw.cancel.contactHint': 'The email and phone shown on their booking, for when they need to reach you.',
    'svcw.cancel.contactDefault': "Your project's notification email",
    'onb.progress': "Step {index} of {total}",
    'onb.skip': "Skip",
    'onb.skipSteps': "Skip these steps",
    'onb.skipStepsHint': "Keep the panel tips.",
    'onb.skipAll': "Skip all help",
    'onb.skipAllHint': "Dismiss the tutorial and panel tips.",
    'onb.rail.about': "About {panel}",
    'onb.rail.eyebrow': "Get to know this panel",
    'onb.rail.gotIt': "Got it",
    'onb.rail.return': "Back to tutorial",
    'onb.rail.templates.body': "Add ready-made sections to your page.",
    'onb.rail.templates.tip1': "Choose a category to explore its designs.",
    'onb.rail.templates.tip2': "Drag a template onto the canvas or use Add.",
    'onb.rail.catalog.body': "Create offers and choose how they look on your page.",
    'onb.rail.catalog.tip1': "Add products, digital files, bookings or services.",
    'onb.rail.catalog.tip2': "Drag an offer or a catalog layout onto the canvas.",
    'onb.rail.blog.body': "Create posts and add your blog to your page.",
    'onb.rail.blog.tip1': "Choose a design for a post or for your latest posts.",
    'onb.rail.blog.tip2': "Drag a design onto the canvas to place it on your page.",
    'onb.rail.collections.body': "Show your collections on your page: a team, a portfolio, pets for adoption…",
    'onb.rail.collections.tip1': "Open a collection and choose a list or a single entry.",
    'onb.rail.collections.tip2': "Drag the design onto the canvas: it fills itself with your entries.",
    'onb.rail.styles.body': "Change the look of your entire site.",
    'onb.rail.styles.tip1': "Adjust your colors, fonts and button styles.",
    'onb.rail.styles.tip2': "Try a design combination to change the overall style.",
    'onb.rail.images.body': "Find photos for your page in the image gallery.",
    'onb.rail.images.tip1': "Drag a photo onto an image on the canvas to replace it.",
    'onb.rail.images.tip2': "Use search to find an image that fits your content.",
    'onb.rail.files.body': "Upload and organize your site's files.",
    'onb.rail.files.tip1': "Use your uploaded images to replace one on the canvas.",
    'onb.rail.files.tip2': "Check where each file is used before removing it.",
    'onb.rail.layers.body': "Explore and organize your page's structure.",
    'onb.rail.layers.tip1': "Expand the arrows to select elements inside each section.",
    'onb.rail.layers.tip2': "Drag sections or use the up and down controls to reorder them.",
    'onb.rail.insert.body': "Add individual elements to your page.",
    'onb.rail.insert.tip1': "Drag text, images or buttons onto the canvas.",
    'onb.rail.insert.tip2': "Select an element to adjust its properties.",
    'onb.rail.pages.body': "Manage your pages and site navigation.",
    'onb.rail.pages.tip1': "Create a page with AI, a template or a blank canvas.",
    'onb.rail.pages.tip2': "Open a page's settings to change its name, address and SEO.",
    'onb.rail.cms.body': "Organize your content in collections.",
    'onb.rail.cms.tip1': "Create a collection for posts, projects or another list.",
    'onb.rail.cms.tip2': "Connect collection fields to canvas elements for dynamic pages.",
    /* The two moments of the first step: the canvas and the picker. */
    'onb.section.rail.title': "Add a section",
    'onb.section.rail.body': "Click + between sections, or the purple button if the canvas is empty.",
    'onb.section.panel.title': "Pick a kind",
    'onb.section.panel.body': "Click a category (a header, some cards, a footer) and you will see the templates of that kind.",
    'onb.section.popup.title': "Choose a template",
    'onb.section.popup.body': "Select a design to see its preview.",
    'onb.section.add.title': "Add the section",
    'onb.section.add.body': "Click Add section to place it on the page. You can change everything later.",
    'onb.text.title': "Change some text",
    'onb.text.body': "Click highlighted text, then choose Edit text in the contextual toolbar.",
    'onb.text.edit.title': "Now click Edit text",
    'onb.text.edit.body': "Type your own words, then click outside the text to keep them.",
    'onb.done.title': "Your site is live!",
    'onb.done.body': "You added a section, made it yours and published it. Anyone with the link can see it now.",
    'onb.done.view': "View my site",
    'onb.done.keep': "Keep editing",
    'pub.done.body': "Your latest changes are published. Anyone with the link can see them now.",
    'onb.publish.title': "Publish",
    'onb.publish.body': "Hit Publish at the top right and your site gets a working address.",
    'cwa.charsLeft': "{count} characters left",
    'cwa.generateShortcut': "Generate my site (⌘↵)",
    'cwa.step.business': "Business",
    'cwa.hue': "Hue",
    'cwa.hueHint': "Turns the hue of the whole palette: backgrounds, cards and buttons change together, so they still match.",
    'cwa.hueOriginal': "Original hue",
    'cwa.paletteGroup.suggested': "Suggested",
    'cwa.paletteGroup.moderno': "Modern",
    'cwa.paletteGroup.calido': "Warm",
    'cwa.paletteGroup.elegante': "Elegant",
    'cwa.paletteGroup.nocturno': "Dark",
    'cwa.paletteAi': "The palette the AI picked",
    'cwa.paletteAiBadge': "AI",
    'cwa.paletteOwn': "The style's palette",
    'cwa.paletteOwnBadge': "Style",
    'cwa.paletteYours': "Your palette",
    'cwa.paletteByAi': "Created by the AI",
    'cwa.paletteOfStyle': "Style palette",
    'cwa.fontByAi': "Created by the AI",
    'cwa.fontOfStyle': "From the style",
    'cwa.styleOfCombination': "From your combination",
    'cwa.paletteMore': "Other palettes",
    'cwa.paletteYoursHint': "The colors your site will use. Click one to change it.",
    'cwa.paletteCurrent': "The chosen palette",
    'cwa.paletteCurrentBadge': "Chosen",
    'cwa.wz.error.title': "We couldn't generate your site",
    'cwa.wz.error.lead': "Something went wrong while the AI was building your site. Try again; your description is still here.",
    'cwa.wz.error.createLead': "The project couldn't be created. Try again in a moment.",
    'cwa.wz.error.edit': "Edit description",
    'cwa.wz.limit.title': "You've used today's generations",
    'cwa.wz.limit.lead': "You can create sites with AI again tomorrow. In the meantime, start from a template or a blank project.",
    'cwa.wz.limit.other': "Start another way",
    'cwa.wz.limit.foot': "The limit resets every day.",
    'cwa.variantNone': "There are no other variants of this section yet.",
    'cwa.step.contact': "Contact",
    'cwa.wz.dialogAria': "Create a site with AI",
    'cwa.wz.progressAria': "Steps to create your site",
    'cwa.wz.kicker': "Step {n} of {total}",
    'cwa.wz.info.title': "Your business",
    'cwa.wz.info.lead': "The name and logo people will know you by. The AI already suggested a name: change it if you like.",
    'cwa.wz.style.title': "Pick a style",
    'cwa.wz.style.lead': "The shape of your site: buttons, cards, borders and spacing between sections. Your colors and fonts stay as you picked them.",
    'cwa.wz.colors.title': "Colors",
    'cwa.wz.colors.lead': "Your colors, ready to use. Change any of them or try another palette.",
    'cwa.wz.fonts.title': "Typography",
    'cwa.wz.fonts.lead': "The typeface for headings and for body text. Check it in the preview before you decide.",
    'cwa.wz.sections.title': "Your site sections",
    'cwa.wz.sections.lead': "Reorder them, turn them off or try another variant. The new variant keeps the same copy.",
    'cwa.wz.contact.title': "Contact and socials",
    'cwa.wz.contact.lead': "Add only what you want to show: email, phone, WhatsApp or your social profiles. Everything you add shows up in your site footer.",
    'cwa.wz.previewNote': "This is how your site will look",
    'cwa.wz.createNow': "Create it now",
    'cwa.wz.generating.plan': "Planning the structure of your site…",
    'cwa.wz.generating.copy': "Writing the copy…",
    'cwa.wz.generating.sections': "Picking the sections that fit best…",
    'cwa.wz.generating.images': "Finding images for your business…",
    'cwa.wz.generating.style': "Applying colors and typography…",
    'cwa.businessNamePlaceholder': "Luna Coffee",
    'cwa.logoUpload': "Upload a logo",
    'cwa.logoChange': "Change",
    'cwa.logoRemove': "Remove",
    'cwa.brandColorHint': "Used on buttons, links and accents.",
    'cwa.fromStyleColor': "The color that comes with the style",
    'cwa.palettesHint': "Pick one to start from: its colors move up to your palette, where you can adjust them.",
    'cwa.fromStylePalette': "The style's backgrounds and text",
    'cwa.fromStyleFont': "The typeface that comes with the style",
    'cwa.fontFilter.all': "All",
    'cwa.fontFilter.sans': "Sans serif",
    'cwa.fontFilter.script': "Script",
    'cwa.fontFilter.serif': "Serif",
    'cwa.fontSingle': "One family for everything",
    'cwa.buttonsHint': "Pick a group and try an option. Click it again to go back to the style's.",
    'cwa.cardsHint': "How service, pricing and review blocks look.",
    'cwa.spacingHint': "More space feels calmer; less feels more direct.",
    'cwa.contact.added': "On your site",
    'cwa.contact.addedHint': "They appear in the footer, in this order.",
    'cwa.contact.empty': "You haven't added anything yet. Pick below what you want to show.",
    'cwa.contact.needed': "Your page shows these details. Fill them in or the site will show “Add your…” instead.",
    'cwa.contact.neededTag': "Shown on your page",
    'cwa.contact.neededMap': "Your page map needs it",
    'cwa.hours.title': "Opening hours",
    'cwa.slider.prev': "Previous",
    'cwa.slider.next': "Next",
    'cwa.paletteEdit': "Change colors",
    'cwa.paletteHide': "Done",
    'cwa.sheet.open': "Open the step",
    'cwa.sheet.close': "Fold to see the page",
    'cwa.locations.title': "Locations",
    'cwa.locations.hint': "Only if you have more than one. With one, the address above is enough.",
    'cwa.locations.name': "Name",
    'cwa.locations.namePlaceholder': "Downtown",
    'cwa.locations.address': "Address",
    'cwa.locations.addressPlaceholder': "Street, number and area",
    'cwa.locations.phone': "Phone",
    'cwa.locations.hours': "Hours",
    'cwa.locations.add': "Add another location",
    'cwa.hours.hint': "Shown in the map, the contact section and your site footer.",
    'cwa.hours.needed': "Your page shows opening hours: add yours or the sample ones will show.",
    'cwa.hours.days': "Days",
    'cwa.hours.daysPlaceholder': "Monday to Friday",
    'cwa.hours.time': "Hours",
    'cwa.hours.timePlaceholder': "9:00 am – 6:00 pm",
    'cwa.hours.add': "Add hours",
    'cwa.contact.add': "Add",
    'cwa.contact.remove': "Remove",
    'cwa.contact.group.contact': "Contact",
    'cwa.contact.group.social': "Socials and web",
    'cwa.contact.kind.email': "Email",
    'cwa.contact.kind.phone': "Phone",
    'cwa.contact.kind.whatsapp': "WhatsApp",
    'cwa.contact.kind.address': "Address",
    'cwa.contact.kind.instagram': "Instagram",
    'cwa.contact.kind.facebook': "Facebook",
    'cwa.contact.kind.linkedin': "LinkedIn",
    'cwa.contact.kind.tiktok': "TikTok",
    'cwa.contact.kind.x': "X",
    'cwa.contact.kind.youtube': "YouTube",
    'cwa.contact.kind.website': "Website",
    'cwa.contact.placeholder.email': "hello@yourbusiness.com",
    'cwa.contact.placeholder.phone': "Number",
    'cwa.contact.placeholder.whatsapp': "Number",
    'cwa.contact.placeholder.address': "Street, number, city",
    'cwa.contact.placeholder.instagram': "@yourbusiness",
    'cwa.contact.placeholder.facebook': "facebook.com/yourbusiness",
    'cwa.contact.placeholder.linkedin': "linkedin.com/company/yourbusiness",
    'cwa.contact.placeholder.tiktok': "@yourbusiness",
    'cwa.contact.placeholder.x': "@yourbusiness",
    'cwa.contact.placeholder.youtube': "@yourbusiness",
    'cwa.contact.placeholder.website': "yourbusiness.com",
    'auth.signupHeroAria': "Urban architecture lit by the sunset",
    'create.blankPage': "Blank page",
    'create.blankPageBody': "Start from scratch with an empty canvas.",
    'create.newProject': "New project",
    'create.stepOf': "Step {n} of {total}",
    'orders.subtitle': "The sales Stripe has confirmed. The money goes straight into the site’s account; it does not pass through Veltica.",
    'an.loadFailed': "Analytics could not be loaded.",
    'an.noCountries': "No countries recorded yet.",
    'an.moreCountries': "More countries",
    'an.noPages': "No pages recorded yet.",
    'an.noDevices': "No devices recorded yet.",
    'an.term': "Term",
    'an.noCampaigns': "No campaigns recorded yet.",
    'an.noSources': "No traffic sources recorded yet.",
    'an.direct': "Direct",
    'an.views': "Views",
    'an.viewsUnit': "views",
    'an.source': "Source",
    'an.medium': "Medium",
    'an.content': "Content",
    'an.device': "Device",
    'team.loadFailed': "The team could not be loaded. Try again.",
    'team.inviteFailed': "The invitation could not be sent. Try again.",
    'team.roleSaveFailed': "The role changes could not be saved. Try again.",
    'team.actionFailed': "The action could not be completed. Try again.",
    'team.seatsUnlimitedOne': "{count} active collaborator · unlimited seats",
    'team.seatsUnlimitedMany': "{count} active collaborators · unlimited seats",
    'team.seatsUsedOne': "{used} of {limit} seat used",
    'team.seatsUsedMany': "{used} of {limit} seats used",
    'team.noSeatsIncluded': "Your plan does not include collaborator seats.",
    'team.seatLimit': "You have reached your plan’s seat limit.",
    'team.upgradeToCollaborate': "Upgrade to enable collaboration on this project.",
    'team.freeUpSeats': "Cancel an invitation, revoke an existing access, or upgrade to free up seats.",
    'team.upgradeCta': "Upgrade plan",
    'team.upsell.eyebrow': "Collaboration",
    'team.upsell.title': "Build this project with your team",
    'team.upsell.body': "Invite the people who work on it with you and give each one exactly the access they need.",
    'team.upsell.point1': "A role per person, from full editor to view only",
    'team.upsell.point2': "They work on this project without seeing your billing",
    'team.upsell.point3': "Revoke an access whenever you want, in one click",
    'team.roleSavedOne': "Role updated",
    'team.roleSavedMany': "{count} roles updated",
    'team.savingRoles': "Saving roles…",
    'team.unnamed': "No name",
    'team.projectFallback': "this project",
    'team.memberFallback': "this member",
    'team.revokeAria': "Revoke {name}’s access",
    'team.revokeTitle': "Revoke access",
    'team.cancelInviteFor': "Cancel the invitation for {email}",
    'team.sendingInvite': "Sending…",
    'team.copied': "Copied",
    'team.copyLink': "Copy link",
    'team.leaving': "Leaving…",
    'team.removing': "Removing…",
    'team.cancelling': "Cancelling…",
    'team.leftToast': "You left {project}",
    'team.removedToast': "{name} no longer has access",
    'team.inviteCancelledToast': "Invitation to {name} cancelled",
    'team.sendInvite': "Send invitation",
    'team.cancelInviteAria': "Cancel the invitation",
    'team.cancelInvite': "Cancel invitation",
    'forms.deleteWarning': "The selected messages and all their answers will be deleted permanently. This cannot be undone.",
    'overview.unit.offer': "offer",
    'overview.unit.offers': "offers",
    'overview.unit.booking': "upcoming appointment",
    'overview.unit.bookings': "upcoming appointments",
    'overview.unit.contact': "recent contact",
    'overview.unit.contacts': "recent contacts",
    'overview.unit.message': "recent message",
    'overview.unit.messages': "recent messages",
    'overview.unit.sale': "recent sale",
    'overview.unit.sales': "recent sales",
    'overview.unit.order': 'order to ship',
    'overview.unit.orders': 'orders to ship',
    'overview.lastPublished': "Last published {when}",
    'overview.lastUpdated': "Updated {when}",
    'overview.row.openInEditor': "Open in Editor",
    'overview.row.openCollection': "Open collection",
    'overview.row.openProfile': "Open profile",
    'overview.row.viewCharge': "View charge",
    'overview.row.viewBooking': "View booking",
    'overview.row.openOffer': "Open offer",
    'overview.row.viewMessage': "View message",
    /* Found by hand: the lint rule does not look inside conditionals. */
    'cms.noFieldsFit': "This collection has no fields that fit here.",
    'cms.noFieldNamed': "No field with that name.",
    'img.selectOne': "Select image",
    'tpl.oneSection': "{n} section",
    'tpl.nSections': "{n} sections",
    'cms.collectionTitleLabel': "Collection title",
    'cms.collectionDescLabel': "Collection description",
    'cms.collectionTitleSample': "The collection title",
    'cms.collectionDescSample': "The collection description",
    'form.sampleTextarea': "Tell us about your project",
    'form.sampleSelect': "Choose an option",
    'panel.italic': "Italic",
    'panel.typography': "Typography",
    'panel.font': "Font",
    'panel.weight': "Weight",
    'panel.style': "Style",
    'panel.decoration': "Decoration",
    'panel.transform': "Transform",
    'panel.alignment': "Alignment",
    'panel.lineHeight': "Line height",
    'panel.color': "Color",
    'panel.background': "Background",
    'panel.spacing': "Spacing",
    'panel.width': "Width",
    'panel.shadow': "Shadow",
    'panel.animation': "Animation",
    /* Text alignment in the floating toolbar. */
    'align.left': "Left",
    'align.center': "Centered",
    'align.right': "Right",
    'align.justify': "Justified",
    'align.cycleTitle': "Alignment: {current}",
    'align.cycleAria': "Text alignment: {current}. Change to {next}",
    'el.headingN': "Heading {n}",
    'backup.httpStatus': "The server answered with HTTP {status}.",
    /* CMS. */
    'cms.deleteFieldQ': "Delete “{name}”?",
    'cms.deleteFieldUsedOne': "You will lose what 1 item has in this field. This cannot be undone.",
    'cms.deleteFieldUsedMany': "You will lose what {count} items have in this field. This cannot be undone.",
    'cms.deleteOptionQ': "Delete “{name}”?",
    'cms.deleteOptionUsedOne': "It will be removed from the 1 item that has it. This cannot be undone.",
    'cms.deleteOptionUsedMany': "It will be removed from the {count} items that have it. This cannot be undone.",
    'cms.deleteItemQ': "Delete “{name}”?",
    'cms.deleteItemsQ': "Delete {count} items?",
    'cms.deleteCollectionQ': "Delete the “{name}” collection?",
    'cms.collectionSettings': "Collection settings",
    'files.dropMany': "Drag images here or click to choose them",
    'saved.searchPlaceholder': "Search saved items…",
    'saved.searchAria': "Search saved items",
    'saved.none': "No saved items",
    'saved.hint': "Right-click an element on the canvas and choose Save as a section.",
    'saved.confirmDelete': "Yes, delete it",
    'sect.adding': "Adding…",
    'sect.add': "Add a section",
    'sect.yourCollections': "Your content",
    'sect.wire.label': "Section view",
    'sect.wire.design': "Design",
    'sect.wire.structure': "Structure",
    'sect.yourCollectionsHint': "A collection’s list, connected to its content",
    'sect.collectionOneEntry': "{n} entry",
    'sect.collectionEntries': "{n} entries",
    'drop.itemImageFailed': "Couldn't save the photo to that item. Try again.",
    'sectAi.ask.title': "What should this section say?",
    'sectAi.ask.go': "Create section",
    'sectAi.ask.ph': "Focus, tone or details to include…",
    'sectAi.create': "Create with AI",
    'sectAi.hint': "Same design, with texts written for your business. Uses a few AI tokens.",
    'sectAi.failed': "The AI couldn't write this section; it kept the sample texts.",
    'sectAi.noTokens': "You've used this month's AI tokens; the section kept the sample texts.",
    'sectAi.tooMany': "Too many AI requests today; the section kept the sample texts.",
    'sect.families': "Section families",
    'sect.sections': "Sections",
    'sect.noneInFamily': "No sections in this family.",
    'sect.pick': "Pick a section",
    'sect.pickHint': "Click any on the left to see it in full here.",
    'sect.preview': "Section preview",
    'tpl.none': "No templates.",
    'tpl.searchAria': "Search templates",
    'tpl.noPage': "No page",
    'tpl.addAfter': "Add “{name}” after the selection",
    'tpl.add': "Add",
    'tpl.createPageFirst': "Create a page to use templates.",
    'tpl.seeMore': "See more",
    'tpl.premium': "Premium",
    'reuse.emptyHint': "Right-click a section on the canvas and choose “Make it reusable”.",
    'reuse.stopsBeing': "{name} stops being reusable.",
    'reuse.manyStay': "The {count} placed sections keep their content and stop syncing.",
    'reuse.oneStays': "The placed section keeps its content and stops syncing.",
    'files.formats': "JPG · PNG · WebP · GIF · AVIF · 10 MB max",
    'files.dropMedia': 'Drop to upload',
    'files.mediaFormats': 'JPG · PNG · WebP · GIF · AVIF · MP4 · WebM',
    'common.sure': "Sure?",
    'cms.loadMore': "Load more",
    'tpl.searchPlaceholder': "Search…",
    'cvs.dragRadius': "Drag to change the border radius",
    'cvs.dragGap': "Drag to adjust the gap",
    'cvs.adjustGap': "Adjust the gap",
    'cvs.aiWorking': "The AI is updating the canvas",
    'cvs.frameTitle': "Editing canvas",
    'cvs.loadingPage': "Loading the page",
    'cvs.emptyPage': "Empty page",
    'cvs.listEmpty.services': "No services yet",
    'cvs.listEmpty.memberships': 'No memberships yet',
    'cvs.listEmpty.bookings': "No booking services yet",
    'cvs.listEmpty.digital': "No digital products yet",
    'cvs.listEmpty.products': "No products yet",
    'cvs.listEmpty.all': "No offers yet",
    'cvs.listEmpty.blog': "No posts yet",
    'cvs.listEmpty.hint': "When you create the first one, it shows up here with this design. On the site, the section stays hidden while it is empty.",
    'cvs.listEmpty.collection': "No entries in {name} yet",
    'cvs.listEmpty.createEntry': "Create entry",
    'cvs.listEmpty.pickCollection': "Choose collection",
    'cvs.listEmpty.nocollection': "This list has no collection",
    'cvs.listEmpty.noCollectionHint': "Choose which collection the cards come from, or create one in the CMS.",
    'cvs.emptyHint': "Start with a section, or drag a block here.",
    'cvs.addSection': "Add a section",
    'cvs.add': "Add",
    'cvs.repeats': "Repeats",
    'cvs.inNRecords': "Across the list’s {count} records",
    'cvs.whyRepeats': "Why it repeats",
    'cvs.repeatsHint': "What sits inside a list is a template: it is drawn once per record, so writing here writes in all of them. To make it differ per record, link the element to a CMS field. To make it appear once, move it out of the list.",
    'cvs.takeOutOfList': "Take it out of the list so it appears once",
    'cvs.doubleClickToEdit': "Double-click to edit it",
    'cvs.whatIsReusable': "What a reusable section is",
    'cvs.placedOnce': "It is placed in 1 spot. ",
    'cvs.reusableHint': "What you change inside changes on every page that uses it.",
    'cvs.reusableBanner': "What you change here changes on every page it is placed on",
    'cvs.reusableSection': "Reusable section",
    'cvs.saveSection': "Save the section",
    'cvs.sectionName': "Section name",
    'cvs.editTextHere': "Edit text",
    'cvs.editFormOptions': "Edit the form options",
    'cvs.hasAnimation': "Has an animation · Edit",
    'cvs.viewOpened': "View open",
    'cvs.addAnother': "Duplicate",
    'cvs.duplicate': "Duplicate",
    'cvs.duplicateCard': "Duplicate card",
    'cvs.listAdd.card': "Add card",
    'cvs.listAdd.photo': "Add photo",
    'cvs.listAdd.review': "Add review",
    'cvs.listAdd.question': "Add question",
    'cvs.listHint': "This section has cards: add another from here, or pick one and duplicate it.",
    'cvs.addInside': "Add here",
    'cvs.open.dropdown': "Open dropdown",
    'cvs.open.inline': "Open “show more”",
    'cvs.open.modal': "Open window",
    'cvs.open.drawer': "Open side panel",
    'cvs.open.fullscreen': "Open full screen",
    'cvs.open.menu': "Open menu",
    'cvs.closeOpened': "Close",
    'cvs.opensOnClick': "opens on click",
    'cvs.opensOnHover': "opens on hover",
    'embed.pasteCode': "Paste code",
    'cvs.stateHint': "Interaction state: pick another or go back to Normal",
    'cvs.stateAria': "Element interaction state",
    'cvs.pickOtherCollection': "Choose another collection",
    'cvs.searchField': "Search for a field…",
    'cvs.searchFieldAria': "Search for a field",
    'cvs.searchRecord': "Search for a record…",
    'cvs.searchRecordAria': "Search for a record",
    'cvs.searchAny': "Search for a collection or record…",
    'cvs.searchAnyAria': "Search for a collection or record",
    'cvs.noRecordNamed': "No record by that name.",
    'cvs.nothingNamed': "Nothing by that name.",
    'cvs.records': "Records",
    'cvs.takeOut': "Take it out of the list",
    'cvs.exit': "Exit",
    'cvs.placedInN': "It is placed in {count} spots. ",
    'bp.block': "Block",
    'bp.section': "Section",
    'bp.grid': "Grid",
    'bp.layout': "Layout",
    'bp.media': "Media",
    'bp.interactive': "Interactive",
    'bp.brand': "Brand",
    'bp.typography': "Typography",
    'bp.navbar': "Navbar",
    'bp.footer': "Footer",
    'bp.form': "Form",
    'bp.beforeAfter': "Before / After",
    'beforeAfter.before': "Before",
    'beforeAfter.after': "After",
    'beforeAfter.position': "Initial position",
    'beforeAfter.compare': "Compare before and after",
    'bp.gallery': "Gallery",
    'bp.marquee': "Endless gallery",
    'bp.cmsGallery': "CMS gallery",
    'bp.cmsGalleryLong': "CMS gallery",
    'bp.carousel': "Carousel",
    'bp.cardRail': "Card rail",
    'bp.tabs': "Tabs",
    'bp.tabsCarousel': "Carousel tabs",
    'bp.faq': "Questions",
    'bp.faqLong': "Frequently asked questions",
    'bp.reviews': "Reviews",
    'bp.logos': "Logos",
    'redesign.title': "Change design",
    'redesign.category': "Section type",
    'redesign.previous': "Previous design",
    'redesign.next': "Next design",
    'redesign.hint': "Pick a design: your texts, buttons and photos move to it. Undo with ⌘Z when you close.",
    'redesign.noneYet': "none yet",
    'redesign.dropped': "This design has fewer spots: {count} items are hidden. They come back if you return to another design.",
    'redesign.original': "Original",
    'redesign.empty': "No other designs in this type yet.",
    'bp.progress': "Progress bar",
    'sample.progressLabel': "Satisfied customers",
    'progress.value': "Value",
    'progress.label': "Text",
    'progress.labelPlaceholder': "What it measures",
    'progress.layout': "Layout",
    'progress.layout.stacked': "Stacked",
    'progress.layout.inline': "Inline",
    'progress.layout.bar': "Bar only",
    'progress.showValue': "Show percentage",
    'progress.height': "Thickness",
    'progress.tone': "Color",
    'progress.tone.primary': "Primary",
    'progress.tone.accent': "Accent",
    'progress.tone.muted': "Soft",
    'progress.corners': "Corners",
    'progress.corners.round': "Round",
    'progress.corners.square': "Square",
    'logos.yes': "Yes",
    'logos.no': "No",
    'logos.layout': "Layout",
    'logos.layout.row': "Row",
    'logos.layout.grid': "Grid",
    'logos.layout.marquee': "Scrolling",
    'logos.columns': "Columns",
    'logos.size': "Logo size",
    'logos.speed': "Speed",
    'logos.grayscale': "Grayscale",
    'logos.grayscaleHint': "Image logos show in gray and get their color back on hover.",
    'logos.tiles': "In tiles",
    'logos.items': "Logos",
    'logos.uploadMany': "Upload logos",
    'logos.uploadOne': "Upload logo",
    'logos.hint': "Each logo can be an image (PNG or SVG with a transparent background works best) or the name written as text.",
    'logos.kind': "Image or text",
    'logos.kind.image': "Image",
    'logos.kind.text': "Text",
    'logos.name': "Name",
    'logos.namePlaceholder': "Brand name",
    'logos.altPlaceholder': "Brand name (for accessibility)",
    'logos.link': "Link",
    'logos.linkPlaceholder': "Link (optional)",
    'logos.moveUp': "Move up",
    'logos.moveDown': "Move down",
    'logos.add': "Add logo",
    'bp.review': "Review",
    'bp.rating': "Rating",
    'rating.value': "Rating",
    'rating.showValue': 'Numeric rating',
    'rating.number.hidden': 'Hide',
    'rating.number.visible': 'Show',
    'rating.max': "Out of",
    'rating.shape': "Shape",
    'rating.shape.star': "Star",
    'rating.shape.heart': "Heart",
    'rating.shape.circle': "Circle",
    'rating.empty': "Empty",
    'rating.empty.soft': "Soft",
    'rating.empty.outline': "Outline",
    'rating.empty.hidden': "Hidden",
    'rating.gap': "Spacing",
    'bp.stat': "Stat",
    'bp.countdown': "Countdown",
    'bp.popover': "Popover",
    'bp.opener': "Button that opens…",
    'popover.howItOpens': "How does it open?",
    'popover.pres.inline': "Show more",
    'popover.pres.dropdown': "Dropdown",
    'popover.pres.modal': "Window",
    'popover.pres.drawer': "Side panel",
    'popover.pres.fullscreen': "Full screen",
    'bp.modal': "Window",
    'bp.modalLong': "Pop-up window",
    'bp.customCode': "Custom code",
    'embed.setupBody': 'This component is hidden on the canvas. Open Preview to see your code in action.',
    'embed.openPreview': 'Open Preview',
    'embed.openPanel': 'Open panel',
    'embed.canvasEmpty': "Custom code: double-click to edit",
    'embed.canvasHasCode': "Custom code · shows on the published page",
    'bp.cardWheel': "Card wheel",
    'bp.avatars': "Avatars",
    'avatars.photos': "Photos",
    'avatars.size': "Size",
    'avatars.spacing': "Spacing",
    'bp.avatar': "Avatar",
    'bp.icon': "Icon",
    'bp.image': "Image",
    'bp.video': "Video",
    'bp.videoEmbed': "YouTube / Vimeo",
    'video.badge': "Video",
    'files.filter': "What to show",
    'files.filter.all': "All",
    'files.filter.images': "Photos",
    'files.filter.videos': "Videos",
    'video.uploading': "Uploading… {pct}%",
    'video.uploadFailed': "Couldn't upload the video.",
    'image.cropValue': "Adjust",
    'video.cover': "Cover",
    'video.coverFromVideo': "From the video",
    'video.coverOwn': "Own photo",
    'video.coverAuto': "Back to the video’s cover",
    'video.pick': "Select video",
    'video.upload': "Upload video",
    'video.onlyMp4': "MP4 or WebM videos only.",
    'media.kind': "Type",
    'media.image': "Image",
    'media.video': "Video",
    'media.slider': "Slide",
    'bgSlider.edit': "Edit photos",
    'bgSlider.pick': "Choose photos",
    'bgSlider.need': "Choose at least 2 photos to start the slide.",
    'bgSlider.count': "{count} photos",
    'bgSlider.effect': "Effect",
    'bgSlider.marquee': "Infinite",
    'bgSlider.fade': "Fade",
    'bgSlider.slide': "Slide",
    'bgSlider.zoom': "Zoom",
    'bgSlider.interval': "Each photo",
    'bgSlider.speed': "Speed",
    'bgSlider.transition': "Transition",
    'bgSlider.zoomAmount': "Zoom",
    'bgSlider.direction': "Direction",
    'bgSlider.toLeft': "To the left",
    'bgSlider.toRight': "To the right",
    'bgSlider.dragHint': "Drag to reorder",
    'bgSlider.add': "Add photos",
    'media.change': "Change",
    'video.playAria': "Play the video",
    'bg.tabMedia': "Media",
    'video.audio': "Audio",
    'video.audioOff': "No audio",
    'video.audioOn': "With audio",
    'video.audioOnHint': "Starts muted (browsers allow nothing else) and plays sound as soon as the visitor touches the page",
    'texture.title': "Texture",
    'texture.none': "None",
    'texture.remove': "Remove the texture",
    'texture.strength': "Intensity",
    'texture.grid': "Grid",
    'texture.dots': "Dots",
    'texture.lines': "Lines",
    'texture.diagonal': "Diagonals",
    'texture.grain': "Grain",
    'texture.blur': "Blur",
    'texture.frosted': "Frosted",
    'texture.vignette': "Vignette",
    'video.playback': "Playback",
    'video.ambient': "Ambient",
    'video.ambientHint': "Plays on its own, muted and looping",
    'video.player': "Player",
    'video.playerHint': "With controls: press play and it has sound",
    'video.embedPlaceholder': "https://www.youtube.com/watch?v=…",
    'video.embedTab': "Video",
    'video.setupTitle': 'Add your video',
    'video.setupBody': 'Paste a YouTube or Vimeo link to add your video to the page.',
    'video.openPanel': 'Open settings',
    'video.embedUrl': "YouTube or Vimeo link",
    'video.embedHint': "Paste the video link; it shows with its player when published.",
    'video.embedInvalid': "That link isn't from YouTube or Vimeo.",
    'editor.video.embedEmpty': "Paste a YouTube or Vimeo link",
    'bp.logo': "Logo",
    'bp.link': "Link",
    'bp.links': "Links",
    'bp.list': "List",
    'bp.simpleList': "Simple list",
    'bp.line': "Line",
    'bp.spacer': "Spacer",
    'spacer.size': "Spacer size",
    'bp.text': "Text",
    'bp.smallText': "Small text",
    'bp.paragraph': "Paragraph",
    'bp.title': "Title",
    'bp.smallTitle': "Small title",
    'bp.mainTitle': "Main title",
    'bp.secondTitle': "Secondary title",
    'bp.sectionTitle': "Section title",
    'bp.blockTitle': "Block title",
    'bp.button': "Button",
    'bp.primaryButton': "Primary button",
    'bp.secondaryButton': "Secondary button",
    'bp.badge': "Badge",
    'bp.menu': "Menu",
    'bp.mobileMenu': "Mobile menu",
    'bp.panel': "Panel",
    'bp.megaPanel': "Mega panel",
    'bp.trigger': "Trigger",
    'bp.arrows': "Arrows",
    'bp.dots': "Dots",
    'bp.track': "Track",
    'bp.viewport': "Viewport",
    'bp.gridBlock': "Grid",
    'bp.content': "Content",
    'bp.hiddenContent': "Hidden content",
    'bp.whatWasHidden': "What was hidden",
    'bp.editableBlocks': "Editable blocks",
    'bp.mainInfo': "Main information",
    'bp.legalInfo': "Legal information",
    'bp.legalLinks': "Legal links",
    'bp.copyright': "Copyright",
    'bp.authorData': "Author details",
    'bp.countdownLabel': "Countdown label",
    'bp.countdownUnits': "Countdown units",
    'bp.cms': "CMS",
    'bp.catalog': "Catalog",
    'bp.catalogGrid': "Catalog grid",
    'bp.catalogList': "Catalog list",
    'bp.catalogCarousel': "Catalog carousel",
    'bp.catalogFeatured': "Featured offer",
    'bp.offerImage': "Offer image",
    'bp.offerDuration': "Offer duration",
    'bp.offerTitle': "Offer title",
    'bp.offerDescription': "Offer description",
    'bp.offerPrice': "Offer price",
    'bp.offerCompareAt': "Compare-at price (struck)",
    'bp.offerCompareRow': "Compare-at price and discount",
    'bp.offerDiscount': "Discount",
    'sample.offerType': "Service",
    'bp.overlay': "Overlay",
    'bp.offerType': "Offer type",
    'bp.offerButton': "Offer button",
    'bp.offerButtons': "Buttons",
    'bp.offerMoreButton': "“More info” button",
    'bp.cardBody': "Body",
    'bp.cardFooter': "Footer",
    'bp.price': "Price",
    'bp.cmsTitle': "CMS Title",
    'bp.cmsText': "CMS Text",
    'bp.cmsImage': "CMS Image",
    'bp.cmsDate': "CMS Date",
    'bp.cmsName': "CMS Name",
    'bp.cmsDescription': "CMS Description",
    'bp.cmsCard': "CMS Card",
    'bp.cmsFeaturedCard': "CMS Featured card",
    'bp.cmsCollectionCard': "CMS Collection card",
    'bp.cmsList': "CMS List",
    'bp.cmsSimpleList': "CMS Simple list",
    'bp.cmsGrid': "CMS Grid",
    'bp.cmsCarousel': "CMS Carousel",
    'bp.cmsRow': "CMS Row",
    'bp.cmsRowText': "CMS Row text",
    'bp.cmsSimpleRow': "CMS Simple row",
    'bp.cmsArticle': "CMS Article",
    'bp.cmsFeatured': "CMS Featured",
    'bp.cmsIndex': "CMS Index",
    'bp.cmsRest': "CMS Rest",
    'bp.collectionIndex': "Collection index",
    'bp.article': "Article",
    'bp.featured': "Featured",
    'bp.blogArticle': "Blog Article",
    'bp.blogCategories': "Blog Categories",
    'bp.blogDate': "Blog Date",
    'bp.blogImage': "Blog Image",
    'bp.blogRichContent': "Blog Rich Content",
    'bp.blogTitle': "Blog Title",
    'bp.h1': "Heading 1",
    'bp.h2': "Heading 2",
    'bp.h3': "Heading 3",
    'bp.h4': "Heading 4",
    'bp.h5': "Heading 5",
    'bp.h6': "Heading 6",
    'bp.smallTextEn': "Small text",
    'sample.postTitle': "Post title",
    'sample.offerTitle': "Offer name",
    'sample.offerDescription': "What it includes, in one or two lines.",
    'sample.offerPrice': "Price: $45",
    'sample.offerDuration': "1 h",
    'sample.offerCta': "See details",
    'sample.offerMore': "More info",
    'part.form.title': "Form title",
    'part.form.label': "Labels",
    'part.form.input': "Fields",
    'part.form.submit': "Submit button",
    'part.form.message': "Success message",
    'part.review.card': "Card",
    'part.review.name': "Name",
    'part.review.meta': "Detail",
    'part.review.text': "Text",
    'part.review.avatar': "Photo",
    'part.review.source': "Source",
    'part.review.stars': "Stars",
    'part.review.more': "“See more” button",
    'part.faq.item': "Question row",
    'part.faq.question': "Question",
    'part.faq.answer': "Answer",
    'part.faq.icon': "Icon",
    'part.selectOnCanvas': "Select “{name}” on the canvas",
    'bp.cd.days.value': "Days · number",
    'bp.cd.days.label': "Days · label",
    'bp.cd.hours.value': "Hours · number",
    'bp.cd.hours.label': "Hours · label",
    'bp.cd.minutes.value': "Minutes · number",
    'bp.cd.minutes.label': "Minutes · label",
    'bp.cd.seconds.value': "Seconds · number",
    'bp.cd.seconds.label': "Seconds · label",
    'bp.offerCard': "Offer card",
    'sample.articleTitle': "Article title",
    'sample.modalTitle': "Window title",
    'sample.collectionName': "Collection name",
    'sample.collectionDescription': "Collection description…",
    'sample.contentDescription': "Content description…",
    'sample.insertTitle': 'Ideas taking shape',
    'sample.insertBody': 'Discover a fresh perspective. Every detail counts when creating something special.',
    'bp.blogPopular': "Most read",
    'bp.blogRelated': "Related posts",
    'bp.blogAdjacent': "Previous and next",
    'bp.blogShare': "Share",
    'bp.shopCollections': "Collections",
    'bp.shopNewest': "New arrivals",
    'bp.shopBestsellers': "Best sellers",
    'bp.shopRelated': "You may also like",
    'bp.cmsCategories': "Categories",
    'bp.cmsRecent': "Latest entries",
    'bp.cmsRelated': "Related entries",
    'bp.blogToc': "Table of contents",
    'bp.blogBreadcrumb': "Breadcrumb",
    'bp.blogNewsletter': "Newsletter",
    'bp.blogAuthorProfile': "Author bio",
    'bp.blogAuthor': "Author",
    'bp.blogAuthorPhoto': "Author photo",
    'bp.blogAuthorText': "Author text",
    'bp.blogAuthorName': "Author name",
    'bp.blogAuthorMeta': "Date and reading time",
    'bp.blogReadingTime': "Reading time",
    'blogWidget.settings': "Blog piece",
    'blogWidget.onlyOnPost': "Shows on each post page.",
    'blogWidget.showTitle': "Title",
    'blogWidget.title': "Title text",
    'blogWidget.titlePlaceholder': "Default",
    'blogWidget.limit': "How many",
    'blogWidget.look': "Look",
    'blogWidget.look.chips': "Chips",
    'blogWidget.look.list': "List",
    'blogWidget.look.cloud': "Cloud",
    'blogWidget.look.cards': "Cards",
    'blogWidget.look.icons': "Icons",
    'blogWidget.look.buttons': "Buttons",
    'blogWidget.showCount': "Count",
    'blogWidget.avatar': "Photo",
    'blogWidget.avatar.photo': "Photo",
    'blogWidget.avatar.initials': "Initials",
    'blogWidget.avatar.none': "None",
    'blogWidget.layout': "Layout",
    'blogWidget.layout.column': "Column",
    'blogWidget.layout.row': "Row",
    'blogWidget.showImage': "Photo",
    'blogWidget.showDate': "Date",
    'blogWidget.buttonText': "Button text",
    'blogWidget.buttonPlaceholder': "Default",
    'blogWidget.text': "Text",
    'blogWidget.textPlaceholder': "Get new posts in your inbox.",
    'blogWidget.tag': "Contacts tag",
    'blogWidget.tagPlaceholder': "newsletter",
    'blogWidget.titleSize': "Title size",
    'blogWidget.textSize': "Text size",
    'blogWidget.avatarSize': "Photo size",
    'blogWidget.gap': "Row spacing",
    'cms.photoSize': "Photo size",
    'cms.photoSize.design': "From design",
    'cms.photoSize.sm': "Small",
    'cms.photoSize.md': "Medium",
    'cms.photoSize.lg': "Large",
    'cms.railBleed': "To the screen edge",
    'cms.listGap': "Photo to text",
    'cms.listSpacing': "Between texts",
    'cms.space.sm': "Less",
    'cms.space.md': "Normal",
    'cms.space.lg': "More",
    'blogWidget.titleStyle': "Title style",
    'blogWidget.textStyle': "Text style",
    'blogWidget.metaStyle': "Date and count style",
    'blogWidget.styleDefault': "Site default",
    'blogWidget.tagNote': "Each email lands in Contacts with this tag.",
    'blogWidget.field.search': "Search",
    'blogWidget.field.topic': "Topic",
    'blogWidget.field.author': "Author",
    'blogWidget.field.sort': "Sort",
    'bp.blogFilters': "Blog filters",
    'bp.blogTopics': "Topics",
    'bp.blogAuthors': "Authors",
    'bp.blogRecent': "Recent posts",
    'bp.blogAbout': "About the blog",
    'sample.blogAboutTitle': "Hi, we are the team",
    'sample.blogAboutText': "We write about what we do every day: ideas, tips and news.",
    'sample.insertEmbed': '<div style="padding:32px;border:1px solid currentColor;border-radius:16px;text-align:center"><h3 style="margin:0 0 12px">A space for your ideas</h3><p style="margin:0">Make every visit the start of something special.</p></div>',
    'sample.description': "Description",
    'sample.name': "Name",
    'sample.email': "Email address",
    'sample.message': "Message",
    'sample.send': "Send",
    'sample.thanks': "Thanks! We got your message.",
    'sample.contact': "Contact",
    'sample.start': "Get started",
    'sample.open': "Open",
    'sample.openMenu': "Open the menu",
    'sample.openWindow': "Open the window",
    'sample.learnMore': "Learn more →",
    'sample.seeMore': "See more",
    'sample.showMore': "Show more",
    'sample.products': "Products",
    'sample.launch': "Launch",
    'sample.availableNow': "Available now",
    'sample.happyClients': "Happy clients",
    'sample.yourContent': "Your content",
    'sample.copyright': "© {year} Your company. All rights reserved.",
    'sample.tagline': "We build digital products and experiences designed to grow your business.",
    'sample.designAnythingMenu': "Design whatever you want here: links, images, columns…",
    'sample.designAnything': "Design whatever you want here: text, images, a form, columns…",
    'sample.modalBody': "Write here what shows when the button is pressed. You can put text, images or whatever you need.",
    'sample.articleBody': "<p>Write the article’s full content in the CMS.</p>",
    'sample.faqQuestion': "How long does shipping take?",
    'sample.faqAnswer': "Between 2 and 5 business days. We email you as soon as it leaves the warehouse.",
    'sample.reviewer1': "James Whitfield",
    'sample.reviewer2': "Laura Bennett",
    'sample.reviewer3': "Marie Fontaine",
    'sample.reviewer4': "Andrew Parrish",
    'sample.reviewerInitials': "JW",
    'sample.roleFounder': "Founder",
    'sample.company': "The Oak Restaurant",
    'sample.city': "Mexico City",
    'sample.clientSince': "Client since 2023",
    'sample.review1': "“A great experience: the process was clear and the result felt professional from day one.”",
    'sample.review2': "We came in with half an idea and left with something better than what we had in mind. They were approachable throughout, explained every step without jargon, and met the deadlines they had promised. We would come back without hesitation, and have already recommended them to two people in the industry.",
    'sample.review3': "Very professional. It took a little longer than planned because of a supplier issue, but they kept us informed the whole time and the final result was well worth the wait.",
    'sample.review4': "Quick to respond and a flawless result. What I value most is that they flagged a problem before we noticed it ourselves.",
    'logo.sub.colorType': 'Color and type',
    'logo.sub.symbol': 'Symbol',
    'logo.sub.colorSize': 'Color and size',
    'logo.sub.background': 'Background',
    'logo.sub.versions': 'Versions',
    'logo.sub.width': 'Width',
    'brand.buttonSample': 'Button',
    'elements.addFavoriteShort': 'Add to favorites',
    'elements.removeFavoriteShort': 'Remove from favorites',
    'elements.addFavorite': "Add {name} to favorites",
    'elements.removeFavorite': "Remove {name} from favorites",
    'ai.elementAdded': "{name} added.",
    'sample.slide1': "Main slide",
    'sample.slide2': "Second slide",
    'sample.slide3': "Third slide",
    'sample.slideBody': "Edit this content from the canvas or from Layers.",
    'sample.slideBody2': "Every slide is a real, editable element.",
    'sample.slideBody3': "Adjust width, colors and content however you like.",
    'sample.card1': "Card one",
    'sample.card2': "Card two",
    'sample.card3': "Card three",
    'sample.card4': "Card four",
    'sample.cardBase': "Base card",
    'sample.cardColor': "Card with color",
    'sample.cardSoft': "Soft card",
    'sample.cardBody1': "Several cards visible at once; use the arrows to move along.",
    'sample.cardBody2': "The cards peek past the edge so you can see there is more.",
    'sample.cardBody3': "Every card is a real, editable element.",
    'sample.cardBody4': "Ideal for services, products, case studies or reviews.",
    'sample.tabCourses': "Courses",
    'sample.tabCommunities': "Communities",
    'sample.tabNewsletters': "Newsletters",
    'sample.tabCoaching': "Coaching",
    'sample.tabCoursesBody': "Create and sell courses with lessons, modules and progress tracking.",
    'sample.tabCommunitiesBody': "Build a space people come back to, and that drives retention.",
    'sample.tabNewslettersBody': "Send newsletters and grow your audience with recurring content.",
    'sample.tabCoachingBody': "Work 1:1 with clients at premium prices using structured programs.",
    'sample.option1': "Option 1",
    'sample.option2': "Option 2",
    'sample.option3': "Option 3",
    'sample.option4': "Option 4",
    'sample.option5': "Option 5",
    'sample.option6': "Option 6",
    'sample.navHome': "Home",
    'sample.more': "More",
    'sample.navServices': "Services",
    'sample.navBookings': "Bookings",
    'sample.navDownloads': "Downloads",
    'sample.navShop': 'Shop',
    'sample.contactTitle': "Contact",
    'sample.copyrightOf': "© {year} {name}. All rights reserved.",
    'sample.navAbout': "About",
    'sample.navSupport': "Support",
    'sample.legalTerms': "Terms",
    'sample.legalPrivacy': "Privacy",
    'sample.social1': "Instagram",
    'sample.social2': "LinkedIn",
    'sample.followUs': "Follow us",
    'sample.serviceWeb': "Web design",
    'sample.serviceDev': "Development",
    'sample.serviceStrategy': "Strategy",
    'sample.iconPrimary': "Primary icon",
    'sample.iconFeatured': "Featured icon",
    'sample.iconSoft': "Soft icon",
    'sample.unitDays': "Days",
    'sample.unitHours': "Hours",
    'sample.unitMin': "Min",
    'sample.unitSec': "Sec",
    'sample.prev': "Previous",
    'sample.next': "Next",
    'bp.dropdownMenu': "Dropdown menu",
    'bp.megaMenu': "Mega menu",
    'bp.navigation': "Navigation",
    'bp.separator': "Separator",
    'bp.linkItem': "Link",
    'bp.lineItem': "Line",
    'sample.contactEmail': "hello@yourcompany.com",
    'policies.hint.privacidad': "What data you ask for, what you use it for, and how people can ask for it back. In almost any country the law requires it the moment you collect a name or an email.",
    'policies.hint.terminos': "The rules of the relationship with your customer: what you sell, how it is paid for, and what happens if something goes wrong.",
    'policies.hint.reembolsos': "When you refund and when you do not. It is the one that counts most if someone disputes a charge with their bank.",
    'policies.hint.cancelaciones': "How far in advance an appointment can be cancelled or moved, and what happens on a no-show.",
    'policies.hint.envios': 'How long you take to ship, how packages are tracked and how a product is returned. Needed if you sell physical products.',
    'policies.hint.aviso-legal': 'Who owns the site and how to reach them: name, tax ID, address and contact. Required in Spain and Mexico.',
    'legalAttention.kicker': "Legal",
    'legalAttention.title': "Your customers pay without seeing your terms",
    'legalAttention.body': "Not published yet: {docs}. Only published documents are linked next to the payment button, so these sales currently carry no accepted terms. Complete them and they will show up on their own.",
    'legalAttention.cta': "Review policies",
    'overview.order.deletedOffer': "Deleted offer",
    'overview.order.noBuyer': "No buyer",
    'overview.order.disputed': "Disputed",
    'overview.switchGreeting': "You're now in “{name}”",
    'overview.switchLine': "Everything you see in the dashboard belongs to this site.",
    'overview.handoverOne': "Up there I left what's still missing to finish receiving this site. You can leave it for later.",
    'overview.handoverMany': "Up there I left the {count} things still missing to finish receiving this site. You can leave it for later.",
    'overview.transferInviteMany': "You received {count} invitations to accept site transfers. Check their details and included content above.",
    'overview.teamInviteMany': "You have {count} team invitations up there waiting for an answer.",
    'overview.projectFallback': "Project",
    'overview.payout.arrives': "Arrives {when}",
    'overview.payout.arrivesInTransit': "Arrives {when} · in transit",
    'overview.payout.none': "No balance to pay out",
    'overview.payout.arrivesApprox': "Arrives around {when}",
    'overview.payout.withinStripe': "Within Stripe's payout window",
    'overview.domain.active': "Active",
    'overview.domain.error': "Error",
    'overview.domain.configuring': "Setting up",
    'plans.feat.noAnalytics': "No analytics",
    'plans.feat.blogPosts': "Blog: {count} published posts",
    'plans.feat.blogUnlimited': "Blog: unlimited posts",
    'plans.feat.search': "Site search",
    'plans.table.row.blog': "Published blog posts",
    'plans.limit.emails': "{count} emails/month",
    'stripe.countryHint': "Your Stripe account will be created in {country}, this project's country. Stripe doesn't allow changing it later.",
    'stripe.countryChange': "Change country",
    'error.message.overLimit': "This message arrived after your plan's limit. Upgrade your plan to read it.",
    'forms.overLimit.title': "You've gone over your plan's limit",
    'forms.overLimit.bodyOne': "You have 1 message you can't see. It's saved: upgrade your plan to read it.",
    'forms.overLimit.bodyMany': "You have {count} messages you can't see. They're saved: upgrade your plan to read them.",
    'forms.overLimit.cta': "Upgrade plan",
    'legal.contact.email': "Contact email: {email}",
    'account.err.signOutSession': "Couldn't sign out that session.",
    'account.err.uploadImage': "Couldn't upload the image.",
    'account.err.save': "Couldn't save your changes.",
    'account.err.startChange': "Couldn't start the change.",
    'account.err.badCode': "That code is invalid or has expired.",
    'account.err.emailInUse': "That email is already in use.",
    'account.err.verifyCode': "Couldn't verify the code.",
    'account.err.confirmEmail': "Couldn't confirm the email.",
    'account.err.resendCode': "Couldn't resend the code.",
    'account.err.connectGoogle': "Couldn't connect Google.",
    'account.err.disconnect': "Couldn't disconnect.",
    'account.err.signOutAll': "Couldn't sign out the other sessions.",
    'account.err.sendCode': "Couldn't send the code.",
    'account.err.deleteAccount': "Couldn't delete the account.",
    'account.resending': "Resending…",
    'account.resendCode': "Resend code",
    'account.locationUnknown': "Location unavailable",
    'account.projectUnnamed': "Untitled project",
    'err.openPaymentsSetup': "We couldn't open the payments setup.",
    'err.saveThat': "We couldn't save that.",
    'err.actionFailed': "We couldn't complete that action.",
    'err.loadDomains': "We couldn't load your domains.",
    'err.connectDomain': "We couldn't connect the domain.",
    'err.loadRequests': "We couldn't load the requests.",
    'err.deliverCode': "We couldn't deliver the code.",
    'err.readDns': "We couldn't read this domain's DNS.",
    'err.registerRequest': "We couldn't register your request.",
    'err.saveRecord': "We couldn't save the record.",
    'err.deleteRecord': "We couldn't delete the record.",
    'err.openReview': "We couldn't open the review.",
    'err.saveData': "We couldn't save the details.",
    'err.openInvite': "We couldn't open the invitation.",
    'err.operationFailed': "The operation couldn't be completed.",
    'err.noInvite': "There's no invitation to open.",
    'app.handoffFailed': "We couldn't create a secure session for the editor.",
    'code.digitAria': "Digit {n}",
    'err.createProject': "Couldn't create the project.",
    'cwa.defaultName': "My site",
    'err.uploadFailed': "Upload failed",
    'err.searchFailed': "Search failed",
    'accountDomains.notConnected': "Not connected",
    'pageSettings.seoPreviewPlaceholder': "Add a clear description to improve how this page shows up in search engines.",
    'switch.arrived': "Project {name}",
    'switch.switching': "Switching project",
    'audience.views': "{count} views",
    'audience.noViews': "No views",
    'backup.copyOf': "Backup from {date}",
    'backup.loading': "Loading backup…",
    'backup.pagesOne': "{count} page",
    'backup.pagesMany': "{count} pages",
    'backup.collectionsOne': "{count} collection",
    'backup.collectionsMany': "{count} collections",
    'brand.loadFailed': "Couldn't load your brand.",
    'forms.noExtraAnswers': "No additional answers",
    'forms.bulkDelete.confirm': "Delete",
    'forms.bulkDelete.titleOne': "Delete 1 message",
    'forms.bulkDelete.titleMany': "Delete {count} messages",
    'forms.selectMessage': "Select the message from {name}",
    'overview.noPublishedLink': "No published link",
    'analytics.infoAbout': "About {title}",
    'analytics.pageDeleted': "This page was deleted",
    'auth.resendIn': "Resend code ({seconds}s)",
    'home.create.catalogAria': "Template catalog",
    'home.create.customizeAria': "Site customization",
    'error.integration.notConfigured': "Integrations aren't available yet. Please try again later.",
    'error.asset.svgTooLarge': "That SVG is {kb} KB. The maximum is 1 MB.",
    'error.asset.videoType': "Only MP4 or WebM videos can be uploaded. iPhone .mov files can be exported to MP4 from Photos or with a converter.",
    'error.asset.videoLength': "Couldn't read the video's size. Please try again.",
    'error.asset.videoEmpty': "The video is empty.",
    'error.asset.videoTooLarge': "The video is {mb} MB; your plan allows up to {max} MB per video.",
    'error.account.verifyFailed': "We couldn't verify your account. Please try again.",
    'error.account.authDeleteFailed': "We couldn't delete your sign-in account. Please try again.",
    'error.domain.lookupFailed': "The domain is already on our network but we couldn't retrieve it. Please try again.",
    'error.domain.registrarBusy': "We're talking to the registrar. Try again in a few seconds.",
    'error.domain.reconnectFailed': "We couldn't reconnect the domain. Try again in a few minutes.",
    'error.invite.wrongAccount': "This invitation is for {email}. Sign in with that account to continue.",
    'error.domain.registerUnavailable': "We can't register that domain right now. Please try again later.",
    'nav.search': "Search",
    'nav.cart': 'Cart',
    'nav.account': "Customer account",
    'offers.look.siteNav': "Navigation bar",
    'offers.look.siteFooter': "Footer",
    'offers.look.siteOn': "Shown",
    'offers.look.siteOff': "Hidden on this page",
    'offers.look.siteMissing': "Shows up once you publish your site",
    'calsync.google.recommended': "Recommended",
    'calsync.google.ok': "Connected and working",
    'calsync.google.writeLabel': "Add my bookings to this calendar",
    'calsync.google.writeHint': "Each new booking shows up as an event.",
    'calsync.google.blockLabel': "Block times when I’m busy",
    'calsync.google.blockHint': "Your events won’t be offered on your booking page.",
    'calsync.google.addAnother': "Connect another Google account",
    'calsync.export.titleFor': "See your bookings in {provider}",
    'layers.simple.hiddenBadge': "Hidden on this device",
    'layers.simple.lockedBadge': "Locked",
    'layers.simple.more': "More options",
    'layers.simple.moveUp': "Move up",
    'layers.simple.moveDown': "Move down",
    'layers.simple.buttons': "Buttons",
    'layers.simple.card': "Card {n}",
    'layers.simple.column': "Column {n}",
    'layers.simple.pathAria': "Where you are on the page",
    'layers.simple.allSections': "Sections",
    'layers.simple.emptySection': "This section is empty",
    'layers.simple.emptySectionHint': "Add text, buttons or images from the canvas.",
    'layers.simple.items.one': "1 element",
    'layers.simple.items.many': "{count} elements",
    'layers.simple.addSectionHint': "Pick one from the catalog",
    'layers.addSectionEnd': "Add section",
    'nav.pillGap': "Logo · menu spacing",
    'cms.design.change': "CMS design",
    'cms.design.itemGroup': "Entry page",
    'cms.design.collectionGroup': "List page",
    'cms.design.applied': "Design applied to the entry page",
    'cms.design.appliedList': "Design applied to the list page",
    'layers.group.siteNav': "Site menu",
    'layers.group.siteFooter': "Site footer",
    'layers.group.allPages': "All pages",
    'layers.group.pageContent': "Content",
    'navm.auto.navHint': "Built from your pages and catalog.",
    'navm.auto.footerHint': "Filled from your pages, catalog, contact and policies.",
    'navm.auto.locked': "Updates on its own",
    'navm.auto.yours': "You control this",
    'link.ext.email': "Email {value}",
    'link.ext.phone': "Call {value}",
    'link.ext.web': "Go to {value}",
    'link.quick.title': "Somewhere else",
    'link.quick.web': "Website",
    'link.quick.email': "Email",
    'link.quick.phone': "Phone",
    'link.quick.whatsapp': "WhatsApp",
    'link.quick.delivery': 'Delivery',
    'link.compose.deliveryLabel': 'Your store link in the app',
    'link.compose.deliveryPlaceholder': 'https://www.ubereats.com/store/…',
    'link.compose.deliveryHint': 'Copy your restaurant’s link from {apps}.',
    'link.orderOn': 'Order on {app}',
    'link.quick.opentable': 'OpenTable',
    'link.compose.opentableLabel': 'Your OpenTable restaurant ID',
    'link.compose.opentablePlaceholder': 'E.g. 1434817',
    'link.compose.opentableHint': 'The button opens OpenTable’s booking page. Pasting the widget link or code also works.',
    'link.compose.webLabel': "Web address",
    'link.compose.webPlaceholder': "example.com",
    'link.compose.emailLabel': "Email address",
    'link.compose.emailPlaceholder': "hello@yourbusiness.com",
    'link.compose.phoneLabel': "Phone number",
    'link.compose.phonePlaceholder': "+1 555 123 4567",
    'link.compose.whatsappLabel': "WhatsApp number",
    'link.compose.whatsappHint': "Include the country code.",
    'link.compose.whatsappMessage': "Starting message (optional)",
    'link.compose.whatsappMessagePlaceholder': "Hi, I would like more information",
    'link.compose.use': "Use",
    'link.compose.back': "Back",
    'link.compose.invalid': "Check that it is written correctly.",
    'link.whatsappTo': "WhatsApp · {value}",
    'token.cardNone': "No style",
    'plans.feat.coursesOff': "No course selling",
    'error.billing.paymentInProgress': "Your payment is being processed. Your plan will show as active in a few seconds.",
    'plans.exists.title': "You already have a membership",
    'plans.exists.body': "To change plan, switch billing cycle or cancel, go to Billing.",
    'plans.exists.cta': "Go to Billing",
    'plans.exists.close': "Close",
    'plans.checkout.billedAnnuallShort': "Billed annually",
    'plans.checkout.chargeToday': "${amount} today",
    'plans.checkout.betaBadge': "Beta · {percent}% applied",
    'plans.regularAnnual': "Regular annual price",
    'plans.betaDiscountRow': "Beta discount ({percent}% off)",
    'plans.renewNote': "After your first year it renews at the regular annual price.",
    'plans.checkout.betaNote': "Launch discount applied to your first year. After that, your plan renews at the regular annual price.",
    'legal.effective': "Effective {date} · Version {version}",
    'legal.toc': "Contents",
    'legal.allDocs': "See all legal documents",
    'legal.hubTitle': "Legal information",
    'legal.hubIntro': "The documents that govern the use of véltica, by topic.",
    'legal.language': "Language",
    'legal.group.core': "The essentials",
    'legal.group.product': "By product",
    'legal.group.data': "Data",
    'anim.title': "Animation",
    'anim.source.asBrand': "As brand",
    'anim.source.withBlock': "Comes in with its block",
    'anim.source.editGlobal': "Edit brand",
    'anim.close': "Close",
    'anim.empty': "Select an element to animate it.",
    'anim.play': "Play",
    'anim.enter': "Entrance",
    'anim.none': "No animation",
    'anim.group.fade': "Fade",
    'anim.group.scale': "Scale",
    'anim.group.motion': "Motion",
    'anim.group.reveal': "Reveal",
    'anim.preset.fade': "Fade in",
    'anim.preset.fade-up': "Fade up",
    'anim.preset.fade-down': "Fade down",
    'anim.preset.fade-left': "From right",
    'anim.preset.fade-right': "From left",
    'anim.preset.zoom-in': "Zoom in",
    'anim.preset.zoom-out': "Zoom out",
    'anim.preset.pop': "Pop",
    'anim.preset.blur-in': "Blur in",
    'anim.preset.flip-up': "Flip up",
    'anim.preset.flip-left': "Flip sideways",
    'anim.preset.rotate-in': "Rotate in",
    'anim.preset.reveal-up': "Reveal up",
    'anim.preset.reveal-left': "Reveal sideways",
    'anim.timing': "Timing",
    'anim.trigger': "Starts",
    'anim.trigger.scroll': "On scroll",
    'anim.trigger.load': "On load",
    'anim.repeat': "Plays",
    'anim.offset': "Start offset",
    'anim.offsetHint': "How far up the screen the element has to come, from the bottom, before it animates. Raise it if it starts too soon.",
    'anim.repeat.once': "Once",
    'anim.repeat.always': "Every time",
    'anim.duration': "Duration",
    'anim.delay': "Delay",
    'anim.easing': "Easing",
    'anim.easing.smooth': "Smooth",
    'anim.easing.expo': "Snappy",
    'anim.easing.spring': "Spring",
    'anim.easing.in-out': "Ease in-out",
    'anim.easing.linear': "Linear",
    'anim.distance': "Distance",
    'anim.distance.sm': "Short",
    'anim.distance.md': "Medium",
    'anim.distance.lg': "Long",
    'anim.target': "What animates",
    'anim.target.self': "The element",
    'anim.target.children': "Its content, one by one",
    'anim.targetHint': "“One by one” animates each card, image or text inside in order, with a short gap between them.",
    'anim.stagger': "Stagger",
    'anim.hover': "On hover",
    'anim.hoverHint': "Phones have no mouse: this effect only shows on desktop.",
    'anim.hover.none': "None",
    'anim.hover.lift': "Lift",
    'anim.hover.grow': "Grow",
    'anim.hover.shrink': "Press",
    'anim.hover.glow': "Glow",
    'anim.hover.dim': "Dim",
    'anim.hover.shadow': "Shadow",
    'anim.hover.outline': "Outline",
    'anim.hover.tilt': "Tilt",
    'anim.reset': "Remove animation",
    'anim.canvasHint': "In the canvas it plays when you change a setting or press Play. On the published site, when it scrolls into view. Visitors who ask their device for reduced motion see it without animation.",
    'anim.tab.enter': "Entrance",
    'anim.tab.timing': "Timing",
    'anim.tab.hover': "Hover",
    'anim.when': "When",
    'anim.needsEnter': "Pick an entrance first: timing and when it starts belong to the entrance animation.",
    'anim.chooseEnter': "Choose entrance",
    'anim.tab.when': "When",
    'stateScope.aria': "What this state affects",
    'stateScope.global': "Global style",
    'stateScope.element': "This element only",
    'stateScope.globalNote': "You are editing “{name}”: the change reaches the {count} elements that use it.",
    'stateScope.elementNote': "This element only. What you change here wins over “{name}”.",
    'stateScope.transition': "Transition",
    'stateScope.duration': "Duration",
    'stateScope.easing': "Easing",
    'stateScope.instant': "Instant",
    'stateScope.ease.smooth': "Smooth",
    'stateScope.ease.ease': "Standard",
    'stateScope.ease.ease-out': "Snappy",
    'stateScope.ease.linear': "Linear",
    'stateScope.reset': "Restore default",
    'buttonHover.auto': "Automatic",
    'buttonHover.darken': "Darken",
    'buttonHover.lighten': "Lighten",
    'buttonHover.lift': "Lift",
    'buttonHover.glow': "Glow",
    'buttonHover.none': "None",
    'buttonHover.hint': "Hover each option to preview it. Every button with this style inherits your choice.",
    'buttonHover.customHint': "This button has a custom hover made in the inspector. Picking an option replaces it.",
    'stateScope.ownNote': "This state belongs to this element only.",
    'stateScope.presets': "Shortcuts",
    'statePreset.hover.lift': "Lift",
    'statePreset.hover.grow': "Grow",
    'statePreset.hover.dim': "Dim",
    'statePreset.hover.shadow': "Shadow",
    'statePreset.hover.underline': "Underline",
    'statePreset.hover.accent': "Accent color",
    'statePreset.pressed.sink': "Press in",
    'statePreset.pressed.dim': "Dim",
    'statePreset.focus.ring': "Ring",
    'statePreset.focus.glow': "Glow",
    'stateScope.appliesTo': "Applies to",
    'stateScope.elementShort': "This element",
    'state.none': "State",
    'anim.demoWord': "Hello",
    'anim.demoWords': "Hello world",
    'anim.group.text': "Letters",
    'anim.preset.text-rise': "Rising letters",
    'anim.preset.text-fade': "Letter by letter",
    'anim.preset.text-blur': "Focus letters",
    'anim.preset.text-drop': "Falling letters",
    'anim.preset.text-words': "Words",
    'anim.preset.text-typewriter': "Typewriter",
    'anim.textPieces': "Letter by letter",
    'anim.textPiecesHint': "The time between one letter and the next.",
    'anim.textPiecesHintWords': "The time between one word and the next.",
    'anim.group.image': "Image",
    'anim.preset.mask-up': "Mask up",
    'anim.preset.mask-down': "Mask down",
    'anim.preset.mask-right': "Mask right",
    'anim.preset.mask-left': "Mask left",
    'anim.preset.mask-center': "Mask center",
    'anim.preset.mask-iris': "Iris",
    'anim.preset.mask-zoom': "Cinematic zoom",
    'design.evergreen': "Evergreen",
    'design.evergreen.desc': "Sober forest green, warm cream and old gold",
    'design.voltage': "Voltage",
    'design.voltage.desc': "Near-black graphite with electric lime and olive lime",
    'design.pulse': "Pulse",
    'design.pulse.desc': "Pearl grey and black ink with a lime accent, all pills and round cards",
    'design.coral': "Coral",
    'design.coral.desc': "White, pale mint and petrol teal with coral actions and a deeper coral accent",
    'design.executive': "Executive",
    'design.executive.desc': "Navy and steel blue with clean typography and crisp cards for corporate sites",
    'design.advisory': "Advisory",
    'design.advisory.desc': "Warm paper, olive and bronze with serif headings for professional services",
    'design.capital': "Capital",
    'design.capital.desc': "Dark forest, ivory and muted gold for investment and wealth management",
    'design.enterprise': "Enterprise",
    'design.enterprise.desc': "Midnight navy, light blue and precise cards for business software",
    'design.counsel': "Counsel",
    'design.counsel.desc': "Warm white, burgundy and classic serif headings for legal practices",
    'design.estate': "Estate",
    'design.estate.desc': "Limestone, graphite and bronze with generous spacing for property and architecture",
    'design.industry': "Industry",
    'design.industry.desc': "Steel gray, petrol blue and copper with compact cards for industrial services",
    'design.care': "Care",
    'design.care.desc': "White and soft teal with clear type and rounded cards for healthcare",
    'design.impact': "Impact",
    'design.impact.desc': "Sage, forest green and natural whites for sustainable businesses",
    'design.venture': "Venture",
    'design.venture.desc': "Dark aubergine and lavender with refined typography for investment and technology",
    'design.sorbet': 'Sorbet',
    'design.sorbet.desc': 'Cream, berry buttons and flowing retro headings with soft rounded cards',
    'cwa.look.sorbet': 'Sorbet',
    'design.wiggle': 'Wiggle',
    'design.wiggle.desc': 'Botanical greens, sculpted headings and warm orange details',
    'cwa.look.wiggle': 'Wiggle',
    'design.papaya': 'Papaya',
    'design.papaya.desc': 'Warm paper, terracotta actions and expressive serif headings',
    'cwa.look.papaya': 'Papaya',
    'design.sunbeam': 'Sunbeam',
    'design.sunbeam.desc': 'Butter cream, toasted orange and cheerful rounded headings',
    'cwa.look.sunbeam': 'Sunbeam',
    'design.bounce': 'Bounce',
    'design.bounce.desc': 'Lavender, violet actions and bold rounded headings with generous space',
    'cwa.look.bounce': 'Bounce',
    'design.clubhouse': 'Clubhouse',
    'design.clubhouse.desc': 'Oat white, forest green and graphic headings for a confident friendly brand',
    'cwa.look.clubhouse': 'Clubhouse',
    'design.bagel': 'Bagel',
    'design.bagel.desc': 'Oat, espresso and brick accents with plump headings and soft cards',
    'cwa.look.bagel': 'Bagel',
    'design.confetti': 'Confetti',
    'design.confetti.desc': 'Lilac paper, berry details and bubbly type balanced by clean body text',
    'cwa.look.confetti': 'Confetti',
    'design.block-party': 'Block Party',
    'design.block-party.desc': 'Cream, petrol blue and chunky headings with crisp offset shadows',
    'cwa.look.block-party': 'Block Party',
    'design.maison': 'Maison',
    'design.maison.desc': 'Ivory, fine serif headings and charcoal buttons with generous space',
    'cwa.look.maison': 'Ivory',
    'design.runway': 'Runway',
    'design.runway.desc': 'Pure white, bold grotesque type and crisp black actions',
    'cwa.look.runway': 'Bold monochrome',
    'design.couture': 'Couture',
    'design.couture.desc': 'White and parchment with delicate Italiana headings and spaced buttons',
    'cwa.look.couture': 'Fine type',
    'design.atelier': 'Atelier',
    'design.atelier.desc': 'Warm cream, a discreet forest accent and classic serif headings',
    'cwa.look.atelier': 'Classic cream',
    'design.silk': 'Silk',
    'design.silk.desc': 'Pearl and muted rose with flowing serif headings and simple buttons',
    'cwa.look.silk': 'Soft pearl',
    'design.sable': 'Sable',
    'design.sable.desc': 'Sand and espresso with light sans-serif headings and clean edges',
    'cwa.look.sable': 'Warm minimal',
    'design.bordeaux': 'Bordeaux',
    'design.bordeaux.desc': 'Warm white, burgundy buttons and elegant Prata headings',
    'cwa.look.bordeaux': 'Burgundy',
    'design.sculpture': 'Sculpture',
    'design.sculpture.desc': 'Limestone, charcoal and refined sans-serif type with open spacing',
    'cwa.look.sculpture': 'Stone',
    'design.archive': 'Archive',
    'design.archive.desc': 'Paper, graphite and restrained sans-serif type with fine outlines',
    'cwa.look.archive': 'Quiet graphite',
    'design.noir': 'Noir',
    'design.noir.desc': 'Warm black, ivory actions and light serif headings without shine',
    'design.encore': 'Encore',
    'design.encore.desc': 'Cream and night violet alternating, condensed headings and pink pill buttons',
    'cwa.look.noir': 'Dark ivory',
    'cwa.look.encore': 'Stage',
    'draft.title': "You have unsaved changes",
    'draft.text': "They were left in this browser {when}. Restore them?",
    'draft.restore': "Restore",
    'draft.discard': "Discard",
    'crash.title': "Something went wrong in the editor",
    'crash.saving': "Saving a copy of your changes in this browser…",
    'crash.safe': "Your changes are safe in this browser. Reload and the editor will offer to restore them.",
    'crash.reload': "Reload the editor",
    'crash.details': "Technical details",
    'error.page.conflict': "This page was changed somewhere else since you opened it.",
    'error.project.conflict': "This project was changed somewhere else since you opened it.",
    'save.err.conflict': "Someone else saved changes",
    'save.err.conflictDetail': "This project was changed somewhere else (another tab, device or person) since you opened it. To avoid erasing anything, saving has stopped.",
    'save.err.offline': "Offline",
    'save.err.offlineDetail': "Your device has no internet. Your changes are still in the editor and will save when you reconnect.",
    'save.err.auth': "Session expired",
    'save.err.authDetail': "Your session could not be renewed. Reload the page to sign in again; your changes are still here.",
    'save.err.network': "Could not reach the server",
    'save.err.networkDetail': "The request did not complete ({raw}). It is usually a brief network drop; it retries on its own. Payload: {size} KB.",
    'save.err.plan': "Your plan does not allow more",
    'save.err.planPages': "Your plan does not allow more pages",
    'save.err.planPagesOne': "The rest of your changes were saved. “{name}” is still unsaved: delete it from the site or upgrade your plan and it will save on its own.",
    'save.err.planPagesMany': "The rest of your changes were saved. {count} pages are still unsaved: delete them from the site or upgrade your plan and they will save on their own.",
    'save.err.server': "Server error (HTTP {status})",
    'save.err.serverDetail': "{raw}. It retries on its own. Payload: {size} KB.",
    'conflict.title': "Someone else saved changes",
    'conflict.text': "This project was changed somewhere else (another tab, device or team member) since you opened it. To avoid erasing anything, we stopped saving until you choose.",
    'conflict.reload': "See the saved version",
    'conflict.reloadHint': "Reloads with the server version. Yours stays in this browser and you can restore it.",
    'conflict.overwrite': "Save mine over it",
    'conflict.overwriteHint': "Replaces what was saved elsewhere with what you have here.",
    'tabs.otherOpen': "This project is also open in another tab. Edit in just one so changes don’t get mixed.",
    'tabs.gotIt': "Got it",
    'elements.basics': "Basics",
    'boot.otherAccountHelp': "Go back to the dashboard and sign in with the account that owns the project.",
    'nav.sep.none': "None",
    'nav.sep.line': "Line",
    'nav.sep.dot': "Dot",
    'nav.sep.slash': "Slash",
    'cms.collectionImageLabel': "Collection image",
    'cms.noCollections': "No content",
    'cms.allCollectionsIndex': "All collections (index)",
    'ai.target.typography': "Typography",
    'ai.progress.globalStyles': "Colors and typography",
    'ai.progress.logo': "Navigation logo",
    'ai.issue.pageGone': "The page “{page}” no longer exists.",
    'ai.issue.duplicate': "The operation “{id}” is duplicated.",
    'ai.issue.unknownStyle': "The requested style does not match any style, color, font or look in the panel.",
    'ai.issue.buttonStyleGone': "The global button style “{style}” no longer exists or belongs to links.",
    'ai.issue.emptyIconChange': "The global icon change has no styles or size.",
    'ai.issue.noTarget': "Could not find where to insert the component.",
    'ai.dim.height': "Height",
    'ai.dim.width': "Width",
    'ai.dim.gap': "Spacing",
    'ai.dim.margin': "Outer margin",
    'ai.dim.padding': "Inner padding",
    'ai.dim.radius': "Rounding",
    'ai.dim.weight': "Font weight",
    'ai.dim.fontSize': "Font size",
    'ai.dim.border': "Border width",
    'ai.dim.lineHeight': "Line height",
    'ai.dim.opacity': "Opacity",
    'ai.dim.already': "{what} is already {value}.",
    'ai.dim.atMax': "It is already at the maximum {what}.",
    'ai.dim.atMin': "There is no more {what} to reduce.",
    'ai.local.repeated': "Repeated.",
    'ai.local.alsoApplied': "Also applied on {breakpoint}.",
    'ai.local.moved': "Element moved.",
    'ai.local.imageDuplicated': "Image duplicated.",
    'ai.local.selectImage': "Select an image, or a section that already has one, to add another with the same design.",
    'ai.local.selectGrid': "Select a card or a section with a grid to add more items.",
    'ai.local.addedOne': "Added 1 item to the grid.",
    'ai.local.addedMany': "Added {count} items to the grid.",
    'ai.local.linkUpdated': "Link updated to {href}.",
    'ai.local.willDelete': "The selected element will be deleted.",
    'ai.local.duplicated': "Element duplicated.",
    'ai.dim.changedToken': "{what}: {value} · style {token}.",
    'ai.dim.changedElement': "{what}: {value} · this element only.",
    'layers.addBanner': "Add banner",
    'cfloat.title': "Contact button",
    'cfloat.channels': "Channels",
    'cfloat.look': "Appearance",
    'cfloat.noChannelsShort': "No channels",
    'cfloat.lead': "Floats at the bottom of every page, with your channels.",
    'cfloat.show': "Show on the site",
    'cfloat.whatsapp': "WhatsApp",
    'cfloat.whatsappMessage': 'Message',
    'cfloat.whatsappMessagePlaceholder': 'Hi! I’d like more information.',
    'cfloat.whatsappHelp': "With the country code. Opens a WhatsApp chat with you.",
    'cfloat.phone': "Phone to call",
    'cfloat.email': "Email",
    'cfloat.emailPlaceholder': "hello@yourbusiness.com",
    'cfloat.form': "“Send a message” (mini form)",
    'cfloat.formHelp': "Messages reach your email and Messages, like any form on the site.",
    'cfloat.greeting': "Greeting",
    'cfloat.greetingPlaceholder': "How can we help?",
    'cfloat.side': "Side",
    'cfloat.left': "Left",
    'cfloat.right': "Right",
    'cfloat.noChannels': "Add at least one channel so it shows on the site.",
    'cfloat.remove': "Remove from the site",
    'cfloat.add': "Contact button",
    'cfloat.channel.whatsapp': "WhatsApp",
    'cfloat.channel.phone': "Call",
    'cfloat.channel.email': "Email",
    'cfloat.channel.form': "Message",
    'layers.addElement': "Add element",
    'layers.siteBanner': "Banner",
    'brand.comboHint': "Colors, fonts and shapes in one click",
    'bp.banner': "Banner",
    'bp.socialLinks': "Social links",
    'social.tab.accounts': "Accounts",
    'social.tab.look': "Look",
    'social.style': "Layout",
    'social.style.icons': "Icons only",
    'social.style.labels': "Icon and name",
    'social.style.buttons': "Buttons",
    'social.style.list': "List",
    'social.shape': "Background",
    'social.shape.circle': "Circle",
    'social.shape.square': "Square",
    'social.shape.plain': "None",
    'social.colors': "Colors",
    'social.colors.site': "Site colors",
    'social.colors.brand': "Each network's colors",
    'social.size': "Size",
    'social.size.sm': "Small",
    'social.size.md': "Medium",
    'social.size.lg': "Large",
    'social.accountsHint': "These are your business accounts: changing them here changes them across the site. The switch only hides one in this element.",
    'social.showHere': "Show here",
    'social.empty': 'You haven’t added any accounts yet.',
    'social.add': 'Add account',
    'social.network': 'Social network',
    'social.other': 'Other',
    'social.title': 'Title',
    'social.titlePlaceholder': 'For example, our community',
    'social.url': 'Link',
    'social.remove': 'Remove {account} from the site',
    'social.accountUrl': '{account} link',
    'social.urlPlaceholder': 'https://',
    'social.sharedHint': 'These accounts are shared across your site.',
    'social.edit': "Edit link",
    'bp.bannerContact': "Contact banner",
    'bp.bannerContactLink': "Contact detail",
    'bnr.contact.call': "Call us",
    'bnr.contact.email': "Email us",
    'bp.bannerContent': "Content",
    'bp.bannerMessage': "Message",
    'sample.bannerText': "Free shipping on orders over $50",
    'sample.bannerLink': "Learn more",
    'bnr.message': "Message",
    'bnr.messagePlaceholder': "A promotion, an announcement…",
    'bnr.link': "Link",
    'bnr.linkText': "Link text",
    'bnr.icon': "Icon",
    'bnr.background': "Background",
    'bnr.bg.footer': "Like the footer",
    'bnr.bg.brand': "Brand color",
    'bnr.bg.soft': "Soft",
    'bnr.hint': "Shows above the menu on every page.",
    'bnr.tab.content': "Message",
    'bnr.tab.extras': "Extras",
    'bnr.tab.display': "Visibility",
    'bnr.views': "Banner settings",
    'bnr.code': "Discount code",
    'bnr.codeHint': "Visitors copy it with one click.",
    'sample.bannerCode': "SAVE20",
    'bnr.phone': "Phone",
    'bnr.phoneVia': "When tapped",
    'bnr.via.call': "Call",
    'bnr.via.whatsapp': "WhatsApp",
    'bnr.phonePlaceholder': "+1 555 010 0123",
    'bnr.socials': "Social media",
    'bnr.socialsHint': "Leave blank the ones you don't use.",
    'bnr.close': "Close button",
    'bnr.closeHint': "Once closed, a visitor won't see it again until you change the dates.",
    'bnr.from': "Starts",
    'bnr.until': "Ends",
    'bnr.clearDate': "Clear date",
    'bnr.status.always': "Always visible.",
    'bnr.status.live': "Visible now.",
    'bnr.status.upcoming': "Starts {date}. Hidden until then.",
    'bnr.status.ended': "Ended {date}: no longer visible.",
    'bnr.datesHint': "In each visitor's local time. Always shown in the editor.",
    'bnr.thisPage': "On this page",
    'bnr.align': "Alignment",
    'bnr.align.center': "Centered",
    'bnr.align.spread': "Spread",
    'bp.bannerCode': "Code",
    'bp.bannerPhone': "Phone",
    'bp.bannerSocials': "Social",
    'bp.bannerClose': "Close",
    'bnr.fromEmpty': "Right away",
    'bnr.untilEmpty': "No end date",
    'bnr.onlyHere': "Only on this page",
    'bnr.onlyHereHint': "Shows only on “{page}”. It won’t appear on any other page.",
    'layers.showHere': "Show here",
    'layers.simple.hideOnPage': "Hide on this page only",
    'layers.simple.removeFromSite': "Remove from all pages",
    'layers.simple.onlyOnPage': "Show only on this page",
    'layers.simple.showEverywhere': "Show on every page",
    'layers.simple.bannerSettings': "More banner options…",
    'layers.simple.navSettings': "More menu options…",
    'layers.simple.footerSettings': "More footer options…",
    'layers.onlyOn': "Only on {pages}",
    'blk.editBlock': "Edit block",
    'blk.addElement': "Add element",
    'dashfoot.copyright': "© {year} Véltica. All rights reserved.",
    'dashfoot.help': "Help center",
    'dashfoot.cookies': "Cookie notice",
    'dashfoot.terms': "Terms",
    'dashfoot.privacy': "Privacy",
    'workspace.saveConflict': "This project was changed somewhere else (for example in the editor) while you had it open here. We reloaded it; repeat your last change.",
    'panel.insert.desc': "Add new elements and blocks to the page.",
    'panel.images.desc': "Search and insert images from the professional library.",
    'panel.files.desc': "Upload and manage your site's own files.",
    'panel.templates.desc': "Browse ready-made sections and add them to the canvas.",
    'panel.pages.desc': "The site's pages and CMS collections, without leaving the canvas.",
    'insp.autoHideTip': "Auto-hide panel (reveals on hover)",
    'insp.autoHideInspectorTip': "Auto-hide the inspector (reveals on hover)",
    'pages.settingsOf': "{name} settings",
    'pub.subdomainTaken': " Try “{subdomain}-2” or a variation of your brand.",
    'layer.title': "Title",
    'layer.metric': "Metric",
    'layer.embed': "Code",
    'layer.h1': "Heading 1",
    'layer.h2': "Heading 2",
    'layer.h3': "Heading 3",
    'layer.h4': "Heading 4",
    'layer.h5': "Heading 5",
    'layer.h6': "Heading 6",
    'state.removeBreakpointOverride': "Remove the override for this breakpoint",
    'section.saved': "Section saved",
    'section.saveFailed': "Couldn't save the section",
    'section.defaultName': "My section",
    'cms.removeImageN': "Remove image {n}",
    'cms.optionActions': "{option} options",
    'cms.editNameOf': "Edit the name of {name}",
    'tokkind.color': "color",
    'tokkind.typography': "text style",
    'tokkind.button': "button style",
    'tokkind.card': "card style",
    'tokkind.section': "section style",
    'tokkind.icon': "icon style",
    'img.uploadFailedNamed': "Couldn't upload {name}",
    'img.retry': 'Retry',
    'img.oneSelected': "1 selected",
    'img.nSelected': "{count} selected",
    'boot.openProjectAgain': "Go back to the dashboard and try opening the project again.",
    'pgnav.listActions': "{name} listing actions",
    'pgnav.templateActions': "{name} template actions",
    'link.cmsThisCard': "This card's entry",
    'link.cmsFirst': "The first in the collection",
    'upload.networkError': "Network error while uploading the file",
    'cms.contentSource': "Content source",
    'cms.bringContent': "Bring in CMS content",
    'cms.bringShort': "Bring from CMS",
    'schedule.all': "All",
    'schedule.activeBoth': "Active (upcoming and ongoing)",
    'upload.manyInvalid': "{count} files can't be uploaded. {first}",
    'layers.lockTip': "Lock (not selectable)",
    'layers.unlockTip': "Unlock (allow selecting)",
    'fill.noImage': "No image",
    'countdown.defaultLabel': "Launch",
    'token.oneElement': "1 element",
    'token.nElements': "{count} elements",
    'panel.letterSpacing': "Letter spacing",
    'cms.siteUnpublished': "Unpublished site",
    'pub.inBackground': "in the background",
    'cms.viewEntry': "View the entry",
    'cms.editEntry': "Edit the entry",
    'cms.pickOtherRecord': "Pick another record",
    'image.changeShort': "Change",
    'cms.theEntries': "The entries",
    'ai.legacyId': "Previous ID kept for compatibility.",
    'cms.statusOf': "Status of {name}",
    'cms.actionsOf': "{name} actions",
    'pgnav.actionsOf': "{name} actions",
    'panel.ariaOf': "{title} panel",
    'menu.itemName': "Item {n} name",
    'footer.colLinks': "Column {n} links",
    'limit.contactSubject': "I need more capacity on Business",
    'cmphint.logo': "Text or image",
    'cmphint.menu': "Editable items",
    'cmphint.actions': "The bar's action button",
    'cmphint.navBackground': "Color, image, transparency",
    'cmphint.behavior': "Sticky and shrinking",
    'cmphint.columns': "Titles and links",
    'cmphint.footerLogo': "Same as the bar or its own",
    'cmphint.primaryIcons': "Set and large size",
    'cmphint.secondaryIcons': "Set and small size",
    'cmphint.textInput': "Base field",
    'cmphint.textarea': "Long area",
    'cmphint.choice': "Checkbox and radio",
    'cmphint.labels': "Label text",
    'cmphint.errors': "Error states",
    'cmphint.configure': "Configure",
    'error.domain.cloudflareFailed': "We couldn't register the domain. Try again in a few minutes.",
    'error.domain.saveFailed': "We couldn't save the domain.",
    'error.domain.requestFailed': "We couldn't register the request.",
    'error.domain.purchaseRateLimited': "Too many purchase attempts. Wait a minute.",
    'error.domain.paymentStartFailed': "We couldn't start the payment.",
    'error.query.invalid': "Invalid query.",
    'error.query.invalidCursor': "Invalid cursor.",
    'common.optionsOf': "Options for {name}",
    'billing.invoice.viewOf': "View the invoice from {date}",
    'billing.invoice.downloadOf': "Download the invoice from {date}",
    'billing.membership.grantedUntil': "Valid until {date}. This plan was assigned directly to your account.",
    'overview.openItem': "Open {name}",
    'overview.unnamedContact': "Unnamed contact",
    'common.colorNamed': "Color {name}",
    'common.iconNamed': "Icon {name}",
    'common.moveNamed': "Move {name}",
    'common.openNamed': "Open {name}",
    'common.selectNamed': "Select {name}",
    'common.removeNamed': "Remove {name}",
    'common.moveUpNamed': "Move {name} up",
    'common.moveDownNamed': "Move {name} down",
    'common.deleteNamed': "Delete {name}",
    'common.renameNamed': "Rename {name}",
    'common.editNamed': "Edit {name}",
    'common.addNamed': "Add {name}",
    'menu.urlItemN': "URL item {n}",
    'effect.panelN': "Panel {n}",
    'admin.users.subtitle': "Manage roles and review each account's subscription and projects.",
    'admin.users.viewPublished': "View published {name}",
    'dash.widgetNamed': "Widget {name}",
    'bookings.statusOf': "Booking status for {name}",
    'bookings.aCustomer': "a customer",
    'forms.sentBy': "Sent by {name} · {date}",
    'forms.aVisitor': "a visitor",
    'forms.starMessageOf': "Star the message from {name}",
    'forms.noName': "no name",
    'overview.stepsDone': "{done} of {total} steps completed",
    'overview.hideStep': "Hide {name}",
    'home.templatePreviewOf': "Preview of {name}",
    'brand.sectionAccent': "Accent section",
    'error.ai.providerFailed': "The AI provider returned an error. Try again in a moment.",
    'cwa.look.product': "Soft",
    'cwa.look.studio': "Rounded",
    'cwa.look.precision': "Fine line",
    'cwa.look.notebook': "Hand-drawn",
    'cwa.look.brutalist': "Blocky",
    'cwa.look.wireframe': "Straight",
    'cwa.look.creator': "Raised",
    'cwa.look.marketplace': "Compact",
    'cwa.look.editorial': "Editorial",
    'cwa.look.gallery': "Gallery",
    'cwa.look.luxury': "Spaced out",
    'cwa.look.swiss': "Geometric",
    'cwa.look.consulting': "Understated",
    'cwa.look.fintech': "Floating",
    'cwa.look.calm': "Roomy",
    'cwa.look.heritage': "Classic",
    'cwa.look.developer': "Technical",
    'cwa.look.clay': "Clay",
    'cwa.look.retail': "Storefront",
    'cwa.look.nordic': "Light",
    'cwa.look.pulse': "Bold",
    'cwa.look.coral': "Soft",
    'cwa.look.evergreen': "Clean",
    'cwa.look.voltage': "Glow",
    'cwa.look.executive': "Executive",
    'cwa.look.advisory': "Serene",
    'cwa.look.capital': "Sharp",
    'cwa.look.enterprise': "Polished",
    'cwa.look.counsel': "Formal",
    'cwa.look.estate': "Stately",
    'cwa.look.industry': "Industrial",
    'cwa.look.care': "Friendly",
    'cwa.look.impact': "Open",
    'cwa.look.venture': "Modern",
    'cwa.paletteBrand': "Your brand colors",
    'cwa.paletteBrandBadge': "Your brand",
    'nav.aiUnmet': "AI requests",
    'nav.adminEmails': 'Emails',
    'global.aiUnmet': "AI requests",
    'global.adminEmails': 'Emails',
    'aiUnmet.title': "What the AI couldn't do",
    'aiUnmet.subtitle': "What customers asked for when creating sites and pages that we don't have yet. Sorted by how many different people asked.",
    'aiUnmet.kind.all': "All",
    'aiUnmet.kind.section': "Sections",
    'aiUnmet.kind.element': "Elements",
    'aiUnmet.kind.font': "Fonts",
    'aiUnmet.kind.style': "Styles",
    'aiUnmet.kind.feature': "Features",
    'aiUnmet.lastDays': "{count} days",
    'aiUnmet.loading': "Loading…",
    'aiUnmet.loadFailed': "We couldn't load the list.",
    'aiUnmet.retry': "Try again",
    'aiUnmet.empty': "Nothing yet",
    'aiUnmet.emptyBody': "When someone asks for something the AI can't do, it will show up here.",
    'aiUnmet.col.what': "Request",
    'aiUnmet.col.kind': "Type",
    'aiUnmet.col.people': "People",
    'aiUnmet.col.times': "Times",
    'aiUnmet.col.source': "Source",
    'aiUnmet.col.lastSeen': "Last",
    'aiUnmet.instead': "Used instead: {categories}",
    'aiUnmet.fromCode': "Detected",
    'aiUnmet.fromAi': "Per the AI",
    'cwa.role.background': "Background",
    'cwa.role.alternate': "Alt. background",
    'cwa.role.card': "Cards",
    'cwa.role.ink': "Text",
    'cwa.role.button': "Brand",
    'cwa.role.accent': "Accent",
    'cwa.role.edit': "Change color: {role}",
    'aiUnmet.period': "Period",
    'aiUnmet.fieldIn': "{field} in {category}",
    'aiUnmet.field.eyebrow': "Eyebrow",
    'aiUnmet.field.subheadline': "Subheadline",
    'aiUnmet.field.primaryAction': "Primary button",
    'aiUnmet.field.secondaryAction': "Secondary button",
    'aiUnmet.field.items': "List of items",
    'aiUnmet.field.image': "Image",
    'cwa.step.template': "Template",
    'cwa.wz.template.title': "Choose a template",
    'cwa.wz.template.lead': "The starting point for your site. In the next steps you add your name, your colors and your fonts.",
    'cwa.wz.template.all': "All",
    'cwa.wz.template.industry': "Industry",
    'cwa.wz.template.noneForIndustry': "There are no templates for this industry yet. Here are all of them.",
    'cwa.wz.template.loading': "Loading templates…",
    'cwa.wz.template.empty': "There are no site templates yet.",
    'cwa.wz.templateFailed': "That template couldn't be loaded. Try another one.",
    'cwa.wz.info.leadTemplate': "The name and logo people will know you by. It shows in the title, the navbar and the template's copy.",
    'cwa.wz.dialogAriaTemplate': "Create site from a template",
    'cwa.role.border': "Lines",
    'preview.popupBlocked': "Your browser blocked the preview window. Allow pop-ups for this site and try again.",
    'cwa.role.muted': "Secondary text",
    'aiGen.tab': "Generations",
    'aiSpend.tab': "Spend",
    'aiSpend.subtitle': "What each AI call costs, by feature, by plan and by day. Numbers only.",
    'adminEmails.subtitle': '{count} emails véltica sends, with sample data. Sign-in emails are sent by Supabase.',
    'adminEmails.loadFailed': 'Couldn’t load the emails.',
    'adminEmails.empty': 'The server sent no emails. If this tab is new, the worker still needs deploying.',
    'adminEmails.language': 'Language',
    'adminEmails.subject': 'Subject',
    'adminEmails.spanishOnly': 'This email only exists in Spanish: it doesn’t change with the language.',
    'adminEmails.group.orders': 'Purchases · to the buyer',
    'adminEmails.group.store': 'Purchases · to the business',
    'adminEmails.group.bookings': 'Bookings',
    'adminEmails.group.forms': 'Forms',
    'adminEmails.group.customers': 'Customer accounts',
    'adminEmails.group.domains': 'Domains',
    'adminEmails.group.account': 'Account and team',
    'adminEmails.audience.customer': 'To the business’s customer',
    'adminEmails.audience.owner': 'To the site owner',
    'adminEmails.audience.staff': 'To véltica',
    'adminEmails.name.orderReceived': 'Order received (shipping)',
    'adminEmails.name.orderReceivedPickup': 'Order received (pickup)',
    'adminEmails.name.purchaseConfirmation': 'Thanks for your purchase',
    'adminEmails.name.claimDigital': 'Digital product download',
    'adminEmails.name.claimFree': 'Free offer claimed',
    'adminEmails.name.shipmentShipped': 'On its way',
    'adminEmails.name.shipmentPickup': 'Ready for pickup',
    'adminEmails.name.refundFull': 'Full refund',
    'adminEmails.name.refundPartial': 'Partial refund',
    'adminEmails.name.subscriptionStarted': 'Subscription started',
    'adminEmails.name.sale': 'New sale',
    'adminEmails.name.saleOversold': 'Sale out of stock',
    'adminEmails.name.saleRenewal': 'Subscription renewal',
    'adminEmails.name.saleFree': 'Someone claimed a free offer',
    'adminEmails.name.subscriptionCancelled': 'Subscription cancelled',
    'adminEmails.name.bookingConfirmation': 'Booking confirmed',
    'adminEmails.name.bookingReminder': 'Booking reminder',
    'adminEmails.name.bookingRescheduled': 'Booking rescheduled',
    'adminEmails.name.bookingCancelled': 'Booking cancelled',
    'adminEmails.name.bookingCancelledByBusiness': 'Business cancelled the booking',
    'adminEmails.name.bookingOwnerBooked': 'New booking (pay on site)',
    'adminEmails.name.disputeOpened': 'Dispute opened',
    'adminEmails.name.bookingOwnerCancelled': 'Customer cancelled',
    'adminEmails.name.bookingOwnerRescheduled': 'Customer rescheduled',
    'adminEmails.name.submission': 'Form message',
    'adminEmails.name.submissionLocked': 'Message locked by plan',
    'adminEmails.name.domainRenewal': 'Renewal coming up',
    'adminEmails.name.domainRenewalFailed': 'Renewal failed',
    'adminEmails.name.domainRenewalFinal': 'Renewal failed (final notice)',
    'adminEmails.name.domainRenewed': 'Domain renewed',
    'adminEmails.name.authCodeReady': 'Transfer code ready',
    'adminEmails.name.authCodeRequest': 'Transfer code requested',
    'adminEmails.name.teamInvite': 'Team invite',
    'adminEmails.name.transferInvite': 'Project transfer',
    'adminEmails.name.accountDeletionScheduled': 'Deletion scheduled',
    'adminEmails.name.accountDeletionReminder': 'Deletion reminder',
    'adminEmails.name.accountDeleted': 'Account deleted',
    'aiSpend.empty': "No spend recorded yet",
    'aiSpend.emptyBody': "Recording starts once the ai_usage_events migration is applied and someone uses AI.",
    'aiSpend.totalIn': "in the last {days} days",
    'aiSpend.byFeature': "By feature",
    'aiSpend.byPlan': "By plan (one account’s spend in the period)",
    'aiSpend.topUsers': "Top spending accounts",
    'aiSpend.byDay': "By day",
    'aiSpend.col.feature': "Feature",
    'aiSpend.col.calls': "Calls",
    'aiSpend.col.avgCost': "Avg cost",
    'aiSpend.col.p90Cost': "p90",
    'aiSpend.col.tokens': "Tokens in / out",
    'aiSpend.col.total': "Total",
    'aiSpend.col.plan': "Plan",
    'aiSpend.col.accounts': "Accounts",
    'aiSpend.col.perAccount': "Avg per account",
    'aiSpend.col.p90Account': "p90 per account",
    'aiSpend.col.maxAccount': "Max",
    'aiSpend.col.account': "Account",
    'aiSpend.col.day': "Day",
    'aiSpend.people': "{count} people",
    'aiSpend.fromCache': "{count} from cache",
    'aiSpend.estimated': "{count} estimated",
    'aiSpend.p90Tokens': "p90: {count} tokens",
    'aiSpend.callsPerAccount': "{count} calls per account",
    'aiSpend.feature.site': "Create site",
    'aiSpend.feature.page': "AI page",
    'aiSpend.feature.editorChat': "Editor chat",
    'aiSpend.feature.editorPlan': "Editor planner",
    'aiSpend.feature.assistant': "Dashboard assistant",
    'aiSpend.feature.writePost': "Blog post",
    'aiSpend.feature.photoNotes': "Photo notes",
    'aiUnmet.tab': "What's missing",
    'aiGen.subtitle': "Every site or page the AI created: the prompt, what it planned, what was built and what it couldn't do.",
    'aiGen.empty': "No generations yet",
    'aiGen.emptyBody': "When someone creates a site or a page with AI, it will show up here.",
    'aiGen.loadMore': "Load more",
    'aiGen.untitled': "Untitled",
    'aiGen.flow.project': "Site",
    'aiGen.flow.page': "Page",
    'aiGen.failed': "Failed",
    'aiGen.lost': "{count} sections lost",
    'aiGen.unmetCount': "{count} unmet",
    'aiGen.notCreated': "Unfinished draft",
    'aiGen.noProject': "No project",
    'aiGen.prompt': "Prompt",
    'aiGen.error': "Error",
    'aiGen.sections': "Sections: the AI planned {planned}, {built} were built",
    'aiGen.planned': "Planned: {list}",
    'aiGen.items': "{count} items",
    'aiGen.extraSections': "{count} sections requested separately to fill the home",
    'aiGen.itemsRequested': "{count} lists without items requested separately",
    'aiGen.unmet': "What couldn't be done",
    'aiGen.tokens': "{count} tokens",
    'aiGen.cost.input': "Input",
    'aiGen.cost.output': "Output",
    'aiGen.cost.total': "Approx. total",
    'aiGen.cost.summary': "≈ {amount}",
    'aiGen.cost.calls': "{count} AI calls",
    'aiGen.cost.note': "Estimated in USD using standard paid API rates and recorded tokens. Output includes thinking tokens; retries and follow-up calls are included.",
    'aiGen.cost.legacy': "This older request only saved total tokens. The range assumes standard uncached rates; the input/output split is unavailable.",
    'aiGen.cost.unavailable': "Cost unavailable: token usage or pricing for this model was not recorded.",
    'aiGen.cost.estimatedTokens': "Some token counts were estimated.",
    'aiGen.cost.cached': "{count} cached input tokens at the discounted rate.",
    'aiGen.cost.rates': "Google pricing",
    'aiGen.openEditor': "Open in editor",
    'aiGen.openSite': "View site",
    'overview.unit.post': "post",
    'overview.unit.posts': "posts",
    'overview.row.openPost': "Open the blog",
    'filter.soft': "Soft",
    'cwa.paletteGroup.suave': "Soft",
    'start.resume.title': "You have an unfinished site: {name}",
    'start.resume.body': "You left it {when}. Pick up where you left off, without generating a new one.",
    'start.resume.discard': "Discard",
    'start.resume.go': "Continue",
    'start.credits.total': "Trying is free (3 times without creating) · {left} of {total} left",
    'start.credits.monthly': "Trying is free (3 times without creating) · {left} of {total} left this month",
    'start.credits.none': "No generations left · Upgrade to create more",
    'cwa.credits.none': "You have no generations left: upgrade your plan to create this site.",
    'error.offer.setupPending': "Complete this offer before putting it on sale: the AI started it with sample details.",
    'error.blog.setupPending': "Write your post before publishing it: it still has the placeholder text.",
    'error.server.dbUnavailable': "The connection to the server was interrupted. Please try again in a moment.",
    'aiPending.chip': "To complete",
    'aiPending.minimize': "Minimize",
    'aiPending.expand': "See what needs completing",
    'aiPending.chipAria': "Complete it: the AI started it and your details are missing",
    'aiPending.chipHint': "The AI started it with sample details. Complete it to be able to publish it: until then it won't appear on your site.",
    'aiPending.wizardNote': "The AI started this with sample details. Go through each step and add your own; when you finish you'll be able to publish it.",
    'aiPending.bookingNote': "The AI started this booking with the default schedule and settings. Go through each step, especially your hours; when you finish you'll be able to publish it.",
    'aiPending.priceHint': "Price suggested by the AI: change it to yours.",
    'aiPending.scheduleHint': "This is the default schedule: set it to yours before opening bookings.",
    'aiPending.postNote': "The AI wrote the title and summary; the text below is placeholder. Write it to be able to publish the post.",
    'aiPending.postHint': "The AI started it: write the body to be able to publish it.",
    'pub.offersPending': "{count} items not published on your site",
    'pub.offersPending.one': "1 item not published on your site",
    'aiPending.toastTitle': "Needs completing",
    'aiPending.toastBody': "{count} items on this page won't appear on your site until you complete them.",
    'aiPending.toastBody.one': "1 item on this page won't appear on your site until you complete it.",
    'aiPending.toastShow': "See which",
    'aiPending.toastHide': "Hide",
    'aiPending.kind.bookings': "Booking",
    'aiPending.kind.services': "Service",
    'aiPending.kind.digital': "Digital product",
    'aiPending.kind.blog': "Blog post",
    'aiPending.openInDashboard': "Open in dashboard",
    'pub.offersPendingLead': "You can see them in the editor, but they won't appear on your site until you complete and publish them. A section with only these is hidden.",
    'pub.offersComplete': "Complete",
    'pub.offersOpen': "Open",
    'aiPending.canvasHint': "The AI started it with sample details. It won't appear on your site until you complete and activate it. Click the label to complete it.",
    'aiPending.canvasDraftHint': "It's a draft: it won't appear on your site until you activate it. Click the label to open it.",
    'aiPending.previewTitlePending': "This still needs finishing",
    'aiPending.previewTitleDraft': "This is a draft",
    'aiPending.previewBodyPending': "The AI started “{title}” and it still needs your details. It won't appear on your site, and its page won't open, until you complete and activate it in the dashboard.",
    'aiPending.previewBodyDraft': "“{title}” is a draft. It won't appear on your site, and its page won't open, until you activate it in the dashboard.",
    'aiPending.previewComplete': "Complete in dashboard",
    'aiPending.previewAnyway': "View anyway",
    'aiPending.bannerTitle': "This isn't finished yet.",
    'aiPending.bannerBody': "This is how it will look once you complete it; it's not on your site yet.",
    'aiPending.stepTitle': "Complete your site",
    'aiPending.stepBody': "The AI started: {list}. Add your details to be able to publish them.",
    'aiPending.stepGo': "Complete the first one",
    'aiPending.n.booking': "{count} booking",
    'aiPending.n.bookings': "{count} bookings",
    'aiPending.n.service': "{count} service",
    'aiPending.n.services': "{count} services",
    'aiPending.n.digital': "{count} digital product",
    'aiPending.n.digitals': "{count} digital products",
    'aiPending.n.post': "{count} blog post",
    'aiPending.n.posts': "{count} blog posts",
    'cwa.credits.cardTitleNone': "You have no generations left",
    'cwa.credits.leftOf': "generations left of {total}",
    'cwa.credits.charged': "This one is already counted: you went past the 3 free tries without creating this month.",
    'cwa.credits.usesOne': "Creating this site uses one.",
    'cwa.credits.resets': "Resets {when}",
    'cwa.credits.lifetime': "In total on the free plan",
    // ── Demo pública (/demo) ──────────────────────────────────────────────────
    'demo.aria': "Design demo",
    'demo.stepsAria': "What to change",
    'demo.kicker': "Try it, no account needed",
    'demo.start': "Start with this design",
    'demo.previewNote': "Double-click any text to write your own.",
    'demo.address': "your-site.veltica.com",
    'demo.loadFailed': "The demo didn't load. Check your connection and try again.",
    'demo.saveFailed': "Your browser won't let us keep this design (private browsing?). Allow site storage and try again.",
    'demo.combination.startBadge': "Starting point",
    'demo.combination.startHint': "How the page opened, to go back to it.",
    'demo.combination.badge': "From the demo",
    'demo.combination.hint': "The design you put together in the demo.",
    'cwa.wz.info.leadDemo': "Your design from the demo, ready. Give it your business name: it replaces ours in the title, the navbar and the copy. Then you rewrite the rest in the editor, or ask the AI to.",
    'embedPrompt.note': "Free to try: create your account and your site is generated right away.",
    'embedPrompt.placeholder': "Tell us what you want to build: your business, what you offer and what the site is for.",
    'embedPrompt.saveFailed': "Your browser won't let us keep what you wrote (private browsing?). Allow site storage and try again.",
    'embedAuth.opening': "Opening your dashboard…",
    'embedAuth.openingHint': "You are already signed in. Taking you there with what you picked.",
    'demo.split.title': "Restyle this page",
    'assistant.period.today': " today",
    'assistant.period.week': " in the last 7 days",
    'assistant.period.month': " this month",
    'assistant.period.year': " this year",
    'assistant.period.all': "",
    'assistant.window.today': " today",
    'assistant.window.week': " in the next 7 days",
    'assistant.window.month': " in the next 30 days",
    'assistant.window.year': " coming up",
    'assistant.window.all': " coming up",
    'assistant.q.contacts_summary': "You have {total} contacts, {recent} new{period}. {buyers} people have bought from you.",
    'assistant.q.contacts_summary.all': "You have {total} contacts. {buyers} people have bought from you.",
    'assistant.q.contacts_summary.empty': "You don’t have contacts or purchases yet.",
    'assistant.q.sales_summary': "You sold {revenue}{period}, across {orders} orders.",
    'assistant.q.sales_summary.one': "You sold {revenue}{period}, in 1 order.",
    'assistant.q.sales_summary.empty': "No sales{period}.",
    'assistant.q.otherCurrencies': "Also in other currencies: {list}.",
    'assistant.q.top_customers': "Your top customer{period} is {name}: {orders} purchases totaling {revenue}.",
    'assistant.q.top_customers.one': "Your top customer{period} is {name}: 1 purchase totaling {revenue}.",
    'assistant.q.top_customers.empty': "No purchases from identified customers{period} yet.",
    'assistant.q.top_offers': "Your best seller{period} is “{title}”: {units} sold, {revenue}.",
    'assistant.q.top_offers.empty': "No sales{period} yet.",
    'assistant.q.upcoming_bookings': "You have {count} appointments{period}. Next up: “{title}” on {next}.",
    'assistant.q.upcoming_bookings.one': "You have 1 appointment{period}: “{title}” on {next}.",
    'assistant.q.upcoming_bookings.empty': "No appointments{period}.",
    'assistant.q.visits_summary': "Your site had {views} visits from {visitors} visitors{period}.",
    'assistant.q.visits_summary.empty': "No visits recorded{period} yet.",
    'assistant.q.unread_forms': "You have {count} unread form messages.",
    'assistant.q.unread_forms.one': "You have 1 unread form message.",
    'assistant.q.unread_forms.empty': "You’re all caught up: no unread form messages.",
    'assistant.q.seeIn': "See in {place}",
    'assistant.disclaimer': "AI can make mistakes. Double-check important info.",
    'find.editor': "Open the editor",
    'assistant.notConfigured': "AI isn’t configured on this server, so I can only look up sections. (The worker is missing its AI key.)",
    'assistant.seeAll': "See full conversation",
    'assistant.usage': "{input} input tokens · {output} output",
    'assistant.usageThought': "{thought} reasoning",
    'assistant.usageCached': "From cache · 0 tokens",
    'assistant.hereItIs': "Here you go:",
    'assistant.offer.ready': "Here’s how your {kind} would look. Review it and I’ll create it:",
    'assistant.offer.createOpen': "Create and open",
    'assistant.post.ready': "Done, I wrote this post. Save it as a draft to review and publish it:",
    'assistant.post.saveOpen': "Save draft and open",
    'assistant.post.note': "It’s saved as a draft: review and publish it from the blog.",
    'assistant.writingPost': "Writing the post…",
    'assistant.draftingOffer': "Drafting the listing…",
    'aiSpend.feature.draftOffer': "Offer listing",
    'assistant.ask.postTopic': "What topic should the post be about?",
    'assistant.ask.pageIdea': "What is the page for? For example: “FAQ” or “our team”.",
    'assistant.ask.offer': "What’s the {kind} called? You can also tell me the price and, for a product, its sizes or colors.",
    'assistant.ask.offerGeneric': "product or service",
    'assistant.offer.scheduleReplaces': "This changes your booking schedule, which all your bookable services share.",
    'assistant.title': "Assistant",
    'assistant.open': "Open the assistant",
    'assistant.close': "Close the assistant",
    'assistant.placeholder': "How can I help you today?",
    'assistant.send': "Send",
    'assistant.clear': "New chat",
    'assistant.thinking': "Thinking…",
    'assistant.hello': "I can take you to any section, create services, products and pages, or write a blog post. What do you need?",
    'assistant.example.find': "Where do I see my sales?",
    'assistant.example.offer': "Create a consulting service",
    'assistant.example.post': "Write a post for my blog",
    'assistant.foundIn': "You’ll find it in {place}:",
    'assistant.pickOne': "Are you looking for one of these?",
    'assistant.foundContent': "Here’s what I found in your project:",
    'assistant.error': "I couldn’t answer right now. Try again in a moment.",
    'assistant.limitDaily': "You’ve reached today’s limit of questions to the assistant. It’ll be back tomorrow.",
    'assistant.tokenLimit': "You’ve used all your AI for this month. It comes back on the 1st.",
    'assistant.forbidden': "Your role in this project doesn’t allow that.",
    'assistant.noAi': "I didn’t find that, and your role can’t use AI in this project. Try the search bar above.",
    'assistant.createFailed': "Couldn’t create it. Please try again.",
    'assistant.cancelled': "Okay, I won’t do anything.",
    'assistant.cancel': "Cancel",
    'assistant.doneShort': "Done",
    'assistant.cancelledShort': "Cancelled",
    'assistant.kind.services': "Service",
    'assistant.kind.digital': "Digital product",
    'assistant.kind.products': "Physical product",
    'assistant.kind.bookings': "Bookable service",
    'assistant.offer.note': "It starts as “To complete”: add the photo, details and payment later in its record.",
    'assistant.offer.done': "Done: “{title}” was created as “To complete”. I opened its record so you can finish it.",
    'assistant.page.propose': "Shall I open the new page assistant?",
    'assistant.page.kind': "New page",
    'assistant.page.untitled': "Pick a design or describe it",
    'assistant.page.note': "It opens in the editor, with your idea already written for the AI.",
    'assistant.page.open': "Open the editor",
    'assistant.page.done': "Taking you to the editor…",
    'assistant.post.kind': "Blog post",
    'assistant.post.done': "Done: I saved “{title}” as a draft. Review it before publishing.",
    'bp.opentable': 'Reservations with OpenTable',
    'bp.classSchedule': 'Class schedule',
    'classes.days': 'Days',
    'classes.days.week': '1 week',
    'classes.days.twoWeeks': '2 weeks',
    'classes.layout': 'View',
    'classes.layout.agenda': 'Agenda',
    'classes.layout.timetable': 'Calendar',
    'classes.layout.timetableHint': 'The week by the hour, colored by class',
    'classes.layout.pro': 'Agenda with filters',
    'classes.layout.proHint': 'Days, filters and spots',
    'classes.layout.people': 'By person',
    'classes.layout.peopleHint': 'Each instructor with their classes',
    'classes.layout.classes': 'By class',
    'classes.layout.classesHint': 'Cards with photo and next sessions',
    'classes.layout.month': 'Month',
    'classes.layout.monthHint': 'Monthly calendar',
    'classes.layout.agendaHint': 'One day at a time, simple',
    'classes.layout.weekHint': 'Compact columns',
    'classes.layout.listHint': 'Every day in a row',
    'classes.styles': 'Style',
    'classes.simple': 'Simple',
    'classes.layout.week': 'Week',
    'classes.layout.list': 'List',
    'classes.allSummary': "All",
    'classes.pickedCount': "{count} of {total}",
    'classes.which': 'Classes',
    'classes.whichInfo': 'Services that take several people show up on their own. Check or uncheck the ones to show.',
    'classes.spots': '{count} spots',
    'classes.oneOnOne': '1 on 1',
    'classes.noServices': 'No bookable services yet. Create a class in Bookings.',
    'classes.allClasses': 'Back to all classes',
    'classes.manage': 'Edit classes in Bookings',
    'classes.refresh': 'Refresh',
    'bp.offerBuy': 'Buy / Book',
    'offerBuy.mode': 'How it looks',
    'offerBuy.modeInfo': 'Full area: buy or book right here (one per page). Button only: links to the offer’s purchase page; good for cards or several offers.',
    'offerBuy.mode.full': 'Full area',
    'offerBuy.mode.button': 'Button only',
    'offerBuy.layout': "Design",
    'offerBuy.layoutInfo': "Purchase only: the payment area (for the offer’s own page, which already has its title). Card, Side by side and Compact add the offer’s photo, title and description. Button only links to its purchase page.",
    'offerBuy.layout.buy': "Purchase only",
    'offerBuy.layout.titled': "Purchase with title",
    'offerBuy.layout.card': "Card",
    'offerBuy.layout.split': "Side by side",
    'offerBuy.layout.compact': "Compact",
    'offerBuy.layout.button': "Button only",
    'offerBuy.label': 'Button text',
    'offerBuy.fallbackLabel': 'Fallback button text',
    'offerBuy.labelBook': 'Book',
    'offerBuy.labelBuy': 'Buy',
    'offerBuy.offer': 'What’s sold here',
    'offerBuy.offerInfo': 'That offer’s full purchase area: price, options and payment, or the calendar for a booking. One per page.',
    'offerBuy.choose': 'Choose an offer…',
    'offerBuy.kind.bookings': 'Bookings',
    'offerBuy.kind.services': 'Services',
    'offerBuy.kind.products': 'Products',
    'offerBuy.kind.digital': 'Digital',
    'offerBuy.draft': 'draft',
    'offerBuy.draftNote': 'It’s a draft: it can’t be bought on the site until you activate it.',
    'offerBuy.noOffers': 'No offers yet. Create them in the dashboard and come back.',
    'offerBuy.edit': 'Edit the offer',
    'offerBuy.emptyTitle': 'Choose what’s sold here',
    'offerBuy.pick': "Choose offer",
    'offerBuy.create': "Create offer",
    'offerBuy.emptyBody': "Pick an offer from your catalog or create a new one: people can buy or book right here.",
    'offerBuy.loading': 'Loading the purchase area…',
    'offerBuy.loadingBody': 'One moment.',
    'bp.map': 'Map',
    'map.previewNote': "To complete · add the map address",
    'map.address': 'Address',
    'map.empty.action': 'Add address',
    'map.addressInfo': 'The exact address of the place, as you’d search for it on Google Maps. It can differ from the legal one in Settings › Business.',
    'map.addressPlaceholder': 'Street, number, city',
    'map.zoom': 'Zoom',
    'map.type': 'Type',
    'map.check': 'View on Google Maps',
    'map.height': 'Height',
    'map.height.low': 'Low',
    'map.height.medium': 'Medium',
    'map.height.high': 'High',
    'map.directions': 'Directions',
    'map.directionsInfo': 'Below the map: the address and a button that opens the route in Google Maps from wherever the visitor is.',
    'map.directions.hide': 'Hide',
    'map.directions.show': 'Show',
    'map.type.roadmap': 'Map',
    'map.type.satellite': 'Satellite',
    'map.empty.title': 'Show where you are',
    'map.empty.body': 'Type your place’s exact address and the Google map will show up here.',
    'map.needsKey': 'The Google Maps key is missing from the editor configuration.',
    'bp.deliveryButtons': 'Order delivery',
    'bp.orderUberEats': 'Order on Uber Eats',
    'bp.orderDoorDash': 'Order on DoorDash',
    'bp.orderRappi': 'Order on Rappi',
    'search.opentable': 'opentable reservations bookings restaurant tables widget external service',
    'opentable.external': 'External service',
    'opentable.title': 'Take reservations with OpenTable',
    'opentable.requirements': 'You need an OpenTable restaurant account and its widget code to take reservations on your site.',
    'opentable.managedExternally': 'Veltica displays the widget on your page. OpenTable manages table reservations; this service is not included in Veltica.',
    'opentable.learnMore': 'Don\'t have OpenTable yet? Explore OpenTable',
    'opentable.pasteWidget': 'Connect with my ID',
    'opentable.editWidget': 'Edit widget code',
    'opentable.codePlaceholder': 'Paste the widget code you copied from your OpenTable restaurant account here.',
    'opentable.canvasEmpty': 'Reservations with OpenTable · External service. Configure the widget in this component’s settings.',
    'opentable.canvasConfigured': 'Reservations with OpenTable · Widget configured. It appears on the published page.',
    'opentable.previewReady': 'Widget configured',
    'opentable.previewPending': 'Not connected yet',
    'opentable.pendingNote': 'To complete: connect your OpenTable',
    'opentable.previewEyebrow': 'Restaurant reservations',
    'opentable.previewTitle': 'Your next table starts here',
    'opentable.previewConfiguredTitle': 'Ready to welcome reservations',
    'opentable.previewBody': 'Connect your restaurant account with the OpenTable widget. Guests book from your site and you manage tables in OpenTable.',
    'opentable.previewConfiguredBody': 'Your widget code is saved. The OpenTable reservation form will appear on your published page.',
    'opentable.openPanel': 'Open panel',
    'opentable.moreInfo': 'Learn more',
    'opentable.previewEditorOnly': 'Setup preview · Only visible in the editor. OpenTable is an external service and requires a restaurant account.',
    'opentable.connectTitle': 'Bring OpenTable to your site',
    'opentable.connectDescription': 'Enter your restaurant ID and you’re done. You choose the design later in the component panel.',
    'opentable.copyStep': 'Find your restaurant ID',
    'opentable.copyStepHint': 'It’s in your OpenTable account (Guest Center), under the reservation widget. If you have the widget code or link, paste it and we’ll pull the ID out.',
    'opentable.openAccount': 'Open my OpenTable account',
    'opentable.pasteStep': 'Enter your ID',
    'opentable.detected': 'ID found: {id}',
    'opentable.detectedMany': 'IDs found: {id}',
    'opentable.notDetected': 'We couldn’t find an ID. Enter the number or paste the widget code.',
    'opentable.design': 'Design',
    'opentable.lockedInfo': 'Connected in Settings › OpenTable: every OpenTable widget and button on the site uses this restaurant. Change it there.',
    'opentable.restaurant': 'Restaurant',
    'opentable.connect': 'Connect',
    'opentable.opensIn': 'When booking',
    'opentable.opensPage': 'On the page',
    'opentable.opensTab': 'New tab',
    'opentable.shape.standard': 'Standard',
    'opentable.shape.tall': 'Tall',
    'opentable.shape.wide': 'Wide',
    'opentable.shape.button': 'Button',
    'opentable.changeId': 'Change ID ({id})',
    'opentable.alignment': 'Alignment',
    'opentable.alignLeft': 'Left',
    'opentable.alignCenter': 'Center',
    'opentable.alignRight': 'Right',
    'opentable.pasteStepHint': 'A number, like 1434817. For several locations, separate them with commas.',
    'opentable.friendlyPlaceholder': 'E.g. 1434817',
    'opentable.noCodeEditing': 'No coding needed.',
    'opentable.codeAdded': 'Code added. You can save your widget now.',
    'opentable.connectServiceNote': 'You need an OpenTable restaurant account. Reservations and availability are managed there; the service is purchased separately.',
    'opentable.visibleOnPublish': 'Appears when you publish your site.',
    'opentable.connectWidget': 'Connect widget',
    'opentable.saveChanges': 'Save changes',
    'delivery.orderOn': 'Order on',
    'delivery.orderNow': 'Order now',
    'delivery.configure': 'Set up ordering',
    'delivery.settingsIntro': 'Choose where customers can order and paste your restaurant’s link for each app.',
    'delivery.enable': 'Enable {name}',
    'delivery.restaurantLink': 'Your restaurant’s link',
    'delivery.linkPending': 'Add your restaurant’s link to publish this button.',
    'delivery.linkHint': 'Copy your store link from {name}.',
    'delivery.invalidLink': 'Use a link to your restaurant on {name}.',
    'delivery.linkReady': 'Ready to take orders on {name}.',
    'delivery.testLink': 'Test link',
    'delivery.empty': 'Enable a delivery app in this component’s settings.',
    'delivery.externalNote': 'Orders and payments are completed in each app. Only enabled companies with a valid link appear on your published site.',
    'delivery.addLink': 'Add link',
    'delivery.editLink': 'Edit link',
};
//# sourceMappingURL=en.js.map